"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6393],{

/***/ 29284:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ Ge; },
/* harmony export */   "A": function() { return /* binding */ Hf; },
/* harmony export */   "AA": function() { return /* binding */ g0; },
/* harmony export */   "BI": function() { return /* binding */ De; },
/* harmony export */   "Eo": function() { return /* binding */ ar; },
/* harmony export */   "Gk": function() { return /* binding */ Ee; },
/* harmony export */   "I": function() { return /* binding */ nt; },
/* harmony export */   "M": function() { return /* binding */ fb; },
/* harmony export */   "MC": function() { return /* binding */ zs; },
/* harmony export */   "R4": function() { return /* binding */ to; },
/* harmony export */   "a": function() { return /* binding */ gb; },
/* harmony export */   "b": function() { return /* binding */ s0; },
/* harmony export */   "c": function() { return /* binding */ b; },
/* harmony export */   "d": function() { return /* binding */ c0; },
/* harmony export */   "du": function() { return /* binding */ ju; },
/* harmony export */   "e": function() { return /* binding */ dm; },
/* harmony export */   "f": function() { return /* binding */ a0; },
/* harmony export */   "fL": function() { return /* binding */ Zt; },
/* harmony export */   "g": function() { return /* binding */ o0; },
/* harmony export */   "h": function() { return /* binding */ Ap; },
/* harmony export */   "m": function() { return /* binding */ Yf; },
/* harmony export */   "n": function() { return /* binding */ Ae; },
/* harmony export */   "p": function() { return /* binding */ i0; },
/* harmony export */   "r": function() { return /* binding */ l0; },
/* harmony export */   "ri": function() { return /* binding */ zA; },
/* harmony export */   "u": function() { return /* binding */ u0; },
/* harmony export */   "xJ": function() { return /* binding */ kt; }
/* harmony export */ });
/* unused harmony exports AgentProviderContainer, AgentUIProviderContainer, CSATType, Commands, ConnectionDelayLayout, ConversationContext, ConversationContextProvider, ConversationLayout, ConversationList, ConversationListContext, ConversationListContextProvider, ConversationListHeaderLayout, ConversationListItemLayout, DefaultMessenger, DeskTicketPriority, DeskTicketStatus, LauncherBase, LogLevel, MessageListUILayout, MessageLogs, OutgoingMessageLayout, PlaceholderLayout, Prechecks, SystemMessageLayout, messengerDispatcher, useAIAgentContext, useLocalizationContext, useRefreshActiveChannel */
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89531);
/* harmony import */ var _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84663);
/* harmony import */ var _sendbird_chat__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11966);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21929);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37236);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43828);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70946);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14444);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73309);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23815);
/* harmony import */ var date_fns_locale_en_US__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64409);
/* harmony import */ var _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18897);
/* harmony import */ var _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35058);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64561);
/* harmony import */ var _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32703);
/* harmony import */ var _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82861);
var ol = Object.defineProperty;
var il = (e, t, n) => t in e ? ol(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var E = (e, t, n) => il(e, typeof t != "symbol" ? t + "" : t, n);











const Pi = (e) => {
  try {
    return JSON.parse(e === "" ? "{}" : e);
  } catch {
    return {};
  }
}, Fi = (e) => {
  const t = Pi(e);
  return typeof t == "object" && t !== null ? t : {};
}, Ui = (e) => typeof e == "string" ? Fi(e) : e ?? {}, Fl = (e) => !!Ui(e).stream, Js = (e) => {
  if (typeof e == "number" && Number.isSafeInteger(e) && e > 0) return e;
  if (typeof e != "string" || e.trim().length === 0) return;
  const t = Number(e);
  return Number.isSafeInteger(t) && t > 0 ? t : void 0;
}, ss = (e) => {
  const t = Ui(e), n = Js(t.user_message_id) ?? Js(t.respond_mesg_id);
  return {
    isStreaming: !!t.stream,
    hasResponseMetadata: Object.prototype.hasOwnProperty.call(t, "stream") || n !== void 0,
    ...n !== void 0 && { userMessageId: n }
  };
}, Ut = "sb-agent", Bi = "KEY_IMG_ASPECT_RATIO", kr = "*/*", ae = {
  BODY_MAX_WIDTH: 244,
  WIDE_BODY_MAX_WIDTH: 640,
  AVATAR_SIZE: 26,
  BODY_TIME_GAP: 4,
  HORIZONTAL_PADDING: 12,
  GAP_GROUPED: 2,
  GAP_UNGROUPED: 16
};
var Bn = /* @__PURE__ */ ((e) => (e.IN_PROGRESS = "IN_PROGRESS", e.COMPLETED = "COMPLETED", e.CANCELED = "CANCELED", e))(Bn || {}), an = /* @__PURE__ */ ((e) => (e.IN_PROGRESS = "IN_PROGRESS", e.COMPLETED = "COMPLETED", e.CANCELED = "CANCELED", e))(an || {});
const Ul = (e) => !!(e != null && e.cta_button), Bl = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.citations) != null && t.length);
}, Hi = (e) => !!(e != null && e.form) && !e.form.canceled_at, Hl = (e) => {
  var t;
  return Hi(e) && !((t = e == null ? void 0 : e.form) != null && t.submitted_at);
}, Gl = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.suggested_replies) != null && t.length);
}, st = (e) => {
  let t;
  return {
    enumerable: !0,
    get: () => (t ?? (t = e()), t)
  };
}, hn = (e) => Object.defineProperties({}, {
  hasMessageTemplate: st(() => !!(e != null && e.message_template)),
  hasCTAButton: st(() => Ul(e)),
  hasChallenge: st(() => !!(e != null && e.challenge)),
  isThinking: st(() => !!(e != null && e.is_thinking)),
  hasCSAT: st(() => !!(e != null && e.csat)),
  hasSuggestedReplies: st(() => Gl(e)),
  hasCustomMessageTemplates: st(() => {
    var t;
    return !!((t = e == null ? void 0 : e.custom_message_templates) != null && t.length);
  }),
  hasForm: st(() => Hi(e)),
  hasActiveForm: st(() => Hl(e)),
  hasSteward: st(() => !!(e != null && e.steward)),
  hasCitations: st(() => Bl(e))
}), Vl = (e) => {
  const t = hn(e);
  return t.hasMessageTemplate || t.hasCTAButton || t.hasCSAT || t.hasSuggestedReplies || t.hasForm || t.hasSteward || t.hasCitations;
}, Gi = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.extendedMessagePayload) != null && t.steward);
}, zl = (e) => e === an.COMPLETED || e === an.CANCELED ? e : an.IN_PROGRESS, ur = (e) => tt(e) && !Gi(e), tt = (e) => !!e && "sender" in e, Kl = (e, { aiAgentInfo: t, members: n }) => t && ze(e, t.userId) ? t : (n == null ? void 0 : n.find((r) => r.userId === e.sender.userId)) ?? e.sender, Wl = (e) => tt(e) && e.reqId ? e.reqId : String(e.messageId), Yl = (e, t, n, r = !0) => {
  if (!r || !ur(e))
    return "single";
  const s = () => {
    if (!ur(t)) return !1;
    const l = t.sender.userId === e.sender.userId, u = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .isSameMinute */ .x)(t.createdAt, e.createdAt);
    return l && u;
  }, o = () => {
    if (!ur(n)) return !1;
    const l = n.sender.userId === e.sender.userId, u = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .isSameMinute */ .x)(n.createdAt, e.createdAt);
    return l && u;
  }, i = s(), c = o();
  return i && c ? "middle" : i ? "bottom" : c ? "top" : "single";
}, ze = (e, t) => (() => {
  var r;
  return tt(e) ? e.sender.userId : ((r = e == null ? void 0 : e.sender) == null ? void 0 : r.userId) ?? void 0;
})() === t, $e = {
  isAdmin: (e) => e.isAdminMessage(),
  isCSAT: (e) => {
    var t;
    return e.isAdminMessage() && !!((t = e.extendedMessagePayload) != null && t.csat);
  },
  isSteward: (e) => Gi(e),
  isIncoming: (e, t) => tt(e) && e.sender.userId !== t,
  isOutgoing: (e, t) => tt(e) && (e.sender.userId === t || e.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.PENDING)
}, je = (e) => e.startsWith("image/"), gn = (e) => e.startsWith("video/"), ql = (e) => e.startsWith("audio/"), Vi = ({ name: e = "", mimeType: t = "" }) => t === "application/pdf" || /\.pdf$/i.test(e.trim()), os = (e, t) => {
  if (e && !e.startsWith(".")) {
    const n = e.split(".").pop();
    if (n && n !== e)
      return n.toUpperCase();
  }
  if (t) {
    const [, n] = t.split("/");
    if (n)
      return n.toUpperCase();
  }
  return "FILE";
}, zi = (e, t) => t.map((r) => r.trim()).filter(Boolean).sort((r, s) => s.length - r.length).reduce((r, s) => r.replace(s, ""), e.trim()).replace(/[\s,]/g, "").length === 0, Ki = (e) => {
  if (e.message.length === 0) return !1;
  if (e.messageType === "file" || e.messageType === "multipleFiles") {
    const t = e.messageType === "file" ? [e.file.name] : e.files.map((n) => n.name);
    return !zi(e.message, t);
  }
  return !0;
}, jl = (e) => {
  if (e.message && e.message.trim().length > 0) return !0;
  const t = e.extendedMessagePayload;
  return Vl(t);
}, Qn = (e) => {
  switch (e) {
    case "top":
    case "middle":
      return ae.GAP_GROUPED;
    default:
      return ae.GAP_UNGROUPED;
  }
}, Xl = (e) => {
  const t = /```(\w+)?\n([\s\S]*?)```/g, n = [];
  let r = 0;
  return e.replace(t, (s, ...o) => {
    const [i, c, l] = o;
    return r < l && n.push({
      type: "text",
      value: e.slice(r, l).trim()
    }), n.push({
      type: "code",
      value: c.trim(),
      language: i ? i.trim() : "plaintext"
    }), r = l + s.length, s;
  }), r < e.length && n.push({
    type: "text",
    value: e.slice(r).trim()
  }), n;
}, is = (e) => {
  const t = [], n = (c, l) => {
    l && t.push({ kind: c, value: l });
  }, r = (c) => {
    var h;
    const l = [], u = /`+/g;
    let d;
    for (; (d = u.exec(c)) !== null; )
      l.push({ start: d.index, end: d.index + d[0].length, length: d[0].length });
    let m = 0;
    for (let g = 0; g < l.length; g++) {
      const f = l[g];
      if (!f) continue;
      let v = 0;
      for (; c[f.start - 1 - v] === "\\"; ) v += 1;
      if (v % 2 === 1) continue;
      let _ = g + 1;
      for (; _ < l.length && ((h = l[_]) == null ? void 0 : h.length) !== f.length; ) _ += 1;
      const p = l[_];
      p && (n("text", c.slice(m, f.start)), n("span", c.slice(f.start, p.end)), m = p.end, g = _);
    }
    n("text", c.slice(m));
  }, s = /(?:^|\n)[ \t]{0,3}((`|~)\2{2,})[\s\S]*?(?:\n[ \t]{0,3}\1\2*[ \t]*(?=\n|$)|$)/g;
  let o = 0, i;
  for (; (i = s.exec(e)) !== null; ) {
    const c = i[0].startsWith(`
`) ? i.index + 1 : i.index;
    r(e.slice(o, c)), n("fence", e.slice(c, i.index + i[0].length)), o = i.index + i[0].length;
  }
  return r(e.slice(o)), t;
}, Qs = (e, { anchorsLineEnd: t = !1 } = {}) => (n, { atLineStart: r, atLineEnd: s } = { atLineStart: !0, atLineEnd: !0 }) => {
  const o = n.indexOf(`
`), i = r ? 0 : o === -1 ? n.length : o + 1, c = !t || s ? n.length : n.lastIndexOf(`
`) + 1;
  return i >= c ? n : n.slice(0, i) + e(n.slice(i, c)) + n.slice(c);
}, Zl = (e) => (t) => {
  const n = is(t);
  return n.map((r, s) => r.kind === "text" ? e(r.value, { atLineStart: s === 0, atLineEnd: s === n.length - 1 }) : r.kind === "span" ? r.value.replace(/\n/g, " ") : r.value).join("");
}, Jl = (e) => e.replace(/\[([^\]]+)\](?!\(\s*[^\s)])/g, "\\[$1\\]"), Ql = (e) => e.replace(/^([ \t]*(?:[-*+]|\d+[.)])[ \t]+)\[( |x|X)\]/gm, "$1\\[$2\\]"), eu = /[\p{P}$+<=>^`|~]/u, Tn = (e) => e === void 0 || /\s/.test(e), Pt = (e) => e !== void 0 && eu.test(e), tu = (e) => {
  const t = [];
  let n = 0;
  for (const _ of is(e))
    _.kind !== "text" && t.push([n, n + _.value.length]), n += _.value.length;
  const r = [], s = /^[ \t]{0,3}(?:_[ \t]*){3,}$/gm;
  let o;
  for (; (o = s.exec(e)) !== null; )
    r.push([o.index, o.index + o[0].length]);
  const i = (_, p, y) => {
    for (; p.index < _.length && _[p.index][1] <= y; ) p.index += 1;
    return p.index < _.length && y >= _[p.index][0];
  }, c = { index: 0 }, l = { index: 0 }, u = [], d = /_+/g;
  let m;
  for (; (m = d.exec(e)) !== null; ) {
    const _ = m.index, p = _ + m[0].length;
    if (i(t, c, _) || i(r, l, _)) continue;
    let y = 0;
    for (; e[_ - 1 - y] === "\\"; ) y += 1;
    if (y % 2 === 1) continue;
    const S = e[_ - 1], A = e[p], I = !Tn(A) && (!Pt(A) || Tn(S) || Pt(S)), k = !Tn(S) && (!Pt(S) || Tn(A) || Pt(A));
    u.push({
      start: _,
      end: p,
      canOpen: I && (!k || Pt(S)),
      canClose: k && (!I || Pt(A)),
      paired: !1
    });
  }
  const h = [];
  let g = 0;
  for (const _ of u) {
    /\n[ \t]*\n/.test(e.slice(g, _.start)) && (h.length = 0), g = _.end;
    const p = _.canClose ? h.pop() : void 0;
    p ? (p.paired = !0, _.paired = !0) : _.canOpen && h.push(_);
  }
  let f = "", v = 0;
  for (const _ of u)
    _.paired || (f += e.slice(v, _.start) + "\\_".repeat(_.end - _.start), v = _.end);
  return f + e.slice(v);
}, nu = (e) => e.replace(/(^|\n)([ \t]{0,3}(?:\*[ \t]*){3,})(?=\n|$)/g, `$1
$2
`).replace(/(^|\n)([ \t]{0,3}(?:_[ \t]*){3,})(?=\n|$)/g, `$1
$2
`), ru = (e) => e.replace(/~~/g, "\\~\\~"), su = (e) => {
  const t = e.replace(/\r\n?/g, `
`), n = (s) => s.replace(/(\S[ \t]*)\n(?![ \t]*\n)/g, `$1  
`), r = is(t);
  return r.map((s, o) => {
    var c;
    if (s.kind !== "text") return s.value;
    const i = n(s.value);
    return ((c = r[o - 1]) == null ? void 0 : c.kind) !== "span" ? i : i.replace(/^([ \t]*)\n(?![ \t]*\n)/, `$1  
`);
  }).join("");
}, Lr = (...e) => (t, n) => e.reduce((r, s) => s(r, n), t), eo = Lr(
  Zl(
    Lr(
      // A thematic break must fill its whole line; a task-list marker only anchors the start.
      Qs(nu, { anchorsLineEnd: !0 }),
      Jl,
      Qs(Ql),
      ru
    )
  ),
  // Runs last, over the whole text, because it tracks code regions itself.
  tu
), s0 = ({ convertSoftBreaks: e = !1 } = {}) => e ? Lr(su, eo) : eo, Wi = typeof navigator < "u" && navigator.product === "ReactNative", ou = (e, t) => {
  for (let n = 0; n < e.length; n++) {
    const r = Wi ? n : e.length - 1 - n, s = e[r];
    if (s && t(s) === "stop") return;
  }
}, Or = (e, t) => {
  const n = (r) => !t || t.length === 0 ? !0 : tt(r) && t.includes(r.sendingStatus);
  return Wi ? e.find(n) : e.findLast(n);
}, iu = (e, t) => {
  const n = Or(e, [_sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED]);
  return n && $e.isIncoming(n, t) ? n : void 0;
}, Oe = (e) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
};
function Ae() {
}
function au() {
  const e = typeof navigator < "u" ? navigator.userAgent : "", t = /iPad|iPhone|iPod/.test(e), n = /Android/.test(e);
  return t || n;
}
function cu(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t = (t << 5) - t + e.charCodeAt(n), t |= 0;
  return t.toString(16);
}
const Re = {
  isStreaming(e) {
    return Fl(e.data);
  },
  isExplicitWelcomeMessage(e) {
    var t;
    return ((t = e.extendedMessagePayload) == null ? void 0 : t.bot_message_type) === "welcome";
  },
  isWelcomeMessage(e, t) {
    var r;
    if (Re.isExplicitWelcomeMessage(e)) return !0;
    if (((r = e.extendedMessagePayload) == null ? void 0 : r.bot_message_type) !== void 0 || !ze(e, t)) return !1;
    const n = ss(e.data);
    return !n.isStreaming && !n.hasResponseMetadata;
  },
  isGeneratedMessage(e) {
    var t;
    return ((t = e.extendedMessagePayload) == null ? void 0 : t.bot_message_type) === "generated";
  },
  hasFeedback(e) {
    var t;
    return !!((t = e.extendedMessagePayload) != null && t.feedback);
  }
}, dr = `@${Ut}`, lu = ({ appId: e, aiAgentId: t, storage: n }) => {
  const r = {
    templateBase: `${dr}-template`,
    template: (s) => `${r.templateBase}/templates/${s}`,
    templateToken: () => `${r.templateBase}/tokens`,
    messengerSession: (s) => {
      const o = cu(`${e}/${t}/${s}`);
      return `${dr}-udata/${o}`;
    },
    anonUserSession: () => `${dr}-session/${e}/${t}`
  };
  return {
    template: {
      set: (s, o) => n.set(r.template(s), o),
      get: (s) => n.get(r.template(s)),
      setCachedToken: (s) => n.set(r.templateToken(), s),
      getCachedToken: () => n.get(r.templateToken()),
      clear: () => {
        n.getKeys(r.templateBase).forEach(n.delete);
      }
    },
    messenger: {
      getSettings: (s) => {
        try {
          const o = n.get(r.messengerSession(s));
          return o ? JSON.parse(o) : null;
        } catch {
          return null;
        }
      },
      setSettings: (s, o) => {
        try {
          delete o.auto_created_user;
          const i = JSON.stringify(o);
          n.set(r.messengerSession(s), i);
        } catch {
          return;
        }
      },
      getAnonUser: () => {
        try {
          const s = n.get(r.anonUserSession());
          return s ? JSON.parse(s) : null;
        } catch {
          return null;
        }
      },
      setAnonUser: (s) => {
        try {
          const o = JSON.stringify(s);
          n.set(r.anonUserSession(), o);
        } catch {
          return;
        }
      },
      clear: (s) => {
        try {
          s && n.delete(r.messengerSession(s)), n.delete(r.anonUserSession());
        } catch {
          return;
        }
      }
    }
  };
}, Yi = (e, t, n = {}) => {
  let r = null, s = null, o = null;
  const { leading: i = !0, trailing: c = !0 } = n, l = (...u) => {
    const d = Date.now();
    if (o === null || d - o >= t)
      i ? (e(...u), o = d) : (s = u, o = d);
    else if (s = u, c && !r) {
      const m = t - (d - o);
      r = setTimeout(() => {
        s && c && (e(...s), o = Date.now()), r = null, s = null;
      }, m);
    }
  };
  return l.cancel = () => {
    r && (clearTimeout(r), r = null), s = null, o = null;
  }, l;
}, uu = () => {
  let e = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (e + Math.random() * 16) % 16 | 0;
    return e = Math.floor(e / 16), (t === "x" ? n : n & 3 | 8).toString(16);
  });
};
class du {
  constructor(t) {
    E(this, "_params");
    this._params = {
      aiAgentChannelFilter: (t == null ? void 0 : t.aiAgentChannelFilter) ?? _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .AIAgentChannelFilter.INCLUDE */ .HO.INCLUDE,
      aiAgentConversationStatusFilter: (t == null ? void 0 : t.aiAgentConversationStatusFilter) ?? [
        _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN,
        _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED
      ],
      aiAgentIds: (t == null ? void 0 : t.aiAgentIds) ?? [],
      deskChannelFilter: (t == null ? void 0 : t.deskChannelFilter) ?? _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .DeskChannelFilter.INCLUDE */ .A1.INCLUDE,
      pinnedChannelUrls: (t == null ? void 0 : t.pinnedChannelUrls) ?? [],
      copilotConversationOnly: (t == null ? void 0 : t.copilotConversationOnly) ?? !1,
      copilotSupportChannelUrl: t == null ? void 0 : t.copilotSupportChannelUrl
    };
  }
  get params() {
    return { ...this._params };
  }
  match(t, n) {
    const { pinnedChannelUrls: r, aiAgentChannelFilter: s, aiAgentConversationStatusFilter: o, aiAgentIds: i, deskChannelFilter: c } = this._params;
    return r != null && r.includes(t.url) ? !0 : t.isAIAgent ? !(!t.conversation || s === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .AIAgentChannelFilter.EXCLUDE */ .HO.EXCLUDE || i && i.length > 0 && !i.includes(t.conversation.aiAgentId) || o && o.length > 0 && !o.some((u) => {
      var d;
      return ((d = t.conversation) == null ? void 0 : d.status) === u;
    })) : t.isDesk ? c !== _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .DeskChannelFilter.EXCLUDE */ .A1.EXCLUDE : !1;
  }
}
class qi extends _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__/* .BaseChannelCollection */ .RC {
  constructor(n, r) {
    const s = new du(r.filter), o = n, i = o.aiAgent._manager, c = r.limit ?? 20, l = _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_7__.G.LATEST_LAST_MESSAGE, u = {
      getRemoteChannels: (d, m, h, g) => i.getMyGroupChannels(d, m.params, g),
      changeLogSync: (d) => {
        const {
          aiAgentChannelFilter: m,
          aiAgentIds: h,
          deskChannelFilter: g,
          pinnedChannelUrls: f,
          copilotConversationOnly: v,
          copilotSupportChannelUrl: _
        } = s.params, p = {
          aiAgentChannelFilter: m,
          aiAgentIds: h,
          deskChannelFilter: g,
          pinnedChannelUrls: f,
          copilotConversationOnly: v,
          copilotSupportChannelUrl: _
        };
        return i.getMyGroupChannelChangeLogs(d, p, _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.i.SYNC_CHANNEL_CHANGELOGS);
      }
    };
    super(o.aiAgent._iid, {
      filter: s,
      order: l,
      limit: c,
      syncKeyPrefix: "aiAgent",
      fetcher: u
    });
    E(this, "_params");
    E(this, "_sdk");
    E(this, "_throttledOnChannelChanged");
    E(this, "_key");
    E(this, "_pendingChannels", []);
    this._sdk = n, this._params = r, this._key = `clc-${uu()}`, this._throttledOnChannelChanged = Yi(
      () => {
        var g;
        const d = [...this._pendingChannels];
        this._pendingChannels = [];
        const m = /* @__PURE__ */ new Map();
        for (const { channel: f, context: v } of d)
          m.delete(f.url), m.set(f.url, { channel: f, context: v });
        const h = /* @__PURE__ */ new Map();
        for (const { channel: f, context: v } of m.values())
          h.has(v) || h.set(v, /* @__PURE__ */ new Map()), h.get(v).set(f.url, f);
        for (const [f, v] of h) {
          const _ = Array.from(v.values()), p = (g = this._sdk.currentUser) == null ? void 0 : g.userId, y = _.filter((A) => this.filter.match(A, p)), S = _.filter((A) => !this.filter.match(A, p)).map((A) => A.url);
          y.length > 0 && this._base._addChannelsToView(y, f, !1), S.length > 0 && this._removeChannels(S, f);
        }
      },
      250,
      { trailing: !0, leading: !0 }
    ), this._base._subscribeChannelEvent(this._key, {
      onUpdate: (d, m) => {
        for (const h of d)
          this._pendingChannels.push({ channel: h, context: m });
        this._throttledOnChannelChanged();
      },
      onRemove: (d, m) => {
        this._removeChannels(d, m);
      }
    });
  }
  get _base() {
    return this;
  }
  _removeChannels(n, r) {
    const s = new Set(n);
    this._pendingChannels = this._pendingChannels.filter(({ channel: o }) => !s.has(o.url)), this._base._removeChannelsFromView(n, r);
  }
  get channels() {
    var c;
    const n = ((c = this._params.filter) == null ? void 0 : c.pinnedChannelUrls) ?? [], r = [], s = new Map(super.channels.map((l) => [l.url, l])), o = /* @__PURE__ */ new Set();
    for (const l of n) {
      const u = s.get(l);
      u && !o.has(l) && (r.push(u), o.add(l));
    }
    const i = super.channels.filter((l) => !o.has(l.url));
    return [...r, ...i];
  }
  /**
   * Sets the event handler for collection updates.
   * @param handler - Event handler for channel collection changes
   */
  setConversationListCollectionHandler(n) {
    super.setGroupChannelCollectionHandler(n);
  }
  dispose() {
    super.dispose(), this._throttledOnChannelChanged.cancel(), this._base._unsubscribeChannelEvent(this._key);
  }
}
class ji {
  constructor(t) {
    E(this, "subscribers", {});
    this.logger = t;
  }
  async send(t) {
    const n = mu(), r = this.subscribers[t.type];
    if (r) {
      this.logger.debug(`messenger.dispatcher: dispatching command: ${t.type}`, t.payload);
      const s = r.map(
        (o) => o(t.payload)
      );
      await Promise.all(s).catch((o) => {
        this.logger.error(`messenger.dispatcher: error in callback for command: ${t.type}`, o);
      });
    }
    return n.resolve(), n.promise;
  }
  subscribe(t, n) {
    this.subscribers[t] || (this.subscribers[t] = []), this.subscribers[t].push(n);
  }
  unsubscribe(t, n) {
    const r = this.subscribers[t];
    r && (this.subscribers[t] = r.filter((s) => s !== n));
  }
}
const mu = () => {
  let e = Ae, t = Ae;
  return { promise: new Promise((r, s) => {
    e = r, t = s;
  }), resolve: e, reject: t };
};
var qe = /* @__PURE__ */ ((e) => (e.ConversationClose = "conv.close", e.MessengerSettingsUpdated = "messenger.settings.updated", e.ActiveChannelUpdated = "active.channel.updated", e.AnonymousSessionTokenExpired = "anon.token.expired", e.AuthTokenRefreshed = "auth.token.refreshed", e.NudgeMessageReceived = "nudge.message.received", e))(qe || {});
class Yt {
  constructor(t = {}) {
    E(this, "payload");
    this.payload = t;
  }
  toJSON() {
    return JSON.stringify({ type: this.type, payload: this.payload });
  }
}
const Ct = {
  CloseConversation: (e) => new hu(e),
  MessengerSettingsUpdated: (e) => new gu(e),
  ActiveChannelUpdated: (e) => new fu(e),
  AnonymousSessionTokenExpired: () => new pu(),
  AuthTokenRefreshed: () => new _u(),
  NudgeMessageReceived: (e) => new Eu(e)
};
class hu extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "conv.close");
  }
}
class gu extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "messenger.settings.updated");
  }
}
class fu extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "active.channel.updated");
  }
}
class pu extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "anon.token.expired");
  }
}
class _u extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "auth.token.refreshed");
  }
}
class Eu extends Yt {
  constructor() {
    super(...arguments);
    E(this, "type", "nudge.message.received");
  }
}
const qt = (e) => {
  const t = {};
  for (const n of Object.keys(e)) {
    const r = e[n];
    r !== void 0 && (t[n] = String(r));
  }
  return t;
};
class fn {
  constructor(t) {
    E(this, "category", "connection");
    this.userId = t;
  }
  get data() {
    return qt({ user_id: this.userId });
  }
}
class Cu extends fn {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "connection_connected");
  }
}
class vu extends fn {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "connection_reconnect_started");
  }
}
class bu extends fn {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "connection_reconnect_succeeded");
  }
}
class Su extends fn {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "connection_reconnect_failed");
  }
}
class yu extends fn {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "connection_disconnected");
  }
}
class Au {
  constructor(t) {
    E(this, "lastKey", null);
    this.dispatch = t;
  }
  handleEvent({ detail: t, userId: n }) {
    const r = `${t}:${n}`;
    if (this.shouldEmit(r)) {
      this.lastKey = r;
      const s = t === "connected" ? new Cu(n) : t === "reconnectStarted" ? new vu(n) : t === "reconnectSucceeded" ? new bu(n) : t === "reconnectFailed" ? new Su(n) : new yu(n);
      this.dispatch(s);
    }
  }
  // Suppress only consecutive identical (detail, userId); A to B to A still emits.
  shouldEmit(t) {
    return t !== this.lastKey;
  }
}
class as {
  constructor(t, n) {
    E(this, "category", "conversation");
    this.channelUrl = t, this.conversationId = n;
  }
  get data() {
    return qt({ channel_url: this.channelUrl, conversation_id: this.conversationId });
  }
}
class Tu extends as {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "conversation_initialized");
  }
}
class Iu extends as {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "conversation_open");
  }
}
class xu extends as {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "conversation_closed");
  }
}
class Mu {
  constructor(t) {
    E(this, "statusByChannel", /* @__PURE__ */ new Map());
    this.dispatch = t;
  }
  handleEvent({ channel: t }) {
    const { conversation: n } = t;
    if (!n) return;
    const r = this.statusByChannel.get(t.url), s = n.status;
    if (this.statusByChannel.set(t.url, s), this.shouldEmit(r, s)) {
      const o = s === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.INITIALIZED ? new Tu(t.url, n.id) : s === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN ? new Iu(t.url, n.id) : new xu(t.url, n.id);
      this.dispatch(o);
    }
  }
  // Forward transitions only: null to INITIALIZED, INITIALIZED to OPEN, OPEN to CLOSED.
  shouldEmit(t, n) {
    return n === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.INITIALIZED ? t === void 0 : n === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN ? t === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.INITIALIZED : t === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN;
  }
}
const Xi = (e, t) => {
  if (e)
    return e.members.filter((n) => n.userId !== t).sort((n, r) => r.joinedAt - n.joinedAt)[0];
}, He = (e) => {
  var t, n;
  return !!(e != null && e.isAIAgent && ((t = e == null ? void 0 : e.conversation) == null ? void 0 : t.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED || e != null && e.isDesk && ((n = e == null ? void 0 : e.helpdeskInfo) == null ? void 0 : n.ticketStatus) === "closed");
}, cs = (e) => {
  var t, n;
  return !!(e != null && e.isAIAgent && ((t = e == null ? void 0 : e.conversation) == null ? void 0 : t.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN || e != null && e.isDesk && ((n = e == null ? void 0 : e.helpdeskInfo) == null ? void 0 : n.ticketStatus) === "open");
};
function ft(e) {
  var n, r, s;
  return typeof (((n = e == null ? void 0 : e.conversation) == null ? void 0 : n.handedOverAt) ?? ((s = (r = e == null ? void 0 : e.conversation) == null ? void 0 : r.handoff) == null ? void 0 : s.timestamp)) == "number";
}
function Ru(e) {
  var r;
  const t = (r = e == null ? void 0 : e.conversation) == null ? void 0 : r.handoff;
  return t ? typeof t.requestedAt == "number" && !ft(e) : !1;
}
function wu(e) {
  var t;
  if (((t = e == null ? void 0 : e.resolution) == null ? void 0 : t.determinedBy) === "user")
    return e.resolution.isResolved;
}
function Zi(e) {
  return !!e && e <= Date.now();
}
function ku(e) {
  return !e.title;
}
function Lu(e, t) {
  var n;
  if (e)
    return ku(e) ? {
      ...e,
      title: t.title,
      csat_question: t.question,
      csat_scores: [
        {
          label: "",
          image_url: "https://static.dashboard.sendbird.com/assets/ai-agent/angry-active.png"
        },
        {
          label: "",
          image_url: "https://static.dashboard.sendbird.com/assets/ai-agent/suspicious-active.png"
        },
        {
          label: "",
          image_url: "https://static.dashboard.sendbird.com/assets/ai-agent/neutral-active.png"
        },
        {
          label: "",
          image_url: "https://static.dashboard.sendbird.com/assets/ai-agent/smile-active.png"
        },
        {
          label: "",
          image_url: "https://static.dashboard.sendbird.com/assets/ai-agent/happy-active.png"
        }
      ],
      cre: {
        required: ((n = e.cre) == null ? void 0 : n.required) ?? !0,
        question: t.cre.question,
        positive_label: t.cre.positive_label,
        negative_label: t.cre.negative_label
      },
      follow_up: [
        {
          response_type: "free_text",
          scores: [1, 2, 3, 4, 5],
          question: t.followUp.question,
          always_visible: !1
        }
      ],
      csat_submit_label: t.submit_label,
      csat_submitted_label: t.submitted_label
    } : e;
}
class ls {
  constructor(t, n) {
    E(this, "category", "handoff");
    this.channelUrl = t, this.conversationId = n;
  }
  get data() {
    return qt({ channel_url: this.channelUrl, conversation_id: this.conversationId });
  }
}
class Ou extends ls {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "handoff_started");
  }
}
class Nu extends ls {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "handoff_succeeded");
  }
}
class Du extends ls {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "handoff_failed");
  }
}
class $u {
  constructor(t) {
    E(this, "statusByChannel", /* @__PURE__ */ new Map());
    this.dispatch = t;
  }
  handleEvent({ channel: t }) {
    const n = !this.statusByChannel.has(t.url);
    n && this.statusByChannel.set(t.url, void 0);
    const r = t.conversation;
    if (!r || !r.handoff || n) return;
    const s = this.statusByChannel.get(t.url), o = this.resolveStatus(t, r);
    if (o !== void 0 && this.shouldEmit(s, o)) {
      this.statusByChannel.set(t.url, o);
      const i = o === "started" ? new Ou(t.url, r.id) : o === "succeeded" ? new Nu(t.url, r.id) : new Du(t.url, r.id);
      this.dispatch(i);
    }
  }
  resolveStatus(t, n) {
    if (He(t)) return "failed";
    const { members: r } = t;
    if (r.length === 1) return "started";
    if (r.length === 2 && n.aiAgentId && !r.some((s) => s.userId === n.aiAgentId))
      return "succeeded";
  }
  shouldEmit(t, n) {
    return n === "started" ? t === void 0 : t === "started";
  }
}
class Pu {
  constructor(t) {
    E(this, "category", "message");
    E(this, "metricKey", "incoming_message_received");
    E(this, "channelUrl");
    E(this, "messageId");
    E(this, "senderType");
    E(this, "createdAt");
    E(this, "conversationId");
    this.channelUrl = t.channelUrl, this.messageId = t.messageId, this.senderType = t.senderType, this.createdAt = t.createdAt, this.conversationId = t.conversationId;
  }
  get data() {
    return qt({
      channel_url: this.channelUrl,
      message_id: this.messageId,
      sender_type: this.senderType,
      created_at: this.createdAt,
      conversation_id: this.conversationId
    });
  }
}
const Fu = (e, t) => {
  const n = tt(e) ? e.sender.userId : void 0;
  return n === void 0 ? "system" : n === t ? "ai_agent" : "human_agent";
};
class Uu {
  constructor(t, n) {
    this.dispatch = t, this.getCurrentUserId = n;
  }
  handleEvent({ channel: t, message: n }) {
    const { conversation: r } = t;
    this.shouldEmit(n, r) && this.dispatch(
      new Pu({
        channelUrl: t.url,
        messageId: n.messageId,
        senderType: Fu(n, r.aiAgentId),
        createdAt: n.createdAt,
        conversationId: r.id
      })
    );
  }
  // Not sent by the current user (admin/system messages have no sender, so they count as incoming).
  shouldEmit(t, n) {
    return !ze(t, this.getCurrentUserId()) && n !== null;
  }
}
class us {
  constructor(t) {
    E(this, "category", "memory");
    E(this, "action");
    E(this, "deleteOnOff");
    E(this, "userId");
    this.action = t.action, this.deleteOnOff = t.deleteOnOff, this.userId = t.userId;
  }
  get data() {
    return qt({ action: this.action, delete_on_off: this.deleteOnOff, user_id: this.userId });
  }
}
class Bu extends us {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "memory_consent");
  }
}
class Hu extends us {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "memory_on");
  }
}
class Gu extends us {
  constructor() {
    super(...arguments);
    E(this, "metricKey", "memory_off");
  }
}
const Vu = {
  // The consent dialog cannot be dismissed — it blocks the backdrop, Escape and Android back.
  consent: { Metric: Bu, actions: { shown: "shown", confirm: "enable", cancel: "disable" } },
  on: { Metric: Hu, actions: { shown: "shown", confirm: "keep", cancel: "disable", dismiss: "dismiss" } },
  off: { Metric: Gu, actions: { shown: "shown", confirm: "keep", cancel: "enable", dismiss: "dismiss" } }
};
class zu {
  constructor(t, n) {
    this.dispatch = t, this.getCurrentUserId = n;
  }
  handleEvent({ variant: t, action: n, deleteOnOff: r }) {
    if (t === "readonly") return;
    const { Metric: s, actions: o } = Vu[t], i = o[n];
    i && this.dispatch(
      new s({
        action: i,
        // Only the on-dialog's disable button is shaped by this flag (Disable vs Disable & Delete).
        deleteOnOff: t === "on" ? r : void 0,
        userId: this.getCurrentUserId()
      })
    );
  }
}
class Ku {
  constructor(t) {
    E(this, "category", "message");
    E(this, "metricKey");
    E(this, "channelUrl");
    E(this, "requestId");
    E(this, "messageId");
    E(this, "target");
    E(this, "sendingStatus");
    E(this, "createdAt");
    E(this, "conversationId");
    this.channelUrl = t.channelUrl, this.requestId = t.requestId, this.messageId = t.messageId, this.target = t.target, this.sendingStatus = t.sendingStatus, this.createdAt = t.createdAt, this.conversationId = t.conversationId, this.metricKey = `outgoing_message_${t.sendingStatus}`;
  }
  get data() {
    return qt({
      channel_url: this.channelUrl,
      request_id: this.requestId,
      message_id: this.messageId,
      target: this.target,
      created_at: this.createdAt,
      conversation_id: this.conversationId
    });
  }
}
const Wu = (e) => {
  switch (e) {
    case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.PENDING:
      return "pending";
    case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED:
      return "succeeded";
    case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.FAILED:
      return "failed";
    case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SCHEDULED:
      return "scheduled";
    default:
      return;
  }
};
class Yu {
  constructor(t, n) {
    E(this, "statusByReqId", /* @__PURE__ */ new Map());
    this.dispatch = t, this.getCurrentUserId = n;
  }
  handleEvent({ channel: t, message: n }) {
    var o;
    if (!ze(n, this.getCurrentUserId())) return;
    const r = Wu(n.sendingStatus);
    if (r === void 0) return;
    const s = this.statusByReqId.get(n.reqId);
    this.statusByReqId.set(n.reqId, r), r !== "scheduled" && this.shouldEmit(s, r) && this.dispatch(
      new Ku({
        channelUrl: t.url,
        requestId: n.reqId,
        messageId: r === "succeeded" ? n.messageId : void 0,
        target: ft(t) ? "human_agent" : "ai_agent",
        sendingStatus: r,
        createdAt: n.createdAt,
        conversationId: (o = t.conversation) == null ? void 0 : o.id
      })
    );
  }
  // pending: skip if prev pending/succeeded; succeeded: only from pending/scheduled; failed: skip if prev failed.
  shouldEmit(t, n) {
    return n === "pending" ? t !== "pending" && t !== "succeeded" : n === "succeeded" ? t === "pending" || t === "scheduled" : t !== "failed";
  }
}
class qu {
  constructor(t) {
    E(this, "id", "aiagent_livemetric");
    /** Sink for emitted metrics. Set by the owner; metrics are dropped while unset. */
    E(this, "dispatch");
    // Project to the plain public shape: drops internal fields and resolves the
    // non-enumerable `data` getter so the payload survives JSON.stringify/spread.
    E(this, "emit", ({ category: t, metricKey: n, data: r }) => {
      var s;
      (s = this.dispatch) == null || s.call(this, { category: t, metricKey: n, data: r });
    });
    E(this, "emitters");
    this.chatSDK = t;
    const n = () => {
      var r;
      return (r = this.chatSDK.currentUser) == null ? void 0 : r.userId;
    };
    this.emitters = {
      connection: new Au(this.emit),
      conversation: new Mu(this.emit),
      handoff: new $u(this.emit),
      incomingMessage: new Uu(this.emit, n),
      outgoingMessage: new Yu(this.emit, n),
      memory: new zu(this.emit, n)
    };
  }
  start() {
    const t = new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.C({
      onConnected: (r) => this.trackConnection("connected", r),
      onDisconnected: (r) => this.trackConnection("disconnected", r),
      onReconnectStarted: () => this.trackConnection("reconnectStarted"),
      onReconnectSucceeded: () => this.trackConnection("reconnectSucceeded"),
      onReconnectFailed: () => this.trackConnection("reconnectFailed")
    }), n = new _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__/* .GroupChannelHandler */ .pe({
      onMessageReceived: (r, s) => {
        r.isGroupChannel() && this.track({ type: "incomingMessage", channel: r, message: s });
      },
      onChannelChanged: (r) => {
        r.isGroupChannel() && (this.track({ type: "handoff", channel: r }), this.track({ type: "conversation", channel: r }));
      },
      onUserJoined: (r) => this.track({ type: "handoff", channel: r }),
      onUserLeft: (r) => this.track({ type: "handoff", channel: r })
    });
    this.chatSDK.addConnectionHandler(this.id, t), this.chatSDK.groupChannel.addGroupChannelHandler(this.id, n);
  }
  /**
   * Routes a source to its emitter. Also the entry point for externally injected
   * sources (outgoing message status, explicit conversation-initialized, memory dialog).
   */
  track(t) {
    try {
      this.emitters[t.type].handleEvent(t);
    } catch {
    }
  }
  dispose() {
    this.chatSDK.removeConnectionHandler(this.id), this.chatSDK.groupChannel.removeGroupChannelHandler(this.id);
  }
  trackConnection(t, n = ((r) => (r = this.chatSDK.currentUser) == null ? void 0 : r.userId)()) {
    n && this.track({ type: "connection", detail: t, userId: n });
  }
}
var Ji = /* @__PURE__ */ ((e) => (e[e.VERBOSE = 0] = "VERBOSE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.NONE = 5] = "NONE", e))(Ji || {});
class Qi {
  constructor(t) {
    E(this, "level");
    this.level = t;
  }
  verbose(...t) {
    this.level <= 0 && console.log(`[${Ut}/verbose]`, ...t);
  }
  debug(...t) {
    this.level <= 1 && console.log(`[${Ut}/debug]`, ...t);
  }
  info(...t) {
    this.level <= 2 && console.log(`[${Ut}/info]`, ...t);
  }
  warn(...t) {
    this.level <= 3 && console.warn(`[${Ut}/warn]`, ...t);
  }
  error(...t) {
    this.level <= 4 && console.error(`[${Ut}/error]`, ...t);
  }
}
class ju {
  constructor({ userId: t, authToken: n, sessionHandler: r }) {
    E(this, "userId");
    E(this, "authToken");
    E(this, "sessionHandler");
    this.userId = t, this.authToken = n, this.sessionHandler = r;
  }
}
class to {
  constructor() {
    E(this, "userId");
    E(this, "authToken");
    E(this, "sessionHandler");
  }
}
const Xu = (e) => ({
  onSessionTokenRequired: (t) => {
    t(null), e.send(Ct.AnonymousSessionTokenExpired());
  }
}), ds = (e) => Object.fromEntries(Object.entries(e).filter(([, t]) => t != null)), Zu = "ai_agent:stats", ms = "ai_agent:assertion", Ju = "conversation_initial_render", Qu = "conversation_not_interactive_timeout", ed = "recovery_not_interactive_timeout", td = "conversation_list_initial_render", nd = "message_pending_stuck", rd = "aiev_auth_expired_unhandled", sd = "user_perceived_response_time", od = "stream_stalled", id = "ai_typing_indicator_absent_timeout", ad = "rendered_content_unusable", cd = "streaming_message_validation", ld = "duplicate_message_response", ud = "message_lifecycle_event", dd = 800220;
var Q = /* @__PURE__ */ ((e) => (e.ACK_TO_FIRST_CHUNK = "ack_to_first_chunk_ms", e.AFTER_TPEN_ABSENT = "after_tpen_absent_ms", e.AUTH = "auth_duration_ms", e.BEFORE_TPST_ABSENT = "before_tpst_absent_ms", e.FIRST_CHUNK_TO_RENDER = "first_chunk_to_render_ms", e.GET_CHANNEL = "get_channel_duration_ms", e.GET_LIST = "get_list_duration_ms", e.GET_MESSAGES = "get_messages_duration_ms", e.PAGE_RENDER = "page_render_duration_ms", e.PAGE_RENDER_FROM_CACHE = "total_duration_from_cache_ms", e.SEND_TO_ACK = "send_to_ack_ms", e.TIMEOUT = "timeout_ms", e))(Q || {});
const Nr = (e, t) => e.startAt === null || e.endedAt === null || t.startAt === null || t.endedAt === null ? 0 : Math.max(0, Math.min(e.endedAt, t.endedAt) - Math.max(e.startAt, t.startAt)), ea = (e) => typeof e == "object" && e !== null, md = (e) => {
  if (ea(e))
    return typeof e.code == "number" ? e.code : void 0;
}, hd = (e) => e instanceof Error ? e.message : typeof e == "string" ? e : ea(e) && typeof e.message == "string" ? e.message : "";
class Xe {
  constructor() {
    E(this, "timers", /* @__PURE__ */ new Map());
    E(this, "committed", !1);
    E(this, "commitCallback", null);
    E(this, "conversationId", null);
    E(this, "errorCode", null);
    E(this, "errorDescription", null);
    E(this, "extraData", {});
  }
  /** The stat type this metric is collected under; assertion metrics override it. */
  getStatType() {
    return Zu;
  }
  setCommitCallback(t) {
    return this.commitCallback = t, this;
  }
  setConversationId(t) {
    return t && (this.conversationId = t), this;
  }
  setError(t) {
    return t == null ? this : (this.errorCode = md(t) ?? dd, this.errorDescription = hd(t), this);
  }
  setExtra(t, n) {
    return n != null && (this.extraData[t] = n), this;
  }
  startTimer(t) {
    if (this.committed) return this;
    const n = this.timers.get(t);
    return (n == null ? void 0 : n.startTime) !== null && (n == null ? void 0 : n.startTime) !== void 0 ? this : (this.timers.set(t, { startTime: performance.now(), endTime: null }), this);
  }
  stopTimer(t) {
    if (this.committed) return this;
    const n = this.timers.get(t);
    return !n || n.startTime === null || n.endTime !== null ? this : (this.timers.set(t, { ...n, endTime: performance.now() }), this);
  }
  getTimer(t) {
    const n = this.timers.get(t);
    return !n || n.startTime === null ? { startAt: null, endedAt: null, duration: null } : {
      startAt: n.startTime,
      endedAt: n.endTime,
      duration: n.endTime === null ? null : n.endTime - n.startTime
    };
  }
  createPayload(t, n) {
    const r = {
      key: this.getMetricKey(),
      value: String(t)
    }, s = (n == null ? void 0 : n.conversationId) ?? this.conversationId ?? void 0;
    s !== void 0 && (r.conversation_id = s), this.errorCode !== null && (r.error_code = this.errorCode, r.error_description = this.errorDescription ?? "");
    const o = ds({
      ...this.extraData,
      ...n == null ? void 0 : n.extra
    });
    return Object.keys(o).length > 0 && (r.extra = o), r;
  }
  isCommitted() {
    return this.committed;
  }
  /** Consume without emitting: the metric counts as committed for once-per-session gating. */
  discard() {
    this.committed = !0;
  }
  commit() {
    if (this.committed || !this.commitCallback)
      return !1;
    const t = this.buildPayload();
    return t ? (this.committed = !0, this.commitCallback(this.getStatType(), t)) : !1;
  }
}
class no extends Xe {
  constructor() {
    super(...arguments);
    E(this, "reason");
    E(this, "aiAgentId");
  }
  setReason(n) {
    return this.reason = n, this;
  }
  setAIAgentId(n) {
    return this.aiAgentId = n, this;
  }
  getMetricKey() {
    return rd;
  }
  buildPayload() {
    return this.reason === void 0 || this.aiAgentId === void 0 ? null : this.createPayload(this.reason, {
      extra: { agent_id: this.aiAgentId }
    });
  }
}
class jt {
  constructor(t) {
    E(this, "commitCallback");
    this.commitCallback = t;
  }
}
class Nt extends jt {
  constructor() {
    super(...arguments);
    E(this, "records", /* @__PURE__ */ new Map());
  }
}
class ta extends jt {
  constructor() {
    super(...arguments);
    E(this, "activeSpan", null);
    // Screen visibility is cross-attempt state (it outlives supersessions), so the
    // tracker owns it and stamps it into each new span, like presentMethod.
    E(this, "visible", !0);
  }
  setVisible(n) {
    var r;
    this.visible = n, (r = this.activeSpan) == null || r.onVisibilityChanged(n);
  }
}
class hs {
  constructor(t, n) {
    E(this, "stats");
    E(this, "visible");
    E(this, "completedHidden", !1);
    this.stats = t, this.visible = n;
  }
  get isRecording() {
    return this.stats !== null && !this.stats.isCommitted();
  }
  onVisibilityChanged(t) {
    this.stats && (this.visible = t, t && this.completedHidden && (this.stats.commit(), this.stats = null));
  }
  /** Commit now when the screen is visible; otherwise hold the frozen measurement until it becomes visible. */
  commitOrDefer() {
    if (this.stats) {
      if (!this.visible) {
        this.completedHidden = !0;
        return;
      }
      this.stats.commit(), this.stats = null;
    }
  }
  cancel() {
    this.stats = null;
  }
}
const Mt = (e, t) => !(e && t && e !== t), Dr = (e, t) => {
  for (const n of e)
    if (n.measure.userMessageId === void 0 && Mt(n.measure.channelUrl, t))
      return !0;
  return !1;
}, pn = (e, t) => {
  if (e.size < t) return;
  const n = e.keys().next();
  n.done || e.delete(n.value);
};
class gd extends jt {
  onPayloadParseFailed(t) {
    new no().setReason("payload_parse_failed").setAIAgentId(t.aiAgentId).setCommitCallback(this.commitCallback).commit();
  }
  onCallbackNotFound(t) {
    new no().setReason("callback_not_found").setAIAgentId(t.aiAgentId).setCommitCallback(this.commitCallback).commit();
  }
  clear() {
  }
}
class fd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "channelUrl", null);
    E(this, "presentMethod", "direct_present");
  }
  setChannelUrl(n) {
    return this.channelUrl = n, this;
  }
  setPresentMethod(n) {
    return this.presentMethod = n, this;
  }
  resetPageRenderSpan() {
    return this.timers.delete(Q.PAGE_RENDER), this.timers.delete(Q.PAGE_RENDER_FROM_CACHE), this.timers.delete(Q.GET_CHANNEL), this.timers.delete(Q.GET_MESSAGES), this.conversationId = null, this.channelUrl = null, this.errorCode = null, this.errorDescription = null, this;
  }
  getMetricKey() {
    return Ju;
  }
  buildPayload() {
    const n = this.getTimer(Q.AUTH), r = this.getTimer(Q.PAGE_RENDER), s = this.getTimer(Q.PAGE_RENDER_FROM_CACHE);
    if (r.duration === null && (this.errorCode === null || n.duration === null)) return null;
    const o = r.duration === null ? 0 : r.duration - Nr(n, r), i = s.duration === null ? null : s.duration - Nr(n, s);
    return this.createPayload((n.duration ?? 0) + o, {
      extra: {
        channel_url: this.channelUrl,
        present_method: this.presentMethod,
        [Q.AUTH]: n.duration,
        [Q.GET_CHANNEL]: this.getTimer(Q.GET_CHANNEL).duration,
        [Q.GET_MESSAGES]: this.getTimer(Q.GET_MESSAGES).duration,
        [Q.PAGE_RENDER_FROM_CACHE]: i
      }
    });
  }
}
class pd extends hs {
  constructor(n, r, s) {
    var o;
    super(n, s);
    E(this, "measure");
    this.measure = { channelUrl: r, pageRenderState: "initialized" }, (o = this.stats) == null || o.setChannelUrl(r).startTimer(Q.PAGE_RENDER).startTimer(Q.PAGE_RENDER_FROM_CACHE);
  }
  onGetChannelStart(n) {
    !this.stats || n !== this.measure.channelUrl || this.measure.pageRenderState !== "initialized" || (this.stats.startTimer(Q.GET_CHANNEL), this.measure.pageRenderState = "channel_fetching");
  }
  onGetChannelComplete(n, r) {
    !this.stats || n !== this.measure.channelUrl || this.measure.pageRenderState !== "channel_fetching" || (this.stats.stopTimer(Q.GET_CHANNEL).setConversationId(r), this.measure.pageRenderState = "channel_fetched");
  }
  onGetChannelError(n, r) {
    !this.stats || n !== this.measure.channelUrl || this.measure.pageRenderState !== "channel_fetching" || (this.stats.stopTimer(Q.GET_CHANNEL).setError(r).stopTimer(Q.PAGE_RENDER), this.measure.pageRenderState = "channel_failed", this.tryFinalize());
  }
  onGetMessagesStart() {
    !this.stats || this.measure.pageRenderState !== "channel_fetched" || (this.stats.startTimer(Q.GET_MESSAGES), this.measure.pageRenderState = "messages_fetching");
  }
  onGetMessagesCacheComplete(n, r) {
    !this.stats || n !== this.measure.channelUrl || r || this.measure.pageRenderState !== "messages_fetching" || this.stats.stopTimer(Q.PAGE_RENDER_FROM_CACHE);
  }
  onGetMessagesComplete(n, r) {
    !this.stats || n !== this.measure.channelUrl || this.measure.pageRenderState !== "messages_fetching" || (this.stats.stopTimer(Q.GET_MESSAGES).setError(r), this.measure.pageRenderState = "messages_fetching_completed");
  }
  onRendered() {
    !this.stats || this.measure.pageRenderState !== "messages_fetching_completed" || (this.stats.stopTimer(Q.PAGE_RENDER), this.tryFinalize());
  }
  onRenderDiscarded() {
    !this.stats || this.measure.pageRenderState !== "messages_fetching_completed" || (this.stats.discard(), this.stats = null);
  }
  /** Auth settled while this span was measuring; a finalize that waited on in-flight auth can proceed. */
  onAuthSettled() {
    this.tryFinalize();
  }
  /** Commit once both facts exist: the page render ended (render or failure) and auth is not in flight. */
  tryFinalize() {
    if (!this.stats || this.stats.getTimer(Q.PAGE_RENDER).endedAt === null) return;
    const n = this.stats.getTimer(Q.AUTH);
    if (!(n.startAt !== null && n.endedAt === null)) {
      if (this.measure.pageRenderState === "channel_failed") {
        this.stats.commit(), this.stats = null;
        return;
      }
      this.commitOrDefer();
    }
  }
}
class _d extends ta {
  constructor() {
    super(...arguments);
    E(this, "stats", null);
    E(this, "authState", "idle");
    E(this, "presentMethod", "direct_present");
  }
  getOrCreateStats() {
    var n;
    return (n = this.stats) != null && n.isCommitted() ? null : (this.stats || (this.stats = new fd().setCommitCallback(this.commitCallback).setPresentMethod(this.presentMethod)), this.stats);
  }
  getActiveStats() {
    return !this.stats || this.stats.isCommitted() ? null : this.stats;
  }
  setPresentMethod(n) {
    var r;
    this.presentMethod = n, (r = this.getActiveStats()) == null || r.setPresentMethod(n);
  }
  onAuthStart() {
    var n, r;
    if ((n = this.stats) != null && n.isCommitted()) {
      if (this.authState !== "failed" || this.activeSpan !== null) return;
      this.stats = null, this.authState = "idle";
    }
    this.authState === "idle" && (this.authState = "in_progress", (r = this.getOrCreateStats()) == null || r.startTimer(Q.AUTH));
  }
  onAuthComplete() {
    var n, r;
    this.authState === "in_progress" && (this.authState = "completed", (n = this.getActiveStats()) == null || n.stopTimer(Q.AUTH)), (r = this.activeSpan) == null || r.onAuthSettled();
  }
  onAuthError(n) {
    var r, s;
    this.authState === "in_progress" && (this.authState = "failed", (r = this.getActiveStats()) == null || r.stopTimer(Q.AUTH).setError(n).commit(), (s = this.activeSpan) == null || s.cancel());
  }
  startSpan(n) {
    const r = this.activeSpan;
    r == null || r.cancel();
    const s = this.getOrCreateStats();
    return s && r && s.resetPageRenderSpan(), this.activeSpan = new pd(s, n, this.visible), this.activeSpan;
  }
  clear() {
    var n;
    (n = this.activeSpan) == null || n.cancel(), this.activeSpan = null, this.stats = null, this.authState = "idle";
  }
}
class Ed extends Xe {
  constructor() {
    super(...arguments);
    E(this, "presentMethod", "direct_present");
  }
  setPresentMethod(n) {
    return this.presentMethod = n, this;
  }
  resetPageRenderSpan() {
    return this.timers.delete(Q.PAGE_RENDER), this.timers.delete(Q.GET_LIST), this.errorCode = null, this.errorDescription = null, this;
  }
  getMetricKey() {
    return td;
  }
  buildPayload() {
    const n = this.getTimer(Q.AUTH), r = this.getTimer(Q.PAGE_RENDER), s = this.getTimer(Q.GET_LIST).duration;
    if (r.duration === null && (this.errorCode === null || n.duration === null)) return null;
    const o = r.duration === null ? 0 : r.duration - Nr(n, r), i = (n.duration ?? 0) + o;
    return this.createPayload(i, {
      extra: {
        present_method: this.presentMethod,
        [Q.AUTH]: n.duration,
        [Q.GET_LIST]: s
      }
    });
  }
}
class Cd extends hs {
  constructor(n, r) {
    var s;
    super(n, r);
    E(this, "measure", { listStarted: !1, listCompleted: !1 });
    (s = this.stats) == null || s.startTimer(Q.PAGE_RENDER);
  }
  onListRequestStart() {
    !this.stats || this.measure.listStarted || (this.stats.startTimer(Q.PAGE_RENDER), this.stats.startTimer(Q.GET_LIST), this.measure.listStarted = !0);
  }
  onListRequestComplete(n) {
    if (!(!this.stats || !this.measure.listStarted || this.measure.listCompleted)) {
      if (n) {
        this.stats.resetPageRenderSpan(), this.measure.listStarted = !1;
        return;
      }
      this.stats.stopTimer(Q.GET_LIST), this.measure.listCompleted = !0;
    }
  }
  onRendered() {
    !this.stats || !this.measure.listCompleted || (this.stats.stopTimer(Q.PAGE_RENDER), this.tryFinalize());
  }
  onRenderDiscarded() {
    !this.stats || !this.measure.listCompleted || (this.stats.discard(), this.stats = null);
  }
  /** Auth settled while this span was measuring; a finalize that waited on in-flight auth can proceed. */
  onAuthSettled() {
    this.tryFinalize();
  }
  /** Commit once both facts exist: the render happened and auth is not in flight. */
  tryFinalize() {
    if (!this.stats || this.stats.getTimer(Q.PAGE_RENDER).endedAt === null) return;
    const n = this.stats.getTimer(Q.AUTH);
    n.startAt !== null && n.endedAt === null || this.commitOrDefer();
  }
}
class vd extends ta {
  constructor() {
    super(...arguments);
    E(this, "stats", null);
    E(this, "authState", "idle");
    E(this, "presentMethod", "direct_present");
  }
  getOrCreateStats() {
    var n;
    return (n = this.stats) != null && n.isCommitted() ? null : (this.stats || (this.stats = new Ed().setCommitCallback(this.commitCallback).setPresentMethod(this.presentMethod)), this.stats);
  }
  getActiveStats() {
    return !this.stats || this.stats.isCommitted() ? null : this.stats;
  }
  setPresentMethod(n) {
    var r;
    this.presentMethod = n, (r = this.getActiveStats()) == null || r.setPresentMethod(n);
  }
  onAuthStart() {
    var n;
    this.authState = "in_progress", (n = this.getOrCreateStats()) == null || n.startTimer(Q.AUTH);
  }
  onAuthComplete() {
    var r, s;
    const n = this.authState === "in_progress";
    this.authState = "completed", n && ((r = this.getActiveStats()) == null || r.stopTimer(Q.AUTH)), (s = this.activeSpan) == null || s.onAuthSettled();
  }
  onAuthError(n) {
    var o;
    const r = this.authState === "in_progress";
    this.authState = "failed";
    const s = this.getActiveStats();
    if (s) {
      if (!((o = this.activeSpan) != null && o.isRecording)) {
        this.stats = null;
        return;
      }
      r && s.stopTimer(Q.AUTH), s.setError(n).commit(), this.activeSpan.cancel();
    }
  }
  startSpan() {
    const n = this.activeSpan;
    n == null || n.cancel();
    const r = this.getOrCreateStats();
    return r && n && r.resetPageRenderSpan(), r && this.authState === "in_progress" && r.startTimer(Q.AUTH), this.activeSpan = new Cd(r, this.visible), this.activeSpan;
  }
  clear() {
    var n;
    (n = this.activeSpan) == null || n.cancel(), this.activeSpan = null, this.stats = null, this.authState = "idle";
  }
}
class bd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "phaseReached", "auth");
    E(this, "historyLoadResult", "pending");
  }
  setHistoryLoadResult(n) {
    return this.historyLoadResult = n, this;
  }
  setPhaseReached(n) {
    return this.phaseReached = n, this;
  }
  getMetricKey() {
    return Qu;
  }
  buildPayload() {
    const n = this.getTimer(Q.TIMEOUT).duration;
    return n === null ? null : this.createPayload(n, {
      extra: {
        outcome: "timeout",
        phase_reached: this.phaseReached,
        history_load_result: this.historyLoadResult
      }
    });
  }
}
class Sd extends Nt {
  start(t) {
    const n = this.getKey(t == null ? void 0 : t.channelUrl);
    this.clearKey(n);
    const r = {
      stats: new bd().setCommitCallback(this.commitCallback).startTimer(Q.TIMEOUT),
      measure: {
        channelUrl: t == null ? void 0 : t.channelUrl,
        historyLoadResult: "pending",
        inputEnabled: !1,
        timer: null
      }
    };
    (t == null ? void 0 : t.conversationId) !== void 0 && r.stats.setConversationId(t.conversationId), r.measure.timer = setTimeout(() => this.commitTimeout(n), 1e4), this.records.set(n, r);
  }
  markChannelJoined(t, n) {
    const r = this.getRecord(n);
    r && (r.stats.setPhaseReached("channel_join"), t !== void 0 && r.stats.setConversationId(t));
  }
  markHistoryLoaded(t, n) {
    const r = this.getRecord(n);
    r && (r.measure.historyLoadResult = t, r.stats.setHistoryLoadResult(t).setPhaseReached("history_load"), this.cancelIfReady(n));
  }
  markInputReady(t) {
    const n = this.getRecord(t);
    n && (n.measure.inputEnabled = !0, n.stats.setPhaseReached("input_enable"), this.cancelIfReady(t));
  }
  markRendered(t) {
    const n = this.getRecord(t);
    n && n.stats.setPhaseReached("render");
  }
  clear() {
    this.records.forEach((t) => {
      t.measure.timer !== null && clearTimeout(t.measure.timer);
    }), this.records.clear();
  }
  clearChannel(t) {
    t !== void 0 && this.clearKey(this.getKey(t));
  }
  clearKey(t) {
    const n = this.records.get(t);
    n && (n.measure.timer !== null && clearTimeout(n.measure.timer), this.records.delete(t));
  }
  cancelIfReady(t) {
    const n = this.getRecord(t);
    !n || !n.measure.inputEnabled || n.measure.historyLoadResult === "pending" || this.clearKey(this.getKey(n.measure.channelUrl));
  }
  commitTimeout(t) {
    const n = this.records.get(t);
    n && (n.measure.timer = null, this.records.delete(t), n.stats.stopTimer(Q.TIMEOUT).commit());
  }
  getRecord(t) {
    return t !== void 0 ? this.records.get(this.getKey(t)) : this.records.size === 1 ? this.records.values().next().value : this.records.get(this.getKey());
  }
  getKey(t) {
    return t ?? "__default__";
  }
}
class yd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "previousMessageId");
    E(this, "nextMessageId");
  }
  setDuplicatePair(n) {
    return this.previousMessageId = n.previousMessageId, this.nextMessageId = n.nextMessageId, this;
  }
  getStatType() {
    return ms;
  }
  getMetricKey() {
    return ld;
  }
  buildPayload() {
    return this.previousMessageId === void 0 || this.nextMessageId === void 0 ? null : this.createPayload("", {
      extra: {
        prev_message_id: String(this.previousMessageId),
        next_message_id: String(this.nextMessageId)
      }
    });
  }
}
const Ad = 500, Td = (e, t) => ze(e, t) && !Re.isStreaming(e) && !!e.message;
class Id extends jt {
  constructor() {
    super(...arguments);
    E(this, "emittedMessageChannels", /* @__PURE__ */ new Map());
  }
  onMessagesChanged(n) {
    const r = this.findLastTwoReplies(n.messages, n.aiAgentUserId);
    r && r.previous.message === r.latest.message && (this.emittedMessageChannels.has(r.latest.messageId) || this.emit(r.latest, r.previous, n));
  }
  clear() {
    this.emittedMessageChannels.clear();
  }
  findLastTwoReplies(n, r) {
    let s = null, o = null;
    return ou(n, (i) => {
      if (!(tt(i) && i.sendingStatus !== _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED) && ze(i, r)) {
        if (!Td(i, r)) return "stop";
        if (!s) s = i;
        else
          return o = i, "stop";
      }
    }), s && o ? { latest: s, previous: o } : null;
  }
  emit(n, r, s) {
    pn(this.emittedMessageChannels, Ad), this.emittedMessageChannels.set(n.messageId, s.channelUrl), new yd().setDuplicatePair({ previousMessageId: r.messageId, nextMessageId: n.messageId }).setConversationId(s.conversationId).setCommitCallback(this.commitCallback).commit();
  }
}
const xd = -1;
class Md extends Xe {
  constructor() {
    super(...arguments);
    E(this, "timestamps");
  }
  /**
   * The order these moments happen in is fixed, but the order they arrive in is not, so every
   * one is stored as it came and the durations between them are left to be derived later.
   */
  setTimestamps(n) {
    return this.timestamps = n, this;
  }
  /** A domain string, never a caught error, so no payload value can leak into the description. */
  setFailure(n) {
    return this.setError(n), this;
  }
  getStatType() {
    return ms;
  }
  getMetricKey() {
    return ud;
  }
  buildPayload() {
    const n = this.timestamps;
    if (!n) return null;
    const r = n.messageSentAt ?? n.streamStartAt, s = n.animationEndAt, o = s === void 0 || r === void 0 ? xd : s - r;
    return this.createPayload(o, {
      extra: {
        message_id: n.messageId === void 0 ? void 0 : String(n.messageId),
        message_sent_at: n.messageSentAt,
        typing_start_at: n.typingStartAt,
        typing_end_at: n.typingEndAt,
        stream_start_at: n.streamStartAt,
        stream_failed_at: n.streamFailedAt,
        last_stream_at: n.lastStreamAt,
        stream_end_at: n.streamEndAt,
        animation_start_at: n.animationStartAt,
        animation_end_at: n.animationEndAt
      }
    });
  }
}
const Rd = 3e4, wd = 1e4, kd = (e) => {
  var t;
  return ((t = e.extendedMessagePayload) == null ? void 0 : t.is_last_in_turn) === !0;
};
class Ld extends hs {
  constructor(n, r) {
    super(n, !0);
    E(this, "measure");
    this.measure = {
      messageSentAt: r.messageSentAt,
      startTimeoutTimer: null,
      stallTimer: null,
      stopBackgroundWatch: r.stopBackgroundWatch
    };
  }
  /** Starts the window the input stays blocked for; a reply that never streams runs it out. */
  armStartTimeout() {
    this.measure.startTimeoutTimer = setTimeout(() => this.failWith("sent_timeout"), Rd);
  }
  setConversationId(n) {
    var r;
    (r = this.stats) == null || r.setConversationId(n);
  }
  onTypingChanged(n) {
    if (this.stats) {
      if (n) {
        this.measure.typingStartAt === void 0 && (this.measure.typingStartAt = Date.now());
        return;
      }
      this.measure.typingStartAt !== void 0 && this.measure.typingEndAt === void 0 && (this.measure.typingEndAt = Date.now());
    }
  }
  /** Latches onto the bubble announcing its stream; nothing else this span sees can be a chunk. */
  onStreamStart(n) {
    this.stats && (this.measure.streamMessageId = n.messageId, this.measure.streamStartAt = Date.now(), this.clearStartTimeout(), this.armStall());
  }
  onStreamFrame(n, r) {
    if (!this.stats) return;
    const s = Date.now();
    if (r && (this.measure.lastStreamAt = s), Re.isStreaming(n)) return this.armStall();
    this.measure.streamEndAt = s, this.clearStall(), this.measure.animationStartAt === void 0 && this.failWith("animation_not_started");
  }
  onAnimationStart() {
    this.stats && this.measure.animationStartAt === void 0 && (this.measure.animationStartAt = Date.now());
  }
  onAnimationComplete(n) {
    if (this.stats) {
      if (!n) return this.cancel();
      this.settle({ animationEndAt: Date.now() });
    }
  }
  cancel() {
    var n, r;
    this.clearTimers(), (r = (n = this.measure).stopBackgroundWatch) == null || r.call(n), super.cancel();
  }
  failWith(n) {
    if (this.stats) {
      if (this.stats.setFailure(n), n !== "stream_failed") return this.settle({});
      this.settle(
        this.measure.lastStreamAt === void 0 ? { streamFailedAt: Date.now(), streamStartAt: void 0 } : { streamFailedAt: Date.now(), lastStreamAt: this.measure.lastStreamAt }
      );
    }
  }
  settle(n) {
    var r, s;
    if (this.stats) {
      if (this.clearTimers(), (s = (r = this.measure).stopBackgroundWatch) != null && s.call(r)) return super.cancel();
      this.stats.setTimestamps({
        messageId: this.measure.streamMessageId,
        messageSentAt: this.measure.messageSentAt,
        typingStartAt: this.measure.typingStartAt,
        typingEndAt: this.measure.typingEndAt,
        streamStartAt: this.measure.streamStartAt,
        streamEndAt: this.measure.streamEndAt,
        animationStartAt: this.measure.animationStartAt,
        ...n
      }), this.commitOrDefer();
    }
  }
  armStall() {
    this.clearStall(), this.measure.stallTimer = setTimeout(() => this.failWith("stream_failed"), wd);
  }
  clearTimers() {
    this.clearStartTimeout(), this.clearStall();
  }
  clearStartTimeout() {
    this.measure.startTimeoutTimer !== null && clearTimeout(this.measure.startTimeoutTimer), this.measure.startTimeoutTimer = null;
  }
  clearStall() {
    this.measure.stallTimer !== null && clearTimeout(this.measure.stallTimer), this.measure.stallTimer = null;
  }
}
class Od extends jt {
  constructor() {
    super(...arguments);
    E(this, "block", null);
    E(this, "watchBackgrounded");
  }
  setBackgroundedWatcher(n) {
    this.watchBackgrounded = n;
  }
  /** Opens a block for the message the user just got acknowledged. */
  onUserMessageSent(n) {
    this.discardBlock();
    const r = this.createSpan(n.conversationId, { messageSentAt: Date.now() });
    r.armStartTimeout(), this.block = {
      channelUrl: n.channelUrl,
      userMessageId: n.messageId,
      conversationId: n.conversationId,
      first: r,
      firstAnnounced: !1,
      spans: /* @__PURE__ */ new Map(),
      closed: !1
    };
  }
  /**
   * The conversation is initialized after the channel is exposed, so a block can open before
   * its id exists — including for a turn that only ever commits on a timeout, which no later
   * event would reach. The setter keeps the first real id it is given.
   */
  onConversationIdResolved(n) {
    const r = this.blockFor(n.channelUrl);
    r && (r.conversationId ?? (r.conversationId = n.conversationId), r.first.setConversationId(n.conversationId), r.spans.forEach((s) => s.setConversationId(n.conversationId)));
  }
  onTypingChanged(n) {
    var r;
    (r = this.blockFor(n.channelUrl)) == null || r.first.onTypingChanged(n.isAgentTyping);
  }
  onCollectionEvent(n) {
    const r = this.blockFor(n.channelUrl), s = n.event;
    if (!r || s.channelUrl !== n.channelUrl) return;
    if (s.kind === "messagesDeleted") {
      s.messages.forEach((i) => {
        var c;
        return (c = r.spans.get(i.messageId)) == null ? void 0 : c.cancel();
      });
      return;
    }
    if (s.kind === "initialized") return;
    const o = s.source === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_UPDATED;
    s.messages.forEach((i) => {
      ze(i, n.aiAgentUserId) && ss(i.data).userMessageId === r.userMessageId && this.observeReply(r, i, o);
    });
  }
  onAnimationStart(n) {
    var r, s;
    (s = (r = this.block) == null ? void 0 : r.spans.get(n.messageId)) == null || s.onAnimationStart();
  }
  onAnimationComplete(n) {
    var r, s;
    (s = (r = this.block) == null ? void 0 : r.spans.get(n.messageId)) == null || s.onAnimationComplete(n.completed);
  }
  /** The conversation going away leaves the turn unfinished, so nothing is reported. */
  clearChannel(n) {
    !n || !this.blockFor(n) || this.discardBlock();
  }
  clear() {
    this.discardBlock();
  }
  observeReply(n, r, s) {
    const o = Re.isStreaming(r);
    kd(r) && (n.lastMessageId = r.messageId);
    const i = n.lastMessageId === r.messageId && !o, c = n.spans.get(r.messageId);
    if (c) {
      c.onStreamFrame(r, s), i && (n.closed = !0);
      return;
    }
    if (n.closed) return;
    if (!o) {
      n.firstAnnounced || n.first.cancel(), n.firstAnnounced = !0, i && (n.closed = !0);
      return;
    }
    const l = n.firstAnnounced ? this.createSpan(n.conversationId, {}) : n.first;
    n.firstAnnounced = !0, l.onStreamStart(r), n.spans.set(r.messageId, l);
  }
  createSpan(n, r) {
    var o;
    const s = new Md().setConversationId(n).setCommitCallback(this.commitCallback);
    return new Ld(s, {
      messageSentAt: r.messageSentAt,
      stopBackgroundWatch: ((o = this.watchBackgrounded) == null ? void 0 : o.call(this)) ?? null
    });
  }
  discardBlock() {
    const n = this.block;
    n && (n.first.cancel(), n.spans.forEach((r) => r.cancel()), this.block = null);
  }
  /** The open block, only when it belongs to the channel in hand. */
  blockFor(n) {
    const r = this.block;
    if (!(!r || r.channelUrl !== n))
      return r;
  }
}
class Nd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "requestId");
    E(this, "messageType");
    E(this, "stuckReason");
  }
  setRequestId(n) {
    return this.requestId = n, this;
  }
  setMessageType(n) {
    return this.messageType = n, this;
  }
  setStuckReason(n) {
    return this.stuckReason = n, this;
  }
  getMetricKey() {
    return nd;
  }
  buildPayload() {
    return this.requestId === void 0 || this.messageType === void 0 || this.stuckReason === void 0 ? null : this.createPayload(this.stuckReason, {
      extra: {
        message_type: this.messageType,
        request_id: this.requestId
      }
    });
  }
}
const Dd = 5e3, ro = 1e4;
class $d extends Nt {
  start(t) {
    if (!t.requestId || this.records.has(t.requestId)) return;
    const n = t.messageType !== "text" && t.tracksUploadProgress === !0, s = {
      stats: new Nd().setRequestId(t.requestId).setMessageType(t.messageType).setStuckReason(n ? "upload_no_progress" : "pending_too_long").setCommitCallback(this.commitCallback),
      measure: {
        channelUrl: t.channelUrl,
        timer: null,
        usesUploadProgress: n
      }
    }, o = n ? ro : Dd;
    s.measure.timer = setTimeout(() => this.detect(t.requestId), o), this.records.set(t.requestId, s);
  }
  resolve(t) {
    this.cancel(t.requestId);
  }
  disappear(t) {
    this.cancel(t.requestId);
  }
  cancel(t) {
    const n = this.records.get(t);
    n && (n.measure.timer !== null && clearTimeout(n.measure.timer), this.records.delete(t));
  }
  markUploadProgress(t) {
    const n = this.records.get(t);
    n && n.measure.usesUploadProgress && (n.measure.timer !== null && clearTimeout(n.measure.timer), n.measure.timer = setTimeout(() => this.detect(t), ro));
  }
  clear() {
    this.records.forEach((t) => {
      t.measure.timer !== null && clearTimeout(t.measure.timer);
    }), this.records.clear();
  }
  clearChannel(t) {
    t && this.records.forEach((n, r) => {
      n.measure.channelUrl === t && (n.measure.timer !== null && clearTimeout(n.measure.timer), this.records.delete(r));
    });
  }
  detect(t) {
    const n = this.records.get(t);
    n && (this.records.delete(t), n.stats.commit());
  }
}
class mr extends Xe {
  constructor() {
    super(...arguments);
    E(this, "triggerType");
  }
  setTriggerType(n) {
    return this.triggerType = n, this;
  }
  getMetricKey() {
    return ed;
  }
  buildPayload() {
    const n = this.getTimer(Q.TIMEOUT).duration;
    return n === null || this.triggerType === void 0 ? null : this.createPayload(n, {
      extra: {
        trigger_type: this.triggerType
      }
    });
  }
}
class Pd extends Nt {
  start(t, n) {
    const r = this.getKey(n);
    let s = this.records.get(r);
    s != null && s.measure.started || s != null && s.measure.inputEnabled || (s || (s = this.createRecord(!1)), s.measure.started = !0, s.stats = new mr().setTriggerType(t).setCommitCallback(this.commitCallback).startTimer(Q.TIMEOUT), s.measure.timer = setTimeout(() => this.commitTimeout(r), 1e4), this.records.set(r, s));
  }
  setInputEnabled(t, n) {
    const r = this.getKey(n);
    let s = this.records.get(r);
    if (!s) {
      if (!t) return;
      s = this.createRecord(t), this.records.set(r, s);
      return;
    }
    s.measure.inputEnabled = t, t ? this.cancelRecord(s) : s.measure.started || this.records.delete(r);
  }
  cancelPending(t) {
    const n = this.getKey(t), r = this.records.get(n);
    r && (this.cancelRecord(r), r.measure.inputEnabled || this.records.delete(n));
  }
  clear() {
    this.records.forEach((t) => {
      t.measure.timer !== null && clearTimeout(t.measure.timer);
    }), this.records.clear();
  }
  clearChannel(t) {
    t !== void 0 && this.clearKey(this.getKey(t));
  }
  clearKey(t) {
    const n = this.records.get(t);
    n && (n.measure.timer !== null && clearTimeout(n.measure.timer), this.records.delete(t));
  }
  commitTimeout(t) {
    const n = this.records.get(t);
    if (!(!n || !n.measure.started)) {
      if (n.measure.inputEnabled) {
        this.cancelRecord(n);
        return;
      }
      n.stats.stopTimer(Q.TIMEOUT), this.records.delete(t), n.stats.commit();
    }
  }
  cancelRecord(t) {
    t.measure.timer !== null && clearTimeout(t.measure.timer), t.measure.timer = null, t.measure.started = !1, t.stats = new mr().setCommitCallback(this.commitCallback);
  }
  createRecord(t) {
    return {
      stats: new mr().setCommitCallback(this.commitCallback),
      measure: {
        inputEnabled: t,
        started: !1,
        timer: null
      }
    };
  }
  getKey(t) {
    return t ?? "__default__";
  }
}
class Fd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "messageId");
    E(this, "contentKind");
    E(this, "errorDomain");
  }
  setMessageId(n) {
    return this.messageId = n, this;
  }
  setContentKind(n) {
    return this.contentKind = n, this;
  }
  setErrorDomain(n) {
    return this.errorDomain = n, this;
  }
  getMetricKey() {
    return ad;
  }
  buildPayload() {
    return this.messageId === void 0 || this.contentKind === void 0 || this.errorDomain === void 0 ? null : this.createPayload(this.errorDomain, {
      extra: {
        content_kind: this.contentKind,
        message_id: String(this.messageId)
      }
    });
  }
}
const Ud = 500;
class Bd extends jt {
  constructor() {
    super(...arguments);
    E(this, "measure", {
      committed: /* @__PURE__ */ new Set()
    });
  }
  commit(n) {
    const r = `${n.messageId}:${n.contentKind}:${n.errorDomain}`;
    if (this.measure.committed.has(r)) return;
    pn(this.measure.committed, Ud), this.measure.committed.add(r), new Fd().setMessageId(n.messageId).setContentKind(n.contentKind).setErrorDomain(n.errorDomain).setError(n.error ? { code: n.error.code, message: n.errorDomain } : void 0).setCommitCallback(this.commitCallback).commit();
  }
  clear() {
    this.measure.committed.clear();
  }
}
class Hd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "durationMs");
    E(this, "messageId");
    E(this, "stallKind");
  }
  setMessageId(n) {
    return this.messageId = n, this;
  }
  setStall(n) {
    return this.durationMs = n.durationMs, this.stallKind = n.stallKind, this;
  }
  getMetricKey() {
    return od;
  }
  buildPayload() {
    return this.durationMs === void 0 || this.messageId === void 0 || this.stallKind === void 0 ? null : this.createPayload(this.durationMs, {
      extra: {
        message_id: String(this.messageId),
        stall_kind: this.stallKind
      }
    });
  }
}
const so = 1e4, Ft = 5e3, Gd = 500;
class Vd extends Nt {
  constructor() {
    super(...arguments);
    E(this, "emittedMessageChannels", /* @__PURE__ */ new Map());
  }
  markRawProgress(n) {
    if (!n.aiResponse.isStreaming) {
      this.completeDelivery(n.messageId, n.textLength);
      return;
    }
    if (this.emittedMessageChannels.has(n.messageId)) return;
    const r = this.getOrCreate(n.messageId, n.channelUrl), s = r.measure;
    this.markRawProgressForRecord(r, n.textLength, performance.now()) ? (s.deliveryTimer !== null && clearTimeout(s.deliveryTimer), s.deliveryTimer = null, this.scheduleDeliveryStallCheck(n.messageId, r)) : this.scheduleDeliveryStallCheck(n.messageId, r), this.isRenderPending(r) && s.renderTimer === null && (s.lastRenderAt = performance.now(), this.scheduleRenderStallCheck(n.messageId, r, Ft));
  }
  markRenderedProgress(n) {
    const r = this.records.get(n.messageId);
    if (!r) return;
    const s = r.measure;
    if (this.markRenderedProgressForRecord(r, n.displayedLength, performance.now())) {
      if (!this.isRenderPending(r)) {
        if (s.deliveryTimer === null) {
          this.clearRecord(n.messageId, r);
          return;
        }
        s.renderTimer !== null && clearTimeout(s.renderTimer), s.renderTimer = null;
        return;
      }
      this.scheduleRenderStallCheck(n.messageId, r, Ft);
    }
  }
  hasPendingStream(n) {
    return this.records.has(n);
  }
  complete(n) {
    const r = this.records.get(n);
    r && this.clearRecord(n, r);
  }
  // Final stream update: no more raw chunks are coming, so stop delivery-stall
  // tracking. The animation can still be catching up after streaming ends
  // (useStreamingText keeps animating while displayedLength < text.length), so
  // keep the render-stall watch alive until rendered progress reaches the last
  // raw length — otherwise a renderer that freezes mid-catch-up never emits a
  // 'render' stall.
  completeDelivery(n, r) {
    const s = this.records.get(n);
    if (!s) return;
    const o = s.measure;
    if (r > o.lastRawLength && (o.lastRawLength = r, o.lastRawAt = performance.now()), o.deliveryTimer !== null && clearTimeout(o.deliveryTimer), o.deliveryTimer = null, !this.isRenderPending(s)) {
      this.clearRecord(n, s);
      return;
    }
    o.renderTimer === null && (o.lastRenderAt = performance.now(), this.scheduleRenderStallCheck(n, s, Ft));
  }
  clearMessage(n) {
    const r = this.records.get(n);
    r && this.clearRecord(n, r), this.emittedMessageChannels.delete(n);
  }
  clear() {
    this.records.forEach((n) => {
      n.measure.deliveryTimer !== null && clearTimeout(n.measure.deliveryTimer), n.measure.renderTimer !== null && clearTimeout(n.measure.renderTimer);
    }), this.records.clear(), this.emittedMessageChannels.clear();
  }
  clearChannel(n) {
    n && (this.records.forEach((r, s) => {
      r.measure.channelUrl !== n && r.measure.channelUrl !== void 0 || this.clearRecord(s, r);
    }), this.emittedMessageChannels.forEach((r, s) => {
      (r === n || r === void 0) && this.emittedMessageChannels.delete(s);
    }));
  }
  detectDelivery(n) {
    const r = this.records.get(n);
    if (!r) return;
    const s = r.measure;
    s.deliveryTimer = null, s.renderTimer !== null && clearTimeout(s.renderTimer), s.renderTimer = null, this.emit(n, r, "delivery");
  }
  detectRender(n) {
    const r = this.records.get(n);
    if (!r) return;
    const s = r.measure;
    if (s.renderTimer = null, !this.isRenderPending(r)) return;
    const o = performance.now() - s.lastRenderAt;
    if (o < Ft) {
      this.scheduleRenderStallCheck(n, r, Ft - o);
      return;
    }
    const i = performance.now() - s.lastRawAt;
    if (i >= Ft && s.deliveryTimer !== null) {
      const c = so - i;
      if (c > 0) {
        this.scheduleRenderStallCheck(n, r, c);
        return;
      }
    }
    this.emit(n, r, "render");
  }
  scheduleRenderStallCheck(n, r, s) {
    r.measure.renderTimer === null && (r.measure.renderTimer = setTimeout(() => this.detectRender(n), s));
  }
  scheduleDeliveryStallCheck(n, r) {
    r.measure.deliveryTimer === null && (r.measure.deliveryTimer = setTimeout(() => this.detectDelivery(n), so));
  }
  emit(n, r, s) {
    if (this.emittedMessageChannels.has(n)) return;
    const o = performance.now(), i = s === "delivery" ? r.measure.lastRawAt : r.measure.lastRenderAt;
    r.stats.setStall({ stallKind: s, durationMs: o - i }).commit(), this.rememberEmitted(n, r.measure.channelUrl), this.clearRecord(n, r);
  }
  getOrCreate(n, r) {
    const s = this.records.get(n);
    if (s) return s;
    const o = performance.now(), i = {
      stats: new Hd().setMessageId(n).setCommitCallback(this.commitCallback),
      measure: {
        channelUrl: r,
        deliveryTimer: null,
        lastRawAt: o,
        lastRawLength: 0,
        lastRenderAt: o,
        lastRenderedLength: 0,
        renderTimer: null
      }
    };
    return this.records.set(n, i), i;
  }
  rememberEmitted(n, r) {
    this.emittedMessageChannels.has(n) || pn(this.emittedMessageChannels, Gd), this.emittedMessageChannels.set(n, r);
  }
  clearRecord(n, r) {
    r.measure.deliveryTimer !== null && clearTimeout(r.measure.deliveryTimer), r.measure.renderTimer !== null && clearTimeout(r.measure.renderTimer), this.records.delete(n);
  }
  isRenderPending(n) {
    return n.measure.lastRenderedLength < n.measure.lastRawLength;
  }
  markRawProgressForRecord(n, r, s) {
    return r <= n.measure.lastRawLength ? !1 : (n.measure.lastRawLength = r, n.measure.lastRawAt = s, !0);
  }
  markRenderedProgressForRecord(n, r, s) {
    return r <= n.measure.lastRenderedLength ? !1 : (n.measure.lastRenderedLength = r, n.measure.lastRenderAt = s, !0);
  }
}
class zd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "durationMs");
    E(this, "messageId");
    E(this, "chunkIntervalsMs", []);
    E(this, "regenerated", !1);
  }
  setMessageId(n) {
    return this.messageId = n, this;
  }
  setStream(n) {
    return this.durationMs = n.durationMs, this.chunkIntervalsMs = n.chunkIntervalsMs, this.regenerated = n.regenerated, this;
  }
  getStatType() {
    return ms;
  }
  getMetricKey() {
    return cd;
  }
  buildPayload() {
    return this.durationMs === void 0 || this.messageId === void 0 ? null : this.createPayload(this.durationMs, {
      extra: {
        message_id: String(this.messageId),
        chunk_intervals_ms: this.chunkIntervalsMs,
        regenerated: this.regenerated
      }
    });
  }
}
const Kd = -1, Wd = (e) => e === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_RECEIVED || e === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_UPDATED;
class Yd extends Nt {
  constructor() {
    super(...arguments);
    E(this, "watchBackgrounded");
  }
  /** Platform capability used to drop samples that spanned a backgrounding. */
  setBackgroundedWatcher(n) {
    this.watchBackgrounded = n;
  }
  onCollectionEvent(n) {
    const r = n.event;
    if (r.channelUrl !== n.channelUrl) return;
    if (r.kind === "messagesDeleted") {
      r.messages.forEach((o) => {
        const i = this.records.get(o.messageId);
        i && this.drop(o.messageId, i);
      });
      return;
    }
    if (r.kind === "initialized" || !Wd(r.source)) return;
    const s = r.source === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_RECEIVED;
    r.messages.forEach((o) => {
      const i = this.records.get(o.messageId);
      if (!i) {
        s && ze(o, n.aiAgentUserId) && Re.isStreaming(o) && this.start(o, n.channelUrl, n.conversationId);
        return;
      }
      i.measure.channelUrl === n.channelUrl && (i.stats.setConversationId(n.conversationId), this.advance(i, o), Re.isStreaming(o) || this.finish(o.messageId, i));
    });
  }
  clearChannel(n) {
    n && this.records.forEach((r, s) => {
      r.measure.channelUrl === n && this.drop(s, r);
    });
  }
  clear() {
    this.records.forEach((n, r) => this.drop(r, n));
  }
  start(n, r, s) {
    var i;
    this.clearChannel(r);
    const o = performance.now();
    this.records.set(n.messageId, {
      stats: new zd().setMessageId(n.messageId).setConversationId(s).setCommitCallback(this.commitCallback),
      measure: {
        channelUrl: r,
        startedAt: o,
        lastAt: o,
        lastText: n.message,
        chunkIntervalsMs: [],
        regenerated: !1,
        stopBackgroundWatch: ((i = this.watchBackgrounded) == null ? void 0 : i.call(this)) ?? null
      }
    });
  }
  advance(n, r) {
    const s = n.measure, o = r.message;
    if (o === s.lastText) return;
    o.startsWith(s.lastText) || (s.regenerated = !0, s.chunkIntervalsMs.push(Kd));
    const i = performance.now();
    s.chunkIntervalsMs.push(Math.round(i - s.lastAt)), s.lastText = o, s.lastAt = i;
  }
  finish(n, r) {
    var o;
    const s = r.measure;
    this.records.delete(n), !((o = s.stopBackgroundWatch) != null && o.call(s)) && r.stats.setStream({
      durationMs: Math.round(performance.now() - s.startedAt),
      chunkIntervalsMs: s.chunkIntervalsMs,
      regenerated: s.regenerated
    }).commit();
  }
  drop(n, r) {
    var s, o;
    (o = (s = r.measure).stopBackgroundWatch) == null || o.call(s), this.records.delete(n);
  }
}
class qd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "beforeTpstAbsentMs");
    E(this, "afterTpenAbsentMs");
  }
  setBeforeTpstAbsentMs(n) {
    return this.beforeTpstAbsentMs = n, this;
  }
  setAfterTpenAbsentMs(n) {
    return this.afterTpenAbsentMs = n, this;
  }
  getMetricKey() {
    return id;
  }
  buildPayload() {
    return this.beforeTpstAbsentMs === void 0 && this.afterTpenAbsentMs === void 0 ? null : this.createPayload((this.beforeTpstAbsentMs ?? 0) + (this.afterTpenAbsentMs ?? 0), {
      extra: {
        [Q.BEFORE_TPST_ABSENT]: this.beforeTpstAbsentMs,
        [Q.AFTER_TPEN_ABSENT]: this.afterTpenAbsentMs
      }
    });
  }
}
const oo = 3e3, jd = 3e4;
class Xd extends Nt {
  constructor() {
    super(...arguments);
    E(this, "pendingAIResponseStartsByUserMessageId", /* @__PURE__ */ new Map());
  }
  startTurn(n) {
    this.cancelTurn(n.requestId);
    const r = {
      stats: new qd().setCommitCallback(this.commitCallback),
      measure: {
        afterTpenStartedAt: null,
        beforeTpstStartedAt: performance.now(),
        channelUrl: n.channelUrl,
        requestId: n.requestId,
        timer: null
      }
    };
    r.measure.timer = setTimeout(() => this.commitTimeout(r.measure.requestId), jd), this.records.set(n.requestId, r);
  }
  markUserMessageAck(n) {
    const r = this.records.get(n.requestId);
    if (!r) return;
    r.measure.userMessageId = n.messageId;
    const s = this.pendingAIResponseStartsByUserMessageId.get(n.messageId);
    s && (this.pendingAIResponseStartsByUserMessageId.delete(n.messageId), this.applyAIResponseStarted(
      { channelUrl: s.channelUrl, matchesUserMessage: !0, userMessageId: n.messageId },
      s.startedAt
    ));
  }
  replaceTurnRequestId(n, r) {
    if (n === r) return;
    const s = this.records.get(n);
    s && (this.records.delete(n), s.measure.requestId = r, this.records.set(r, s));
  }
  cancelTurn(n) {
    this.cleanupTurn(n);
  }
  markTypingStarted(n) {
    const r = performance.now();
    this.records.forEach((s) => {
      Mt(s.measure.channelUrl, n) && (this.recordAfterTpen(s, r), this.recordBeforeTpst(s, r));
    });
  }
  markTypingEnded(n) {
    const r = performance.now();
    this.records.forEach((s) => {
      Mt(s.measure.channelUrl, n) && (this.recordBeforeTpst(s, r), s.measure.afterTpenStartedAt = r);
    });
  }
  markAIResponseStarted(n = {}) {
    const r = n.channelUrl, s = n.userMessageId, o = s !== void 0, i = performance.now();
    this.applyAIResponseStarted({ channelUrl: r, matchesUserMessage: o, userMessageId: s }, i) || !o || s === void 0 || !Dr(this.records.values(), r) || this.pendingAIResponseStartsByUserMessageId.has(s) || (pn(this.pendingAIResponseStartsByUserMessageId, 100), this.pendingAIResponseStartsByUserMessageId.set(s, { channelUrl: r, startedAt: i }));
  }
  applyAIResponseStarted(n, r) {
    if (!n.matchesUserMessage) {
      const o = this.findSingleTurn(n.channelUrl);
      return o ? (this.completeTurn(o.requestId, o.record, r), !0) : !1;
    }
    let s = !1;
    return this.records.forEach((o) => {
      Mt(o.measure.channelUrl, n.channelUrl) && (n.matchesUserMessage && o.measure.userMessageId !== n.userMessageId || (s = !0, this.completeTurn(o.measure.requestId, o, r)));
    }), s;
  }
  findSingleTurn(n) {
    let r, s = 0;
    return this.records.forEach((o) => {
      Mt(o.measure.channelUrl, n) && (s += 1, !(s > 1) && (r = { requestId: o.measure.requestId, record: o }));
    }), s === 1 ? r : void 0;
  }
  completeTurn(n, r, s) {
    this.recordBeforeTpst(r, s), this.recordAfterTpen(r, s), this.commitIfAbsent(n, r);
  }
  clear() {
    this.records.forEach((n) => {
      n.measure.timer !== null && clearTimeout(n.measure.timer);
    }), this.records.clear(), this.pendingAIResponseStartsByUserMessageId.clear();
  }
  clearChannel(n) {
    n && (this.records.forEach((r) => {
      r.measure.channelUrl === n && this.cleanupTurn(r.measure.requestId);
    }), this.pendingAIResponseStartsByUserMessageId.forEach((r, s) => {
      r.channelUrl === n && this.pendingAIResponseStartsByUserMessageId.delete(s);
    }));
  }
  commitTimeout(n) {
    const r = this.records.get(n);
    if (!r) return;
    const s = performance.now();
    this.recordBeforeTpst(r, s), this.recordAfterTpen(r, s), this.commitIfAbsent(n, r);
  }
  commitIfAbsent(n, r) {
    r.stats.commit(), this.cleanupTurn(n);
  }
  cleanupTurn(n) {
    const r = this.records.get(n);
    r && (r.measure.timer !== null && clearTimeout(r.measure.timer), this.records.delete(n));
  }
  recordBeforeTpst(n, r) {
    if (n.measure.beforeTpstStartedAt === null) return;
    const s = r - n.measure.beforeTpstStartedAt;
    s >= oo && n.stats.setBeforeTpstAbsentMs(s), n.measure.beforeTpstStartedAt = null;
  }
  recordAfterTpen(n, r) {
    if (n.measure.afterTpenStartedAt === null) return;
    const s = r - n.measure.afterTpenStartedAt;
    s >= oo && n.stats.setAfterTpenAbsentMs(s), n.measure.afterTpenStartedAt = null;
  }
}
class Zd extends Xe {
  constructor() {
    super(...arguments);
    E(this, "ackToFirstChunkMs");
    E(this, "firstChunkToRenderMs");
    E(this, "isStreaming");
    E(this, "sendToAckMs");
    E(this, "totalDurationMs");
  }
  setDurations(n) {
    return this.ackToFirstChunkMs = n.ackToFirstChunkMs, this.firstChunkToRenderMs = n.firstChunkToRenderMs, this.isStreaming = n.isStreaming, this.sendToAckMs = n.sendToAckMs, this.totalDurationMs = n.totalDurationMs, this;
  }
  getMetricKey() {
    return sd;
  }
  buildPayload() {
    return this.ackToFirstChunkMs === void 0 || this.firstChunkToRenderMs === void 0 || this.isStreaming === void 0 || this.sendToAckMs === void 0 || this.totalDurationMs === void 0 ? null : this.createPayload(this.totalDurationMs, {
      extra: {
        is_streaming: this.isStreaming,
        [Q.ACK_TO_FIRST_CHUNK]: this.ackToFirstChunkMs,
        [Q.FIRST_CHUNK_TO_RENDER]: this.firstChunkToRenderMs,
        [Q.SEND_TO_ACK]: this.sendToAckMs
      }
    });
  }
}
const Jd = 0.15, Qd = 10, em = (e) => e <= 0 ? !1 : e >= 1 ? !0 : Math.random() < e;
class tm extends Nt {
  constructor(n, r) {
    super(n);
    E(this, "samplingRate");
    E(this, "pendingAIResponseByUserMessageId", /* @__PURE__ */ new Map());
    E(this, "collectedCount", 0);
    this.samplingRate = (r == null ? void 0 : r.samplingRate) ?? Jd;
  }
  startTurn(n) {
    if (this.collectedCount >= Qd || !em(this.samplingRate)) return;
    this.collectedCount += 1;
    const r = {
      stats: new Zd().setCommitCallback(this.commitCallback),
      measure: {
        channelUrl: n.channelUrl,
        requestId: n.requestId,
        startedAt: performance.now()
      }
    };
    this.records.set(n.requestId, r);
  }
  markUserMessageAck(n) {
    const r = this.records.get(n.requestId);
    if (!r) return;
    r.measure.ackAt = performance.now(), r.measure.userMessageId = n.messageId;
    const s = this.pendingAIResponseByUserMessageId.get(n.messageId);
    s && (this.pendingAIResponseByUserMessageId.delete(n.messageId), this.applyAIResponseRaw(r, s));
  }
  replaceTurnRequestId(n, r) {
    if (n === r) return;
    const s = this.records.get(n);
    s && (this.records.delete(n), s.measure.requestId = r, this.records.set(r, s));
  }
  cancelTurn(n) {
    const r = this.records.get(n);
    r && (this.deleteRecord(r), this.collectedCount > 0 && (this.collectedCount -= 1));
  }
  markAIResponseRaw(n) {
    const r = performance.now(), s = n.aiResponse.userMessageId;
    if (s === void 0 && Dr(this.records.values(), n.channelUrl)) return;
    const o = this.findPendingRecord(n.channelUrl, s);
    if (o) {
      this.applyAIResponseRaw(o, { ...n, firstChunkAt: r });
      return;
    }
    s === void 0 || !Dr(this.records.values(), n.channelUrl) || this.bufferAIResponseRaw(
      {
        messageId: n.messageId,
        ...n.channelUrl !== void 0 && { channelUrl: n.channelUrl },
        aiResponse: n.aiResponse,
        firstChunkAt: r
      },
      s
    );
  }
  markAIResponseVisible(n) {
    const r = this.findRecordByAIMessageId(n);
    if (!r) return !1;
    const s = r.measure;
    if (s.ackAt === void 0 || s.firstChunkAt === void 0 || s.userMessageId === void 0)
      return !1;
    const o = performance.now();
    return r.stats.setDurations({
      ackToFirstChunkMs: s.firstChunkAt - s.ackAt,
      firstChunkToRenderMs: o - s.firstChunkAt,
      isStreaming: !!s.isStreaming,
      sendToAckMs: s.ackAt - s.startedAt,
      totalDurationMs: o - s.startedAt
    }).commit(), this.deleteRecord(r), !0;
  }
  hasPendingAIResponse(n) {
    return this.findRecordByAIMessageId(n) !== void 0;
  }
  clearMessage(n) {
    this.pendingAIResponseByUserMessageId.forEach((s, o) => {
      s.messageId === n && this.pendingAIResponseByUserMessageId.delete(o);
    });
    const r = this.findRecordByAIMessageId(n);
    r && (this.deleteRecord(r), this.collectedCount > 0 && (this.collectedCount -= 1));
  }
  clearChannel(n) {
    n && (this.records.forEach((r) => {
      r.measure.channelUrl === n && (this.deleteRecord(r), this.collectedCount > 0 && (this.collectedCount -= 1));
    }), this.pendingAIResponseByUserMessageId.forEach((r, s) => {
      r.channelUrl === n && this.pendingAIResponseByUserMessageId.delete(s);
    }));
  }
  clear() {
    this.records.clear(), this.pendingAIResponseByUserMessageId.clear(), this.collectedCount = 0;
  }
  findRecordByAIMessageId(n) {
    for (const r of this.records.values())
      if (r.measure.aiMessageId === n) return r;
  }
  findPendingRecord(n, r) {
    if (r !== void 0) {
      for (const o of this.records.values())
        if (!(o.measure.ackAt === void 0 || o.measure.firstChunkAt !== void 0) && Mt(o.measure.channelUrl, n) && o.measure.userMessageId === r)
          return o;
      return;
    }
    let s;
    for (const o of this.records.values())
      if (!(o.measure.ackAt === void 0 || o.measure.firstChunkAt !== void 0) && Mt(o.measure.channelUrl, n)) {
        if (s) return;
        s = o;
      }
    return s;
  }
  applyAIResponseRaw(n, r) {
    n.measure.firstChunkAt === void 0 && (n.measure.firstChunkAt = n.measure.ackAt === void 0 ? r.firstChunkAt : Math.max(r.firstChunkAt, n.measure.ackAt), n.measure.aiMessageId = r.messageId, n.measure.channelUrl = n.measure.channelUrl ?? r.channelUrl, n.measure.isStreaming = r.aiResponse.isStreaming);
  }
  bufferAIResponseRaw(n, r) {
    this.pendingAIResponseByUserMessageId.has(r) || (pn(this.pendingAIResponseByUserMessageId, 100), this.pendingAIResponseByUserMessageId.set(r, n));
  }
  deleteRecord(n) {
    this.records.delete(n.measure.requestId), n.measure.userMessageId !== void 0 && this.pendingAIResponseByUserMessageId.delete(n.measure.userMessageId);
  }
}
function nm() {
  let e = null, t = 0;
  const n = (r, s) => {
    if ((e == null ? void 0 : e.key) === r) return e.promise;
    const o = ++t, c = (e ? e.promise.catch(() => {
    }).then(() => s()) : s()).finally(() => {
      (e == null ? void 0 : e.id) === o && (e = null);
    });
    return e = { key: r, id: o, promise: c }, c;
  };
  return n.isPending = () => e !== null, n;
}
const io = {
  isTalkToAgentViewEnabled: !0,
  scrollMode: "auto",
  newMessageIndicatorEnabled: !0,
  senderAvatarEnabled: !0
}, gs = {
  conversation: {
    ...io,
    messageAlertSoundEnabled: !1,
    list: {
      ...io,
      deferredMarkdownElements: []
    },
    header: {
      avatarEnabled: !0
    },
    input: {
      camera: {
        photoEnabled: !0
      },
      gallery: {
        photoEnabled: !0
      },
      fileEnabled: !0
    },
    fileViewer: {
      downloadEnabled: !0
    }
  },
  launcher: {
    unreadBadgeEnabled: !1
  }
}, ao = (e) => e ? {
  conversation: om(e.conversation),
  launcher: rm(e.launcher)
} : gs, rm = (e) => Bt(gs.launcher, e), sm = (e) => {
  if (e.deferredMarkdownElements) return [...e.deferredMarkdownElements];
  const t = [];
  return e.markdownImageRenderMode === "complete-only" && t.push("image"), e.markdownLinkRenderMode === "complete-only" && t.push("link"), t;
}, om = (e) => {
  const t = gs.conversation;
  if (!e) return t;
  const {
    list: n = {},
    header: r = {},
    input: s,
    fileViewer: o = {},
    messageAlertSoundEnabled: i = t.messageAlertSoundEnabled,
    ...c
  } = e, { camera: l = {}, gallery: u = {}, fileEnabled: d = t.input.fileEnabled } = s ?? {}, m = {
    ...Bt(t.list, c, n),
    deferredMarkdownElements: sm(n)
  };
  return {
    ...m,
    messageAlertSoundEnabled: i,
    list: m,
    header: Bt(t.header, r),
    input: {
      camera: Bt(t.input.camera, l),
      gallery: Bt(t.input.gallery, u),
      fileEnabled: d
    },
    fileViewer: Bt(t.fileViewer, o)
  };
}, Bt = (e, ...t) => {
  const n = { ...e };
  for (const r of t) r && Object.assign(n, ds(r));
  return n;
}, im = (e, t) => $r(e, t), $r = (e, t) => {
  if (Object.is(e, t)) return !0;
  if (Array.isArray(e) || Array.isArray(t))
    return Array.isArray(e) && Array.isArray(t) && e.length === t.length && e.every((r, s) => $r(r, t[s]));
  if (!co(e) || !co(t)) return !1;
  const n = Object.keys(e);
  return n.length === Object.keys(t).length && n.every((r) => $r(e[r], t[r]));
}, co = (e) => typeof e == "object" && e !== null, am = (e) => ({
  userId: e.bot_userid,
  profileUrl: e.bot_profile_url,
  nickname: e.bot_nickname,
  replyToFile: e.reply_to_file,
  specialNotice: e.special_notice,
  specialNoticeEnabled: e.is_special_notice_enabled,
  showHandoffButton: e.show_handoff_button ?? !0,
  isMultipleActiveConversationsEnabled: e.is_multiple_active_conversations_enabled ?? !0,
  isUserFeedbackEnabled: e.is_user_feedback_enabled ?? !1,
  isUserFeedbackCommentOptionEnabled: e.is_user_feedback_comment_option_enabled ?? !1
}), cm = (e) => ({
  type: e.image_type || "default_icon",
  imageUrl: e.image_url
}), Pr = (e) => ({
  enabled: e.enabled,
  showIndicator: e.show_indicator,
  toggleAllowed: e.toggle_allowed,
  deleteOnOff: e.delete_on_off,
  consentDialog: e.consent_dialog
});
class lm {
  constructor() {
    E(this, "_channelHandlerId", null);
    E(this, "_connectionHandlerId", null);
    E(this, "_initConversationRequests", /* @__PURE__ */ new Map());
    E(this, "_handleActiveChannelChangedThrottled", null);
    E(this, "_setupChannelHandler", () => {
      const t = Date.now();
      this._channelHandlerId = `aiagent_channel_${t}`, this._connectionHandlerId = `aiagent_connection_${t}`, this._handleActiveChannelChangedThrottled = Yi(
        (s) => {
          var o, i;
          (i = this._session) == null || i._updateActiveChannel({
            url: s.url,
            status: He(s) ? "closed" : "open",
            conversationStatus: (o = s.conversation) == null ? void 0 : o.status
          }), this._logger.debug("AIAgentEventManager: activeChannel updated", s.url);
        },
        250,
        { leading: !0, trailing: !1 }
      );
      const n = new _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__/* .GroupChannelHandler */ .pe({
        onChannelChanged: (s) => {
          var o, i;
          s.isGroupChannel() && s.url === ((o = this._session) == null ? void 0 : o.activeChannel.url) && ((i = this._handleActiveChannelChangedThrottled) == null || i.call(this, s));
        }
      }), r = new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.C({
        onReconnectSucceeded: async () => {
          await this._syncActiveChannelOnReconnect();
        }
      });
      this._chatClient.chatSDK.groupChannel.addGroupChannelHandler(this._channelHandlerId, n), this._chatClient.chatSDK.addConnectionHandler(this._connectionHandlerId, r), this._logger.debug("AIAgentEventManager: handlers registered", {
        channelHandlerId: this._channelHandlerId,
        connectionHandlerId: this._connectionHandlerId
      });
    });
    E(this, "_removeChannelHandler", () => {
      this._channelHandlerId && (this._chatClient.chatSDK.groupChannel.removeGroupChannelHandler(this._channelHandlerId), this._channelHandlerId = null), this._connectionHandlerId && (this._chatClient.chatSDK.removeConnectionHandler(this._connectionHandlerId), this._connectionHandlerId = null), this._handleActiveChannelChangedThrottled && (this._handleActiveChannelChangedThrottled.cancel(), this._handleActiveChannelChangedThrottled = null), this._logger.debug("AIAgentEventManager: handlers removed");
    });
    E(this, "_syncActiveChannelOnReconnect", async () => {
      var n, r, s;
      const t = (n = this._session) == null ? void 0 : n.activeChannel.url;
      if (t)
        try {
          const i = await (await this._chatClient.chatSDK.groupChannel.getChannel(t)).refresh();
          i.url === t && ((s = this._session) == null || s._updateActiveChannel({
            url: i.url,
            status: He(i) ? "closed" : "open",
            conversationStatus: (r = i.conversation) == null ? void 0 : r.status
          }), this._logger.debug("AIAgentEventManager: activeChannel synced on reconnect", i.url));
        } catch (o) {
          this._logger.error("AIAgentEventManager: failed to sync activeChannel on reconnect", o);
        }
    });
    E(this, "_initConversationIfNeeded", (t, n) => {
      if (!t.isAIAgent || t.conversation) return Promise.resolve();
      const r = this._initConversationRequests.get(t.url);
      if (r) return r;
      const s = t.initConversation({ aiAgentId: this.aiAgentId, initialUserMessage: n == null ? void 0 : n.initialUserMessage }).then(() => {
      }).catch((o) => {
        this._logger.warn("AIAgentEventManager: initConversation failed", o);
      }).finally(() => {
        this._initConversationRequests.delete(t.url);
      });
      return this._initConversationRequests.set(t.url, s), s;
    });
    /**
     * Registers a handler for messenger settings updates.
     * This is called twice during authentication:
     * 1. With cached settings (source: 'cache') - for early UI updates
     * 2. With server response (source: 'server') - for final updates
     *
     * @returns Unsubscribe function
     */
    E(this, "onMessengerSettingsUpdated", (t) => (this._dispatcher.subscribe(qe.MessengerSettingsUpdated, t), () => {
      this._dispatcher.unsubscribe(qe.MessengerSettingsUpdated, t);
    }));
    /**
     * Registers a handler for active channel updates.
     * This is called when the active channel status changes (e.g., conversation closed).
     *
     * @returns Unsubscribe function
     */
    E(this, "onActiveChannelUpdated", (t) => (this._dispatcher.subscribe(qe.ActiveChannelUpdated, t), () => {
      this._dispatcher.unsubscribe(qe.ActiveChannelUpdated, t);
    }));
    /**
     * Registers a handler for auth token refresh events.
     * This is called when the session token is refreshed via session handler.
     *
     * @returns Unsubscribe function
     */
    E(this, "onAuthTokenRefreshed", (t) => (this._dispatcher.subscribe(qe.AuthTokenRefreshed, t), () => {
      this._dispatcher.unsubscribe(qe.AuthTokenRefreshed, t);
    }));
    /**
     * Registers a handler for nudge messages.
     * This is called whenever requestNudgeMessage receives a displayable message from the server.
     *
     * @returns Unsubscribe function
     */
    E(this, "onNudgeMessageReceived", (t) => (this._dispatcher.subscribe(qe.NudgeMessageReceived, t), () => {
      this._dispatcher.unsubscribe(qe.NudgeMessageReceived, t);
    }));
  }
}
class um {
  constructor(t) {
    E(this, "_sdkUser");
    E(this, "_userSession");
    E(this, "_dispatcher");
    E(this, "_activeChannel");
    /**
     * Updates the active channel and dispatches ActiveChannelUpdated event.
     * @internal
     */
    E(this, "_updateActiveChannel", (t) => {
      this._activeChannel = t, this._dispatcher.send(
        Ct.ActiveChannelUpdated({
          channelUrl: t.url,
          status: t.status,
          conversationStatus: t.conversationStatus
        })
      );
    });
    /**
     * Updates the auth token when session is refreshed.
     * @internal
     */
    E(this, "_updateAuthToken", (t) => {
      this._userSession.authToken = t, this._dispatcher.send(Ct.AuthTokenRefreshed());
    });
    this._sdkUser = t.sdkUser, this._userSession = t.userSession, this._dispatcher = t.dispatcher, this._activeChannel = t.activeChannel;
  }
  /**
   * The authenticated Sendbird user.
   */
  get sdkUser() {
    return this._sdkUser;
  }
  /**
   * The current user session containing userId and authToken.
   */
  get userSession() {
    return this._userSession;
  }
  /**
   * The currently active channel.
   */
  get activeChannel() {
    return this._activeChannel;
  }
}
const na = (e) => {
  try {
    const t = JSON.parse(e);
    return typeof t == "string" ? JSON.stringify(t).slice(1, -1) : e.trim();
  } catch {
    return JSON.stringify(e).slice(1, -1);
  }
}, dm = (e) => JSON.parse(e), o0 = (e) => JSON.parse(e);
function i0(e, t) {
  const [n, r] = t.split(",").map((s) => s.trim());
  return e === "dark" && r || n;
}
function a0(e) {
  const t = {};
  function n(r, s = "") {
    for (const [o, i] of Object.entries(r)) {
      const c = s ? `${s}.${o}` : o;
      i && typeof i == "object" && !Array.isArray(i) ? n(i, c) : t[c] = i;
    }
  }
  return n(e), t;
}
function c0({
  template: e,
  variables: t,
  variableKeyPattern: n,
  variableValueTransformer: r
}) {
  return Object.entries(t).reduce((s, [o, i]) => {
    if (!r && !["number", "boolean", "string"].includes(typeof i))
      throw new Error(`If transformer is not provided, value(${o}:${i}) must be a {string, number, or boolean}`);
    const c = r ? r(i) : String(i), l = n(o);
    return s.replace(l, na(c));
  }, e);
}
async function l0({
  template: e,
  variables: t,
  variableKeyPattern: n,
  variableValueTransformer: r
}) {
  return (await Promise.all(
    Object.entries(t).map(async ([o, i]) => {
      const c = await r(i);
      return { regex: n(o), transformedValue: c };
    })
  )).reduce((o, { regex: i, transformedValue: c }) => o.replace(i, na(c)), e);
}
var fs = /* @__PURE__ */ ((e) => (e[e.EXTERNAL_AUTH_TOKEN_EXPIRED = 1] = "EXTERNAL_AUTH_TOKEN_EXPIRED", e))(fs || {});
const ra = (e) => typeof e == "object" && e !== null, hr = (e, t) => t in e && typeof e[t] == "string" && e[t] !== "", mm = (e) => !ra(e) || !hr(e, "channel_url") || !hr(e, "ai_agent_id") || !hr(e, "cpa_key") ? null : {
  channelUrl: e.channel_url,
  aiAgentId: e.ai_agent_id,
  cpaKey: e.cpa_key
}, hm = {
  1: mm
};
function gm(e) {
  if (!ra(e) || !("cat" in e) || typeof e.cat != "number" || !("data" in e)) return null;
  const t = e.cat, n = hm[t];
  if (!n) return null;
  const r = n(e.data);
  return r ? { category: t, data: r } : null;
}
function fm(e, t, n, r) {
  const s = _sendbird_chat__WEBPACK_IMPORTED_MODULE_9__/* ["default"].init */ .ZP.init({
    appId: e,
    modules: [new _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__/* .GroupChannelModule */ .rY(), new _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .AIAgentModule */ .Sq()],
    localCacheEnabled: !0,
    options: new _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.S({ typingIndicatorInvalidateTime: 2e4 }),
    ...r,
    customApiHost: (r == null ? void 0 : r.customApiHost) ?? `https://api-${e}.app.delight.ai`,
    customWebSocketHost: (r == null ? void 0 : r.customWebSocketHost) ?? `wss://ws-${e}.app.delight.ai`
  });
  return s.addSendbirdExtensions(
    [{ version: n, product: _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.am.AI_AGENT, platform: t.platform }],
    { platform: t.deviceOSPlatform, version: t.deviceOSVersion },
    t.customData
  ) || console.warn("Invalid Sendbird Extensions", t), s;
}
function pm(e) {
  const t = (n) => {
    throw new Error(`Please initialize chat sdk with ${n}`);
  };
  typeof e.groupChannel != "object" && t("GroupChannelModule"), typeof e.aiAgent != "object" && t("AIAgentModule");
}
const _m = [400300, 400301, 400302, 400310], Em = fs.EXTERNAL_AUTH_TOKEN_EXPIRED.toString(), Cm = (e) => `${Em}:${e}`;
class ps {
  constructor(t, n, r, s, o) {
    E(this, "chatSDK");
    E(this, "_aiAgentId");
    E(this, "_externalAuthTokenExpiredEventHandlerKey");
    E(this, "_logger");
    E(this, "_cache");
    E(this, "_statsTrackers");
    E(this, "_sessionHandler");
    E(this, "_aiEventHandlerRegistered", !1);
    /**
     * Connects to the Sendbird Chat SDK with the provided session credentials.
     */
    E(this, "connect", async (t, n, r, s, o) => {
      if (this._logger.debug("ChatClient.connect: start", t.userId), n) {
        this._sessionHandler = n;
        const i = new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.S({
          ...n,
          onSessionTokenRequired: this._interceptTokenRefresh(
            n.onSessionTokenRequired,
            r,
            s
          )
        });
        this.chatSDK.setSessionHandler(i);
      }
      this._registerAIEventHandler();
      try {
        await this.chatSDK.connect(t.userId, t.authToken);
        const [, i] = await Promise.allSettled([
          this._syncTemplatesIfNeeded(),
          o ? this.submitCPAAuthorizationCodes(o) : Promise.resolve()
        ]);
        return o && (i.status === "fulfilled" ? this._logger.debug("ChatClient.connect: CPA authorization codes submitted", i.value) : this._logger.error("ChatClient.connect: CPA authorization code submission failed", i.reason)), this._logger.debug("ChatClient.connect: end", this.chatSDK.currentUser), this.chatSDK.currentUser;
      } catch (i) {
        const c = i;
        if (this.chatSDK.isCacheEnabled) {
          if (this._isCacheRestrictedError(c))
            this._logger.warn("ChatClient.connect", "offline connect restricted", c.message, c.code), this._logger.warn("ChatClient.connect", "clear cached-data"), await this.chatSDK.clearCachedData().catch((l) => this._logger.warn("ChatClient.connect", "clear cached-data failure", l));
          else if (this.chatSDK.currentUser)
            return this._logger.debug("ChatClient.connect: end (offline)", this.chatSDK.currentUser), this.chatSDK.currentUser;
        }
        throw this._logger.warn("ChatClient.connect", "connect failure", c.message, c.code), this.dispose(), c;
      }
    });
    E(this, "_registerAIEventHandler", () => {
      this._aiEventHandlerRegistered || (this._aiEventHandlerRegistered = !0, this.chatSDK.aiAgent.addEventHandler(this._externalAuthTokenExpiredEventHandlerKey, this._handleAIEvent));
    });
    E(this, "_handleAIEvent", (t) => {
      var o;
      this._logger.debug("ChatClient.connect: EXTERNAL_AUTH_TOKEN_EXPIRED event received", t);
      const n = gm(t), r = typeof t.cat == "number" ? t.cat : void 0;
      if (r !== void 0 && r !== fs.EXTERNAL_AUTH_TOKEN_EXPIRED)
        return;
      if (!n) {
        this._statsTrackers.aievAuthExpiredUnhandled.onPayloadParseFailed({ aiAgentId: this._aiAgentId });
        return;
      }
      if (n.data.aiAgentId !== this._aiAgentId) {
        this._logger.debug("ChatClient.connect: ignore EXTERNAL_AUTH_TOKEN_EXPIRED for another agent", n.data);
        return;
      }
      const s = (o = this._sessionHandler) == null ? void 0 : o.onExternalAuthTokenExpired;
      if (!s) {
        this._statsTrackers.aievAuthExpiredUnhandled.onCallbackNotFound(n.data);
        return;
      }
      this._logger.debug("ChatClient.connect: calling onExternalAuthTokenExpired handler", n.data), s(n.data);
    });
    /**
     * Synchronously clears ChatClient-owned AI event handler state.
     */
    E(this, "dispose", () => {
      this._aiEventHandlerRegistered && (this.chatSDK.aiAgent.removeEventHandler(this._externalAuthTokenExpiredEventHandlerKey), this._aiEventHandlerRegistered = !1), this._sessionHandler = void 0;
    });
    /**
     * Disconnects from the Sendbird Chat SDK and clears template cache.
     */
    E(this, "disconnect", async () => {
      this._logger.debug("ChatClient.disconnect: start"), this.dispose(), await this.chatSDK.disconnect(), this._cache.template.clear(), this._logger.debug("ChatClient.disconnect: end");
    });
    E(this, "getChannel", async (t) => this.chatSDK.groupChannel.getChannel(t));
    E(this, "patchContext", async (t, n, r) => this.chatSDK.aiAgent.patchContext(t, n, r));
    E(this, "updateContext", async (t, n, r) => this.chatSDK.aiAgent.updateContext(t, n, r));
    E(this, "requestNudgeMessage", async (t) => this.chatSDK.aiAgent.requestNudgeMessage(t));
    E(this, "submitCPAAuthorizationCodes", async ({
      aiAgentId: t,
      authCodes: n
    }) => this.chatSDK.aiAgent.submitCustomerProvidedAuthCodes({
      aiAgentId: t,
      authorizationCodes: n
    }));
    /**
     * Requests messenger settings from the server.
     */
    E(this, "requestMessengerSettings", async (t) => {
      var s;
      if (t.userId === "") {
        const o = new Error("userId cannot be empty string for messenger settings request");
        throw this._logger.error("ChatClient.requestMessengerSettings: invalid userId", o), o;
      }
      const n = { ...t, shouldSendFirstMessage: !1 };
      this._logger.debug("ChatClient.requestMessengerSettings: requesting", n);
      const r = await this.chatSDK.aiAgent.requestMessengerSettings(n);
      return this._logger.debug("ChatClient.requestMessengerSettings: received", (s = r.active_channel) == null ? void 0 : s.channel_url), r;
    });
    E(this, "setUserMemoryState", async (t) => {
      this._logger.debug("ChatClient.setUserMemoryState: requesting", t);
      const n = await this.chatSDK.aiAgent.setUserMemoryState(t);
      return this._logger.debug("ChatClient.setUserMemoryState: received", n.enabled), n;
    });
    E(this, "clearUserMemories", async (t = {}) => {
      this._logger.debug("ChatClient.clearUserMemories: requesting", t), await this.chatSDK.aiAgent.clearUserMemories(t), this._logger.debug("ChatClient.clearUserMemories: completed");
    });
    /**
     * Intercepts the token refresh process to notify when a new token is obtained.
     */
    E(this, "_interceptTokenRefresh", (t, n, r) => {
      if (t)
        return async (s, o) => {
          new Promise((i, c) => t == null ? void 0 : t(i, c)).then((i) => {
            i ? n == null || n(i) : r == null || r(), s(i);
          }).catch((i) => {
            r == null || r(), o(i);
          });
        };
    });
    /**
     * Checks if the error is a cache restricted error that requires clearing cached data.
     */
    E(this, "_isCacheRestrictedError", (t) => _m.some((n) => t.code === n));
    /**
     * Syncs message templates if the cached token differs from the server token.
     */
    E(this, "_syncTemplatesIfNeeded", async () => {
      var r, s;
      const t = (s = (r = this.chatSDK.appInfo) == null ? void 0 : r.aiAgentInfo) == null ? void 0 : s.templateListToken;
      if (!t) return;
      const n = this._cache.template.getCachedToken();
      if (!(n && n === t)) {
        this._logger.debug("ChatClient._syncTemplatesIfNeeded: syncing templates");
        try {
          const { templates: o, token: i } = await this.chatSDK.aiAgent.getMessageTemplates({ limit: 20 });
          for (const { template: c } of o) {
            const { key: l } = dm(c);
            this._cache.template.set(l, c);
          }
          this._cache.template.setCachedToken(i), this._logger.debug("ChatClient._syncTemplatesIfNeeded: sync completed");
        } catch (o) {
          this._logger.error("ChatClient._syncTemplatesIfNeeded: error", o);
        }
      }
    });
    this.chatSDK = t, this._aiAgentId = n, this._externalAuthTokenExpiredEventHandlerKey = Cm(n), this._logger = r, this._cache = s, this._statsTrackers = o;
  }
  static init(t) {
    let n;
    return t.chatSDK ? (pm(t.chatSDK), n = t.chatSDK) : n = fm(t.appId, t.extensions, t.messengerVersion, t.chatParams), new ps(n, t.aiAgentId, t.logger, t.cache, t.statsTrackers);
  }
}
const vm = (e) => (t) => {
  if (!e || e.getState() === "foregrounded") {
    t();
    return;
  }
  const n = e.subscribe((r) => {
    r === "foregrounded" && (n(), t());
  });
  return n;
}, bm = (e) => () => {
  let t = e.getState() === "backgrounded";
  const n = e.subscribe((r) => {
    r === "backgrounded" && (t = !0);
  });
  return () => (n(), t);
}, In = /* @__PURE__ */ new Map(), sa = {
  set: (e, t) => {
    In.set(e, t);
  },
  get: (e) => {
    if (In.size === 0)
      throw new Error(
        "AIAgent platform not configured. Ensure you are using the correct package (@sendbird/ai-agent-messenger-react or @sendbird/ai-agent-messenger-react-native)."
      );
    if (e) {
      const n = In.get(e);
      if (!n)
        throw new Error(`AIAgent platform "${e}" is not configured.`);
      return { platform: e, ...n };
    }
    const t = In.entries().next().value;
    return { platform: t[0], ...t[1] };
  }
}, oa = "SENDBIRD_DESK_INQUIRE_TICKET_CLOSURE";
var Hn = /* @__PURE__ */ ((e) => (e.WAITING = "WAITING", e.CONFIRMED = "CONFIRMED", e.DECLINED = "DECLINED", e))(Hn || {});
const Sm = (e) => {
  if (!e) return null;
  const t = Fi(e);
  if (t.type !== oa) return null;
  const { state: n, ticketId: r } = t.body ?? {};
  return n == null || r == null ? null : { state: n, ticketId: r };
};
class lo extends Error {
  constructor(n, r) {
    const s = (r == null ? void 0 : r.detail) ?? "";
    super(s || `Desk API error (${n})`);
    E(this, "status");
    E(this, "code");
    E(this, "detail");
    this.name = "DeskApiError", this.status = n, this.code = (r == null ? void 0 : r.code) ?? "", this.detail = s;
  }
}
var ia = /* @__PURE__ */ ((e) => (e.INITIALIZED = "INITIALIZED", e.PROACTIVE = "PROACTIVE", e.PENDING = "PENDING", e.ACTIVE = "ACTIVE", e.CLOSED = "CLOSED", e.WORK_IN_PROGRESS = "WORK_IN_PROGRESS", e.IDLE = "IDLE", e))(ia || {}), aa = /* @__PURE__ */ ((e) => (e.URGENT = "URGENT", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(aa || {}), ca = /* @__PURE__ */ ((e) => (e.ERR_CREDENTIALS_NOT_PROVIDED = "desk401100", e.ERR_NON_AUTHORIZED = "desk401103", e.ERR_SESSION_KEY_EXPIRED = "desk401106", e.ERR_SESSION_TOKEN_REVOKED = "desk401107", e.ERR_USER_DEACTIVATED = "desk401108", e.ERR_USER_NOT_EXIST = "desk401109", e))(ca || {});
const ym = (e) => e === "desk401103" || e === "desk401106" || e === "desk401107" || e === "desk401108" || e === "desk401109";
class Am {
  constructor(t) {
    E(this, "_appId");
    E(this, "_apiHost");
    E(this, "_logger");
    E(this, "_credential", null);
    E(this, "_authRefreshPromise", null);
    E(this, "_onDeskTokenRefreshRequired", async () => !1);
    /**
     * Makes a request. Handles JSON serialization and response parsing.
     *
     * By default, injects deskToken header and enables 401 recovery.
     * Set `authRequired: false` to use custom headers with no recovery (e.g. authenticate).
     * @param path The API path.
     * @param options Request options.
     * @returns The parsed response data.
     * @throws {DeskApiError} When the response is non-2xx or body cannot be parsed.
     */
    E(this, "request", async (t, n) => {
      const r = n.authRequired ?? !0, s = `${this._apiHost}${t}`;
      r && this._authRefreshPromise && (this._logger.debug("DeskApiClient: waiting for in-flight recovery..."), await this._authRefreshPromise);
      const o = await this._fetch(s, n);
      return r && o.status === 401 ? this._handleUnauthorized(o, s, n) : this._toResult(o);
    });
    E(this, "setCredential", (t, n = async () => !1) => {
      this._authRefreshPromise = null, this._onDeskTokenRefreshRequired = n, this._credential = t;
    });
    E(this, "clearCredential", () => {
      this._authRefreshPromise = null, this._credential = null, this._onDeskTokenRefreshRequired = async () => !1;
    });
    /**
     * Handles 401 responses. Attempts delegated recovery on recoverable Desk auth errors
     * and retries the original request on success.
     * Non-recoverable errors and failed recoveries re-throw via {@link _toResult}.
     */
    E(this, "_handleUnauthorized", async (t, n, r) => {
      const s = await this._parseErrorCode(t);
      if (!ym(s))
        return this._toResult(t);
      if (!await this._refresh(s) || this._credential === null)
        return this._toResult(t);
      const i = await this._fetch(n, r);
      return this._toResult(i);
    });
    /**
     * Attempts delegated recovery from a recoverable Desk auth error.
     * Concurrent calls share the same promise — only the first caller runs the
     * actual recovery logic; subsequent callers join the in-flight promise.
     * @returns Whether recovery succeeded and the request can be retried.
     */
    E(this, "_refresh", async (t) => {
      if (this._authRefreshPromise)
        return this._logger.debug("DeskApiClient: refresh already in progress, joining..."), this._authRefreshPromise;
      try {
        return this._authRefreshPromise = this._onDeskTokenRefreshRequired({ reason: t }).catch((n) => (this._logger.error("DeskApiClient: delegated recovery failed", n), !1)), await this._authRefreshPromise;
      } finally {
        this._authRefreshPromise = null;
      }
    });
    E(this, "_fetch", (t, n) => fetch(`${t}?${this._buildParams(n.params)}`, {
      method: n.method,
      headers: this._buildHeaders(n.authRequired ?? !0, n.headers),
      ...n.body ? { body: JSON.stringify(this._buildBody(n.body)) } : {}
    }));
    E(this, "_buildParams", (t) => new URLSearchParams({ sendbirdAppId: this._appId, ...t }));
    E(this, "_buildBody", (t) => ({ sendbirdAppId: this._appId, ...t }));
    E(this, "_buildHeaders", (t, n) => ({
      "content-type": "application/json",
      ...t && this._credential ? { sendbirdDeskToken: this._credential.deskToken } : {},
      ...n
    }));
    E(this, "_toResult", async (t) => {
      if (!t.ok) {
        const r = await t.json().catch(() => ({}));
        throw new lo(t.status, r);
      }
      const n = await t.text();
      if (n)
        try {
          return JSON.parse(n);
        } catch {
          throw new lo(t.status, {});
        }
    });
    E(this, "_parseErrorCode", async (t) => {
      const n = await t.clone().json().catch(() => ({}));
      return n == null ? void 0 : n.code;
    });
    this._appId = t.appId, this._apiHost = t.customApiHost ?? `https://desk-api-${t.appId}.app.delight.ai/sapi`, this._logger = t.logger;
  }
  get credential() {
    return this._credential;
  }
}
class Gn {
  constructor(t, n) {
    E(this, "id");
    E(this, "title");
    E(this, "status");
    E(this, "agent");
    E(this, "priority");
    E(this, "group");
    E(this, "firstResponseTime");
    E(this, "issuedAt");
    E(this, "customFields");
    E(this, "_client");
    /**
     * Refreshes all the data of this ticket from the server.
     * Returns a new {@link DeskTicketInterface} instance.
     */
    E(this, "refresh", async () => this._client.getTicket(this.id));
    this.id = t.id, this.title = t.title, this.status = t.status, this.agent = t.agent, this.priority = t.priority, this.group = t.group, this.firstResponseTime = t.firstResponseTime, this.issuedAt = t.issuedAt, this.customFields = t.customFields, this._client = n;
  }
  /**
   * @internal
   * Factory method that creates a DeskTicket from a raw server response.
   */
  static _fromResponse(t, n) {
    var r;
    return new Gn(
      {
        id: t.id,
        title: t.channelName ?? null,
        status: t.status2 ?? ia.INITIALIZED,
        agent: (() => {
          var o;
          const s = (o = t.recentAssignment) == null ? void 0 : o.agent;
          return s ? { userId: s.sendbirdId ?? "", name: s.displayName ?? "", profileUrl: s.photoThumbnailUrl ?? "" } : null;
        })(),
        priority: t.priority ?? aa.MEDIUM,
        group: t.group ?? 0,
        firstResponseTime: t.firstResponseTime ?? -1,
        issuedAt: t.issuedAt ?? null,
        customFields: Object.fromEntries(((r = t.customFields) == null ? void 0 : r.map((s) => [s.key, s.value])) ?? [])
      },
      n
    );
  }
}
class _s {
  constructor(t) {
    E(this, "_logger");
    E(this, "_apiClient");
    E(this, "_onDeskTokenRefreshRequired");
    /**
     * @internal Updates the chat token used for API requests.
     * Should be called when the chat token is refreshed to avoid authentication issues.
     * @param accessToken The new chat authentication token.
     * @returns True if the token was successfully refreshed, false otherwise.
     * */
    E(this, "refreshDeskAuthToken", async (t) => this._apiClient.credential ? this.authenticate({
      userId: this._apiClient.credential.userId,
      accessToken: t,
      onDeskTokenRefreshRequired: this._onDeskTokenRefreshRequired
    }) : !1);
    /**
     * @internal Authenticates with the Desk server and stores the desk token.
     * @param params Authentication parameters including userId and accessToken.
     */
    E(this, "authenticate", async (t) => {
      this._logger.debug("DeskClient.authenticate: start", t.userId);
      try {
        const { token: n } = await this._apiClient.request("/customers/auth/", {
          method: "POST",
          headers: { sendbirdAccessToken: t.accessToken },
          body: { sendbirdId: t.userId },
          authRequired: !1
        });
        return t.onDeskTokenRefreshRequired !== void 0 && (this._onDeskTokenRefreshRequired = t.onDeskTokenRefreshRequired), this._apiClient.setCredential(
          { userId: t.userId, deskToken: n, chatToken: t.accessToken },
          this._onDeskTokenRefreshRequired
        ), this._logger.debug("DeskClient.authenticate: end"), !0;
      } catch (n) {
        return this._apiClient.clearCredential(), this._logger.debug("DeskClient.authenticate: failed", n), !1;
      }
    });
    /**
     * @internal Clears the desk token and resets the recovery callback.
     */
    E(this, "deauthenticate", () => {
      this._apiClient.clearCredential(), this._onDeskTokenRefreshRequired = void 0, this._logger.debug("DeskClient.deauthenticate: token cleared");
    });
    /**
     * @internal Sets customer's language.
     * @param language Language in IETF BCP 47 format (e.g., "ko", "en").
     */
    E(this, "setCustomerLanguage", async (t) => {
      this._assertAuthenticated(this._apiClient), this._logger.debug("DeskClient.setCustomerLanguage: start", t), await this._apiClient.request("/customers/language/", {
        method: "PATCH",
        body: { language: t }
      }), this._logger.debug("DeskClient.setCustomerLanguage: end");
    });
    /**
     * @public Gets a ticket by its ID.
     * @param ticketId The ticket ID.
     * @returns The {@link DeskTicketInterface}.
     */
    E(this, "getTicket", async (t) => {
      this._assertAuthenticated(this._apiClient);
      const n = await this._apiClient.request(`/tickets/${encodeURIComponent(t)}/`, {
        method: "GET"
      });
      return Gn._fromResponse(n, this);
    });
    /**
     * @internal Creates a ticket.
     * @param params.title Ticket title.
     * @param params.name User name.
     * @param params.groupKey Group key.
     * @param params.customFields Custom fields.
     * @param params.priority Ticket priority. Defaults to {@link DeskTicketPriority.MEDIUM}.
     * @returns The created {@link DeskTicketInterface}.
     */
    E(this, "createTicket", async (t) => {
      this._assertAuthenticated(this._apiClient);
      const n = await this._apiClient.request("/tickets/", {
        method: "POST",
        body: ds({
          channelName: t.title,
          channelType: "SENDBIRD_JAVASCRIPT",
          customFields: t.customFields ? JSON.stringify(t.customFields) : void 0,
          info: JSON.stringify({
            ticket: {
              subject: t.title,
              // Zendesk legacy: `email` is required by the API but not used — fill with userId per existing convention (desk-js, android)
              requester: { name: t.name, email: this._apiClient.credential.userId }
            }
          }),
          priority: t.priority,
          groupKey: t.groupKey
        })
      });
      return Gn._fromResponse(n, this);
    });
    /**
     * @internal Records the end user's response to a ticket closure inquiry.
     * @param params.messageId The inquiry message ID.
     * @param params.ticketId The ticket ID carried by the inquiry payload.
     * @param params.confirmed Whether the user accepted the closure.
     */
    E(this, "confirmEndOfChat", async ({ messageId: t, ticketId: n, confirmed: r }) => {
      this._assertAuthenticated(this._apiClient), await this._apiClient.request(`/tickets/${encodeURIComponent(n)}/edit_message/`, {
        method: "PATCH",
        body: {
          messageId: t,
          // Desk expects this field as a JSON string, not a nested object
          messageData: JSON.stringify({
            type: oa,
            body: {
              state: r ? Hn.CONFIRMED : Hn.DECLINED,
              ticketId: n
            }
          })
        }
      });
    });
    this._logger = t.logger, this._apiClient = new Am(t);
  }
  static init(t) {
    return new _s(t);
  }
  _assertAuthenticated(t) {
    if (t.credential == null)
      throw new Error("DeskClient is not authenticated");
  }
}
class Es {
  constructor() {
    E(this, "authenticate", async (t) => !1);
    E(this, "deauthenticate", () => {
    });
    E(this, "refreshDeskAuthToken", async () => !1);
    E(this, "setCustomerLanguage", async () => {
    });
    E(this, "getTicket", async () => {
      throw new Error("DeskClient is disabled via __SBA_USE_DESK_CLIENT__");
    });
    E(this, "confirmEndOfChat", async () => {
      throw new Error("DeskClient is disabled via __SBA_USE_DESK_CLIENT__");
    });
  }
  static init() {
    return new Es();
  }
}
function Tm(e) {
  return {
    get: (t) => e.getString(t) ?? null,
    set: (t, n) => {
      e.set(t, n);
    },
    delete: (t) => {
      e.delete ? e.delete(t) : e.remove && e.remove(t);
    },
    getKeys: (t) => e.getAllKeys().filter((n) => n.startsWith(t))
  };
}
const Im = 1440 * 60 * 1e3, xm = typeof __SBA_USE_DESK_CLIENT__ > "u" || __SBA_USE_DESK_CLIENT__;
function Ze(e) {
  if (!e)
    throw new Error("Not authenticated. Call authenticate() first.");
}
function Mm(e, t) {
  return Object.entries(t).every(([n, r]) => e[n] === r);
}
const Rm = (e) => {
  const t = {
    conversationInitialRender: new _d(e),
    conversationNotInteractiveTimeout: new Sd(e),
    recoveryNotInteractiveTimeout: new Pd(e),
    conversationListInitialRender: new vd(e),
    aievAuthExpiredUnhandled: new gd(e),
    messagePendingStuck: new $d(e),
    userPerceivedResponseTime: new tm(e),
    streamStalled: new Vd(e),
    typingIndicatorAbsentTimeout: new Xd(e),
    renderedContentUnusable: new Bd(e),
    streamingMessageValidation: new Yd(e),
    duplicateMessageResponse: new Id(e),
    messageLifecycleEvent: new Od(e)
  };
  return {
    ...t,
    clear: () => {
      Object.values(t).forEach((n) => n.clear());
    }
  };
};
class Vn extends lm {
  constructor(n) {
    super();
    E(this, "appId");
    E(this, "aiAgentId");
    E(this, "_chatClient");
    E(this, "_deskClient");
    E(this, "_cache");
    E(this, "_logger");
    E(this, "_dispatcher");
    E(this, "_session", null);
    E(this, "language");
    E(this, "countryCode");
    E(this, "context");
    E(this, "cpaAuthorizationCodes");
    E(this, "queryParams");
    E(this, "_config", ao());
    E(this, "_networkStateAdapter");
    E(this, "_scheduleForegroundTask");
    E(this, "_watchBackgrounded");
    E(this, "_forceCreateChannel");
    E(this, "_agentVersion");
    E(this, "_statsTrackers");
    E(this, "_liveMetricManager");
    E(this, "_operationQueue", nm());
    /**
     * @description Disposes all resources held by this instance.
     */
    E(this, "dispose", () => {
      this._operationQueue.isPending() || (this._logger.debug("AIAgent.dispose: start"), this._chatClient.dispose(), this._chatClient.chatSDK.connectionState === "OPEN" && this._chatClient.chatSDK.disconnectWebSocket(), this._removeChannelHandler(), this._session = null, this._deskClient.deauthenticate(), this._statsTrackers.clear(), this._liveMetricManager.dispose(), this._logger.debug("AIAgent.dispose: end"));
    });
    /**
     * @internal
     * @description Initializes a conversation on the channel if it's an AI Agent channel without a conversation.
     */
    E(this, "initConversationIfNeeded", (n, r) => this._initConversationIfNeeded(n, r));
    /**
     * @param sessionInfo
     * @returns
     * @description Authenticates with the AI Agent server and establishes a session.
     */
    E(this, "authenticate", (n) => {
      if (!this.appId)
        return Promise.reject(new Error("appId is required"));
      if (!this.aiAgentId)
        return Promise.reject(new Error("aiAgentId is required"));
      const r = n && "userId" in n ? `auth:${n.userId}` : "auth:anon";
      return this._operationQueue(r, async () => {
        var i, c, l, u, d;
        this._logger.debug("AIAgent.authenticate: start"), this._statsTrackers.conversationInitialRender.onAuthStart(), this._statsTrackers.conversationListInitialRender.onAuthStart();
        const s = this._getSessionCandidate(n), o = (i = s.userSessionCandidate) != null && i.userId ? this._cache.messenger.getSettings(s.userSessionCandidate.userId) : null;
        o != null && o.bot && this._dispatcher.send(
          Ct.MessengerSettingsUpdated({ settings: o, source: "cache" })
        );
        try {
          const m = await this._chatClient.requestMessengerSettings({
            aiAgentId: this.aiAgentId,
            userId: (c = s.userSessionCandidate) == null ? void 0 : c.userId,
            language: this.language,
            country: this.countryCode,
            context: this.context,
            knownActiveChannelUrl: (l = o == null ? void 0 : o.active_channel) == null ? void 0 : l.channel_url,
            forceCreateChannel: this._forceCreateChannel,
            agentVersion: this._agentVersion
          });
          let h;
          if (m.auto_created_user)
            if (s.type === "manual")
              this._logger.warn(
                "Received auto created user info but current session is manual. Ignoring auto created user info."
              ), h = {
                userId: s.userSessionCandidate.userId,
                authToken: s.userSessionCandidate.authToken
              };
            else {
              const { user_id: v, session_token: _, expire_at: p } = m.auto_created_user;
              this._cache.messenger.setAnonUser({ userId: v, authToken: _, expireAt: p }), h = { userId: v, authToken: _ }, this._logger.debug("AIAgent.authenticate: anonymous user created", v);
            }
          else
            h = {
              userId: ((u = s.userSessionCandidate) == null ? void 0 : u.userId) ?? "",
              authToken: ((d = s.userSessionCandidate) == null ? void 0 : d.authToken) ?? ""
            };
          this._cache.messenger.setSettings(h.userId, m), this._dispatcher.send(Ct.MessengerSettingsUpdated({ settings: m, source: "server" }));
          const g = (() => {
            var v;
            return s.type === "anonymous" ? Xu(this._dispatcher) : (v = s.userSessionCandidate) == null ? void 0 : v.sessionHandler;
          })(), f = await this._chatClient.connect(
            h,
            g,
            (v) => {
              var _;
              this._logger.debug("AIAgent: session token refreshed"), (_ = this._session) == null || _._updateAuthToken(v), this._deskClient.refreshDeskAuthToken(v);
            },
            () => {
              this._logger.debug("AIAgent: session token unavailable, deauthenticating desk"), this._deskClient.deauthenticate();
            },
            this.cpaAuthorizationCodes ? {
              aiAgentId: this.aiAgentId,
              authCodes: this.cpaAuthorizationCodes
            } : void 0
          );
          return await this._deskClient.authenticate({
            userId: h.userId,
            accessToken: h.authToken,
            onDeskTokenRefreshRequired: async ({ reason: v }) => {
              var _;
              if (v === ca.ERR_SESSION_KEY_EXPIRED) {
                await new Promise((y) => setTimeout(y, 2e3));
                const p = (_ = this._session) == null ? void 0 : _.userSession.authToken;
                return p ? await this._deskClient.refreshDeskAuthToken(p) : !1;
              }
              return !1;
            }
          }), (o == null ? void 0 : o.language) !== m.language && this._deskClient.setCustomerLanguage(this.language).catch(() => {
          }), this._statsTrackers.conversationInitialRender.onAuthComplete(), this._statsTrackers.conversationListInitialRender.onAuthComplete(), this._session = new um({
            sdkUser: f,
            userSession: h,
            activeChannel: {
              url: m.active_channel.channel_url,
              status: "open"
            },
            dispatcher: this._dispatcher
          }), this._setupChannelHandler(), this._logger.debug("AIAgent.authenticate: end", { userId: h.userId }), m;
        } catch (m) {
          throw this._statsTrackers.conversationInitialRender.onAuthError(m), this._statsTrackers.conversationListInitialRender.onAuthError(m), m;
        }
      });
    });
    E(this, "submitCPAAuthorizationCodes", async (n) => {
      Ze(this._session), this._logger.debug("AIAgent.submitCPAAuthorizationCodes: start");
      const r = await this._chatClient.submitCPAAuthorizationCodes({
        aiAgentId: this.aiAgentId,
        authCodes: n
      });
      return this._logger.debug("AIAgent.submitCPAAuthorizationCodes: end", r), r;
    });
    /**
     * @returns
     * @description Disconnects from the AI Agent server and clears the session.
     */
    E(this, "deauthenticate", () => this._operationQueue("deauth", async () => {
      var r;
      this._logger.debug("AIAgent.deauthenticate: start");
      const n = (r = this._session) == null ? void 0 : r.userSession.userId;
      this._statsTrackers.clear();
      try {
        await this._chatClient.disconnect();
      } finally {
        this._deskClient.deauthenticate(), this._cache.messenger.clear(n), this._session = null, this._removeChannelHandler(), this._statsTrackers.clear();
      }
      this._logger.debug("AIAgent.deauthenticate: end");
    }));
    /**
     * @param params
     * @returns The channel URL of the newly created conversation.
     * @description Creates a new conversation with the AI Agent.
     */
    E(this, "createConversation", async (n) => {
      Ze(this._session), this._logger.debug("AIAgent.createConversation: start", n);
      const r = await this._chatClient.requestMessengerSettings({
        ...n,
        userId: this._session.userSession.userId,
        knownActiveChannelUrl: void 0,
        agentVersion: this._agentVersion
      }), s = r.active_channel.channel_url;
      return this._cache.messenger.setSettings(this._session.userSession.userId, r), this._logger.debug("AIAgent.createConversation: end", s), s;
    });
    /**
     * @param params
     * @returns An array of channel URLs that match the given context.
     * @description Searches for open conversations that match the specified context.
     */
    E(this, "searchConversation", async (n) => {
      if (Ze(this._session), this._logger.debug("AIAgent.searchConversation: start", n), Object.entries(n.context).length === 0)
        return this._logger.debug("AIAgent.searchConversation: empty context, returning empty array"), [];
      const r = this.chatSDK.aiAgent.createConversationListQuery({
        aiAgentId: n.aiAgentId,
        status: _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN,
        limit: 100
      }), s = [];
      for (; r.hasNext; ) {
        const o = await r.next();
        for (const i of o)
          Mm(i.context ?? {}, n.context) && s.push(i.channelInfo.url);
      }
      return this._logger.debug("AIAgent.searchConversation: end", { count: s.length }), s;
    });
    /**
     * @param channelUrl
     * @description Closes an open conversation.
     */
    E(this, "closeConversation", async (n) => {
      var s;
      Ze(this._session), this._logger.debug("AIAgent.closeConversation: start", n);
      const r = await this._chatClient.getChannel(n);
      ((s = r.conversation) == null ? void 0 : s.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN ? (await r.closeConversation(), this._session.activeChannel.url === n && this._session._updateActiveChannel({
        url: n,
        status: "closed",
        conversationStatus: _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED
      }), this._logger.debug("AIAgent.closeConversation: end")) : this._logger.debug("AIAgent.closeConversation: already closed or not an AI agent conversation");
    });
    /**
     * @param params
     * @returns
     * @description Creates a collection for paginating through conversations.
     */
    E(this, "createConversationListCollection", (n) => new qi(this.chatSDK, n ?? {}));
    /**
     * @param channelUrl
     * @param context
     * @returns
     * @description Patches (merges) context data for the specified channel.
     */
    E(this, "patchContext", async (n, r) => {
      Ze(this._session), this._logger.debug("AIAgent.patchContext: start", { channelUrl: n, context: r });
      const s = await this._chatClient.patchContext(this.aiAgentId, n, r);
      return this._logger.debug("AIAgent.patchContext: end", s), { ...s, context: s.context ?? {} };
    });
    /**
     * @param channelUrl
     * @param context
     * @returns
     * @description Replaces the entire context data for the specified channel.
     */
    E(this, "updateContext", async (n, r) => {
      Ze(this._session), this._logger.debug("AIAgent.updateContext: start", { channelUrl: n, context: r });
      const s = await this._chatClient.updateContext(this.aiAgentId, n, r);
      return this._logger.debug("AIAgent.updateContext: end", s), { ...s, context: s.context ?? {} };
    });
    /**
     * @param channelUrl
     * @returns
     * @description Retrieves the context data for the specified channel.
     */
    E(this, "getContextObject", async (n) => {
      Ze(this._session), this._logger.debug("AIAgent.getContextObject: start", n);
      const s = await (await this._chatClient.getChannel(n)).getContextObject(this.aiAgentId);
      return this._logger.debug("AIAgent.getContextObject: end", s), { ...s, context: s.context ?? {} };
    });
    /**
     * @param params
     * @description Requests a nudge message to be shown above the launcher. Fire-and-forget:
     * the result is broadcast to onNudgeMessageReceived subscribers only when the server
     * returns an ok status with a non-empty message.
     */
    E(this, "requestNudgeMessage", async (n) => {
      Ze(this._session);
      const r = this._session;
      this._logger.debug("AIAgent.requestNudgeMessage: start", n);
      const s = await this._chatClient.requestNudgeMessage({
        aiAgentId: this.aiAgentId,
        key: n.key,
        context: n.context,
        language: this.language
      });
      if (this._logger.debug("AIAgent.requestNudgeMessage: end", s), this._session !== r) {
        this._logger.debug("AIAgent.requestNudgeMessage: session changed during request, discarding stale nudge");
        return;
      }
      s.status !== "ok" || !s.payload.message || this._dispatcher.send(
        Ct.NudgeMessageReceived({
          message: s.payload.message,
          callbackUserMessage: s.payload.callback_user_message ?? void 0
        })
      );
    });
    E(this, "clearUserMemories", async (n = {}) => {
      Ze(this._session);
      const r = { ...n, contextAiAgentId: n.contextAiAgentId ?? this.aiAgentId };
      this._logger.debug("AIAgent.clearUserMemories: start", r), await this._chatClient.clearUserMemories(r), this._logger.debug("AIAgent.clearUserMemories: end");
    });
    /**
     * @internal Records the end user's response to a Desk ticket closure inquiry.
     */
    E(this, "confirmEndOfChat", async (n) => {
      Ze(this._session), this._logger.debug("AIAgent.confirmEndOfChat: start", n), await this._deskClient.confirmEndOfChat(n), this._logger.debug("AIAgent.confirmEndOfChat: end");
    });
    /**
     * @internal
     */
    E(this, "setUserMemoryState", async (n) => {
      Ze(this._session);
      const r = this._session;
      this._logger.debug("AIAgent.setUserMemoryState: start", n.enabled);
      const s = { ...n, contextAiAgentId: n.contextAiAgentId ?? this.aiAgentId }, o = r.userSession.userId, i = await this._chatClient.setUserMemoryState(s);
      if (this._session !== r)
        return this._logger.debug("AIAgent.setUserMemoryState: session changed during request, discarding stale result"), Pr(i);
      const c = this._cache.messenger.getSettings(o);
      if (c) {
        const l = { ...c, memory: i };
        this._cache.messenger.setSettings(o, l), this._dispatcher.send(Ct.MessengerSettingsUpdated({ settings: l, source: "cache" }));
      }
      return this._logger.debug("AIAgent.setUserMemoryState: end", i.enabled), Pr(i);
    });
    /**
     * @internal
     * @param options.useKnownActiveChannelUrl - If true (default), reuses existing active channel. If false, creates a new conversation.
     * @returns The channel URL of the refreshed active channel.
     * @description Refreshes and returns the current active channel from the server.
     */
    E(this, "refreshActiveChannel", async (n) => {
      var c, l, u;
      Ze(this._session);
      const r = this._session, s = (n == null ? void 0 : n.useKnownActiveChannelUrl) ?? !0;
      this._logger.debug("AIAgent.refreshActiveChannel: start", { useKnownActiveChannelUrl: s });
      const o = await this._chatClient.requestMessengerSettings({
        aiAgentId: this.aiAgentId,
        userId: r.userSession.userId,
        language: this.language,
        country: this.countryCode,
        context: this.context,
        knownActiveChannelUrl: s ? (l = (c = this._cache.messenger.getSettings(r.userSession.userId)) == null ? void 0 : c.active_channel) == null ? void 0 : l.channel_url : void 0,
        forceCreateChannel: this._forceCreateChannel,
        agentVersion: this._agentVersion
      });
      if (this._session !== r)
        return this._logger.debug("AIAgent.refreshActiveChannel: session changed during refresh, discarding stale result"), ((u = this._session) == null ? void 0 : u.activeChannel.url) ?? o.active_channel.channel_url;
      const i = o.active_channel.channel_url;
      return this._cache.messenger.setSettings(this._session.userSession.userId, o), this._session._updateActiveChannel({ url: i, status: "open" }), this._logger.debug("AIAgent.refreshActiveChannel: end", i), i;
    });
    /**
     * @internal
     * */
    E(this, "_getSessionCandidate", (n) => n instanceof ju ? { type: "manual", userSessionCandidate: this._getManualSessionInfo(n) } : n instanceof to ? { type: "anonymous", userSessionCandidate: this._getAnonymousSessionInfo() } : n && typeof n == "object" ? (this._logger.warn("Please use ManualSessionInfo instead of the old userSessionInfo format."), { type: "manual", userSessionCandidate: this._getManualSessionInfo(n) }) : n === void 0 ? (this._logger.warn("Please use AnonymousSessionInfo instead of undefined userSessionInfo."), { type: "anonymous", userSessionCandidate: this._getAnonymousSessionInfo() }) : { type: "anonymous", userSessionCandidate: null });
    /**
     * @internal
     * */
    E(this, "_getAnonymousSessionInfo", () => {
      const n = this._cache.messenger.getAnonUser();
      return n ? n.expireAt - Im <= Date.now() ? (this._logger.debug("_getAnonymousSessionInfo: auto session expired, clear cache"), this._cache.messenger.clear(n.userId), null) : (this._logger.debug("_getAnonymousSessionInfo: auto session info detected"), {
        userId: n.userId,
        authToken: n.authToken
      }) : null;
    });
    /**
     * @internal
     * */
    E(this, "_getManualSessionInfo", (n) => {
      if (!n || n instanceof to)
        throw new Error("userSessionInfo must be an instance of ManualSessionInfo");
      if (typeof n.userId != "string")
        throw new Error("userSessionInfo.userId must be a string");
      const r = ["userId", "authToken", "sessionHandler"].filter((s) => !(s in n));
      return r.length > 0 && this._logger.error(`_getManualSessionInfo: missing required keys in userSessionInfo: ${r.join(", ")}`), this._logger.debug("_getManualSessionInfo: manual session info detected"), {
        userId: n.userId,
        authToken: n.authToken,
        sessionHandler: n.sessionHandler
      };
    });
    this.appId = n.appId, this.aiAgentId = n.aiAgentId, this.language = n.language ?? "en", this.countryCode = n.countryCode, this.context = n.context, this.cpaAuthorizationCodes = n.cpaAuthorizationCodes, this.config = n.config, this.queryParams = n.queryParams, this._networkStateAdapter = n.networkStateAdapter, this._scheduleForegroundTask = vm(n.foregroundStateAdapter), this._watchBackgrounded = n.foregroundStateAdapter && bm(n.foregroundStateAdapter), this._forceCreateChannel = n.forceCreateChannel, this._agentVersion = n.agentVersion, this._chatClient = n.chatClient, this._deskClient = n.deskClient, this._cache = n.cache, this._logger = n.logger, this._dispatcher = n.dispatcher, this._statsTrackers = n.statsTrackers, this._liveMetricManager = new qu(this._chatClient.chatSDK), this._liveMetricManager.start();
  }
  /**
   * @param options
   * @returns
   * @description Creates and initializes an AIAgent instance.
   */
  static init(n) {
    var g;
    const r = sa.get(n.platform), s = n.logger ?? new Qi(n.logLevel ?? Ji.WARN), o = n.dispatcher ?? new ji(s), i = n.useMMKVStorage ? Tm(n.useMMKVStorage) : r.keyValueStorage, c = n.useMMKVStorage ? {
      ...n.chatParams,
      useMMKVStorageStore: n.useMMKVStorage
    } : n.chatParams, l = lu({
      appId: n.appId,
      aiAgentId: n.aiAgentId,
      storage: i
    });
    let u;
    const m = Rm((f, v) => {
      if (!u) throw new Error("ChatClient is not initialized.");
      return u.chatSDK.aiAgent.appendStat(f, v);
    });
    u = ps.init({
      appId: n.appId,
      aiAgentId: n.aiAgentId,
      messengerVersion: r.messengerVersion,
      extensions: {
        platform: r.platform,
        deviceOSPlatform: r.deviceOSPlatform,
        deviceOSVersion: r.deviceOSVersion,
        customData: n._sourceService ? { source_service: n._sourceService } : void 0
      },
      chatParams: c,
      chatSDK: n.chatSDK,
      logger: s,
      cache: l,
      statsTrackers: m
    });
    const h = xm ? _s.init({
      appId: n.appId,
      logger: s,
      customApiHost: (g = n.deskParams) == null ? void 0 : g.customApiHost
    }) : Es.init();
    return s.debug("AIAgent.init: created", { appId: n.appId, aiAgentId: n.aiAgentId }), new Vn({
      appId: n.appId,
      aiAgentId: n.aiAgentId,
      language: n.language,
      countryCode: n.countryCode,
      context: n.context,
      cpaAuthorizationCodes: n.cpaAuthorizationCodes,
      config: n.config,
      queryParams: n.queryParams,
      networkStateAdapter: r.networkStateAdapter,
      foregroundStateAdapter: r.foregroundStateAdapter,
      forceCreateChannel: n._forceCreateChannel,
      agentVersion: n._agentVersion,
      chatClient: u,
      deskClient: h,
      cache: l,
      logger: s,
      dispatcher: o,
      statsTrackers: m
    });
  }
  /** The underlying Sendbird Chat SDK instance. */
  get chatSDK() {
    return this._chatClient.chatSDK;
  }
  /** The Desk client. */
  get deskClient() {
    return this._deskClient;
  }
  /** The current authenticated session. `null` if not authenticated. */
  get session() {
    return this._session;
  }
  /** The AI Agent configuration. */
  get config() {
    return this._config;
  }
  set config(n) {
    const r = ao(n);
    im(r, this._config) || (this._config = r);
  }
  /** @internal Agent version for conversation initialization. */
  get agentVersion() {
    return this._agentVersion;
  }
  set agentVersion(n) {
    this._agentVersion = n;
  }
  /** @internal Stats trackers owned by this SDK instance. */
  get statsTrackers() {
    return this._statsTrackers;
  }
  /** @internal Live metric manager owned by this SDK instance. */
  get liveMetricManager() {
    return this._liveMetricManager;
  }
  /** @internal Live metric handler; forwards to the manager's dispatch sink. */
  get onLiveMetric() {
    return this._liveMetricManager.dispatch;
  }
  set onLiveMetric(n) {
    this._liveMetricManager.dispatch = n;
  }
  /** The adapter for detecting online/offline network state. */
  get networkStateAdapter() {
    return this._networkStateAdapter;
  }
  /** The logger instance. */
  get logger() {
    return this._logger;
  }
  /** The event dispatcher. */
  get dispatcher() {
    return this._dispatcher;
  }
  /** The cache instance. */
  get cache() {
    return this._cache;
  }
  /**
   * @internal
   * Schedules metrics work that should only start while the app is foregrounded.
   */
  get scheduleForegroundTask() {
    return this._scheduleForegroundTask;
  }
  get watchBackgrounded() {
    return this._watchBackgrounded;
  }
}
const xe = (e, t) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(t ?? null), r = ({ children: i, value: c }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n.Provider, { value: c }, typeof i == "function" ? i(c) : i), s = ({ children: i }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n.Consumer, null, (c) => c ? typeof i == "function" ? i(c) : i : null), o = () => {
    const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(n);
    if (!i)
      throw new Error(`use${e}Context must be used within a ${e}Provider`);
    return i;
  };
  return n.displayName = `${e}Context`, r.displayName = `${e}Provider`, s.displayName = `${e}Consumer`, o.displayName = `use${e}Context`, { Context: n, Provider: r, Consumer: s, useContext: o };
};
function ot(e) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    Template: e.template,
    updateTemplate: () => {
    },
    components: e.components,
    updateComponent: () => {
    }
  });
  function n({ children: o }) {
    const [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => e.template), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(e.components), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((g) => c(() => g), []), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      (g, f) => u((v) => v[g] === f ? v : { ...v, [g]: f }),
      []
    ), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
      () => ({
        Template: i,
        updateTemplate: d,
        components: l,
        updateComponent: m
      }),
      [i, l, d, m]
    );
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Provider, { value: h }, o);
  }
  function r({ template: o, children: i }) {
    const { updateTemplate: c } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(t);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
      o && c(o);
    }, [o]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, i);
  }
  function s({ children: o }) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, null, o);
  }
  return s.defaults = e, s.useContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(t), s.Context = t, s.Template = r, Object.keys(e.components).forEach((o) => {
    s[o] = function({
      component: c
    }) {
      const { updateComponent: l } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(t);
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
        c && l(o, c);
      }, [c]), null;
    };
  }), s;
}
function wm(...e) {
  return function({ children: n }) {
    return e.reduce((r, s) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(s, null, r), n);
  };
}
function km(e, t) {
  const n = e.lastMessage;
  return n != null && n.isAdminMessage() ? n.message ?? "" : Lm(e, t);
}
function Lm(e, t) {
  var r;
  const n = e.lastMessage;
  if (n != null && n.isUserMessage())
    return n.message || "";
  if (n != null && n.isAdminMessage())
    return n.message ?? "";
  if (n != null && n.isFileMessage())
    return n.message || n.name || "FILE";
  if (n != null && n.isMultipleFilesMessage()) {
    if (n.message)
      return n.message;
    const s = n.fileInfoList.length;
    return ((r = t == null ? void 0 : t.formatMultipleFilesCount) == null ? void 0 : r.call(t, s)) ?? `${s} photos`;
  }
  return e.name;
}
function Om(e, t, n) {
  var i;
  const r = /* @__PURE__ */ new Date(), s = new Date(((i = e.lastMessage) == null ? void 0 : i.createdAt) || e.createdAt), o = (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* .differenceInMinutes */ .X)(r, s);
  return o < 1 ? n.justNow : o < 60 ? n.minutesAgo(o) : (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* .isToday */ .z)(s) ? n.hoursAgo((0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* .differenceInHours */ .A)(r, s)) : t(s, n.dateShortFormat);
}
const Nm = typeof __SBA_USE_DESK_CLIENT__ > "u" || __SBA_USE_DESK_CLIENT__, Dm = ({
  data: e,
  extendedMessagePayload: t,
  ticketClosureLabels: n
}) => {
  if (Nm) {
    const r = Sm(e);
    if (r)
      return r.state !== Hn.WAITING ? [] : [
        {
          action: "confirmTicketClosure",
          label: n.confirm,
          confirmed: !0,
          ticketId: r.ticketId
        },
        {
          action: "confirmTicketClosure",
          label: n.decline,
          confirmed: !1,
          ticketId: r.ticketId
        }
      ];
  }
  return ((t == null ? void 0 : t.suggested_replies) ?? []).map((r) => ({
    action: "sendMessage",
    label: r
  }));
}, $m = (e) => {
  const t = e.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
  return t ? [Number(t[1]), Number(t[2]), Number(t[3])] : null;
}, xn = (e) => Math.max(0, Math.min(255, e)).toString(16).padStart(2, "0"), uo = (e, t) => {
  const n = xn(Math.round(t * 255));
  if (e.startsWith("#")) {
    const s = e.slice(1);
    return s.length === 3 || s.length === 4 ? `#${s[0]}${s[0]}${s[1]}${s[1]}${s[2]}${s[2]}${n}` : `#${s.slice(0, 6)}${n}`;
  }
  const r = $m(e);
  return r ? `#${xn(r[0])}${xn(r[1])}${xn(r[2])}${n}` : e;
}, Pm = (e, t) => {
  if (!t) return e;
  const n = { ...e };
  for (const [r, s] of Object.entries(t))
    s && (n[r] = s);
  return n;
}, Fm = (e) => e.consentDialog ? "consent" : e.toggleAllowed ? e.enabled ? "on" : "off" : "readonly", Um = (e) => e.length > 0, Bm = (e) => {
  const t = e[0];
  if (!t) return e;
  const n = e.some((s) => je(s.type)), r = e.some((s) => !je(s.type));
  return n && r ? je(t.type) ? e.filter((s) => je(s.type)) : [t] : r ? [t] : e;
}, mo = (e) => e.length === 0 ? "empty" : e.every((t) => je(t.type)) ? "images" : "non_images", Hm = ({
  currentFiles: e,
  incomingFiles: t,
  maxAttachmentCount: n
}) => {
  const r = Bm(t), s = mo(e), o = mo(r), c = s === "images" && o === "images" ? {
    type: "append",
    files: r,
    nextFiles: [...e, ...r]
  } : {
    type: "replace",
    files: r,
    nextFiles: r
  };
  return c.nextFiles.length > n ? {
    type: "reject",
    reason: "count_limit",
    maxAttachmentCount: n,
    nextFileCount: c.nextFiles.length
  } : c.type === "replace" && s !== "empty" && s !== o ? {
    type: "confirm_replace",
    action: c
  } : {
    type: "apply",
    action: c
  };
}, Vt = 3, la = 6, Gm = (e) => e % Vt === 0 ? Vt : la, Vm = ({ index: e, itemCount: t }) => {
  const n = t % Vt, r = n > 0, s = r ? t - n : t, o = r && e >= s, i = o ? n : Vt, c = o ? e - s : e % Vt, l = !r && e >= t - Vt;
  return {
    columnSpan: r ? la / i : 1,
    rowItemCount: i,
    isLastInRow: c === i - 1,
    isLastRow: o || l
  };
}, ua = xe("AIAgent"), zm = ua.Provider, we = ua.useContext;
function Km(e) {
  const t = Wm(e), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      _aiAgentSDK: t,
      chatSDK: t.chatSDK,
      deskClient: t.deskClient,
      appId: t.appId,
      aiAgentId: t.aiAgentId,
      language: t.language,
      countryCode: t.countryCode,
      context: t.context,
      cpaAuthorizationCodes: t.cpaAuthorizationCodes,
      logger: t.logger,
      dispatcher: t.dispatcher,
      cache: t.cache,
      networkStateAdapter: t.networkStateAdapter,
      queryParams: t.queryParams,
      config: t.config,
      handlers: e.handlers
    }),
    // useAIAgentSDK mutates the instance in place, so the mutable fields are listed
    // individually rather than relying on the instance identity.
    [
      t,
      t.chatSDK,
      t.deskClient,
      t.appId,
      t.aiAgentId,
      t.language,
      t.countryCode,
      t.context,
      t.cpaAuthorizationCodes,
      t.logger,
      t.dispatcher,
      t.cache,
      t.networkStateAdapter,
      t.queryParams,
      t.config,
      e.handlers
    ]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zm, { value: n }, e.children);
}
function Wm(e) {
  var o, i;
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  if (!t.current || !n.current)
    t.current = Vn.init(e);
  else {
    const c = Ym(n.current, e);
    (c.appId || c.aiAgentId || c.chatSDK) && (t.current.dispose(), t.current = Vn.init({
      ...e,
      // If appId changed without chatSDK prop, force new SDK instance
      chatParams: c.appId ? { ...e.chatParams, newInstance: !0 } : e.chatParams
    }));
  }
  n.current = e, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    var c;
    (c = t.current) == null || c.dispose();
  }, []);
  const r = t.current;
  r.language = e.language ?? "en", r.countryCode = e.countryCode, r.context = e.context, r.cpaAuthorizationCodes = e.cpaAuthorizationCodes, r.queryParams = e.queryParams, r.config = e.config, r.agentVersion = e._agentVersion, r.onLiveMetric = (o = e.handlers) == null ? void 0 : o.onLiveMetric;
  const s = (i = e.handlers) == null ? void 0 : i.onNudgeMessageReceived;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (s)
      return r.onNudgeMessageReceived(async (c) => s(c));
  }, [r, s]), r;
}
function Ym(e, t) {
  const n = t.chatSDK !== void 0 && t.chatSDK !== null;
  return {
    appId: !n && e.appId !== t.appId,
    aiAgentId: e.aiAgentId !== t.aiAgentId,
    chatSDK: !!e.chatSDK !== n || n && t.chatSDK !== e.chatSDK
  };
}
function ge(e) {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);
  return t.current = e, (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...n) => t.current(...n), [t]);
}
const er = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => t((r) => r + 1), []);
  return n.revision = e, n;
};
let qm = 0;
function jm() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => `${qm++}`)[0];
}
const At = (e, t, n) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), o = jm();
  r.current = t, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var c;
    const i = (l) => {
      const u = l;
      return Object.keys(u).forEach((m) => {
        u[m] = (...h) => {
          var f;
          const g = r.current;
          (f = g[m]) == null || f.call(g, ...h);
        };
      }), u;
    };
    return (c = e == null ? void 0 : e.groupChannel) == null || c.addGroupChannelHandler(o, i(new _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_6__/* .GroupChannelHandler */ .pe())), () => {
      var l;
      (l = e == null ? void 0 : e.groupChannel) == null || l.removeGroupChannelHandler(o);
    };
  }, [e == null ? void 0 : e.groupChannel, o]);
};
function Xm(e, t) {
  return !e || !t ? !0 : e.url !== t.url;
}
function et(e) {
  return e != null && "sendingStatus" in e;
}
function Zm(e, t = "##__USER_ID_IS_NOT_PROVIDED__##") {
  var n;
  return et(e) ? ((n = e.sender) == null ? void 0 : n.userId) === t : !1;
}
function Jm(e, t) {
  return Zm(e, t) || e.isAdminMessage() ? !1 : e.updatedAt === 0;
}
function ho(e) {
  return "sendingStatus" in e ? e.sendingStatus === "succeeded" ? String(e.messageId) : e.reqId : String(e.messageId);
}
const zn = {
  collection: {
    groupChannel: {
      defaultOrder: _sendbird_chat_groupChannel__WEBPACK_IMPORTED_MODULE_7__.G.LATEST_LAST_MESSAGE
    },
    message: {
      defaultLimit: { next: 25, prev: 25 },
      searchLimit: { next: 10, prev: 10 }
    }
  }
};
function go(e) {
  return !e || !Array.isArray(e) ? !1 : e.length !== 0;
}
function fo(e, t) {
  return e.reduce(
    (n, r) => {
      const s = t(r);
      return n[s] = r, n;
    },
    {}
  );
}
const Qm = ({ ...e }, t) => {
  switch (t.type) {
    case "update_initialized":
      return e.initialized = t.value.status, e;
    case "update_refreshing":
      return e.refreshing = t.value.status, e;
    case "update_loading":
      return e.loading = t.value.status, e;
    case "update_messages": {
      if (t.value.clearBeforeAction)
        e.messageMap = eh(t.value.messages);
      else {
        const n = { ...e.messageMap }, r = [], s = [];
        t.value.messages.forEach((o) => {
          const i = et(o) ? o.reqId : void 0, c = o.messageId || void 0;
          [i, c].forEach((l) => {
            if (!l) return;
            const u = n[l];
            th(u, o, t.value.strictStreamingOrder) && (u && r.push(u), o.parentMessageId > 0 && (u != null && u.parentMessage) && o.applyParentMessage(u.parentMessage), s.push(o));
          });
        }), r.forEach((o) => {
          et(o) && delete n[o.reqId], delete n[o.messageId];
        }), s.forEach((o) => {
          et(o) && (n[o.reqId] = o), o.messageId !== 0 && (n[o.messageId] = o);
        }), e.messageMap = n;
      }
      return e;
    }
    case "update_new_messages": {
      const n = t.value.currentUserId, r = t.value.messages.filter((s) => Jm(s, n));
      return t.value.clearBeforeAction ? e.newMessageMap = fo(r, ho) : (r.map((o) => o.messageId).forEach((o) => delete e.newMessageMap[o]), e.newMessageMap = {
        ...e.newMessageMap,
        ...fo(r, ho)
      }), e;
    }
    case "delete_messages":
    case "delete_new_messages": {
      const n = t.type === "delete_messages" ? "messageMap" : "newMessageMap";
      return e[n] = { ...e[n] }, t.value.messageIds.forEach((r) => {
        if (r === 0) return;
        const s = e[n][r];
        s && (et(s) && delete e[n][s.reqId], delete e[n][s.messageId]);
      }), t.value.reqIds.forEach((r) => {
        const s = e[n][r];
        s && (et(s) && delete e[n][s.reqId], delete e[n][s.messageId]);
      }), e;
    }
  }
}, eh = (e) => e.reduce(
  (t, n) => (et(n) ? (t[n.reqId] = n, n.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED && (t[n.messageId] = n)) : t[n.messageId] = n, t),
  {}
), th = (e, t, n = !1) => {
  var r, s;
  if (!et(e) || !et(t)) return !0;
  if (n && e && Re.isStreaming(e) && Re.isStreaming(t)) {
    const o = ((r = e.message) == null ? void 0 : r.length) || 0, i = ((s = t.message) == null ? void 0 : s.length) || 0;
    if (o > i)
      return !1;
  }
  return e.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED ? t.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED : e.sendingStatus !== t.sendingStatus;
}, nh = (e = rh) => {
  const [{ initialized: t, loading: n, refreshing: r, messageMap: s, newMessageMap: o }, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Qm, {
    initialized: !1,
    loading: !0,
    refreshing: !1,
    messageMap: {},
    newMessageMap: {}
  }), c = (_, p, y, S) => {
    i({
      type: "update_messages",
      value: { messages: _, clearBeforeAction: p, currentUserId: y, strictStreamingOrder: S }
    });
  }, l = (_, p) => {
    i({ type: "delete_messages", value: { messageIds: _, reqIds: p } });
  }, u = (_, p, y) => {
    i({
      type: "update_new_messages",
      value: { messages: _, clearBeforeAction: p, currentUserId: y }
    });
  }, d = (_, p) => {
    i({ type: "delete_new_messages", value: { messageIds: _, reqIds: p } });
  }, m = (_) => {
    i({ type: "update_initialized", value: { status: _ } });
  }, h = (_) => {
    i({ type: "update_loading", value: { status: _ } });
  }, g = (_) => {
    i({ type: "update_refreshing", value: { status: _ } });
  }, f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => Object.values(o), [o]), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => Array.from(new Set(Object.values(s))).sort(e), [s]);
  return {
    updateInitialized: m,
    updateLoading: h,
    updateRefreshing: g,
    updateMessages: c,
    deleteMessages: l,
    initialized: t,
    loading: n,
    refreshing: r,
    messages: v,
    newMessages: f,
    updateNewMessages: u,
    deleteNewMessages: d
  };
}, po = Math.floor(Number.MAX_SAFE_INTEGER / 10);
function rh(e, t) {
  let n = 0, r = 0;
  return et(e) && e.sendingStatus !== "succeeded" && (n = po), et(t) && t.sendingStatus !== "succeeded" && (r = po), e.createdAt + n - (t.createdAt + r);
}
const sh = (e, t, n) => {
  var o;
  const r = {
    prevResultLimit: t.prev,
    nextResultLimit: t.next,
    startingPoint: n == null ? void 0 : n.startingPoint,
    replyType: n == null ? void 0 : n.replyType
  }, s = (o = n == null ? void 0 : n.collectionCreator) == null ? void 0 : o.call(n, r);
  return s || e.createMessageCollection({
    ...r,
    filter: new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.ag(r)
  });
};
function _o(e) {
  return e < Date.now() ? zn.collection.message.searchLimit : zn.collection.message.defaultLimit;
}
const oh = (e, t, n = {}) => {
  var ke, Pe;
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n);
  r.current = n;
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  s.current = t;
  const o = r.current.logger, i = r.current.startingPoint ?? Number.MAX_SAFE_INTEGER, c = _o(i), l = r.current.strictStreamingOrder ?? !1, u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({ prev: !1, next: !1 }), d = er(), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    initialized: !1,
    apiInitialized: !1,
    instance: null
  }), {
    initialized: h,
    loading: g,
    refreshing: f,
    messages: v,
    newMessages: _,
    updateMessages: p,
    updateNewMessages: y,
    deleteNewMessages: S,
    deleteMessages: A,
    updateInitialized: I,
    updateLoading: k,
    updateRefreshing: N
  } = nh(n == null ? void 0 : n.sortComparator), R = ge((x) => {
    var O, F, H, te;
    if (!s.current || !s.current.url)
      return (O = o == null ? void 0 : o.error) == null ? void 0 : O.call(o, "[useGroupChannelMessages] channel is required");
    try {
      switch (x) {
        case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_RECEIVED:
        case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_SENT_SUCCESS:
        case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.SYNC_MESSAGE_FILL:
        case void 0:
          (H = (F = r.current).markAsRead) == null || H.call(F, [s.current]);
          break;
      }
    } catch (ue) {
      (te = o == null ? void 0 : o.warn) == null || te.call(o, "[useGroupChannelMessages/markAsReadBySource]", ue);
    }
  }), M = ge(
    (x, O) => {
      var F, H, te, ue, re;
      if (O.length > 0)
        switch (x) {
          case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_RECEIVED:
          case _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.SYNC_MESSAGE_FILL: {
            (H = (F = r.current).shouldCountNewMessages) != null && H.call(F) && y(O, !1, (te = e.currentUser) == null ? void 0 : te.userId), (re = (ue = r.current).onMessagesReceived) == null || re.call(ue, O);
            break;
          }
        }
    }
  ), B = ge((x) => {
    var O, F;
    (F = (O = r.current).onCollectionEvent) == null || F.call(O, x);
  }), P = ge(
    async (x, O, F) => new Promise((H, te) => {
      var K, Ce, ve;
      m.current.instance && m.current.instance.dispose(), R(), y([], !0, (K = e.currentUser) == null ? void 0 : K.userId);
      const ue = () => {
        var _e, Te;
        const { pendingMessages: de, failedMessages: Se } = m.current.instance ?? {};
        go(de) && p(de, !1, (_e = e.currentUser) == null ? void 0 : _e.userId), go(Se) && p(Se, !1, (Te = e.currentUser) == null ? void 0 : Te.userId);
      }, re = sh(x, F, {
        ...r.current,
        startingPoint: O
      });
      m.current = { apiInitialized: !1, initialized: !1, instance: re }, re.setMessageCollectionHandler({
        onMessagesAdded: (de, Se, _e) => {
          var Te;
          R(de.source), M(de.source, _e), p(_e, !1, (Te = e.currentUser) == null ? void 0 : Te.userId, l), B({
            kind: "messagesAdded",
            source: de.source,
            channelUrl: x.url,
            messages: _e
          });
        },
        onMessagesUpdated: (de, Se, _e) => {
          var Te, Ke, We;
          R(de.source), M(de.source, _e), p(_e, !1, (Te = e.currentUser) == null ? void 0 : Te.userId, l), de.source === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_UPDATED && ((We = (Ke = r.current).onMessagesUpdated) == null || We.call(Ke, _e)), B({
            kind: "messagesUpdated",
            source: de.source,
            channelUrl: x.url,
            messages: _e
          });
        },
        onMessagesDeleted: (de, Se, _e, Te) => {
          const Ke = Te.map((rt) => rt.messageId), We = Te.filter(et).map((rt) => rt.reqId);
          A(Ke, We), S(Ke, We), B({
            kind: "messagesDeleted",
            source: de.source,
            channelUrl: x.url,
            messages: Te
          });
        },
        onChannelDeleted: (de, Se) => {
          var _e, Te;
          (Te = (_e = r.current).onChannelDeleted) == null || Te.call(_e, Se);
        },
        onChannelUpdated: (de, Se) => {
          var _e, Te;
          d(), (Te = (_e = r.current).onChannelUpdated) == null || Te.call(_e, Se, de);
        },
        onHugeGapDetected: () => {
          P(x, Number.MAX_SAFE_INTEGER, zn.collection.message.defaultLimit);
        }
      });
      let ye = !1;
      (ve = (Ce = r.current).onCollectionInitializeStart) == null || ve.call(Ce), re.initialize(_sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.t.CACHE_AND_REPLACE_BY_API).onCacheResult((de, Se) => {
        var _e, Te, Ke, We, rt;
        (Te = (_e = r.current).onCacheResult) == null || Te.call(_e, de, Se ?? [], x.url), de ? (e.isCacheEnabled && ((Ke = o == null ? void 0 : o.error) == null || Ke.call(o, "[useGroupChannelMessages/onCacheResult]", de)), ye = !0) : Se && ((We = o == null ? void 0 : o.debug) == null || We.call(o, "[useGroupChannelMessages/onCacheResult]", "message length:", Se.length), p(re.succeededMessages, !0, (rt = e.currentUser) == null ? void 0 : rt.userId), ue(), Se.length > 0 && (m.current.initialized = !0, H())), B({
          kind: "initialized",
          source: "cache",
          channelUrl: x.url,
          messages: Se ?? [],
          error: de
        });
      }).onApiResult((de, Se) => {
        var _e, Te, Ke, We, rt, Be, at;
        (Te = (_e = r.current).onApiResult) == null || Te.call(_e, de, Se ?? [], x.url), m.current.initialized = !0, m.current.apiInitialized = !0, de ? ((Ke = o == null ? void 0 : o.warn) == null || Ke.call(o, "[useGroupChannelMessages/onApiResult]", de), ye ? te(de) : H()) : Se && ((We = o == null ? void 0 : o.debug) == null || We.call(o, "[useGroupChannelMessages/onApiResult]", "message length:", Se.length), p(re.succeededMessages, !0, (rt = e.currentUser) == null ? void 0 : rt.userId), r.current.startingPoint || (at = (Be = r.current).onMessagesReceived) == null || at.call(Be, Se), e.isCacheEnabled && ue(), H()), B({
          kind: "initialized",
          source: "api",
          channelUrl: x.url,
          messages: Se ?? [],
          error: de
        });
      });
    })
  );
  At(e, {
    onUserBanned(x, O) {
      var F, H, te;
      x.isGroupChannel() && !Xm(x, s.current) && (O.userId === ((F = e.currentUser) == null ? void 0 : F.userId) ? (te = (H = r.current).onCurrentUserBanned) == null || te.call(H) : d());
    }
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const x = setTimeout(async () => {
      e.currentUser && s.current && (I(!1), k(!0), await P(s.current, i, c), k(!1), I(!0));
    });
    return () => clearTimeout(x);
  }, [e, (ke = e.currentUser) == null ? void 0 : ke.userId, (Pe = s.current) == null ? void 0 : Pe.url, r.current.replyType]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    m.current.instance && m.current.instance.dispose();
  }, []);
  const ne = ge(async () => {
    e.currentUser && s.current && (N(!0), await P(s.current, Number.MAX_SAFE_INTEGER, zn.collection.message.defaultLimit), N(!1));
  }), ce = ge(async () => {
    var O;
    const x = m.current.instance;
    if (x != null && x.hasPrevious && !u.current.prev)
      try {
        u.current.prev = !0;
        const F = await x.loadPrevious();
        p(F, !1, (O = e.currentUser) == null ? void 0 : O.userId);
      } catch {
      } finally {
        u.current.prev = !1;
      }
  }), X = ge(() => {
    const { initialized: x, instance: O } = m.current;
    return x && O ? O.hasPrevious : !1;
  }), J = ge(async () => {
    var O;
    const x = m.current.instance;
    if (x != null && x.hasNext && !u.current.next)
      try {
        u.current.next = !0;
        const F = await x.loadNext();
        p(F, !1, (O = e.currentUser) == null ? void 0 : O.userId);
      } catch {
      } finally {
        u.current.next = !1;
      }
  }), U = ge(() => {
    const { initialized: x, apiInitialized: O, instance: F } = m.current;
    return O && x && F ? F.hasNext : !1;
  }), Y = (x) => {
    var O, F, H, te;
    !x || x.channelUrl !== ((O = s.current) == null ? void 0 : O.url) || (p([x], !1, (F = e.currentUser) == null ? void 0 : F.userId), (te = (H = r.current).onOutgoingMessageStatusChanged) == null || te.call(H, x));
  }, q = ge(
    (x, O) => {
      var F;
      if (!s.current || !s.current.url)
        throw (F = o == null ? void 0 : o.error) == null || F.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      return new Promise((H, te) => {
        s.current.sendUserMessage(x).onPending((ue) => {
          Y(ue), O == null || O(ue);
        }).onSucceeded((ue) => {
          Y(ue), H(ue);
        }).onFailed((ue, re) => {
          Y(re), te(ue);
        });
      });
    }
  ), j = ge(
    (x, O) => {
      var F;
      if (!s.current || !s.current.url)
        throw (F = o == null ? void 0 : o.error) == null || F.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      return new Promise((H, te) => {
        s.current.sendFileMessage(x).onPending((ue) => {
          Y(ue), O == null || O(ue);
        }).onSucceeded((ue) => {
          Y(ue), H(ue);
        }).onFailed((ue, re) => {
          Y(re), te(ue);
        });
      });
    }
  ), V = ge(
    (x, O, F) => {
      var H;
      if (!s.current || !s.current.url)
        throw (H = o == null ? void 0 : o.error) == null || H.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      return new Promise((te, ue) => {
        s.current.sendMultipleFilesMessage(x).onPending((re) => {
          Y(re), O == null || O(re);
        }).onFileUploaded((re) => {
          F == null || F(re), d();
        }).onSucceeded((re) => {
          Y(re), te(re);
        }).onFailed((re, ye) => {
          Y(ye), ue(re);
        });
      });
    }
  ), z = ge(
    async (x, O) => {
      var H, te;
      if (!s.current || !s.current.url)
        throw (H = o == null ? void 0 : o.error) == null || H.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      const F = await s.current.updateUserMessage(x, O);
      return F.channelUrl === s.current.url && p([F], !1, (te = e.currentUser) == null ? void 0 : te.userId), F;
    }
  ), W = ge(
    async (x, O) => {
      var H, te;
      if (!s.current || !s.current.url)
        throw (H = o == null ? void 0 : o.error) == null || H.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      const F = await s.current.updateFileMessage(x, O);
      return F.channelUrl === s.current.url && p([F], !1, (te = e.currentUser) == null ? void 0 : te.userId), F;
    }
  ), se = ge(
    async (x, O, F) => {
      var H;
      if (!s.current || !s.current.url)
        throw (H = o == null ? void 0 : o.error) == null || H.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      return new Promise((te, ue) => {
        let re;
        x.isUserMessage() && (re = s.current.resendMessage(x)), x.isFileMessage() && (re = s.current.resendMessage(x)), x.isMultipleFilesMessage() && (re = s.current.resendMessage(x)), re && ("onPending" in re && re.onPending((ye) => {
          Y(ye), O == null || O(ye);
        }), "onFileUploaded" in re && re.onFileUploaded((ye) => {
          F == null || F(ye), d();
        }), "onSucceeded" in re && re.onSucceeded((ye) => {
          Y(ye), te(ye);
        }), "onFailed" in re && re.onFailed((ye, K) => {
          Y(K), ue(ye);
        }));
      });
    }
  ), he = ge(
    async (x) => {
      var O, F, H, te;
      if (!s.current || !s.current.url)
        throw (O = o == null ? void 0 : o.error) == null || O.call(o, "[useGroupChannelMessages] channel is required"), new Error("Channel is required");
      if (x.sendingStatus === "succeeded")
        x.isUserMessage() && await s.current.deleteMessage(x), x.isFileMessage() && await s.current.deleteMessage(x), x.isMultipleFilesMessage() && await s.current.deleteMessage(x);
      else
        try {
          await ((F = m.current.instance) == null ? void 0 : F.removeFailedMessage(x.reqId));
        } finally {
          A([], [x.reqId]), (te = (H = r.current).onLocalMessageDeleted) == null || te.call(H, x);
        }
    }
  ), $ = ge(() => {
    var x;
    y([], !0, (x = e.currentUser) == null ? void 0 : x.userId);
  }), Ie = ge(async (x) => {
    var O;
    if (e.currentUser && s.current) {
      const F = _o(x);
      k(!0), p([], !0, (O = e.currentUser) == null ? void 0 : O.userId), await P(s.current, x, F), k(!1);
    }
  });
  return {
    /**
     * Initialized state, only available on first render
     * */
    initialized: h,
    /**
     * Loading state, status is changes on first mount or when the resetWithStartingPoint is called.
     * */
    loading: g,
    /**
     * Refreshing state, status is changes when the refresh is called.
     * */
    refreshing: f,
    /**
     * Bumped when the SDK mutates collection state in place with no reducer change
     * (upload progress, channel update, member ban) — memoizing consumers must depend
     * on it to observe those renders.
     * */
    collectionRevision: d.revision,
    /**
     * Get messages, this state is for render
     * For example, if a user receives a new messages while searching for an old message
     * for this case, new messages will be included here.
     * */
    messages: v,
    /**
     * If the `shouldCountNewMessages()` is true, only then push in the newMessages state.
     * (Return false for the `shouldCountNewMessages()` if the message scroll is the most recent; otherwise, return true.)
     *
     * A new message means a message that meets the below conditions
     * - Not admin message
     * - Not updated message
     * - Not current user's message
     * */
    newMessages: _,
    /**
     * Reset new message list
     * @return {void}
     * */
    resetNewMessages: $,
    /**
     * Reset message list and create a new collection for latest messages
     * @return {Promise<void>}
     * */
    refresh: ne,
    /**
     * Load previous messages to state
     * @return {Promise<void>}
     * */
    loadPrevious: ce,
    /**
     * Check if there are more previous messages to fetch
     * @return {boolean}
     * */
    hasPrevious: X,
    /**
     * Load next messages to state
     * @return {Promise<void>}
     * */
    loadNext: J,
    /**
     * Check if there are more next messages to fetch
     * @return {boolean}
     * */
    hasNext: U,
    /**
     * Send user message
     * @param {UserMessageCreateParams} params user message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<UserMessage>} succeeded message
     * */
    sendUserMessage: q,
    /**
     * Send file message
     * @param {FileMessageCreateParams} params file message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<FileMessage>} succeeded message
     * */
    sendFileMessage: j,
    /**
     * Send multiple files message
     * @param {MultipleFilesMessageCreateParams} params multiple files message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<MultipleFilesMessage>} succeeded message
     * */
    sendMultipleFilesMessage: V,
    /**
     * Update user message
     * @param {number} messageId
     * @param {UserMessageUpdateParams} params user message update params
     * @return {Promise<UserMessage>}
     * */
    updateUserMessage: z,
    /**
     * Update file message
     * @param {number} messageId
     * @param {FileMessageUpdateParams} params file message update params
     * @return {Promise<FileMessage>}
     * */
    updateFileMessage: W,
    /**
     * Resend failed message
     * @template {UserMessage | FileMessage | MultipleFilesMessage} T
     * @param {T} failedMessage message to resend
     * @return {Promise<T>}
     * */
    resendMessage: se,
    /**
     * Delete a message
     * @template {UserMessage | FileMessage | MultipleFilesMessage} T
     * @param {T} message succeeded or failed message
     * @return {Promise<void>}
     * */
    deleteMessage: he,
    /**
     * Reset message list and create a new collection with starting point
     * @param {number} startingPoint
     * @param {function} callback
     * @return {void}
     * */
    resetWithStartingPoint: Ie,
    /**
     * Do not use this api
     * */
    _dangerous_reducer_updateMessages: p,
    /**
     * Do not use this api
     * */
    _dangerous_reducer_deleteMessages: A
  };
}, ih = (e) => e.customType === "SENDBIRD_DESK_ADMIN_MESSAGE_CUSTOM_TYPE" ? !0 : e.isAdminMessage() ? e.message === "The channel's custom_type was updated." : !1, ah = (e, t, n) => {
  const r = oh(e, t, {
    ...n,
    strictStreamingOrder: !0
  }), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => r.messages.filter((o) => !ih(o)),
    [r.messages]
  );
  return { ...r, messages: s };
}, ch = () => {
  const e = /* @__PURE__ */ new Set();
  return {
    publish: (t) => {
      e.size !== 0 && [...e].forEach((n) => {
        try {
          n(t);
        } catch {
        }
      });
    },
    subscribe: (t) => {
      let n = !0;
      return e.add(t), () => {
        n && (n = !1, e.delete(t));
      };
    }
  };
}, tr = ch(), lh = ({
  channelUrl: e,
  enabled: t = !0,
  statsTracker: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  s.current = t;
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((f) => r.current === f, []), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    i.current && (n.clearChannel(r.current), i.current = !1);
  }, [n]), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (f) => {
      c(f) && s.current && (i.current = !0);
    },
    [c]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({ channelUrl: f, conversationId: v }) => {
      i.current = !0, n.markChannelJoined(v, f);
    },
    [n]
  ), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({ channelUrl: f }) => {
      n.clearChannel(f), i.current = !1;
    },
    [n]
  ), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (f) => {
      if (c(f.channelUrl)) {
        if (!s.current) {
          o.current = f;
          return;
        }
        o.current = null, d(f);
      }
    },
    [c, d]
  ), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (f) => {
      if (c(f.channelUrl)) {
        if (!s.current) {
          o.current = f;
          return;
        }
        o.current = null, m(f);
      }
    },
    [c, m]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t) {
      const f = o.current;
      if (!f || (o.current = null, f.channelUrl !== e)) return;
      "error" in f ? m(f) : d(f);
      return;
    }
    l();
  }, [e, l, t, m, d]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => (r.current = e, o.current = null, i.current = !1, () => {
    l(), o.current = null, i.current = !1;
  }), [e, l]), {
    onFetchStart: u,
    onFetchSuccess: h,
    onFetchError: g
  };
}, uh = ({
  channelUrl: e,
  enabled: t = !0,
  scheduleForegroundTask: n,
  statsTracker: r
}) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  i.current = t;
  const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m = !0) => {
      var g;
      (g = o.current) == null || g.call(o), o.current = null;
      const h = l.current;
      m && (l.current = null), m && h && r.clearChannel(h);
    },
    [r]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m) => {
      if (!i.current) {
        u(), r.clearChannel(m);
        return;
      }
      u(!1), l.current = m;
      const h = c.current, g = () => {
        if (!i.current || h !== c.current || s.current !== m) {
          r.clearChannel(m), l.current === m && (l.current = null);
          return;
        }
        r.start("ws_reconnected", m);
      };
      o.current = (n == null ? void 0 : n(g)) ?? null, n || g();
    },
    [u, n, r]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t || u();
  }, [u, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => (s.current = e, c.current += 1, () => {
    c.current += 1, u();
  }), [e, u]), {
    onReconnectSucceeded: d
  };
}, un = {
  DEFAULT_PRIMARY: "#000000",
  DEFAULT_BOT_MSG_BG: "#ECECEC",
  WHITE: "#ffffff",
  BLACK: "#000000"
};
function da(e) {
  return e.length === 4 ? `#${[...e.slice(1)].map((t) => t + t).join("")}` : e;
}
function dh(e) {
  const t = da(e);
  return [
    parseInt(t.slice(1, 3), 16),
    // r
    parseInt(t.slice(3, 5), 16),
    // g
    parseInt(t.slice(5, 7), 16)
    // b
  ];
}
function mh(e) {
  return `#${e.map((t) => t.toString(16).padStart(2, "0")).join("")}`;
}
function hh(e, t, n) {
  e /= 255, t /= 255, n /= 255;
  const r = Math.max(e, t, n), s = Math.min(e, t, n), o = r - s;
  let i = 0, c = 0;
  const l = (r + s) / 2;
  return r !== s && (c = l > 0.5 ? o / (2 - r - s) : o / (r + s)), r === e ? i = (t - n) / o + (t < n ? 6 : 0) : r === t ? i = (n - e) / o + 2 : r === n && (i = (e - t) / o + 4), i /= 6, [i, c, l];
}
function gh(e, t, n) {
  let r, s, o;
  if (t === 0)
    r = s = o = n;
  else {
    const i = function(d, m, h) {
      return h < 0 && (h += 1), h > 1 && (h -= 1), h < 0.16666666666666666 ? d + (m - d) * 6 * h : h < 0.5 ? m : h < 0.6666666666666666 ? d + (m - d) * (0.6666666666666666 - h) * 6 : d;
    }, c = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - c;
    r = i(l, c, e + 1 / 3), s = i(l, c, e), o = i(l, c, e - 1 / 3);
  }
  return [Math.round(r * 255), Math.round(s * 255), Math.round(o * 255)];
}
function Mn(e, t, n) {
  const [r, s, o] = dh(e), [i, c, l] = hh(r, s, o), u = Math.max(0, Math.min(1, l * t)), d = Math.max(0, Math.min(1, c * n)), [m, h, g] = gh(i, d, u);
  return mh([Math.round(m), Math.round(h), Math.round(g)]);
}
function fh(e, t = "light") {
  return {
    extraDark: Mn(e, 0.6, 1.2),
    dark: Mn(e, 0.85, 1.1),
    main: e,
    light: Mn(e, t === "dark" ? 1.1 : 1.5, t === "dark" ? 0.95 : 0.9),
    extraLight: Mn(e, t === "dark" ? 1.2 : 1.75, t === "dark" ? 0.9 : 0.8)
  };
}
function Fr(e) {
  const t = da(e), n = 149, r = +`0x${t[1]}${t[2]}`, s = +`0x${t[3]}${t[4]}`, o = +`0x${t[5]}${t[6]}`;
  return r * 0.299 + s * 0.587 + o * 0.114 > n ? un.BLACK : un.WHITE;
}
function ph(e, t, n, r, s) {
  return {
    base: {
      primary: t,
      primaryContrastContent: n,
      background: e.background50,
      headerBackground: e.background50,
      modalContentBackground: e.background50
    },
    messageInput: {
      text: e.onlight.textHighEmphasis,
      placeholderText: e.onlight.textLowEmphasis,
      background: e.background100
    },
    messageIncoming: {
      text: s,
      background: r
    },
    messageOutgoing: {
      text: n,
      background: t
    },
    csat: {
      background: e.background100
    },
    conversation: {
      headerProfileSkeleton: e.background100
    },
    memoryDialog: {
      titleText: e.onlight.textHighEmphasis,
      markdownBodyText: e.onlight.textLowEmphasis,
      markdownLinkText: e.onlight.textHighEmphasis,
      positiveBackground: e.onlight.textHighEmphasis,
      positiveText: e.ondark.textHighEmphasis,
      positiveBorderColor: "transparent",
      negativeBackground: "transparent",
      negativeText: e.onlight.textHighEmphasis,
      negativeBorderColor: "transparent"
    }
  };
}
const _h = (e, t, n, r, s) => ({
  base: {
    primary: t,
    primaryContrastContent: n,
    background: e.background600,
    headerBackground: e.background500,
    modalContentBackground: e.background500
  },
  messageInput: {
    text: e.ondark.textHighEmphasis,
    placeholderText: e.ondark.textLowEmphasis,
    background: e.background400
  },
  messageIncoming: {
    text: s,
    background: r
  },
  messageOutgoing: {
    text: n,
    background: t
  },
  csat: {
    background: e.background400
  },
  conversation: {
    headerProfileSkeleton: e.background400
  },
  memoryDialog: {
    titleText: e.ondark.textHighEmphasis,
    markdownBodyText: e.ondark.textLowEmphasis,
    markdownLinkText: e.ondark.textHighEmphasis,
    positiveBackground: e.ondark.textHighEmphasis,
    positiveText: e.onlight.textHighEmphasis,
    positiveBorderColor: "transparent",
    negativeBackground: "transparent",
    negativeText: e.ondark.textHighEmphasis,
    negativeBorderColor: "transparent"
  }
}), Rn = {
  primary: {
    extraDark: "#491389",
    dark: "#6211c8",
    main: "#742ddd",
    light: "#c2a9fa",
    extraLight: "#dbd1ff"
  },
  secondary: {
    extraDark: "#066858",
    dark: "#027d69",
    main: "#259c72",
    light: "#69c085",
    extraLight: "#a8e2ab"
  },
  error: {
    extraDark: "#9d091e",
    dark: "#bf0711",
    main: "#de360b",
    light: "#f66161",
    extraLight: "#fdaaaa"
  },
  information: {
    extraDark: "#241389",
    dark: "#362ca9",
    main: "#4a48cd",
    light: "#a9bbfa",
    extraLight: "#d1dbff"
  },
  background700: "#000000",
  background600: "#161616",
  background500: "#2c2c2c",
  background400: "#393939",
  background300: "#bdbdbd",
  background200: "#e0e0e0",
  background100: "#eeeeee",
  background50: "#ffffff",
  onlight: {
    textHighEmphasis: "rgba(0, 0, 0, 1)",
    textMidEmphasis: "rgba(0, 0, 0, 0.75)",
    textLowEmphasis: "rgba(0, 0, 0, 0.55)",
    textDisabled: "rgba(0, 0, 0, 0.12)"
  },
  ondark: {
    textHighEmphasis: "rgba(255, 255, 255, 1)",
    textMidEmphasis: "rgba(255, 255, 255, 0.75)",
    textLowEmphasis: "rgba(255, 255, 255, 0.58)",
    textDisabled: "rgba(255, 255, 255, 0.12)"
  },
  overlay: {
    dark: "rgba(0, 0, 0, 0.55)",
    light: "rgba(22, 22, 22, 0.32)"
  }
}, gr = {
  h1: { fontSize: 18, fontWeight: 700 },
  h2: { fontSize: 16, fontWeight: 700 },
  subtitle1: { fontSize: 16, fontWeight: 500 },
  subtitle2: { fontSize: 16, fontWeight: 400 },
  body1: { fontSize: 16, fontWeight: 400 },
  body2: { fontSize: 14, fontWeight: 500 },
  body3: { fontSize: 14, fontWeight: 400 },
  button: { fontSize: 14, fontWeight: 700 },
  caption1: { fontSize: 12, fontWeight: 700 },
  caption2: { fontSize: 12, fontWeight: 400 },
  caption3: { fontSize: 11, fontWeight: 700 },
  caption4: { fontSize: 11, fontWeight: 400 }
};
function Eo(e) {
  const t = Eh(e), n = Ch(e, t), r = bh(n, e.colors, e.selectedTheme), s = yh(e);
  return {
    selectedTheme: e.selectedTheme,
    palette: t,
    colors: r,
    aiAgentColorVariables: {
      primary_color: r.base.primary,
      primary_contrast_color: r.base.primaryContrastContent,
      bot_message_bg_color: r.messageIncoming.background,
      bot_message_bg_contrast_color: r.messageIncoming.text
    },
    typography: s
  };
}
function Eh({ selectedTheme: e, palette: t, primary: n }) {
  const r = t != null && t.primary ? t.primary : n ? n === Rn.primary.main ? Rn.primary : fh(n, e) : Rn.primary;
  return {
    ...Rn,
    primary: r,
    ...t
  };
}
function Ch({ selectedTheme: e, primaryContrast: t, botMessageBackground: n, botMessageBackgroundContrast: r }, s) {
  const o = s.primary.main, i = t ?? Fr(o), c = n ?? un.DEFAULT_BOT_MSG_BG, l = r ?? Fr(c);
  return (e === "light" ? ph : _h)(s, o, i, c, l);
}
function vh(e, t, n) {
  return typeof e == "string" ? e : e[t] ?? n;
}
function bh(e, t, n) {
  var i;
  if (!t || Object.keys(t).length === 0) return e;
  const r = { ...e }, s = r, o = e;
  for (const c of Object.keys(t)) {
    const l = t[c];
    if (l) {
      s[c] = { ...s[c] };
      for (const [u, d] of Object.entries(l))
        if (d !== void 0) {
          const m = ((i = o[c]) == null ? void 0 : i[u]) ?? "";
          s[c][u] = vh(d, n, m);
        }
    }
  }
  return r;
}
function Sh(e, t, n) {
  const r = { ...e };
  return n.forEach((s) => {
    const o = t[s];
    o != null && (r[s] = o);
  }), r;
}
function yh({ typography: e }) {
  if (!e)
    return gr;
  const t = { ...gr };
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (r && typeof r == "object") {
      const s = gr[n], o = ["fontSize", "fontWeight", "fontFamily", "lineHeight"];
      t[n] = Sh(s, r, o);
    }
  }), t;
}
const {
  Provider: Ah,
  useContext: nr
} = xe("AIAgentTheme");
function Th({
  logger: e,
  palette: t,
  typography: n,
  colors: r,
  appearance: s,
  children: o
}) {
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => Eo({
      selectedTheme: (s == null ? void 0 : s.theme) ?? "light",
      palette: t,
      typography: n,
      colors: r,
      primary: s == null ? void 0 : s.primaryColor,
      botMessageBackground: s == null ? void 0 : s.botMessageBackgroundColor
    })
  ), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m, h) => {
      h && (i.current = h);
      const g = (s == null ? void 0 : s.theme) ?? m, f = i.current ? i.current.themes[g] : null, v = {
        primary: s == null ? void 0 : s.primaryColor,
        primaryContrast: void 0,
        botMessageBackground: s == null ? void 0 : s.botMessageBackgroundColor,
        botMessageBackgroundContrast: void 0
      };
      !v.primary && (f != null && f.primary_color) && (v.primary = f.primary_color, v.primaryContrast = f.primary_contrast_color), !v.botMessageBackground && (f != null && f.bot_message_bg_color) && (v.botMessageBackground = f.bot_message_bg_color, v.botMessageBackgroundContrast = f.bot_message_bg_contrast_color);
      const _ = Eo({ selectedTheme: g, palette: t, typography: n, colors: r, ...v });
      l(_), e == null || e.info("theme.update:", g);
    },
    [
      s == null ? void 0 : s.theme,
      s == null ? void 0 : s.primaryColor,
      s == null ? void 0 : s.botMessageBackgroundColor,
      t,
      n,
      r,
      e
    ]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    (s != null && s.theme || s != null && s.primaryColor || s != null && s.botMessageBackgroundColor) && u(c.selectedTheme);
  }, [s == null ? void 0 : s.theme, s == null ? void 0 : s.primaryColor, s == null ? void 0 : s.botMessageBackgroundColor]);
  const d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ theme: c, updateTheme: u }), [c, u]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ah, { value: d }, o);
}
const fr = 25 * 1024 * 1024, Co = 1, vo = /* @__PURE__ */ new Set(["image/png", "image/jpeg", "image/jpg"]), bo = /* @__PURE__ */ new Set(["application/pdf"]), Ih = {
  off: "off",
  always: "always",
  handed_off_only: "handed_off_only"
  /* HANDED_OFF_ONLY */
}, xh = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => ({
    maxAttachmentCount: Co,
    attachmentMode: "handed_off_only",
    defaultUploadSizeLimit: fr,
    uploadSizeLimitPerType: /* @__PURE__ */ new Map(),
    supportedImageMimeTypes: vo,
    supportedFileMimeTypes: bo
  })), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({
      active_channel: s,
      upload_restriction: o
    }) => {
      t({
        maxAttachmentCount: (o == null ? void 0 : o.max_attachment_count) ?? Co,
        attachmentMode: Ih[s.attachment_mode] ?? "handed_off_only",
        defaultUploadSizeLimit: (o == null ? void 0 : o.default_upload_size_limit) ?? fr,
        uploadSizeLimitPerType: new Map(Object.entries((o == null ? void 0 : o.upload_size_limit_per_type) ?? [])),
        supportedImageMimeTypes: new Set(
          (o == null ? void 0 : o.supported_image_mime_types) ?? vo
        ),
        supportedFileMimeTypes: new Set(
          (o == null ? void 0 : o.supported_file_mime_types) ?? bo
        )
      });
    },
    []
  ), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (s) => {
      const { channel: o, uploadSizeLimit: i = fr } = s, c = (u = !0) => o != null && o.isAIAgent ? u ? ft(o) : !1 : !0, l = (u) => {
        if (c())
          return e.defaultUploadSizeLimit ?? i;
        const d = e.defaultUploadSizeLimit ?? i, m = e.uploadSizeLimitPerType.get(u) ?? d;
        return Math.min(d, m);
      };
      return {
        maxAttachmentCount: e.maxAttachmentCount,
        isEnabled: () => {
          if (c(!1))
            return !0;
          switch (e.attachmentMode) {
            case "off":
              return !1;
            case "always":
              return !0;
            case "handed_off_only":
              return ft(o);
            default:
              return !0;
          }
        },
        get supportedMimeTypes() {
          return c() ? [kr] : [...e.supportedImageMimeTypes, ...e.supportedFileMimeTypes];
        },
        isSupportedMimeType: (u) => c() ? !0 : e.supportedImageMimeTypes.has(u) || e.supportedFileMimeTypes.has(u),
        getUploadSizeLimit: l,
        getUploadSizeLimitInMB: (u) => l(u) / (1024 * 1024)
      };
    },
    [e]
  );
  return {
    updateBaseAttachmentRules: n,
    createAttachmentRules: r
  };
}, So = (...e) => {
  const [t, n, r] = e;
  if (e.length === 1 && typeof t == "object" && t !== null)
    return { type: "active", context: t };
  if (e.length === 3 && typeof t == "string" && typeof n == "string" && typeof r == "object" && r !== null)
    return { type: "specific", aiAgentId: t, channelUrl: n, context: r };
  throw new Error("Invalid arguments: expected (context) or (aiAgentId, channelUrl, context)");
}, en = (e) => ({
  ...e,
  context: e.context ?? {}
}), {
  Provider: Mh,
  useContext: it
} = xe("AIAgentMessengerSession"), Rh = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  function({ userSessionInfo: e, children: t }, n) {
    const { _aiAgentSDK: r, chatSDK: s, aiAgentId: o, logger: i } = we(), { updateTheme: c } = nr(), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), [d, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), [h, g] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [f, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [_, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [y, S] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [A, I] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), { updateBaseAttachmentRules: k, createAttachmentRules: N } = xh();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
      const P = r.onMessengerSettingsUpdated(({ settings: X }) => {
        const { appearance: J, bot: U, launcher: Y, memory: q } = X;
        c(J.selected_theme, J), p(am(U)), S(cm(Y)), I(q ? Pr(q) : null), k(X);
      }), ne = r.onActiveChannelUpdated(({ channelUrl: X, status: J, conversationStatus: U }) => {
        m({ url: X, status: J, conversationStatus: U });
      }), ce = r.onAuthTokenRefreshed(() => {
        var J;
        const X = (J = r.session) == null ? void 0 : J.userSession.authToken;
        X && v((U) => U ? { ...U, authToken: X } : null);
      });
      return () => {
        P(), ne(), ce();
      };
    }, [r, c, k]);
    const R = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
      try {
        const P = await r.authenticate(e), ne = r.session;
        return g(ne.sdkUser), v(ne.userSession), m(ne.activeChannel), u(void 0), P;
      } catch (P) {
        throw g(null), v(null), m(void 0), u(P), P;
      }
    }, [r, e]), M = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
      await r.deauthenticate(), g(null), m(void 0), v(null), p(null), S(null), I(null);
    }, [r]), B = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
      if (!r.session) {
        if (f)
          return i.debug("agentMessengerSession.refreshActiveChannel: stale call after deauthenticate, skipping"), "";
        throw i.error("agentMessengerSession.refreshActiveChannel: userSession is not ready"), new Error("userSession is not ready");
      }
      return r.session.userSession.userId !== (f == null ? void 0 : f.userId) ? (i.debug("agentMessengerSession.refreshActiveChannel: stale call from previous session, skipping"), r.session.activeChannel.url) : (m(void 0), await r.refreshActiveChannel());
    }, [r, i, f]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(n, () => {
      const P = async () => {
        if (!d) throw new Error("No active conversation. Please start a conversation first.");
        return await s.groupChannel.getChannel(d.url);
      };
      return {
        activeChannel: d,
        chatSDK: s,
        authenticate: R,
        deauthenticate: M,
        submitCPAAuthorizationCodes: r.submitCPAAuthorizationCodes,
        updateContext: async (...ne) => {
          const ce = So(...ne);
          if (ce.type === "active") {
            const U = await (await P()).updateContext(o, ce.context);
            return en(U);
          }
          const X = await s.aiAgent.updateContext(
            ce.aiAgentId,
            ce.channelUrl,
            ce.context
          );
          return en(X);
        },
        patchContext: async (...ne) => {
          const ce = So(...ne);
          if (ce.type === "active") {
            const U = await (await P()).patchContext(o, ce.context);
            return en(U);
          }
          const X = await s.aiAgent.patchContext(
            ce.aiAgentId,
            ce.channelUrl,
            ce.context
          );
          return en(X);
        },
        getContextObject: async () => {
          const ce = await (await P()).getContextObject(o);
          return en(ce);
        },
        requestNudgeMessage: (ne) => r.requestNudgeMessage(ne)
      };
    }, [R, M, d, s, o, i, r]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Mh,
      {
        value: {
          sdkUser: h,
          userSessionInfo: e,
          userSession: f,
          activeChannel: d,
          setActiveChannel: m,
          refreshActiveChannel: B,
          createConversation: r.createConversation,
          searchConversation: r.searchConversation,
          submitCPAAuthorizationCodes: r.submitCPAAuthorizationCodes,
          connectionError: l,
          aiAgentInfo: _,
          launcherInfo: y,
          memoryInfo: A,
          authenticate: R,
          deauthenticate: M,
          createAttachmentRules: N
        }
      },
      t
    );
  }
), wh = {
  ai_responding: "not_ready",
  conversation_closed: "ready",
  form_active: "ready",
  handoff_pending: "ready",
  reconnecting: "not_ready",
  steward: "ready",
  suggested_replies: "ready",
  system: "ready",
  unavailable: "not_ready"
}, kh = (e) => e.disabled ? wh[e.disabledBy] === "ready" : !0, Lh = (e) => {
  var n, r, s, o, i;
  if (e.isUserMessage()) return "text";
  const t = e.isFileMessage() ? e.type : ((r = (n = e.fileInfoList) == null ? void 0 : n[0]) == null ? void 0 : r.mimeType) ?? ((i = (o = (s = e.messageParams) == null ? void 0 : s.fileInfoList) == null ? void 0 : o[0]) == null ? void 0 : i.mimeType);
  return t && je(t) ? "file_image" : t && gn(t) ? "file_video" : t && ql(t) ? "file_audio" : "file_document";
};
let yo = 0;
const Oh = (e) => (yo += 1, `${e ?? "unknown"}:${yo}`), Ht = (e, t) => e === void 0 || t === e, ma = (e, t) => {
  !t.error && t.messages.length > 0 && e.conversationNotInteractiveTimeout.markHistoryLoaded("success", t.channelUrl);
}, ha = (e, t) => {
  t.error ? e.conversationNotInteractiveTimeout.markHistoryLoaded("failed", t.channelUrl) : e.conversationNotInteractiveTimeout.markHistoryLoaded(
    t.messages.length > 0 ? "success" : "verified_empty",
    t.channelUrl
  );
}, Nh = (e, t) => {
  ma(e, t);
}, Dh = (e, t) => {
  ha(e, t);
}, $h = (e, t, n) => {
  var o;
  if (!ze(e, n)) return;
  const { hasResponseMetadata: r, ...s } = ss(e.data);
  r && (t.typingIndicatorAbsentTimeout.markAIResponseStarted({
    channelUrl: e.channelUrl,
    userMessageId: s.userMessageId
  }), t.userPerceivedResponseTime.markAIResponseRaw({
    messageId: e.messageId,
    channelUrl: e.channelUrl,
    aiResponse: s
  }), t.streamStalled.markRawProgress({
    messageId: e.messageId,
    channelUrl: e.channelUrl,
    textLength: ((o = e.message) == null ? void 0 : o.length) ?? 0,
    aiResponse: s
  }));
}, Ao = (e, t) => {
  t.streamStalled.clearMessage(e.messageId), t.userPerceivedResponseTime.clearMessage(e.messageId);
  const n = tt(e) ? e.reqId : void 0;
  n && (t.messagePendingStuck.disappear({ requestId: n }), t.userPerceivedResponseTime.cancelTurn(n), t.typingIndicatorAbsentTimeout.cancelTurn(n));
}, pr = (e, t) => {
  t && (e.conversationNotInteractiveTimeout.clearChannel(t), e.recoveryNotInteractiveTimeout.clearChannel(t), e.messagePendingStuck.clearChannel(t), e.userPerceivedResponseTime.clearChannel(t), e.typingIndicatorAbsentTimeout.clearChannel(t), e.streamStalled.clearChannel(t));
}, Ph = ({
  activeChannelUrl: e,
  statsTrackers: t
}) => {
  const { chatSDK: n } = we(), { aiAgentInfo: r } = it(), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), o = r == null ? void 0 : r.userId;
  At(!!e && !!o ? n : void 0, {
    onTypingStatusUpdated(c) {
      if (c.url !== e) return;
      const l = c.getTypingUsers().some((d) => d.userId === o), u = s.current;
      l && !u ? t.typingIndicatorAbsentTimeout.markTypingStarted(c.url) : !l && u && t.typingIndicatorAbsentTimeout.markTypingEnded(c.url), s.current = l;
    }
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    s.current = !1;
  }, [e, o]);
}, Fh = ({
  enabled: e = !0,
  requestedChannelUrl: t,
  statsTrackers: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const s = r.current;
    if (!e) {
      s && (pr(n, s), r.current = void 0);
      return;
    }
    s && s !== t && (pr(n, s), r.current = void 0), t && s !== t && (n.conversationNotInteractiveTimeout.start({ channelUrl: t }), r.current = t);
  }, [e, t, n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => () => {
    const s = r.current;
    s && (pr(n, s), r.current = void 0);
  }, [n]);
}, Uh = ({
  aiAgentUserId: e,
  statsEnabled: t = !0,
  requestedChannelUrl: n,
  statsTrackers: r
}) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => c.current + 1, [n]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (i.current = !0, c.current = d, () => {
    i.current = !1, c.current += 1;
  }), [d]);
  const m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((g) => i.current && c.current === g, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    l.current += 1, s.current = null, o.current = null;
  }, [n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const g = u.current;
    u.current = t, !(g || !t) && (s.current && (s.current.tracked = !1), o.current && (o.current.tracked = !1));
  }, [t]);
  const h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g) => g.lifecycleGeneration === l.current && Ht(n, g.channelUrl),
    [n]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) return;
    const g = s.current;
    g && h(g) && (g.tracked || (ma(r, g), g.tracked = !0));
    const f = o.current;
    f && h(f) && (f.tracked || (ha(r, f), f.tracked = !0));
  }, [t, h, r]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      onCollectionEvent: (g) => {
        if (m(d) && Ht(n, g.channelUrl)) {
          if (g.kind === "messagesDeleted") {
            g.messages.forEach((f) => Ao(f, r));
            return;
          }
          t && g.messages.forEach((f) => $h(f, r, e));
        }
      },
      onCacheResult: (g, f, v) => {
        if (!m(d) || !Ht(n, v)) return;
        const _ = {
          error: g,
          messages: f,
          channelUrl: v,
          lifecycleGeneration: l.current,
          tracked: !1
        };
        s.current = _, t && (Nh(r, _), _.tracked = !0);
      },
      onApiResult: (g, f, v) => {
        if (!m(d) || !Ht(n, v)) return;
        const _ = {
          error: g,
          messages: f,
          channelUrl: v,
          lifecycleGeneration: l.current,
          tracked: !1
        };
        o.current = _, t && (Dh(r, _), _.tracked = !0);
      },
      onLocalMessageDeleted: (g) => {
        m(d) && Ht(n, g.channelUrl) && Ao(g, r);
      }
    }),
    [e, d, t, m, n, r]
  );
}, Bh = ({
  enabled: e = !0,
  channelUrl: t,
  initialized: n,
  inputReady: r,
  renderedSignal: s,
  statsTrackers: o
}) => {
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    c.current += 1, i.current = !1;
  }, [t, e]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e && (o.recoveryNotInteractiveTimeout.setInputEnabled(r, t), r && o.conversationNotInteractiveTimeout.markInputReady(t));
  }, [t, e, r, o]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e || !n || i.current) return;
    const l = c.current, u = setTimeout(() => {
      c.current === l && (o.conversationNotInteractiveTimeout.markRendered(t), i.current = !0);
    });
    return () => clearTimeout(u);
  }, [t, e, n, s, o]);
}, Hh = ({
  channelUrl: e,
  enabled: t = !0,
  statsTrackers: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (r.current = !0, s.current = e, o.current = t, i.current += 1, () => {
    r.current = !1, i.current += 1;
  }), [e, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (c, l, u = {}) => {
      if (!r.current || !o.current)
        return c(
          (v) => l == null ? void 0 : l(v),
          () => {
          }
        );
      let d;
      const m = i.current, h = s.current, g = () => r.current && o.current && i.current === m && s.current === h, f = (v) => g() && Ht(h, v);
      try {
        const v = await c(
          (_) => {
            if (!f(_.channelUrl)) {
              l == null || l(_);
              return;
            }
            d = _.reqId, n.messagePendingStuck.start({
              requestId: _.reqId,
              channelUrl: _.channelUrl,
              messageType: Lh(_),
              tracksUploadProgress: u.tracksUploadProgress ?? !1
            }), l == null || l(_);
          },
          (_) => {
            !g() || d !== _ || n.messagePendingStuck.markUploadProgress(_);
          }
        );
        return d && (g() ? n.messagePendingStuck.resolve({ requestId: d }) : n.messagePendingStuck.disappear({ requestId: d })), v;
      } catch (v) {
        throw d && (g() ? n.messagePendingStuck.resolve({ requestId: d }) : n.messagePendingStuck.disappear({ requestId: d })), v;
      }
    },
    [n]
  );
}, Gh = ({
  channelUrl: e,
  enabled: t = !0,
  statsTrackers: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (r.current = !0, s.current = e, o.current = t, i.current += 1, () => {
    r.current = !1, i.current += 1;
  }), [e, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (c) => {
      if (!r.current || !o.current)
        return c(() => {
        });
      const l = i.current, u = s.current, d = () => r.current && o.current && i.current === l && s.current === u;
      let m = Oh(u);
      n.userPerceivedResponseTime.startTurn({ requestId: m, channelUrl: u }), n.typingIndicatorAbsentTimeout.startTurn({ requestId: m, channelUrl: u });
      try {
        const h = await c((g) => {
          d() && (n.userPerceivedResponseTime.replaceTurnRequestId(m, g), n.typingIndicatorAbsentTimeout.replaceTurnRequestId(m, g), m = g);
        });
        return d() ? (n.userPerceivedResponseTime.markUserMessageAck({
          requestId: m,
          messageId: h.messageId
        }), n.typingIndicatorAbsentTimeout.markUserMessageAck({
          requestId: m,
          messageId: h.messageId
        })) : (n.userPerceivedResponseTime.cancelTurn(m), n.typingIndicatorAbsentTimeout.cancelTurn(m)), h;
      } catch (h) {
        throw n.userPerceivedResponseTime.cancelTurn(m), n.typingIndicatorAbsentTimeout.cancelTurn(m), h;
      }
    },
    [e, n]
  );
}, Vh = ({
  requestedChannelUrl: e,
  activeChannelUrl: t,
  statsEnabled: n = !0,
  statsTrackers: r
}) => {
  const { aiAgentInfo: s } = it();
  Ph({ activeChannelUrl: t, statsTrackers: r }), Fh({ enabled: n, requestedChannelUrl: e, statsTrackers: r });
  const o = Uh({
    aiAgentUserId: s == null ? void 0 : s.userId,
    statsEnabled: n,
    requestedChannelUrl: e,
    statsTrackers: r
  }), i = Hh({
    channelUrl: t,
    enabled: n,
    statsTrackers: r
  }), c = Gh({
    channelUrl: t,
    enabled: n,
    statsTrackers: r
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      messageCallbacks: o,
      runWithPendingStuckStats: i,
      runWithUserTurnStats: c
    }),
    [o, i, c]
  );
}, pt = () => we()._aiAgentSDK.statsTrackers, zh = ({
  enabled: e = !0,
  channelUrl: t
} = {}) => {
  const { conversationInitialRender: n } = pt(), { watchBackgrounded: r } = we()._aiAgentSDK, s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    n.setVisible(e);
  }, [e, n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (!t) return;
    const o = n.startSpan(t);
    return s.current = o, () => {
      o.cancel(), s.current === o && (s.current = null);
    };
  }, [t, n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      onGetChannelStart: (o) => {
        var i;
        (i = s.current) == null || i.onGetChannelStart(o);
      },
      onGetChannelComplete: ({ channelUrl: o, conversationId: i }) => {
        var c;
        (c = s.current) == null || c.onGetChannelComplete(o, i);
      },
      onGetChannelError: ({ channelUrl: o, error: i }) => {
        var c;
        (c = s.current) == null || c.onGetChannelError(o, i);
      },
      onCollectionInitializeStart: () => {
        var o;
        (o = s.current) == null || o.onGetMessagesStart();
      },
      onCollectionCacheResult: (o, i) => {
        var c;
        (c = s.current) == null || c.onGetMessagesCacheComplete(i, o);
      },
      onCollectionApiResult: (o, i) => {
        const c = s.current;
        if (!c) return;
        c.onGetMessagesComplete(i, o);
        const l = r == null ? void 0 : r();
        Oe(() => {
          l != null && l() ? c.onRenderDiscarded() : c.onRendered();
        });
      }
    }),
    [r]
  );
}, Kh = ({
  enabled: e = !0,
  channelUrl: t,
  conversationId: n,
  messages: r
}) => {
  const { duplicateMessageResponse: s } = pt(), { aiAgentInfo: o } = it(), i = o == null ? void 0 : o.userId;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    !e || !t || !i || s.onMessagesChanged({ channelUrl: t, conversationId: n, aiAgentUserId: i, messages: r });
  }, [i, t, n, e, r, s]);
}, Wh = ({
  enabled: e = !0,
  channelUrl: t,
  conversationId: n
} = {}) => {
  const { messageLifecycleEvent: r } = pt(), { chatSDK: s, _aiAgentSDK: o } = we(), { watchBackgrounded: i } = o, { aiAgentInfo: c } = it(), l = c == null ? void 0 : c.userId, u = e && !!t && !!l;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    r.setBackgroundedWatcher(i);
  }, [r, i]), At(u ? s : void 0, {
    onTypingStatusUpdated(g) {
      g.url === t && r.onTypingChanged({
        channelUrl: g.url,
        isAgentTyping: g.getTypingUsers().some((f) => f.userId === l)
      });
    }
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!u || !t || !l) return;
    const g = tr.subscribe((f) => {
      r.onCollectionEvent({ event: f, channelUrl: t, aiAgentUserId: l });
    });
    return () => {
      g(), r.clearChannel(t);
    };
  }, [l, t, u, r]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    !u || !t || r.onConversationIdResolved({ channelUrl: t, conversationId: n });
  }, [t, n, u, r]);
  const d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g) => {
      !u || !t || !tt(g) || g.sendingStatus !== _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED || r.onUserMessageSent({ channelUrl: t, conversationId: n, messageId: g.messageId });
    },
    [t, n, u, r]
  ), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g) => {
      u && r.onAnimationStart({ messageId: g });
    },
    [u, r]
  ), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g, f) => {
      u && r.onAnimationComplete({ messageId: g, completed: f });
    },
    [u, r]
  );
  return { onOutgoingMessageStatusChanged: d, onAnimationStart: m, onAnimationComplete: h };
}, Yh = ({
  enabled: e = !0,
  channelUrl: t,
  conversationId: n
} = {}) => {
  const { streamingMessageValidation: r } = pt(), { watchBackgrounded: s } = we()._aiAgentSDK, { aiAgentInfo: o } = it(), i = o == null ? void 0 : o.userId, c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n);
  c.current = n, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    r.setBackgroundedWatcher(s);
  }, [r, s]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e || !t || !i) return;
    const l = tr.subscribe((u) => {
      r.onCollectionEvent({ event: u, channelUrl: t, conversationId: c.current, aiAgentUserId: i });
    });
    return () => {
      l(), r.clearChannel(t);
    };
  }, [i, t, e, r]);
}, It = (e) => {
  e && e.catch(() => {
  });
}, _n = (e, t) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    r.current = t;
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const s = new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.C({
      onDisconnected: (o) => {
        var i, c;
        return It((c = (i = r.current).onDisconnected) == null ? void 0 : c.call(i, o));
      },
      onConnected: (o) => {
        var i, c;
        return It((c = (i = r.current).onConnected) == null ? void 0 : c.call(i, o));
      },
      onReconnectStarted: () => {
        var o, i;
        return It((i = (o = r.current).onReconnectStarted) == null ? void 0 : i.call(o));
      },
      onReconnectSucceeded: () => {
        var o, i;
        return It((i = (o = r.current).onReconnectSucceeded) == null ? void 0 : i.call(o));
      },
      onReconnectFailed: () => {
        var o, i;
        return It((i = (o = r.current).onReconnectFailed) == null ? void 0 : i.call(o));
      },
      onConnectionLost: () => {
        var o, i;
        return It((i = (o = r.current).onConnectionLost) == null ? void 0 : i.call(o));
      },
      onConnectionDelayed: (o) => {
        var i, c;
        return It((c = (i = r.current).onConnectionDelayed) == null ? void 0 : c.call(i, o));
      }
    });
    return e.addConnectionHandler(n, s), () => {
      e.removeConnectionHandler(n);
    };
  }, [e, n]);
}, To = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
  return {
    next: () => (e.current += 1, e.current),
    current: () => e.current,
    invalidate: () => {
      e.current += 1;
    },
    isCurrent: (t) => t === e.current
  };
};
function qh(e, t = {}) {
  const { shouldInitializeConversation: n = !0, initialUserMessage: r } = t, { chatSDK: s, logger: o, aiAgentId: i, _aiAgentSDK: c } = we(), { sdkUser: l } = it(), u = To(), d = To(), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), g = er(), [f, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), [_, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), y = ge((A) => {
    if (n && A.isAIAgent && !A.conversation) {
      const I = d.next();
      p(!0), c.initConversationIfNeeded(A, { initialUserMessage: r }).finally(() => {
        d.isCurrent(I) && p(!1);
      });
    }
  });
  async function S() {
    var I, k, N, R, M, B;
    const A = u.next();
    if (!l) {
      o.debug("useChannel.getChannel: no sdk user, skip fetching channel");
      return;
    }
    if (o.debug("useChannel.getChannel: start"), h(void 0), v(void 0), d.invalidate(), p(!1), e) {
      (I = t.onFetchStart) == null || I.call(t, e);
      try {
        o.debug("useChannel.getChannel: get channel", e);
        const P = await s.groupChannel.getChannel(e);
        if (!u.isCurrent(A)) return;
        y(P), h(P), (N = t.onFetchSuccess) == null || N.call(t, {
          channelUrl: P.url,
          conversationId: (k = P.conversation) == null ? void 0 : k.id
        }), P.url === ((R = c.session) == null ? void 0 : R.activeChannel.url) && c.session._updateActiveChannel({
          url: P.url,
          status: He(P) ? "closed" : "open",
          conversationStatus: (M = P.conversation) == null ? void 0 : M.status
        }), o.debug("useChannel.getChannel: fetched channel", P);
      } catch (P) {
        if (!u.isCurrent(A)) return;
        (B = t.onFetchError) == null || B.call(t, {
          channelUrl: e,
          error: P
        }), P instanceof _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.q && v(P), o.error("useChannel.getChannel: error", P);
      }
    }
  }
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => (S(), () => {
    u.invalidate();
  }), [s, l, e, i]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    n && m && y(m);
  }, [n]), _n(s, {
    async onReconnectSucceeded() {
      var A;
      try {
        if (!m) {
          f && await S();
          return;
        }
        const I = u.current(), k = await m.refresh();
        if (!u.isCurrent(I) || m.url !== e) return;
        (A = t.onReconnectSucceeded) == null || A.call(t, m.url), y(k), h(k);
      } catch (I) {
        o.error("useChannel.onReconnectSucceeded: failed to sync the channel", I);
      }
    }
  }), At(s, {
    onChannelChanged: (A) => {
      A.isGroupChannel() && A.url === e && (o.debug("useChannel.onChannelChanged: channel changed", A.url), h(A), g());
    }
  }), {
    channel: m,
    channelRevision: g.revision,
    channelFetchError: f,
    getChannel: S,
    isInitializingConversation: _
  };
}
const jh = (e) => {
  const t = e == null ? void 0 : e.lastMessage, n = t == null ? void 0 : t.extendedMessagePayload, r = n == null ? void 0 : n.user_input_disabled_by;
  if (!r) return;
  const s = hn(n);
  switch (r) {
    case "suggested_replies":
      return s.hasSuggestedReplies ? r : void 0;
    case "steward":
      return s.hasSteward ? r : void 0;
    case "system":
      return r;
    default:
      return;
  }
}, Xh = (e) => {
  var o;
  const t = e == null ? void 0 : e.lastMessage;
  if (!t || !e) return !1;
  const n = t.extendedMessagePayload, r = hn(n).hasActiveForm, s = e.isAIAgent && !!((o = e.conversation) != null && o.handedOverAt);
  return r && !s;
}, Zh = () => {
  const { chatSDK: e, networkStateAdapter: t } = we(), [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => t ? t.isOnline() ? "connected" : "reconnecting" : "connected");
  return _n(e, {
    onConnected: () => r("connected"),
    onDisconnected: () => r("disconnected"),
    onReconnectStarted: () => r("reconnecting"),
    onReconnectSucceeded: () => r("connected"),
    onReconnectFailed: () => r("disconnected"),
    onConnectionLost: () => r("reconnecting")
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return t.subscribe((s) => {
        if (!s) {
          r("reconnecting");
          return;
        }
        r((o) => o === "reconnecting" && e.connectionState === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.w.OPEN ? "connected" : o);
      });
  }, [t, e]), n;
}, Jh = 3e4, Qh = ({
  shouldApply: e,
  lastMessage: t,
  isBlockedWhileAIResponding: n,
  currentUserId: r
}) => {
  const [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), c = t && ze(t, r) ? t.createdAt : 0;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const l = () => {
      i.current && (clearTimeout(i.current), i.current = null), o(!1);
    }, u = (h) => {
      i.current && clearTimeout(i.current), o(!0), i.current = setTimeout(() => {
        o(!1), i.current = null;
      }, h);
    }, d = Date.now() - c, m = Jh - d;
    return n || m <= 0 ? l() : u(m), () => {
      i.current && clearTimeout(i.current);
    };
  }, [n, c]), s && e;
}, ga = (e) => {
  const { chatSDK: t } = we(), [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  return At(t, {
    onTypingStatusUpdated(s) {
      if (s.url === (e == null ? void 0 : e.url)) {
        const o = s.getTypingUsers();
        r(o);
      }
    }
  }), n;
}, eg = ({ channel: e, lastMessage: t, aiAgentUserId: n, isStreamAnimating: r }) => {
  const [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = ga(e);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) return;
    const c = i.some((u) => u.userId === n), l = ze(t, n) && (Re.isStreaming(t) || r);
    o(l || c);
  }, [i, t, n, r]), s;
}, tg = ({
  channel: e,
  messages: t,
  isStreamAnimating: n,
  isInitializingConversation: r
}) => {
  const { aiAgentInfo: s, userSession: o } = it(), i = Zh(), c = eg({
    channel: e,
    lastMessage: Or(t, [_sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED]),
    aiAgentUserId: (s == null ? void 0 : s.userId) ?? "",
    isStreamAnimating: n
  }), l = Qh({
    shouldApply: !!(e != null && e.isAIAgent) && !ft(e),
    isBlockedWhileAIResponding: c,
    lastMessage: Or(t, [_sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.PENDING, _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED]),
    currentUserId: (o == null ? void 0 : o.userId) ?? ""
  });
  if (!e || i === "disconnected")
    return xt.unavailable;
  if (i === "reconnecting")
    return xt.reconnecting;
  if (He(e))
    return xt.conversation_closed;
  if (Ru(e))
    return xt.handoff_pending;
  if (Xh(e))
    return xt.form_active;
  const u = jh(e);
  return u ? xt[u] : c || l || r ? xt.ai_responding : ng;
}, ht = (e) => Object.freeze(e === "ai_responding" ? { disabled: !0, disabledBy: e, focusPolicy: "preserve" } : { disabled: !0, disabledBy: e, focusPolicy: "release" }), ng = Object.freeze({ disabled: !1, disabledBy: "", focusPolicy: "auto" }), xt = Object.freeze({
  ai_responding: ht("ai_responding"),
  unavailable: ht("unavailable"),
  form_active: ht("form_active"),
  conversation_closed: ht("conversation_closed"),
  suggested_replies: ht("suggested_replies"),
  steward: ht("steward"),
  system: ht("system"),
  reconnecting: ht("reconnecting"),
  handoff_pending: ht("handoff_pending")
}), rg = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(/* @__PURE__ */ new Set()), [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(/* @__PURE__ */ new Map()), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m) => {
    t((h) => {
      if (h.has(m)) return h;
      const g = new Set(h);
      return g.add(m), g;
    });
  }, []), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m) => {
    t((h) => {
      if (!h.has(m)) return h;
      const g = new Set(h);
      return g.delete(m), g;
    });
  }, []), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m, h) => {
    r((g) => {
      const f = new Map(g);
      return f.set(m, h), f;
    });
  }, []), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m) => {
    r((h) => {
      if (!h.has(m)) return h;
      const g = new Map(h);
      return g.delete(m), g;
    });
  }, []), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((m) => n.has(m), [n]), u = n.values().next().value, d = e.size > 0;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      isAnimating: d,
      start: s,
      stop: o,
      isHolding: l,
      heldTypingInfo: u,
      holdStart: i,
      holdStop: c
    }),
    [d, s, o, l, u, i, c]
  );
}, {
  Provider: sg
} = xe("AIAgentConversation");
function og({
  children: e,
  channelUrl: t,
  onChannelDeleted: n,
  onMessagesReceived: r,
  onMessagesUpdated: s,
  onConversationStatusChanged: o,
  onConversationClosedViaDispatcher: i,
  onBeforeSendMessage: c,
  onAfterSendMessage: l = Ae,
  shouldMarkAsRead: u = !0,
  conversationStatsEnabled: d = !0,
  shouldInitializeConversation: m = !0,
  initialUserMessage: h,
  shouldCountNewMessages: g = () => !1,
  sortComparator: f
}) {
  var H, te, ue, re, ye;
  const { _aiAgentSDK: v, chatSDK: _, logger: p, dispatcher: y } = we(), S = () => {
    u && (M == null || M.markAsRead().catch((K) => p.warn("AIAgentConversationContext: markAsRead failed", K)));
  }, A = pt(), I = {
    channelUrl: t,
    enabled: d
  }, k = lh({
    ...I,
    statsTracker: A.conversationNotInteractiveTimeout
  }), N = uh({
    ...I,
    scheduleForegroundTask: v.scheduleForegroundTask,
    statsTracker: A.recoveryNotInteractiveTimeout
  }), R = zh(I), { channel: M, channelRevision: B, channelFetchError: P, getChannel: ne, isInitializingConversation: ce } = qh(
    t,
    {
      shouldInitializeConversation: m,
      initialUserMessage: h,
      onFetchStart: (K) => {
        k.onFetchStart(K), R.onGetChannelStart(K);
      },
      onFetchSuccess: (K) => {
        k.onFetchSuccess(K), R.onGetChannelComplete(K);
      },
      onFetchError: (K) => {
        k.onFetchError(K), R.onGetChannelError(K);
      },
      onReconnectSucceeded: N.onReconnectSucceeded
    }
  ), X = M == null ? void 0 : M.url, J = Wh({
    // Only a bot-handled AI agent channel has the render path these moments describe.
    // `hasAiBot` goes false for the stretch a human agent handles the conversation, which is
    // what keeps a handed-off turn from being reported as a reply that never arrived.
    enabled: d && !!(M != null && M.isAIAgent) && M.hasAiBot,
    channelUrl: X,
    conversationId: (H = M == null ? void 0 : M.conversation) == null ? void 0 : H.id
  }), U = Vh({
    requestedChannelUrl: t,
    activeChannelUrl: X,
    statsEnabled: d,
    statsTrackers: A
  }), Y = ah(_, M, {
    replyType: _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.aw.ONLY_REPLY_TO_CHANNEL,
    shouldCountNewMessages: g,
    logger: p,
    markAsRead: S,
    sortComparator: f,
    onChannelDeleted: n,
    onMessagesReceived: (K) => r == null ? void 0 : r(K),
    onMessagesUpdated: (K) => s == null ? void 0 : s(K),
    onCollectionInitializeStart: () => {
      R.onCollectionInitializeStart();
    },
    onApiResult: (K, Ce, ve) => {
      R.onCollectionApiResult(K, ve), U.messageCallbacks.onApiResult(K, Ce, ve);
    },
    onCacheResult: (K, Ce, ve) => {
      R.onCollectionCacheResult(K, ve), U.messageCallbacks.onCacheResult(K, Ce, ve);
    },
    onCollectionEvent: (K) => {
      U.messageCallbacks.onCollectionEvent(K), tr.publish(K);
    },
    onLocalMessageDeleted: (K) => {
      U.messageCallbacks.onLocalMessageDeleted(K);
    },
    onOutgoingMessageStatusChanged: (K) => {
      J.onOutgoingMessageStatusChanged(K), M && v.liveMetricManager.track({ type: "outgoingMessage", channel: M, message: K });
    }
  }), q = rg(), j = tg({
    channel: M,
    messages: Y.messages,
    isStreamAnimating: q.isAnimating,
    isInitializingConversation: ce
  });
  Yh({
    enabled: d,
    channelUrl: X,
    conversationId: (te = M == null ? void 0 : M.conversation) == null ? void 0 : te.id
  }), Kh({
    enabled: d,
    channelUrl: X,
    conversationId: (ue = M == null ? void 0 : M.conversation) == null ? void 0 : ue.id,
    messages: Y.messages
  }), Bh({
    enabled: d,
    channelUrl: X,
    initialized: Y.initialized,
    inputReady: kh(j),
    renderedSignal: Y.messages,
    statsTrackers: A
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    S();
  }, [u, M]);
  const V = (re = M == null ? void 0 : M.conversation) == null ? void 0 : re.status;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    V && (o == null || o(V));
  }, [V, o]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const K = async (Ce) => {
      const ve = typeof (Ce == null ? void 0 : Ce.channelUrl) == "string";
      M && ve && Ce.channelUrl !== M.url || (p.debug("conversation.dispatcher: try to close conversation", M), M != null && M.conversation && M.conversation.status === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN && (await M.closeConversation(), i == null || i()));
    };
    return y.subscribe(qe.ConversationClose, K), () => {
      y.unsubscribe(qe.ConversationClose, K);
    };
  }, [y, M, p, (ye = M == null ? void 0 : M.conversation) == null ? void 0 : ye.status, i]);
  const z = ge(() => Y.loadPrevious()), W = ge(() => Y.loadNext()), se = ge(
    async (K) => {
      try {
        await Y.deleteMessage(K);
      } finally {
        K.sendingStatus !== "succeeded" && U.messageCallbacks.onLocalMessageDeleted(K);
      }
    }
  ), he = ge(
    (K) => K.isUserMessage() ? U.runWithUserTurnStats(
      (Ce) => U.runWithPendingStuckStats(
        (ve) => Y.resendMessage(K, (de) => {
          Ce(de.reqId), ve(de);
        }),
        void 0
      )
    ) : U.runWithPendingStuckStats(
      (Ce, ve) => Y.resendMessage(K, Ce, ve),
      void 0,
      { tracksUploadProgress: K.isMultipleFilesMessage() }
    )
  ), $ = ge(() => Y.resetNewMessages()), Ie = ge(async (K) => {
    var ve;
    if (((ve = M == null ? void 0 : M.conversation) == null ? void 0 : ve.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED)
      throw new Error("Conversation is closed");
    c && (K = await c(K));
    const Ce = await U.runWithUserTurnStats(
      (de) => U.runWithPendingStuckStats(
        (Se) => Y.sendUserMessage(K, (_e) => {
          de(_e.reqId), Se(_e);
        }),
        l
      )
    );
    return l == null || l(Ce), Ce;
  }), ke = ge(async (K) => {
    var ve;
    if (((ve = M == null ? void 0 : M.conversation) == null ? void 0 : ve.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED)
      throw new Error("Conversation is closed");
    c && (K = await c(K));
    const Ce = await U.runWithPendingStuckStats(
      (de) => Y.sendFileMessage(K, de),
      l
    );
    return l == null || l(Ce), Ce;
  }), Pe = ge(async (K) => {
    var ve;
    if (((ve = M == null ? void 0 : M.conversation) == null ? void 0 : ve.status) === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED)
      throw new Error("Conversation is closed");
    c && (K = await c(K));
    const Ce = await U.runWithPendingStuckStats(
      (de, Se) => Y.sendMultipleFilesMessage(K, de, Se),
      l,
      { tracksUploadProgress: !0 }
    );
    return l == null || l(Ce), Ce;
  }), x = ge(ne), O = ge(async () => {
    He(M) || await (M == null ? void 0 : M.closeConversation());
  }), F = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      _statsEnabled: d,
      _stats: {
        onMessageLifecycleAnimationStart: J.onAnimationStart,
        onMessageLifecycleAnimationComplete: J.onAnimationComplete
      },
      conversation: (M == null ? void 0 : M.conversation) ?? void 0,
      actions: {
        setUserMemoryState: v.setUserMemoryState
      },
      channelSource: {
        channel: M,
        error: P,
        refetch: x,
        closeConversation: O
      },
      messageSource: {
        messages: Y.messages,
        newMessages: Y.newMessages,
        initialized: Y.initialized,
        loadPrevious: z,
        loadNext: W,
        deleteMessage: se,
        resendMessage: he,
        resetNewMessages: $,
        sendUserMessage: Ie,
        sendFileMessage: ke,
        sendMultipleFilesMessage: Pe
      },
      state: {
        streamAnimation: q,
        input: j
      }
    }),
    [
      d,
      J.onAnimationStart,
      J.onAnimationComplete,
      M,
      // Reflects in-place SDK channel mutations (see useChannel).
      B,
      v,
      P,
      x,
      O,
      Y.messages,
      Y.newMessages,
      Y.initialized,
      // Reflects in-place SDK message mutations published via forced renders (see useGroupChannelMessages).
      Y.collectionRevision,
      z,
      W,
      se,
      he,
      $,
      Ie,
      ke,
      Pe,
      q,
      j
    ]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sg, { value: F }, e);
}
function ig(e, t, n) {
  var p, y, S, A, I, k, N, R, M, B;
  const [r, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), h = ge(() => {
    var P;
    return (P = n == null ? void 0 : n.onListRequestStart) == null ? void 0 : P.call(n);
  }), g = ge((P) => {
    var ne;
    return (ne = n == null ? void 0 : n.onListRequestComplete) == null ? void 0 : ne.call(n, P);
  }), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (P) => {
      h();
      try {
        await P.loadMore(), g();
      } catch (ne) {
        throw g(ne), ne;
      }
    },
    [h, g]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    if (!m.current && e.currentUser) {
      m.current = !0, s(!1), i(null), l([]);
      try {
        u == null || u.dispose();
        const P = new qi(e, t);
        P.setConversationListCollectionHandler({
          onChannelsAdded: () => {
            l(P.channels);
          },
          onChannelsUpdated: () => {
            l(P.channels);
          },
          onChannelsDeleted: () => {
            l(P.channels);
          }
        }), await f(P), l(P.channels), d(P), i(null);
      } catch (P) {
        d(null), i(P);
      } finally {
        s(!0), m.current = !1;
      }
    }
  }, [
    e,
    e.currentUser,
    (p = t.filter) == null ? void 0 : p.aiAgentChannelFilter,
    (S = (y = t.filter) == null ? void 0 : y.aiAgentConversationStatusFilter) == null ? void 0 : S.join(),
    (I = (A = t.filter) == null ? void 0 : A.aiAgentIds) == null ? void 0 : I.join(),
    (k = t.filter) == null ? void 0 : k.deskChannelFilter,
    (R = (N = t.filter) == null ? void 0 : N.pinnedChannelUrls) == null ? void 0 : R.join(),
    (M = t.filter) == null ? void 0 : M.copilotConversationOnly,
    (B = t.filter) == null ? void 0 : B.copilotSupportChannelUrl,
    t.limit,
    f
  ]), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    if (u)
      try {
        await u.loadMore(), l(u.channels);
      } catch (P) {
        i(P);
      }
  }, [u]);
  return _n(e, {
    onConnected: () => v()
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    v();
  }, [v]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    m.current = !1, u == null || u.dispose();
  }, [u]), {
    initialized: r,
    error: o,
    channels: c,
    loadMore: _
  };
}
const fa = (e) => {
  var s;
  const { aiAgentId: t, queryParams: n } = we(), r = (s = n == null ? void 0 : n.conversationListParams) == null ? void 0 : s.filter;
  return {
    aiAgentIds: [t],
    aiAgentConversationStatusFilter: [_sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED, _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.OPEN],
    ...r,
    ...e
  };
}, ag = ({
  enabled: e = !0
} = {}) => {
  const { conversationListInitialRender: t } = pt(), { watchBackgrounded: n } = we()._aiAgentSDK, r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    t.setVisible(e);
  }, [e, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const s = t.startSpan();
    return r.current = s, () => {
      s.cancel(), r.current === s && (r.current = null);
    };
  }, [t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      onListRequestStart: () => {
        var s;
        (s = r.current) == null || s.onListRequestStart();
      },
      onListRequestComplete: (s) => {
        const o = r.current;
        if (!o || (o.onListRequestComplete(s), s)) return;
        const i = n == null ? void 0 : n();
        Oe(() => {
          i != null && i() ? o.onRenderDiscarded() : o.onRendered();
        });
      }
    }),
    [n]
  );
}, {
  Provider: cg
} = xe("AIAgentConversationList");
function lg({
  conversationListLimit: e,
  conversationListFilter: t,
  conversationListStatsEnabled: n = !0,
  children: r
}) {
  var m;
  const { chatSDK: s, queryParams: o } = we(), i = e ?? ((m = o == null ? void 0 : o.conversationListParams) == null ? void 0 : m.limit), c = fa(t), l = ag({ enabled: n }), u = ig(
    s,
    { limit: i, filter: c },
    {
      onListRequestStart: () => {
        l.onListRequestStart();
      },
      onListRequestComplete: (h) => {
        l.onListRequestComplete(h);
      }
    }
  ), d = {
    listSource: {
      initialized: u.initialized,
      error: u.error ?? void 0,
      channels: u.channels,
      loadMore: () => u.loadMore()
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cg, { value: d }, r);
}
function ug(e) {
  let t = "pending", n = e.then((r) => {
    t = "resolved", n = r;
  }).catch((r) => {
    t = "rejected", n = r;
  });
  return {
    get value() {
      if (t === "resolved")
        return n;
      throw n;
    }
  };
}
const {
  Provider: dg,
  useContext: u0
} = xe("MessageTemplateFetching");
function mg({ children: e, internalVariables: t }) {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}), [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((u, d) => {
    o((m) => ({
      ...m,
      [u]: { fetching: !1, error: !1, ...m[u], ...d }
    }));
  }, []), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async ({
      onRequestTemplate: u,
      onGetCachedTemplate: d,
      templateKey: m,
      suspense: h = !1
    }) => {
      const g = d(m);
      if (g) return g;
      const f = r.current[m];
      if (f) return f;
      h || i(m, { fetching: !0 });
      const v = u(m).catch((_) => {
        throw h || i(m, { error: !0 }), _;
      }).finally(() => {
        h || i(m, { fetching: !1 }), delete r.current[m];
      });
      return r.current[m] = v, v;
    },
    [i]
  ), l = {
    internalVariables: t,
    fetchTemplate: c,
    suspend: (u, d) => {
      if (n.current[u])
        return n.current[u];
      const m = ug(d());
      return n.current[u] = m, m;
    },
    getIsFetching: (u) => {
      var d;
      return ((d = s[u]) == null ? void 0 : d.fetching) ?? !1;
    },
    getHasError: (u) => {
      var d;
      return ((d = s[u]) == null ? void 0 : d.error) ?? !1;
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(dg, { value: l }, e);
}
const hg = "remove_powered_by", Cs = (e, t) => {
  var s, o;
  const { chatSDK: n } = we(), { aiAgentInfo: r } = it();
  if (e === "handoff-button") {
    const i = !!((s = t == null ? void 0 : t.conversation) != null && s.handoff);
    return !!(t != null && t.isAIAgent) && !!(r != null && r.showHandoffButton) && i && cs(t);
  }
  if (e === "special-notice")
    return !!(t != null && t.isAIAgent) && !!(r != null && r.specialNoticeEnabled) && !!(r != null && r.specialNotice);
  if (e === "powered-by") {
    const i = (o = n == null ? void 0 : n.appInfo) == null ? void 0 : o.applicationAttributes;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => !(Array.isArray(i) && i.includes(hg)), [i]);
  }
  throw new Error("Unsupported feature");
}, gg = {
  required: "This question is required",
  minLength: (e) => `Minimum ${e} characters required`,
  maxLength: (e) => `Maximum ${e} characters allowed`,
  min: (e) => `Minimum value is ${e}`,
  max: (e) => `Maximum value is ${e}`,
  minSelect: (e) => `Select at least ${e} options`,
  maxSelect: (e) => `Select at most ${e} options`,
  regex: "Invalid format",
  invalidSelection: "Invalid selection"
}, fg = {
  getValueOrDefault: (e) => e.value ?? e.default_value ?? null,
  validate: (e, t, n) => {
    const r = t;
    if (e.required && (!r || r.trim() === ""))
      return {
        isValid: !1,
        error: n.required
      };
    if (!r)
      return { isValid: !0 };
    const { rules: s } = e;
    if (s) {
      if (s.min_length !== void 0 && r.length < s.min_length)
        return {
          isValid: !1,
          error: typeof n.minLength == "function" ? n.minLength(s.min_length) : n.minLength
        };
      if (s.max_length !== void 0 && r.length > s.max_length)
        return {
          isValid: !1,
          error: typeof n.maxLength == "function" ? n.maxLength(s.max_length) : n.maxLength
        };
      if (s.regex && !new RegExp(s.regex).test(r))
        return {
          isValid: !1,
          error: n.regex
        };
    }
    return { isValid: !0 };
  }
}, pg = {
  getValueOrDefault: (e) => e.value ?? e.default_value ?? null,
  validate: (e, t, n) => {
    const r = t;
    if (e.required && r === null)
      return {
        isValid: !1,
        error: n.required
      };
    if (r === null)
      return { isValid: !0 };
    const { rules: s } = e;
    if (s) {
      if (s.min !== void 0 && r < s.min)
        return {
          isValid: !1,
          error: typeof n.min == "function" ? n.min(s.min) : n.min
        };
      if (s.max !== void 0 && r > s.max)
        return {
          isValid: !1,
          error: typeof n.max == "function" ? n.max(s.max) : n.max
        };
    }
    return { isValid: !0 };
  }
}, _g = {
  getValueOrDefault: (e) => e.value ?? e.default_value ?? null,
  validate: (e, t, n) => {
    const r = t;
    return e.required && !r ? {
      isValid: !1,
      error: n.required
    } : r && !e.options.includes(r) ? {
      isValid: !1,
      error: n.invalidSelection
    } : { isValid: !0 };
  }
}, Eg = {
  getValueOrDefault: (e) => e.values ?? e.default_values ?? null,
  validate: (e, t, n) => {
    const r = t;
    if (e.required && (!r || r.length === 0))
      return {
        isValid: !1,
        error: n.required
      };
    if (!r || r.length === 0)
      return { isValid: !0 };
    if (r.filter((i) => !e.options.includes(i)).length > 0)
      return {
        isValid: !1,
        error: n.invalidSelection
      };
    const { rules: o } = e;
    if (o) {
      if (o.min_select !== void 0 && r.length < o.min_select)
        return {
          isValid: !1,
          error: typeof n.minSelect == "function" ? n.minSelect(o.min_select) : n.minSelect
        };
      if (o.max_select !== void 0 && r.length > o.max_select)
        return {
          isValid: !1,
          error: typeof n.maxSelect == "function" ? n.maxSelect(o.max_select) : n.maxSelect
        };
    }
    return { isValid: !0 };
  }
}, Cg = {
  text: fg,
  number: pg,
  "single-select": _g,
  "multi-select": Eg
}, vg = {
  getValueOrDefault: () => null,
  validate: () => ({ isValid: !1 })
};
function pa(e) {
  return Cg[e.type] || vg;
}
function Io(e) {
  return pa(e).getValueOrDefault(e);
}
function bg(e, t, n = {}) {
  const r = { ...gg, ...n };
  return pa(e).validate(e, t, r);
}
const Sg = (e, t = {}) => {
  const { labels: n = {}, onSubmit: r, onCancel: s } = t, [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    const v = {};
    return e.fields.forEach((_) => {
      v[_.key] = Io(_);
    }), v;
  }), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => e.submitted_at ? "submitted" : e.canceled_at ? "canceled" : "draft", [e.submitted_at, e.canceled_at]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (u === "submitted" || u === "canceled") {
      const v = {};
      let _ = !1;
      e.fields.forEach((p) => {
        const y = Io(p);
        JSON.stringify(c[p.key]) !== JSON.stringify(y) && (_ = !0), v[p.key] = y;
      }), _ && l(v);
    }
  }, [u]);
  const d = (v, _) => {
    l((p) => ({ ...p, [v]: _ })), i((p) => ({ ...p, [v]: void 0 }));
  }, m = e.fields.map((v) => {
    var y, S, A;
    const _ = c[v.key] ?? null, p = {
      key: v.key,
      label: v.label,
      error: o[v.key],
      required: v.required
    };
    return v.type === "text" ? {
      ...p,
      type: "text",
      layout: v.layout,
      value: _,
      ...v.placeholder && { placeholder: v.placeholder },
      ...((y = v.rules) == null ? void 0 : y.max_length) && { maxLength: v.rules.max_length }
    } : v.type === "number" ? {
      ...p,
      type: "number",
      layout: v.layout,
      value: _,
      ...v.placeholder && { placeholder: v.placeholder },
      ...((S = v.rules) == null ? void 0 : S.max) && { max: v.rules.max }
    } : v.type === "single-select" ? {
      ...p,
      type: "single-select",
      layout: v.layout,
      value: _,
      options: v.options
    } : v.type === "multi-select" ? {
      ...p,
      type: "multi-select",
      layout: v.layout,
      value: _,
      options: v.options,
      ...((A = v.rules) == null ? void 0 : A.max_select) && { maxSelect: v.rules.max_select }
    } : { ...p, type: "unknown", layout: "default", value: null };
  });
  return {
    state: u,
    fields: m,
    getField: (v) => m.find((_) => _.key === v),
    updateFieldValue: d,
    submit: async () => {
      const v = {};
      let _ = !1;
      for (const p of e.fields) {
        const y = c[p.key] ?? null, S = bg(p, y, n);
        S.isValid || (v[p.key] = S.error, _ = !0);
      }
      if (i(v), !_ && r) {
        const p = {};
        e.fields.forEach((y) => {
          p[y.key] = c[y.key] ?? null;
        }), await r(p);
      }
    },
    cancel: async () => {
      await (s == null ? void 0 : s());
    }
  };
}, _r = (e) => e.response === null ? e : { ...e, response: null }, _a = ({
  isMessengerOpened: e,
  onConversationStarted: t
}) => {
  const { _aiAgentSDK: n, aiAgentId: r, language: s, countryCode: o, context: i } = we(), { createConversation: c, userSession: l } = it(), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ seq: 0, response: null }), m = l == null ? void 0 : l.userId;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (d(_r), !(e || !m))
      return n.onNudgeMessageReceived(
        (v) => d((_) => ({ seq: _.seq + 1, response: v }))
      );
  }, [n, e, m]);
  const h = () => d(_r), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), f = async () => {
    var _;
    if (!u.response || g.current) return;
    g.current = !0, d(_r);
    const v = n.session;
    try {
      const p = await c({
        aiAgentId: r,
        language: s,
        country: o,
        context: i
      });
      if (n.session !== v) return;
      (_ = n.session) == null || _._updateActiveChannel({ url: p, status: "open" }), t({ channelUrl: p, initialUserMessage: u.response.callbackUserMessage });
    } finally {
      g.current = !1;
    }
  };
  return {
    // The state clears via the effect when the messenger opens; masking here avoids a one-frame flash.
    nudgeMessage: e ? null : u.response,
    nudgeMessageKey: u.seq,
    dismissNudgeMessage: h,
    startNudgeConversation: f
  };
}, yg = (e) => {
  const { chatSDK: t, handlers: n, logger: r } = we(), { aiAgentInfo: s } = it(), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), c = (d, m) => {
    if (!(n != null && n.onCustomEvent) || !(s != null && s.userId) || !ze(d, s.userId)) return;
    const h = d.messageId;
    if (Re.isStreaming(d)) {
      i.current.add(h);
      return;
    }
    m === "updated" && !i.current.has(h) || (r.debug("useCustomEventForMessageReceive: bot-message-received", d), n.onCustomEvent({ type: "bot-message-received", data: { message: d } }), i.current.delete(h));
  }, l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (d) => {
      if (n != null && n.onCustomEvent && d.isAdminMessage() && d.customType === "user_action_required" && !o.current.has(d.messageId)) {
        const m = Pi(d.data);
        Array.isArray(m.history) && m.history.length === 0 && (r.debug("useCustomEventForMessageReceive: user_action_required", m), n.onCustomEvent({
          type: "user-action-requested",
          data: m
        }), o.current.add(d.messageId));
      }
    },
    [n, r]
  ), u = (d, m, h) => {
    d.url === e && (c(m, h), l(m));
  };
  return At(t, {
    onMessageReceived: (d, m) => u(d, m, "received"),
    onMessageUpdated: (d, m) => u(d, m, "updated")
  }), {
    checkForUserActionRequired: l
  };
}, Ag = (e) => {
  if (e == null || typeof e != "object") return;
  const t = "thinking_message" in e ? e.thinking_message : void 0;
  return typeof t == "string" && t ? t : void 0;
}, Ea = (e) => {
  const { aiAgentInfo: t } = it(), n = ga(e);
  if (He(e)) return null;
  const r = n[0];
  if (!r) return null;
  const s = r.userId === (t == null ? void 0 : t.userId), o = s ? Ag(r.metaData) : void 0;
  return { user: s ? t : r, isBot: s, thinkingMessage: o };
}, Tg = 250, Ig = (e, t) => {
  var i;
  const [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  return e !== null ? (s.current = e, n || (o.current = t == null ? void 0 : t.messageId, r(!0))) : n && t !== void 0 && t.sender.userId === ((i = s.current) == null ? void 0 : i.user.userId) && t.messageId !== o.current && r(!1), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!n || e !== null) return;
    const c = setTimeout(() => r(!1), Tg);
    return () => clearTimeout(c);
  }, [n, e !== null]), e ?? (n ? s.current : null);
}, xg = (e, t, { enabled: n = !0, idleMs: r = 1e3 } = {}) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  o.current = t, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (s.current && (clearTimeout(s.current), s.current = null), !n || !e) {
      (c.current ? i.current : o.current)(!1), c.current = !1, i.current = o.current;
      return;
    }
    c.current = !0, i.current = o.current, i.current(!0), s.current = setTimeout(() => {
      s.current = null, i.current(!1), c.current = !1, i.current = o.current;
    }, r);
  }, [n, r, e]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    s.current && (clearTimeout(s.current), s.current = null), (c.current ? i.current : o.current)(!1), c.current = !1, i.current = o.current;
  }, []);
}, Mg = (e = 1e4) => {
  const t = /* @__PURE__ */ new Map();
  let n = e;
  return {
    shouldAnnounce: (c) => {
      const l = Date.now(), u = t.get(c);
      return u !== void 0 && l - u < n ? !1 : (t.set(c, l), !0);
    },
    setInterval: (c) => {
      n = c;
    },
    reset: () => {
      t.clear();
    }
  };
}, Rg = (e, t, n = 1e4, r = !0) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  s.current || (s.current = Mg(n));
  const c = (e == null ? void 0 : e.nickname.trim()) || null, l = (e == null ? void 0 : e.userId) ?? c;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var u;
    (u = s.current) == null || u.setInterval(n);
  }, [n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var m;
    if (!r) {
      i.current = !1, o.current = l;
      return;
    }
    if (!l || !c) {
      i.current = !1, o.current = null;
      return;
    }
    const u = !i.current, d = o.current !== l;
    i.current = !0, o.current = l, !(!u && !d) && (m = s.current) != null && m.shouldAnnounce(l) && t(c);
  }, [l, c, r, t]);
}, wg = ({
  csat: e,
  csatPayload: t,
  isRenderableCSAT: n,
  isExpiredNow: r,
  announceStatus: s,
  onSubmittedAnnounced: o
}) => {
  const i = (t == null ? void 0 : t.csat_submitted_label) ?? "", c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n && typeof e == "number"), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n && r);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    n && i && (typeof e != "number" || c.current || (c.current = !0, s && (s({ event: "csatSubmitted", submittedLabel: i }), o == null || o())));
  }, [s, e, n, o, i]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    n && r && (l.current || (l.current = !0, s == null || s({ event: "csatExpired" })));
  }, [s, r, n]);
}, vs = ({ channel: e, userSession: t, aiAgentInfo: n }) => {
  if (!t || !n || !e)
    return { fallbackIcon: void 0, url: void 0, title: "" };
  const r = Xi(e, t.userId), s = {
    ai(o) {
      return { fallbackIcon: o, url: n.profileUrl, title: n.nickname };
    },
    human(o) {
      return { fallbackIcon: o, url: r == null ? void 0 : r.profileUrl, title: (r == null ? void 0 : r.nickname) || n.nickname };
    },
    channel(o) {
      return { fallbackIcon: o, url: e == null ? void 0 : e.coverUrl, title: (e == null ? void 0 : e.name) ?? "" };
    }
  };
  return e.isAIAgent ? ft(e) ? s.human("agent") : s.ai("delight") : e.isDesk ? s.human("agent") : s.channel("user");
}, xo = (e) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((t, n) => ({ ...t, ...n }), e);
var gt = /* @__PURE__ */ ((e) => (e.AI_AGENT_CSAT_5 = "AI_AGENT_CSAT_5", e.AI_AGENT_CSAT_5_WITH_CRE = "AI_AGENT_CSAT_5_WITH_CRE", e.HELPDESK_CSAT_5 = "HELPDESK_CSAT_5", e))(gt || {});
const kg = /* @__PURE__ */ new Set(["free_text", "single_choice"]), Lg = ({ csatPayload: e, type: t, initialCsat: n, initialCsatReason: r, initialIsResolved: s }) => {
  const [o, i] = xo({
    csatType: t,
    csat: n,
    csatReason: r,
    isResolved: s
  }), [c, l] = xo({ followUpItem: !1 }), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var _;
    const g = o.csat, f = typeof g == "number", v = (_ = e.follow_up) == null ? void 0 : _.find((p) => f ? p.scores.includes(g) : p.always_visible ?? !1);
    if (kg.has(v == null ? void 0 : v.response_type)) return v;
  }, [o.csat, e.follow_up]), d = (() => {
    var g;
    if (typeof n == "number")
      return "submitted";
    if ((t === gt.AI_AGENT_CSAT_5 || t === gt.HELPDESK_CSAT_5) && typeof o.csat == "number")
      return "submittable";
    if (t === gt.AI_AGENT_CSAT_5_WITH_CRE) {
      const f = typeof o.csat == "number", v = !((g = e.cre) != null && g.required) || typeof o.isResolved == "boolean";
      if (f && v) return "submittable";
    }
    return "unsubmittable";
  })(), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => typeof o.csat > "u" ? !1 : u != null && u.required && !o.csatReason ? (l({ followUpItem: !0 }), !1) : !0, [o, u, l]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    r || (i({ csatReason: "" }), l({ followUpItem: !1 }));
  }, [r, u, i, l]), {
    params: o,
    setParams: i,
    error: c,
    setError: l,
    followUpItem: u,
    state: d,
    validateParams: m,
    itemProps: {
      csatPayload: e,
      state: d,
      submitted: d === "submitted"
    }
  };
}, Og = ({ csat: e, csatExpireAt: t, csatPayload: n, isSubmitInFlight: r = !1 }) => {
  const s = !!n && n.visibility && !!gt[n.type], o = !r && typeof e != "number" && Zi(t), i = er();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!s || typeof e == "number" || t == null || o) return;
    const c = t - Date.now();
    if (c <= 0 && r) return;
    const l = setTimeout(i, Math.max(0, c));
    return () => clearTimeout(l);
  }, [i, e, t, o, s, r]), { isRenderableCSAT: s, isExpiredNow: o };
}, Er = 5, rn = 250, Ca = 50, Ng = 1500, Cr = (e) => Math.max(0, e - Ca), $n = () => typeof performance < "u" && typeof performance.now == "function" ? performance.now() : 0, Dg = (e, t) => {
  const n = e && t.length <= Ca, r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n && t.length > 0 ? t : null), [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => !n), i = r.current !== null && t !== r.current, c = !n || i;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (s) return;
    const l = () => {
      r.current = null, o(!0);
    };
    if (c) {
      l();
      return;
    }
    if (r.current === null && t.length > 0 && (r.current = t), r.current === null) return;
    const u = setTimeout(l, Ng);
    return () => clearTimeout(u);
  }, [s, c, t]), !s && !c;
}, $g = (e) => e < 1e3 ? { speed: Er * 0.5, chunkSize: 2 } : e < 2e3 ? { speed: Er * 0.8, chunkSize: 2 } : { speed: Er * 0.6, chunkSize: 3 }, Pn = (e, t) => {
  let n = 0;
  for (let r = t - 1; r >= 0 && e[r] === "\\"; r--)
    n++;
  return n % 2 === 1;
}, Mo = (e, t, n, r) => {
  let s = 1, o = t;
  for (; o < e.length && s > 0; ) {
    if (Pn(e, o)) {
      o++;
      continue;
    }
    e[o] === n ? s++ : e[o] === r && s--, o++;
  }
  return s > 0 ? -1 : o;
}, va = (e, { hideImages: t, hideLinks: n }) => {
  let r = "", s = 0, o = 0;
  for (; s < e.length; ) {
    if (e[s] === "`" && !Pn(e, s)) {
      let m = 1;
      for (; e[s + m] === "`"; ) m++;
      o === 0 ? o = m : m === o && (o = 0), r += e.slice(s, s + m), s += m;
      continue;
    }
    const i = e[s] === "!" && e[s + 1] === "[" && !Pn(e, s), c = e[s] === "[" && !Pn(e, s);
    if (o > 0 || !i && !c) {
      r += e[s], s++;
      continue;
    }
    if (i ? !t : !n) {
      const m = i ? "![" : "[";
      r += m, s += m.length;
      continue;
    }
    const l = s, u = Mo(e, s + (i ? 2 : 1), "[", "]");
    if (u === -1) return r;
    if (s = u, e[s] !== "(") {
      r += e.slice(l, s);
      continue;
    }
    const d = Mo(e, s + 1, "(", ")");
    if (d === -1) return r;
    s = d, r += e.slice(l, s);
  }
  return r;
}, Pg = ({
  trackedRef: e,
  onVisibleTextProgress: t,
  onRenderedTextProgress: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    lastLength: 0,
    lastReportedAt: 0
  }).current, c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    lastLength: 0,
    lastReportedAt: 0,
    lastCheckedAt: 0
  }).current, l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    r.current = t, s.current = n;
  });
  const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((y) => {
    var S;
    (S = r.current) == null || S.call(r, y);
  }, []), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => {
      const S = e.initialEnabled && (e.enabled || y < e.textLength), A = S && e.deferImages, I = S && e.deferLinks;
      return !A && !I ? y : va(e.text.slice(0, y), { hideImages: A, hideLinks: I }).length;
    },
    [e]
  ), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y, S, A = !1) => {
      r.current && (y <= c.lastLength || !A && S - c.lastReportedAt < rn || (c.lastLength = y, c.lastReportedAt = S, u(y)));
    },
    [u, c]
  ), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y, S, A = !1) => {
      if (!r.current) return;
      const I = Math.max(c.lastReportedAt, c.lastCheckedAt);
      !A && S - I < rn || (c.lastCheckedAt = S, m(d(y), S, !0));
    },
    [d, m, c]
  ), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y, S, A = !1) => {
      s.current && (y <= i.lastLength || !A && S - i.lastReportedAt < rn || (i.lastLength = y, i.lastReportedAt = S, s.current(y)));
    },
    [i]
  ), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y, S, A) => {
      const I = y >= S, k = A - i.lastReportedAt >= rn;
      if (!I && !k) return;
      const N = d(y);
      g(N, A, I);
    },
    [d, i, g]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    c.lastLength = 0, c.lastReportedAt = 0, c.lastCheckedAt = 0, i.lastLength = 0, i.lastReportedAt = 0;
  }, [i, c]), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => {
      r.current && (o.current !== null && y <= o.current || (o.current = y, u(y)));
    },
    [u]
  ), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({ displayedLength: y, streamTextLength: S }) => {
      const A = l.current;
      if (l.current = { displayedLength: y, streamTextLength: S }, !e.initialEnabled || !A || y > A.displayedLength || S <= A.streamTextLength) return;
      const I = $n();
      m(S, I, !0), g(S, I, !0);
    },
    [l, g, m, e]
  );
  return {
    resetProgress: v,
    reportVisibleTextProgress: h,
    reportRenderedTextProgress: f,
    reportNonStreamingVisibleTextProgress: _,
    reportMarkdownRevealProgress: p
  };
}, Fg = (e) => {
  const {
    text: t,
    enabled: n = !1,
    snapOnDisable: r = !1,
    deferredMarkdownElements: s = [],
    onAnimationStart: o,
    onAnimationProgress: i,
    onAnimationComplete: c,
    onAnimationHoldChange: l,
    onVisibleTextProgress: u,
    onRenderedTextProgress: d
  } = e, m = Dg(n, t), h = s.includes("image"), g = s.includes("link"), [f, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => n ? m ? 0 : Cr(t.length) : t.length
  ), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    startTime: 0,
    lastUpdate: 0,
    lastProgressCall: 0
  }).current, y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    startCalled: !1,
    completeCalled: !1
  }).current, S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    initialEnabled: n,
    textLength: t.length,
    enabled: n,
    text: t,
    deferImages: h,
    deferLinks: g,
    snapOnDisable: r,
    isGatingStreamingStart: m
  }).current, A = ge(() => o == null ? void 0 : o()), I = ge(() => i == null ? void 0 : i()), k = ge(
    (q) => c == null ? void 0 : c(q)
  ), N = ge((q) => l == null ? void 0 : l(q)), {
    resetProgress: R,
    reportVisibleTextProgress: M,
    reportRenderedTextProgress: B,
    reportNonStreamingVisibleTextProgress: P,
    reportMarkdownRevealProgress: ne
  } = Pg({
    trackedRef: S,
    onVisibleTextProgress: u,
    onRenderedTextProgress: d
  }), ce = n, X = f < t.length, J = S.initialEnabled && (ce || X);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    S.textLength = t.length, S.enabled = n, S.text = t, S.deferImages = h, S.deferLinks = g, S.snapOnDisable = r, S.isGatingStreamingStart = m;
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (S.initialEnabled) {
      if (y.startCalled || (y.startCalled = !0, A()), !S.enabled && S.snapOnDisable) {
        v(t.length);
        const q = $n();
        M(t.length, q, !0), B(t.length, t.length, q);
        return;
      }
      v((q) => t.length < q ? t.length : q);
    }
  }, [A, B, M, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!S.initialEnabled) return;
    let q = m ? 0 : Cr(t.length), j = m;
    p.lastUpdate = 0, p.startTime = 0, p.lastProgressCall = 0, R();
    const V = (z) => {
      p.lastUpdate === 0 && (p.lastUpdate = z, p.startTime = z, p.lastProgressCall = z, q > 0 && M(q, z, !0));
      const W = S.textLength;
      j && !S.isGatingStreamingStart && (q = Cr(W), v(q), q > 0 && M(q, z, !0), p.lastUpdate = z, j = !1), !S.enabled && S.snapOnDisable && q < W && (q = W, v(q), M(q, z, !0), B(q, W, z));
      const se = z - p.lastUpdate, he = z - p.startTime, { speed: $, chunkSize: Ie } = $g(he), ke = $ * Ie;
      !S.isGatingStreamingStart && se >= ke && q < W && (q = Math.min(q + Ie, W), v(q), M(q, z, q >= W), B(q, W, z), p.lastUpdate = z), z - p.lastProgressCall >= rn && (p.lastProgressCall = z, I()), (q < W || S.enabled) && (_.current = requestAnimationFrame(V));
    };
    return _.current = requestAnimationFrame(V), () => {
      _.current && cancelAnimationFrame(_.current), y.startCalled && !y.completeCalled && (y.completeCalled = !0, k({ completed: !1 }));
    };
  }, [
    k,
    I,
    B,
    M,
    R
  ]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    S.initialEnabled && (n || t.length > 0) || (P(t.length), B(t.length, t.length, $n()));
  }, [
    n,
    d,
    u,
    P,
    B,
    t.length,
    S
  ]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const q = S.initialEnabled && y.startCalled, j = !n, V = f >= t.length;
    q && j && V && !y.completeCalled && (y.completeCalled = !0, k({ completed: !0 }));
  }, [n, f, k, t.length]);
  const U = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    let q = t;
    S.initialEnabled && (q = m ? "" : t.slice(0, f));
    const j = J && h, V = J && g;
    return !j && !V ? q : va(q, { hideImages: j, hideLinks: V });
  }, [t, f, h, g, J, m]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    !S.initialEnabled || J || M(f, $n(), !0);
  }, [f, J, M]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ne({
      displayedLength: f,
      streamTextLength: U.length
    });
  }, [f, ne, U.length]);
  const Y = U.length === 0 && J;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (N(Y), () => N(!1)), [N, Y]), {
    streamText: U,
    isAnimating: J,
    isHolding: Y
  };
}, Ro = {
  visible: !1,
  remainingTime: 0,
  showDescription: !1,
  targetTimeMs: null
}, Ug = (e) => ({
  visible: !0,
  remainingTime: e,
  showDescription: !0,
  targetTimeMs: Date.now() + e * 1e3
}), Bg = (e, t = Date.now()) => {
  if (!e.visible || e.targetTimeMs == null) return e;
  const n = Math.max(Math.ceil((e.targetTimeMs - t) / 1e3), 0);
  return n <= 0 ? {
    ...e,
    remainingTime: 0,
    showDescription: !1,
    targetTimeMs: null
  } : e.remainingTime === n && e.showDescription ? e : {
    ...e,
    remainingTime: n,
    showDescription: !0
  };
}, Hg = () => {
  const { chatSDK: e } = we(), [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Ro), r = () => n(Ro);
  return _n(e, {
    onConnectionDelayed: (s) => {
      s > 0 ? n(Ug(s)) : r();
    },
    onReconnectSucceeded: r,
    onConnected: r
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t.visible || !t.showDescription || t.targetTimeMs == null) return;
    const s = setTimeout(() => {
      n((o) => Bg(o));
    }, 1e3);
    return () => clearTimeout(s);
  }, [t.visible, t.showDescription, t.targetTimeMs, t.remainingTime]), {
    visible: t.visible,
    remainingTime: t.remainingTime,
    showDescription: t.showDescription
  };
}, Gg = (e) => {
  const t = Math.floor(e / 60), n = e % 60;
  return `${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}, Vg = (e, t) => {
  if (!t)
    return {
      beforeText: e,
      highlightedText: "",
      afterText: ""
    };
  const n = e.indexOf(t);
  return n < 0 ? {
    beforeText: e,
    highlightedText: "",
    afterText: ""
  } : {
    beforeText: e.slice(0, n),
    highlightedText: t,
    afterText: e.slice(n + t.length)
  };
}, zg = ({ enabled: e = !0 } = {}) => {
  const t = pt();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    ({
      message: n,
      isBotMessage: r,
      aiAgentUserId: s
    }) => {
      if (!e) return;
      const o = n.messageId, i = Re.isStreaming(n), c = hn(n.extendedMessagePayload), l = c.hasMessageTemplate, u = c.hasForm, d = r && n.isUserMessage() && !i && !jl(n) && !Re.isWelcomeMessage(n, s), m = i || t.streamStalled.hasPendingStream(o), h = t.userPerceivedResponseTime.hasPendingAIResponse(o);
      if (!m && !h && !d && !l && !u)
        return;
      let g = !1, f = !1;
      const v = {};
      return (h || d) && (v.onVisibleTextProgress = () => {
        h && !g && (g = t.userPerceivedResponseTime.markAIResponseVisible(o)), d && !f && (f = !0, t.renderedContentUnusable.commit({
          messageId: o,
          contentKind: "text",
          errorDomain: "empty_render"
        }));
      }), m && (v.onRenderedTextProgress = (_) => {
        t.streamStalled.markRenderedProgress({ messageId: o, displayedLength: _ });
      }), l && (v.onMessageTemplateError = (_) => {
        t.renderedContentUnusable.commit({
          messageId: o,
          contentKind: "template",
          errorDomain: "template_error",
          error: _
        });
      }), u && (v.onFormRenderError = (_) => {
        t.renderedContentUnusable.commit({
          messageId: o,
          contentKind: "form",
          errorDomain: "form_error",
          error: _
        });
      }), v;
    },
    [e, t]
  );
}, Kg = (e) => {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t.current || e != null && e.onVisibleTextProgress && (t.current = !0, e.onVisibleTextProgress(0));
  }, [e]);
}, vr = 5e3, Wg = ({
  channelUrl: e,
  enabled: t = !0,
  isInitiallyBackgrounded: n,
  isForegrounded: r,
  subscribeToForegroundState: s
}) => {
  const o = pt(), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(n), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(
    t && n() ? performance.now() - vr : null
  ), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  i.current = t, c.current = n;
  const d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (m = r()) => {
      if (!i.current) {
        u.current = !1;
        return;
      }
      if (!m) {
        u.current = !1;
        return;
      }
      if (l.current === null) {
        u.current = !1;
        return;
      }
      if (performance.now() - l.current < vr) {
        l.current = null, u.current = !1;
        return;
      }
      if (!e) {
        u.current = !0;
        return;
      }
      l.current = null, u.current = !1, o.recoveryNotInteractiveTimeout.start("foreground_resume", e);
    },
    [e, r, o]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    t || (l.current = null, u.current = !1, e && o.recoveryNotInteractiveTimeout.cancelPending(e));
  }, [e, t, o]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) return;
    u.current && !!e && r() && d();
  }, [e, t, r, d]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (t)
      return c.current() ? l.current ?? (l.current = performance.now() - vr) : l.current = null, s((m) => {
        if (m === "backgrounded") {
          l.current ?? (l.current = performance.now()), u.current = !1, e && o.recoveryNotInteractiveTimeout.cancelPending(e);
          return;
        }
        d(!0);
      });
  }, [e, t, d, o, s]);
}, Yg = (e) => {
  const { conversationInitialRender: t, conversationListInitialRender: n } = pt();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    t.setPresentMethod(e), n.setPresentMethod(e);
  }, [t, n, e]);
}, qg = (e, { enabled: t = !0, opened: n = !1, filter: r } = {}) => {
  var l, u, d;
  const [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), c = () => {
    if (!t) return;
    const m = ++i.current;
    e.aiAgent.getUnreadMessageCount(r).then((h) => {
      m === i.current && o(h.total > 0);
    }).catch(() => {
    });
  };
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) {
      o(!1), i.current++;
      return;
    }
    e.connectionState === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.w.OPEN && c();
  }, [
    t,
    e,
    r == null ? void 0 : r.aiAgentChannelFilter,
    (l = r == null ? void 0 : r.aiAgentConversationStatusFilter) == null ? void 0 : l.join(),
    (u = r == null ? void 0 : r.aiAgentIds) == null ? void 0 : u.join(),
    r == null ? void 0 : r.deskChannelFilter,
    (d = r == null ? void 0 : r.pinnedChannelUrls) == null ? void 0 : d.join(),
    r == null ? void 0 : r.copilotConversationOnly,
    r == null ? void 0 : r.copilotSupportChannelUrl
  ]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    n && (o(!1), i.current++);
  }, [n]), _n(e, {
    onConnected: c,
    onReconnectSucceeded: c
  }), s;
}, Kt = (e) => e.replace(/\s+/g, " ").trim(), jg = "Code block", ba = (e) => `A11Y_INLINE_CODE_${e}`, Sa = (e) => {
  let t = "", n = e;
  for (; ; ) {
    const r = n.match(/^([ \t]{0,3}>\s?)(.*)$/);
    if (r) {
      t += r[1], n = r[2];
      continue;
    }
    break;
  }
  return {
    blockquotePrefix: t,
    content: n
  };
}, ya = (e) => {
  const t = e.match(/^([ \t]{0,3}[-+*]\s+)(.*)$/);
  if (t)
    return {
      content: t[2],
      hasListPrefix: !0
    };
  const n = e.match(/^([ \t]{0,3}\d+[.)]\s+)(.*)$/);
  return n ? {
    content: n[2],
    hasListPrefix: !0
  } : {
    content: e,
    hasListPrefix: !1
  };
}, Xg = (e) => {
  const { blockquotePrefix: t, content: n } = Sa(e), { content: r } = ya(n), s = r.match(/^[ \t]{0,3}([`~]{3,})(.*)$/);
  if (!s)
    return;
  const o = s[1], i = s[2], c = o[0];
  if (!(c !== "`" && c !== "~" || !o.split("").every((l) => l === c)) && !(c === "`" && i.includes("`")))
    return {
      char: c,
      blockquotePrefix: t,
      length: o.length
    };
}, Zg = (e, t) => {
  const { blockquotePrefix: n, content: r } = Sa(e);
  if (n !== t.blockquotePrefix)
    return !1;
  const { content: s, hasListPrefix: o } = ya(r);
  if (o)
    return !1;
  const i = s.match(/^[ \t]{0,3}([`~]{3,})[ \t]*$/);
  if (!i)
    return !1;
  const c = i[1];
  return c[0] === t.char && c.length >= t.length && c.split("").every((l) => l === t.char);
}, Jg = (e, t, n) => {
  let r = n;
  for (; r < e.length; ) {
    const s = e[r];
    if (s === "\\" && r + 1 < e.length) {
      r += 2;
      continue;
    }
    if (s === t)
      return r;
    r += 1;
  }
  return -1;
}, Qg = (e, t) => {
  let n = 1, r = t;
  for (; r < e.length; ) {
    const s = e[r];
    if (s === "\\" && r + 1 < e.length) {
      r += 2;
      continue;
    }
    if (s === "[") {
      n += 1, r += 1;
      continue;
    }
    if (s === "]" && (n -= 1, n === 0))
      return r;
    r += 1;
  }
  return -1;
}, ef = (e, t) => {
  let n = t, r = 1, s, o = !1, i = !1;
  for (; n < e.length && r > 0; ) {
    const c = e[n];
    if (c === "\\" && n + 1 < e.length) {
      n += 2;
      continue;
    }
    if (s) {
      c === s && (s = void 0), n += 1;
      continue;
    }
    if (r === 1 && o && /\s/.test(c)) {
      i = !0, n += 1;
      continue;
    }
    if (r === 1 && i && (c === '"' || c === "'")) {
      s = c, n += 1;
      continue;
    }
    if (c === "(") {
      r += 1, o = !0, n += 1;
      continue;
    }
    if (c === ")") {
      r -= 1, n += 1;
      continue;
    }
    /\s/.test(c) || (o = !0), n += 1;
  }
  return r === 0 ? n : -1;
}, tf = (e) => {
  let t = 0, n = "";
  for (; t < e.length; ) {
    const r = Jg(e, "[", t);
    if (r === -1) {
      n += e.slice(t);
      break;
    }
    const s = Qg(e, r + 1);
    if (s === -1) {
      n += e.slice(t);
      break;
    }
    if (r > 0 && e[r - 1] === "!" && Kn(e, r - 1)) {
      n += e.slice(t, s + 1), t = s + 1;
      continue;
    }
    if (e[s + 1] !== "(") {
      n += e.slice(t, s + 1), t = s + 1;
      continue;
    }
    const o = r > 0 && e[r - 1] === "!" && !Kn(e, r - 1) ? r - 1 : r;
    n += e.slice(t, o);
    const i = e.slice(r + 1, s), c = ef(e, s + 2);
    if (c === -1) {
      n += e.slice(o);
      break;
    }
    n += i, t = c;
  }
  return n;
}, Aa = (e, t, n) => {
  if (!/^\d+$/.test(t))
    return !1;
  const r = e.slice(-1);
  return /\d/.test(r) && /\d/.test(n);
}, nf = (e) => e.replace(
  /(^|[^*\\])\*\*([^\s*](?:[\s\S]*?[^\s*])?)\*\*(?!\*)/g,
  (t, n, r, s, o) => {
    const i = o[s + t.length] ?? "";
    return Aa(n, r, i) ? t : `${n}${r}`;
  }
), rf = (e) => e.replace(/(^|[^_\\])__([^\s_](?:[\s\S]*?[^\s_])?)__(?!_)/g, "$1$2"), sf = (e) => e.replace(/(^|[^~\\])~~([^\s~](?:[\s\S]*?[^\s~])?)~~(?!~)/g, "$1$2"), of = (e) => {
  let t = e;
  return t = t.replace(
    /(^|[^*\\])\*([^\s*](?:[\s\S]*?[^\s*])?)\*(?!\*)/g,
    (n, r, s, o, i) => {
      const c = i[o + n.length] ?? "";
      return Aa(r, s, c) ? n : `${r}${s}`;
    }
  ), t = t.replace(/(^|[\s([{"'])_([^_\s](?:[\s\S]*?[^_\s])?)_(?=$|[\s)\]}"'.,!?:;])/g, "$1$2"), t;
}, af = (e) => e.replace(/\\([\\`*_[\]()#+.!~|-])/g, "$1"), cf = (e) => {
  let t = e;
  return t = t.replace(/^\s{0,3}#{1,6}\s+/gm, ""), t = t.replace(/^\s{0,3}>\s?/gm, ""), t = t.replace(/^\s{0,3}(?!([-*_])(?:\s*\1){2,}\s*$)[-*+]\s+/gm, ""), t = t.replace(/^\s{0,3}\d+[.)]\s+/gm, ""), t;
}, wo = (e) => {
  const t = e.trim();
  if (!t.includes("|")) return !1;
  const n = t.split("|").map((r) => r.trim()).filter(Boolean);
  return n.length === 0 ? !1 : n.every((r) => /^:?-{3,}:?$/.test(r));
}, ko = (e) => {
  const t = [];
  let n = "", r = !1;
  for (const o of e.trim()) {
    if (r) {
      n += o === "|" ? "|" : `\\${o}`, r = !1;
      continue;
    }
    if (o === "\\") {
      r = !0;
      continue;
    }
    if (o === "|") {
      const i = n.trim();
      i && t.push(i), n = "";
      continue;
    }
    n += o;
  }
  r && (n += "\\");
  const s = n.trim();
  return s && t.push(s), t;
}, lf = (e) => {
  const t = e.split(`
`), n = [];
  let r = 0;
  for (; r < t.length; ) {
    const s = t[r], o = t[r + 1], i = ko(s);
    if (i.length > 0 && o && wo(o)) {
      for (n.push(i.join(" ")), r += 2; r < t.length; ) {
        const c = t[r], l = ko(c);
        if (l.length === 0 || wo(c))
          break;
        n.push(l.join(" ")), r += 1;
      }
      continue;
    }
    n.push(s), r += 1;
  }
  return n.join(`
`);
}, uf = (e) => e.replace(/^\s{0,3}(?:(?:-\s*){3,}|(?:\*\s*){3,}|(?:_\s*){3,})$/gm, ""), df = (e, t) => {
  const n = e.split(`
`), r = [];
  let s = 0;
  for (; s < n.length; ) {
    const o = n[s], i = Xg(o);
    if (!i) {
      r.push(o), s += 1;
      continue;
    }
    let c = -1;
    for (let l = s + 1; l < n.length; l++)
      if (Zg(n[l], i)) {
        c = l;
        break;
      }
    if (c === -1) {
      r.push(o), s += 1;
      continue;
    }
    r.push(` ${t} `), s = c + 1;
  }
  return r.join(`
`);
}, Kn = (e, t) => {
  let n = 0, r = t - 1;
  for (; r >= 0 && e[r] === "\\"; )
    n += 1, r -= 1;
  return n % 2 === 1;
}, mf = (e) => {
  const t = [];
  let n = 0, r = "";
  for (; n < e.length; ) {
    const s = e[n];
    if (s !== "`" || Kn(e, n)) {
      r += s, n += 1;
      continue;
    }
    let o = n;
    for (; o < e.length && e[o] === "`"; )
      o += 1;
    const i = e.slice(n, o);
    let c = o, l = !1;
    for (; c < e.length && e[c] !== `
`; ) {
      if (e[c] === "`" && !Kn(e, c) && e.startsWith(i, c)) {
        const u = e.slice(o, c), d = t.push(u) - 1;
        r += ba(d), n = c + i.length, l = !0;
        break;
      }
      c += 1;
    }
    l || (r += i, n = o);
  }
  return {
    text: r,
    inlineCodes: t
  };
}, Ta = (e, { codeBlockPlaceholder: t = jg } = {}) => {
  const n = e == null ? void 0 : e.replace(/\r\n?/g, `
`);
  if (!n) return;
  const r = [];
  let s = n;
  s = df(s, t), s = cf(s);
  const o = mf(s);
  s = o.text, r.push(...o.inlineCodes), s = tf(s), s = nf(s), s = rf(s), s = sf(s), s = of(s), s = lf(s), s = uf(s), s = af(s);
  for (let c = 0; c < r.length; c++)
    s = s.replaceAll(ba(c), r[c]);
  return Kt(s) || void 0;
}, hf = (e, t) => {
  var s;
  const n = ((s = e.name) == null ? void 0 : s.trim()) || "", r = e.mimeType ?? "";
  return je(r) ? t.image : gn(r) ? t.video : Vi({ name: n, mimeType: r }) ? t.pdf(n) : t.document(n);
}, Wn = (e) => (e == null ? void 0 : e.trim()) || "", gf = (e) => (e ? Kt(e) : void 0) || void 0, Lo = 30, ff = (e) => e.length > Lo ? `${e.slice(0, Lo)}…` : e, pf = ({ agent: e, status: t, lastMessage: n, time: r, unreadCount: s }, o) => {
  const i = ff(Kt(n)), c = [t, i].filter(Boolean).join(", ");
  return o(Kt(e), Kt(c), r, s);
}, Ur = (e) => ({
  text: Wn(e),
  format: "plain"
}), _f = (e) => ({
  text: Wn(e),
  format: "markdown"
}), Ef = ({
  markdownText: e,
  plainText: t,
  comparisonText: n
}) => {
  const r = Wn(e);
  return r && r !== Wn(n) ? _f(r) : Ur(t);
}, cn = ({
  sender: e,
  message: t,
  messageFormat: n = "plain",
  time: r,
  codeBlockPlaceholder: s
}) => {
  const o = [], i = n === "markdown" ? Ta(t, { codeBlockPlaceholder: s }) : gf(t);
  if (r && o.push(r), e && o.push(e), i && o.push(i), o.length !== 0)
    return o.join(", ");
}, Ia = (e, t) => Ta(e == null ? void 0 : e.trim(), t !== void 0 ? { codeBlockPlaceholder: t } : void 0), Cf = (...e) => Kt(e.filter(Boolean).join(", ")) || void 0, Oo = (e, t, n, r) => {
  if (!t || zi(t, n)) return e;
  const s = Ia(t, r);
  return s ? Cf(e, s) : e;
}, xa = (e, t) => {
  var r, s;
  const n = (r = e.message) == null ? void 0 : r.trim();
  if (e.isFileMessage()) {
    const o = ((s = e.name) == null ? void 0 : s.trim()) || "", i = hf({ name: o, mimeType: e.type }, t);
    return Oo(i, n, [o], t.codeBlockPlaceholder);
  }
  if (e.isMultipleFilesMessage()) {
    const o = e.fileInfoList ?? [], i = o.length;
    if (i === 0) return;
    const c = o.map((d) => {
      var m;
      return ((m = d.fileName) == null ? void 0 : m.trim()) || "";
    }), u = o.every((d) => {
      var m;
      return (m = d.mimeType) == null ? void 0 : m.startsWith("image");
    }) ? t.receivedFilesImageCount(i) : t.multipleFilesCount(i);
    return Oo(u, n, c, t.codeBlockPlaceholder);
  }
  return Ia(n, t.codeBlockPlaceholder);
}, vf = (e, t = {}) => {
  const { throttleMs: n = 1e3, isSuppressed: r, maxOrderedQueueSize: s = 10 } = t, o = Math.max(1, s);
  let i = null;
  const c = [];
  let l = null, u = null, d = null, m = !1, h = 0;
  const g = (R, M, B) => ({
    text: R,
    ignoreSuppression: M,
    queueOrder: h++,
    dedupeKey: B
  }), f = () => {
    const R = c[0] ?? null, M = i;
    return R && M ? M.queueOrder < R.queueOrder ? (i = null, M) : c.shift() ?? null : R ? c.shift() ?? null : M !== null ? (i = null, M) : null;
  }, v = () => {
    for (; ; ) {
      const R = f();
      if (!R) return null;
      if (!(!R.ignoreSuppression && (r != null && r())))
        return R;
    }
  }, _ = (R) => {
    l = R.text, u = R.dedupeKey ?? null, m = !0, e(R.text), d = setTimeout(() => {
      d = null, m = !1;
      const M = v();
      M && _(M);
    }, n);
  }, p = (R) => {
    l = R.text, u = R.dedupeKey ?? null, e(R.text);
  }, y = (R, M, B, P) => M != null && P != null ? M === P : M == null && P == null ? R != null && R === B : !1, S = (R, M, B) => {
    if (!R || !M && (r != null && r())) return;
    const P = B == null ? void 0 : B.dedupeKey;
    if (!(m && y(R, P, l, u)))
      if (m) {
        if (((B == null ? void 0 : B.mode) ?? "latestOnly") === "ordered") {
          const ce = c[c.length - 1];
          if (ce && y(R, P, ce.text, ce.dedupeKey)) return;
          c.push(g(R, M, P)), c.length > o && c.shift();
          return;
        }
        i = g(R, M, P);
      } else
        i = null, _(g(R, M, P));
  };
  return { announce: (R, M) => {
    S(R, !1, M);
  }, announceIgnoringSuppression: (R, M) => {
    S(R, !0, M);
  }, flush: () => {
    const R = [];
    let M = f();
    for (; M !== null; )
      R.push(M), M = f();
    if (d !== null && (clearTimeout(d), d = null), m = !1, R.length !== 0)
      for (const B of R)
        p(B);
  }, destroy: () => {
    d !== null && (clearTimeout(d), d = null), i = null, c.length = 0, l = null, u = null, m = !1;
  } };
}, bf = (e) => {
  switch (e) {
    case "newMessage":
    case "conversationClosed":
    case "csatDisplayed":
    case "csatSubmitted":
    case "csatExpired":
      return "ordered";
    default:
      return "latestOnly";
  }
}, Sf = (e, t) => e.screen === "conversationList" ? typeof e.conversationCount == "number" ? t.screenConversationListWithCount(e.conversationCount) : t.screenConversationListNoCount : [
  e.agentName ? t.screenConversationWithAgent(e.agentName) : t.screenConversation,
  e.isClosed ? t.conversationClosed : null,
  e.isClosed && e.hasCSAT ? t.csatDisplayed : null,
  e.isEmpty ? t.emptyState : null
].filter((r) => !!r).join(". "), yf = (e, t) => {
  switch (e.event) {
    case "newMessage":
      return e.body !== void 0 || e.time !== void 0 ? [t.newMessage(1), e.time, e.senderName, e.body].filter((r) => !!r).join(", ") : e.senderName ? t.newMessageFromSender(e.senderName, 1) : t.newMessage(1);
    case "typing":
      return t.typing(e.agentName ?? "");
    case "sendFailed":
      return t.sendFailed;
    case "agentConnected":
      return t.agentConnected(e.agentName ?? "");
    case "conversationClosed":
      return t.conversationClosed;
    case "csatDisplayed":
      return t.csatDisplayed;
    case "csatSubmitted":
      return e.submittedLabel;
    case "csatExpired":
      return t.csatExpired;
    case "emptyState":
      return t.emptyState;
    case "inputDisabled":
      return t.inputDisabled;
  }
}, Af = (e, t) => {
  switch (e.type) {
    case "fileSizeExceeded":
      return t.fileSizeExceeded(e.maxSizeMB ?? 25);
    case "sendFailed":
      return t.sendFailed;
    case "csatFormError":
      return t.csatFormError;
    case "generic":
      return e.message;
  }
}, Tf = (e, t) => !t || !tt(e) || e.sender.userId !== t ? null : e.reqId || (e.messageId > 0 ? String(e.messageId) : null), If = (e, t) => $e.isAdmin(e) ? $e.isCSAT(e) : "sender" in e ? e.sender.userId !== t : !1, xf = (e) => "messageId" in e && e.messageId > 0 ? String(e.messageId) : "reqId" in e && typeof e.reqId == "string" && e.reqId.length > 0 ? e.reqId : null, Mf = (e) => e === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_RECEIVED || e === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ab.EVENT_MESSAGE_UPDATED, Rf = ({
  isOpened: e,
  opensConversationList: t
}) => e ? t ? "closeConversationList" : "closeConversation" : t ? "openConversationList" : "openConversation", wf = (e, t) => {
  switch (e) {
    case "closeConversationList":
      return t.closeConversationList;
    case "closeConversation":
      return t.closeConversation;
    case "openConversationList":
      return t.openConversationList;
    case "openConversation":
      return t.openConversation;
  }
}, kf = (e, t) => {
  switch (e) {
    case "closeConversation":
      return t.hintCloseConversation;
    case "openConversationList":
      return t.hintOpenConversationList;
    case "openConversation":
      return t.hintOpenConversation;
    default:
      return;
  }
}, Lf = ({
  intent: e,
  strings: t
}) => ({
  label: wf(e, t),
  hint: kf(e, t)
}), Of = "1.42.0", Ve = "sb-agent", Me = {
  ENTRY: `${Ve}-entry`,
  MODAL_ROOT: `${Ve}-modal-root`,
  WINDOW: `${Ve}-window`,
  LAUNCHER: `${Ve}-launcher`,
  NUDGE_MESSAGE: `${Ve}-nudge-message`,
  WINDOW_TITLE: `${Ve}-window-title`
}, Ma = "data-sb-initial-focus", Ra = "true", Nf = `[${Ma}="${Ra}"]`, wa = {
  [Ma]: Ra
}, bs = "data-sb-focus-trap-sentinel", Df = "true", ka = "data-sb-initial-focus-header", La = "true", $f = `[${ka}="${La}"]`, Oa = {
  [ka]: La
}, Na = "data-sb-message-input", Da = "true", Pf = `textarea[${Na}="${Da}"]:not(:disabled)`, Ff = {
  [Na]: Da
}, $a = 1e3, wn = 2147483647, Dt = {
  MODAL: wn - 1,
  // FIXME: need to cover the case where the tooltip is on the top of the modal
  TOOLTIP: wn - 2,
  WINDOW: wn - 3,
  LAUNCHER: wn - 4
}, Pa = 36, Uf = 100, Bf = Of, Hf = "noopener noreferrer nofollow", Gf = () => typeof document > "u" || document.visibilityState === "visible", Br = () => typeof document < "u" && document.visibilityState === "hidden", No = () => Br() ? "backgrounded" : "foregrounded", Vf = {
  getState: No,
  subscribe: (e) => {
    if (typeof document > "u") return () => {
    };
    const t = () => e(No());
    return document.addEventListener("visibilitychange", t), () => document.removeEventListener("visibilitychange", t);
  }
};
function zf() {
  return {
    isOnline: () => navigator.onLine,
    subscribe: (e) => {
      const t = () => e(!0), n = () => e(!1);
      return window.addEventListener("online", t), window.addEventListener("offline", n), () => {
        window.removeEventListener("online", t), window.removeEventListener("offline", n);
      };
    }
  };
}
const kn = {};
function Kf() {
  return {
    get: (e) => {
      try {
        return localStorage.getItem(e);
      } catch {
        return kn[e] ?? null;
      }
    },
    set: (e, t) => {
      try {
        localStorage.setItem(e, t);
      } catch {
        kn[e] = t;
      }
    },
    delete: (e) => {
      try {
        localStorage.removeItem(e);
      } catch {
        delete kn[e];
      }
    },
    getKeys: (e) => {
      try {
        const t = [];
        for (let n = 0; n < localStorage.length; n++) {
          const r = localStorage.key(n);
          r && r.startsWith(e) && t.push(r);
        }
        return t;
      } catch {
        return Object.keys(kn).filter((t) => t.startsWith(e));
      }
    }
  };
}
const Wf = {
  conversation: {
    input_placeholder: "Ask a question",
    input_placeholder_disabled: "Chat is unavailable in this channel",
    input_placeholder_steward: "Processing your request...",
    input_placeholder_wait_ai_agent_response: "Waiting for the agent's reply...",
    input_placeholder_active_form: "Please fill out the form to move forward.",
    input_placeholder_reconnecting: "Trying to reconnect. Refresh if persists.",
    unknown_message_type: "(Unknown message type)",
    powered_by: "Powered by",
    citation_title: "Source",
    start_new_conversation_label: "Start a conversation",
    scroll_to_new_messages_label: () => "New message",
    failed_message_resend: "Retry",
    failed_message_remove: "Remove",
    file_upload_no_supported_files: "No supported file types available.",
    file_upload_replace_alert_title: "Replace attachment?",
    file_upload_replace_alert_description: "Uploading a different file type will replace the current one.",
    // Accessibility
    a11y_message_list: "Chat messages",
    a11y_scroll_to_bottom: "Scroll to bottom",
    a11y_scroll_to_new_messages: "Scroll to new messages",
    a11y_open_conversation_list: "Open conversation list",
    a11y_open_conversation: "Open conversation with Support",
    a11y_open_conversations: "Open conversations",
    a11y_close_conversation: "Close conversation",
    a11y_close_conversations: "Close conversations",
    a11y_menu: "Menu",
    a11y_message_input: "Message",
    a11y_send_message: "Send message",
    a11y_attach_file: "Attach file",
    a11y_close_messenger: "Close messenger",
    a11y_dismiss_nudge_message: "Dismiss message",
    a11y_expand_messenger: "Expand messenger",
    a11y_collapse_messenger: "Collapse messenger",
    a11y_connect_agent: "Talk to human agent",
    a11y_message_sender_you: "You",
    a11y_suggested_reply: "Suggested reply",
    a11y_typing_indicator: "Typing",
    a11y_code_block_placeholder: "Code block",
    a11y_typing_format: (e) => `${e} is typing`,
    a11y_message_failed: "Message send failed",
    a11y_new_messages_received: (e) => `${e} new ${e === 1 ? "message" : "messages"} received`,
    a11y_new_messages_received_from_sender: (e, t) => `${e}: ${t} new ${t === 1 ? "message" : "messages"} received`,
    a11y_agent_connected: (e) => "Connected to human agent",
    a11y_conversation_closed: "Conversation has ended",
    a11y_file_image: (e) => `Image file: ${e}`,
    a11y_file_video: (e) => `Video file: ${e}`,
    a11y_file_pdf: (e) => `PDF file: ${e}`,
    a11y_file_document: (e) => `Document file: ${e}`,
    a11y_received_file_image: "Image file",
    a11y_received_file_video: "Video file",
    a11y_received_file_pdf: (e) => `PDF file: ${e}`,
    a11y_received_files_image_count: (e) => `${e} ${e === 1 ? "image" : "images"}`,
    a11y_screen_conversation: "Conversation",
    a11y_screen_conversation_with_agent: (e) => `Conversation with ${e}`,
    a11y_screen_conversation_list_no_count: "Conversation list",
    a11y_screen_conversation_list_with_count: (e) => `Conversations, ${e} total`,
    a11y_csat_displayed: "Satisfaction survey displayed",
    a11y_empty_conversation: "No messages in this conversation",
    a11y_input_disabled: "Message input is disabled",
    a11y_file_size_exceeded: (e) => `File exceeds size limit of ${e}MB`,
    a11y_csat_form_error: "Please complete the required fields",
    a11y_hint_send_message: "Sends the message",
    a11y_hint_open_conversation: "Opens the conversation",
    a11y_hint_open_conversations: "Opens conversations",
    a11y_hint_close_conversation: "Closes the conversation",
    a11y_hint_close_messenger: "Closes the messenger",
    a11y_hint_open_menu: "Opens the menu",
    a11y_hint_connect_to_agent: "Escalates to a human agent",
    a11y_hint_attach_file: "Opens file attachment options",
    a11y_hint_view_new_messages: "Scrolls to new messages",
    a11y_hint_open_file: "Opens the file",
    a11y_hint_open_image: "Opens the image",
    a11y_hint_send_reply: "Sends this reply",
    image_viewer_default_title: "Image",
    a11y_image_viewer_close: "Close image viewer",
    a11y_image_viewer_previous: "Previous image",
    a11y_image_viewer_next: "Next image",
    a11y_image_viewer_download: "Download image",
    attachment_document: "Files"
  },
  conversation_list: {
    header_title: "Conversations",
    ended: "Ended",
    system_message: "System message",
    footer_title: "Start a conversation",
    multiple_files_count: (e) => `${e} ${e === 1 ? "file" : "files"}`,
    a11y_conversation_item: (e, t, n, r) => `${e}, ${t}, ${n}${r > 0 ? `, ${r} unread ${r === 1 ? "message" : "messages"}` : ""}`
  },
  date_format: {
    just_now: "Just now",
    minutes_ago: (e) => `${e} minutes ago`,
    hours_ago: (e) => `${e} hours ago`,
    date_short: "MM/dd/yyyy",
    date_separator: "MMMM dd, yyyy",
    message_timestamp: "p"
  },
  csat: {
    title: "Your feedback matters to us",
    submitted_label: "Successfully submitted!",
    cre_question: "Was your issue resolved?",
    cre_positive_label: "Yes, thank you! 👍",
    cre_negative_label: "No, that didn't help.",
    reason_placeholder: "Share your feedback",
    question: "How would you rate your experience?",
    submit_label: "Submit",
    submission_expired: "We're sorry, the survey period has ended.",
    a11y_csat_rating_label: (e, t) => `${e} out of 5 — ${t}`,
    a11y_hint_select_rating: "Selects this rating"
  },
  form: {
    optional_label: "optional",
    validation_required: "This question is required"
  },
  common: {
    placeholder_something_went_wrong: "Something went wrong",
    placeholder_no_messages: "No messages",
    placeholder_no_conversations: "No conversations yet",
    placeholder_something_went_wrong_retry_label: "Retry",
    button_ok: "OK",
    button_cancel: "Cancel"
  },
  feedback: {
    title: "Submit feedback",
    good: "Good",
    bad: "Bad",
    comment_label: "Comment (optional)",
    comment_placeholder: "Leave a comment",
    cancel: "Cancel",
    submit: "Submit",
    save: "Save",
    edit: "Edit feedback",
    remove: "Remove feedback"
  },
  handoff: {
    confirm_title: "Request handoff?",
    confirm_description: "You'll be transferred to a human agent. Your conversation history will be shared.",
    confirm_cancel: "Cancel",
    confirm_handoff: "Handoff"
  },
  memory: {
    dialog_title: "Memory",
    desc_on: "Memory is **turned on**. It remembers your conversation history to provide personalized responses tailored to your previous questions and preferences.",
    desc_off: "Memory is **turned off**. If turned on, it will remember your conversation history to provide personalized responses tailored to your previous questions and preferences.",
    button_use: "Use",
    button_dont_use: "Don't use",
    button_keep_using: "Keep using",
    button_disable: "Disable",
    button_disable_and_delete: "Disable & Delete memory",
    button_keep_off: "Keep off",
    button_enable: "Enable memory",
    button_cancel: "Cancel",
    error_message: "Failed to update memory state. Please try again.",
    a11y_indicator_manage: "Manage memory",
    a11y_indicator_on: "Memory is on",
    a11y_indicator_off: "Memory is off"
  },
  connection_delay: {
    title: "Something went wrong. You'll be reconnected shortly.",
    description: (e) => `Estimated waiting time: ${e}`
  },
  desk: {
    ticket_closure_confirm: "Yes, it's resolved",
    ticket_closure_decline: "No, I still need help",
    ticket_closure_error_message: "Failed to update the resolution status. Please try again."
  }
}, Hr = {
  language: "en",
  strings: Wf,
  dateLocale: date_fns_locale_en_US__WEBPACK_IMPORTED_MODULE_13__/* .enUS */ ._
}, Yf = (e) => ({
  // Message Input
  MESSAGE_INPUT__PLACE_HOLDER: e.conversation.input_placeholder,
  MESSAGE_INPUT__PLACE_HOLDER__DISABLED: e.conversation.input_placeholder_disabled,
  MESSAGE_INPUT__PLACE_HOLDER__STEWARD: e.conversation.input_placeholder_steward,
  MESSAGE_INPUT__PLACE_HOLDER__WAIT_AI_AGENT_RESPONSE: e.conversation.input_placeholder_wait_ai_agent_response,
  MESSAGE_INPUT__PLACE_HOLDER__RECONNECTING: e.conversation.input_placeholder_reconnecting,
  // Messages
  UNKNOWN__UNKNOWN_MESSAGE_TYPE: e.conversation.unknown_message_type,
  POWERED_BY: e.conversation.powered_by,
  // CSAT
  CSAT_TITLE_UNSUBMITTED: e.csat.title,
  CSAT_TITLE_SUBMITTED: e.csat.submitted_label,
  CSAT_CRE_TITLE: e.csat.cre_question,
  CSAT_CRE_SOLVED: e.csat.cre_positive_label,
  CSAT_CRE_NOT_SOLVED: e.csat.cre_negative_label,
  CSAT_REASON_PLACEHOLDER: e.csat.reason_placeholder,
  CSAT_RATING_TITLE: e.csat.question,
  CSAT_SUBMIT_LABEL: e.csat.submit_label,
  CSAT_SUBMISSION_EXPIRED: e.csat.submission_expired,
  // Date format
  DATE_FORMAT__JUST_NOW: e.date_format.just_now,
  DATE_FORMAT__MINUTES_AGO: e.date_format.minutes_ago,
  DATE_FORMAT__HOURS_AGO: e.date_format.hours_ago,
  DATE_FORMAT__DATE_SHORT: e.date_format.date_short,
  DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR: e.date_format.date_separator,
  DATE_FORMAT__MESSAGE_TIMESTAMP: e.date_format.message_timestamp,
  // Conversation list
  CONVERSATION_LIST__HEADER_TITLE: e.conversation_list.header_title,
  CONVERSATION_LIST__ENDED: e.conversation_list.ended,
  CONVERSATION_LIST__SYSTEM_MESSAGE: e.conversation_list.system_message,
  CONVERSATION_LIST__NO_CONVERSATIONS: e.common.placeholder_no_conversations,
  CONVERSATION_LIST__MULTIPLE_FILES_COUNT: e.conversation_list.multiple_files_count,
  TALK_TO_AGENT: e.conversation.start_new_conversation_label,
  // Citation
  CITATION_SOURCE_TITLE: e.conversation.citation_title,
  // Form
  FORM_PLACEHOLDER: e.conversation.input_placeholder_active_form,
  FORM_VALIDATION_REQUIRED: e.form.validation_required,
  OPTIONAL: e.form.optional_label,
  // Common Placeholders
  PLACE_HOLDER__WRONG: e.common.placeholder_something_went_wrong,
  PLACE_HOLDER__NO_MESSAGES: e.common.placeholder_no_messages,
  RETRY: e.common.placeholder_something_went_wrong_retry_label,
  // Common UI
  BUTTON__OK: e.common.button_ok,
  BUTTON__CANCEL: e.common.button_cancel,
  // Failed Message
  FAILED_MESSAGE_RESEND: e.conversation.failed_message_resend,
  FAILED_MESSAGE_REMOVE: e.conversation.failed_message_remove,
  // Ticket closure
  DESK__TICKET_CLOSURE_CONFIRM: e.desk.ticket_closure_confirm,
  DESK__TICKET_CLOSURE_DECLINE: e.desk.ticket_closure_decline,
  DESK__TICKET_CLOSURE_ERROR_MESSAGE: e.desk.ticket_closure_error_message,
  // File upload
  FILE_UPLOAD_NO_SUPPORTED_FILES: e.conversation.file_upload_no_supported_files,
  FILE_UPLOAD_REPLACE_ALERT__TITLE: e.conversation.file_upload_replace_alert_title,
  FILE_UPLOAD_REPLACE_ALERT__DESCRIPTION: e.conversation.file_upload_replace_alert_description,
  FILE_UPLOAD_FILES: e.conversation.attachment_document,
  // Feedback
  FEEDBACK_TITLE: e.feedback.title,
  FEEDBACK_GOOD: e.feedback.good,
  FEEDBACK_BAD: e.feedback.bad,
  FEEDBACK_COMMENT_LABEL: e.feedback.comment_label,
  FEEDBACK_COMMENT_PLACEHOLDER: e.feedback.comment_placeholder,
  FEEDBACK_CANCEL: e.feedback.cancel,
  FEEDBACK_SUBMIT: e.feedback.submit,
  FEEDBACK_SAVE: e.feedback.save,
  FEEDBACK_EDIT: e.feedback.edit,
  FEEDBACK_REMOVE: e.feedback.remove,
  // Accessibility
  A11Y_MESSAGE_LIST: e.conversation.a11y_message_list,
  A11Y_SCROLL_TO_BOTTOM: e.conversation.a11y_scroll_to_bottom,
  A11Y_SCROLL_TO_NEW_MESSAGES: e.conversation.a11y_scroll_to_new_messages,
  A11Y_OPEN_CONVERSATION_LIST: e.conversation.a11y_open_conversation_list,
  A11Y_OPEN_CONVERSATION: e.conversation.a11y_open_conversation,
  A11Y_OPEN_CONVERSATIONS: e.conversation.a11y_open_conversations,
  A11Y_CLOSE_CONVERSATION: e.conversation.a11y_close_conversation,
  A11Y_CLOSE_CONVERSATIONS: e.conversation.a11y_close_conversations,
  A11Y_MENU: e.conversation.a11y_menu,
  A11Y_MESSAGE_INPUT: e.conversation.a11y_message_input,
  A11Y_SEND_MESSAGE: e.conversation.a11y_send_message,
  A11Y_ATTACH_FILE: e.conversation.a11y_attach_file,
  A11Y_CONNECT_AGENT: e.conversation.a11y_connect_agent,
  A11Y_CLOSE_MESSENGER: e.conversation.a11y_close_messenger,
  A11Y_DISMISS_NUDGE_MESSAGE: e.conversation.a11y_dismiss_nudge_message,
  A11Y_EXPAND_MESSENGER: e.conversation.a11y_expand_messenger,
  A11Y_COLLAPSE_MESSENGER: e.conversation.a11y_collapse_messenger,
  A11Y_MESSAGE_SENDER_YOU: e.conversation.a11y_message_sender_you,
  A11Y_SUGGESTED_REPLY: e.conversation.a11y_suggested_reply,
  A11Y_TYPING_INDICATOR: e.conversation.a11y_typing_indicator,
  A11Y_CODE_BLOCK_PLACEHOLDER: e.conversation.a11y_code_block_placeholder,
  A11Y_TYPING_FORMAT: e.conversation.a11y_typing_format,
  A11Y_MESSAGE_FAILED: e.conversation.a11y_message_failed,
  A11Y_NEW_MESSAGES_RECEIVED: e.conversation.a11y_new_messages_received,
  A11Y_NEW_MESSAGES_RECEIVED_FROM_SENDER: e.conversation.a11y_new_messages_received_from_sender,
  A11Y_AGENT_CONNECTED: e.conversation.a11y_agent_connected,
  A11Y_CONVERSATION_CLOSED: e.conversation.a11y_conversation_closed,
  A11Y_FILE_IMAGE: e.conversation.a11y_file_image,
  A11Y_FILE_VIDEO: e.conversation.a11y_file_video,
  A11Y_FILE_PDF: e.conversation.a11y_file_pdf,
  A11Y_FILE_DOCUMENT: e.conversation.a11y_file_document,
  A11Y_RECEIVED_FILE_IMAGE: e.conversation.a11y_received_file_image,
  A11Y_RECEIVED_FILE_VIDEO: e.conversation.a11y_received_file_video,
  A11Y_RECEIVED_FILE_PDF: e.conversation.a11y_received_file_pdf,
  A11Y_RECEIVED_FILES_IMAGE_COUNT: e.conversation.a11y_received_files_image_count,
  A11Y_SCREEN_CONVERSATION: e.conversation.a11y_screen_conversation,
  A11Y_SCREEN_CONVERSATION_WITH_AGENT: e.conversation.a11y_screen_conversation_with_agent,
  A11Y_SCREEN_CONVERSATION_LIST_NO_COUNT: e.conversation.a11y_screen_conversation_list_no_count,
  A11Y_SCREEN_CONVERSATION_LIST_WITH_COUNT: e.conversation.a11y_screen_conversation_list_with_count,
  A11Y_CSAT_DISPLAYED: e.conversation.a11y_csat_displayed,
  A11Y_EMPTY_CONVERSATION: e.conversation.a11y_empty_conversation,
  A11Y_INPUT_DISABLED: e.conversation.a11y_input_disabled,
  A11Y_FILE_SIZE_EXCEEDED: e.conversation.a11y_file_size_exceeded,
  A11Y_CSAT_FORM_ERROR: e.conversation.a11y_csat_form_error,
  A11Y_HINT_SEND_MESSAGE: e.conversation.a11y_hint_send_message,
  A11Y_HINT_OPEN_CONVERSATION: e.conversation.a11y_hint_open_conversation,
  A11Y_HINT_OPEN_CONVERSATIONS: e.conversation.a11y_hint_open_conversations,
  A11Y_HINT_CLOSE_CONVERSATION: e.conversation.a11y_hint_close_conversation,
  A11Y_HINT_OPEN_MENU: e.conversation.a11y_hint_open_menu,
  A11Y_HINT_CONNECT_TO_AGENT: e.conversation.a11y_hint_connect_to_agent,
  A11Y_HINT_ATTACH_FILE: e.conversation.a11y_hint_attach_file,
  A11Y_HINT_VIEW_NEW_MESSAGES: e.conversation.a11y_hint_view_new_messages,
  A11Y_HINT_OPEN_FILE: e.conversation.a11y_hint_open_file,
  A11Y_HINT_OPEN_IMAGE: e.conversation.a11y_hint_open_image,
  A11Y_HINT_SEND_REPLY: e.conversation.a11y_hint_send_reply,
  A11Y_CONVERSATION_ITEM: e.conversation_list.a11y_conversation_item,
  A11Y_CSAT_RATING_LABEL: e.csat.a11y_csat_rating_label,
  A11Y_HINT_SELECT_RATING: e.csat.a11y_hint_select_rating,
  // Image viewer
  IMAGE_VIEWER__DEFAULT_TITLE: e.conversation.image_viewer_default_title,
  A11Y_IMAGE_VIEWER_CLOSE: e.conversation.a11y_image_viewer_close,
  A11Y_IMAGE_VIEWER_PREVIOUS: e.conversation.a11y_image_viewer_previous,
  A11Y_IMAGE_VIEWER_NEXT: e.conversation.a11y_image_viewer_next,
  A11Y_IMAGE_VIEWER_DOWNLOAD: e.conversation.a11y_image_viewer_download,
  // Scroll
  SCROLL_TO_NEW_MESSAGES_LABEL: e.conversation.scroll_to_new_messages_label,
  // Handoff
  HANDOFF_CONFIRM__TITLE: e.handoff.confirm_title,
  HANDOFF_CONFIRM__DESCRIPTION: e.handoff.confirm_description,
  HANDOFF_CONFIRM__CANCEL: e.handoff.confirm_cancel,
  HANDOFF_CONFIRM__HANDOFF: e.handoff.confirm_handoff,
  // Memory
  MEMORY__DIALOG_TITLE: e.memory.dialog_title,
  MEMORY__DESC_ON: e.memory.desc_on,
  MEMORY__DESC_OFF: e.memory.desc_off,
  MEMORY__BUTTON_USE: e.memory.button_use,
  MEMORY__BUTTON_DONT_USE: e.memory.button_dont_use,
  MEMORY__BUTTON_KEEP_USING: e.memory.button_keep_using,
  MEMORY__BUTTON_DISABLE: e.memory.button_disable,
  MEMORY__BUTTON_DISABLE_AND_DELETE: e.memory.button_disable_and_delete,
  MEMORY__BUTTON_KEEP_OFF: e.memory.button_keep_off,
  MEMORY__BUTTON_ENABLE: e.memory.button_enable,
  MEMORY__BUTTON_CANCEL: e.memory.button_cancel,
  MEMORY__ERROR_MESSAGE: e.memory.error_message,
  A11Y_MEMORY_INDICATOR_MANAGE: e.memory.a11y_indicator_manage,
  A11Y_MEMORY_INDICATOR_ON: e.memory.a11y_indicator_on,
  A11Y_MEMORY_INDICATOR_OFF: e.memory.a11y_indicator_off,
  // Connection delay
  CONNECTION_DELAY__TITLE: e.connection_delay.title,
  CONNECTION_DELAY__DESCRIPTION: e.connection_delay.description
}), Fa = (e) => {
  var t;
  return ((t = e.split("-")) == null ? void 0 : t[0]) ?? En;
}, En = "en", Ua = /* @__PURE__ */ new Set([En, "ko", "es", "pt", "fr", "hi", "it", "de", "tr", "ja"]), qf = '@import"https://fonts.googleapis.com/css?family=Roboto:400,500,600,700&display=swap";.sb-message-template__border{position:relative}.sb-message-template__border:after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;box-shadow:inset 0 0 0 var(--border-width) var(--border-color);border-radius:var(--border-radius);pointer-events:none}.sb-message-template__action{cursor:pointer}.sb-message-template__parent{font-family:Roboto,serif}.sb-message-template__text{font-family:inherit;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;letter-spacing:normal;text-align:left}.sb-message-template__text-button{font-family:inherit;background-color:#e0e0e0;text-align:center;padding:10px;border-radius:6px;font-size:14px;font-weight:600;font-stretch:normal;font-style:normal;letter-spacing:normal}.sendbird-theme--light .sb-message-template__text-button{color:#742ddd}.sendbird-theme--dark .sb-message-template__text-button{color:#c2a9fa}.sb-message-template__text-button:hover{opacity:1;box-shadow:#0000001a 0 1px 3px,#0000000f 0 1px 2px}.sb-message-template__text-button,.sb-message-template__image-button{cursor:pointer;border-style:none}.sb-message-template__parent{border-radius:unset;background-color:transparent;overflow:hidden}.sb-message-template__parent *{box-sizing:border-box;line-height:1.3}.sb-message-template__carousel{display:flex;width:100%;box-sizing:border-box;touch-action:pan-y}', { Provider: jf, useContext: Ss } = xe("AgentUIElementResolver"), Xf = ({
  entryElement: e,
  modalRootElement: t,
  rootElement: n,
  children: r
}) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const o = n ?? document.body, i = e ?? o, c = t ?? o, l = (u) => u === Me.MODAL_ROOT ? c : i.querySelector(`#${u}`);
    return {
      resolveElement: l,
      resolvePortalContainer: (u) => l(u) ?? c
    };
  }, [e, t, n]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jf, { value: s }, r);
};
function yt(e, t) {
  const n = e.getRootNode({ composed: t });
  return n instanceof ShadowRoot || n instanceof Document ? n : document;
}
const Do = () => {
  const e = [];
  let t = 0;
  const n = /* @__PURE__ */ new Set(), r = () => n.forEach((s) => s());
  return {
    register: (s) => {
      const o = ++t;
      return e.push({ id: o, handler: s }), r(), () => {
        const i = e.findIndex((c) => c.id === o);
        i >= 0 && (e.splice(i, 1), r());
      };
    },
    dismissTopmost: () => {
      const s = e[e.length - 1];
      return s ? (s.handler(), !0) : !1;
    },
    subscribe: (s) => (n.add(s), () => {
      n.delete(s);
    }),
    getOpenCount: () => e.length
  };
}, {
  Provider: Zf,
  useContext: ys
} = xe("EscapeDismissStack"), $o = (e) => {
  e.stopPropagation(), e.stopImmediatePropagation();
}, Jf = ({
  rootElement: e = document.body,
  boundaryElement: t,
  children: n
}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  r.current || (r.current = Do()), s.current || (s.current = Do());
  const o = r.current, i = s.current;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const l = t ?? yt(e), u = (d) => {
      if (d.key === "Escape") {
        if (o.dismissTopmost()) {
          $o(d);
          return;
        }
        i.dismissTopmost() && $o(d);
      }
    };
    return l.addEventListener("keydown", u), () => l.removeEventListener("keydown", u);
  }, [t, e, i, o]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      register: o.register,
      dismissTopmost: o.dismissTopmost,
      registerShellDismissHandler: i.register,
      subscribe: o.subscribe,
      getOpenCount: o.getOpenCount
    }),
    [i, o]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zf, { value: c }, n);
}, Ba = (e, t, n) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    r.current = t;
  }, [t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (e)
      return n(() => r.current());
  }, [e, n]);
}, Qf = (e, t) => {
  const { register: n } = ys();
  Ba(e, t, n);
}, ep = (e, t) => {
  const { registerShellDismissHandler: n } = ys();
  Ba(e, t, n);
}, Ha = () => {
  const { subscribe: e, getOpenCount: t } = ys();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore)(
    e,
    () => t() > 0,
    () => !1
  );
}, tp = (e, t, n) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((s, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      o.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Po = Yf(Hr.strings), np = {
  ...Po,
  // Channel Header
  HEADER_BUTTON__AGENT_HANDOFF: "Talk to human agent",
  // Message Input
  MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES: "Select an option to continue",
  // Common UI
  BUTTON__SUBMIT: "Submit",
  SUBMITTED: "Submitted",
  TRY_AGAIN: "Please try again.",
  // File Upload
  FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT: "Up to %d files can be attached.",
  FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT: "The maximum size per file is %d MB.",
  FILE_UPLOAD_NOTIFICATION__FILES_EXCLUDED_BY_VALIDATION: "%d files were excluded due to limits. Please select files individually.",
  FILE_UPLOAD_PHOTOS: "Photos",
  // File Viewer
  FILE_VIEWER__UNSUPPORT: "Unsupported message",
  // Accessibility
  A11Y_FILE_SELECTED: (e) => `${e}, selected`,
  A11Y_FILE_REMOVE_BUTTON: (e) => `Remove file: ${e}`,
  A11Y_FILE_UPLOAD_OPTIONS: "File upload options",
  A11Y_FAILED_MESSAGE_OPTIONS: "Failed message options",
  A11Y_FEEDBACK_OPTIONS: "Feedback options",
  A11Y_CSAT_TEXT_INPUT_LABEL: "Enter answer",
  // Form
  FORM_UNAVAILABLE: "Form is no longer available.",
  FORM_NOT_SUPPORTED: "This form is not supported in the current version.",
  FORM_VALIDATION_MIN_LENGTH: (e) => `Minimum ${e} characters required`,
  FORM_VALIDATION_MAX_LENGTH: (e) => `Maximum ${e} characters allowed`,
  FORM_VALIDATION_MIN: (e) => `Minimum value is ${e}`,
  FORM_VALIDATION_MAX: (e) => `Maximum value is ${e}`,
  FORM_VALIDATION_MIN_SELECT: (e) => `Select at least ${e} options`,
  FORM_VALIDATION_MAX_SELECT: (e) => `Select at most ${e} options`,
  FORM_VALIDATION_REGEX_FAILED: "Invalid format",
  /** @deprecated Please use DATE_FORMAT__DATE_SHORT instead. **/
  DATE_FORMAT__CONVERSATION_LIST__LIST_ITEM_TITLE: Po.DATE_FORMAT__DATE_SHORT,
  /** @deprecated Unused string **/
  DATE_FORMAT__CONVERSATION_LIST__LIST_ITEM_TITLE_CAPTION: "h:mma",
  /** @deprecated Unused string **/
  CONVERSATION_LIST__TOPICS_FALLBACK: "No category",
  /** @deprecated Unused string **/
  CONVERSATION_CLOSED_FOOTER_LABEL: "Your conversation has ended",
  /** @deprecated Unused string **/
  START_NEW_CONVERSATION: "💬 Start a new conversation",
  /** @deprecated Unused string **/
  RETURN_TO_CONVERSATION: "💬 Return to conversation",
  /** @deprecated Unused string **/
  BUTTON__SAVE: "Save",
  /** @deprecated Unused string **/
  NO_NAME: "(No name)",
  /** @deprecated Unused string **/
  CHANNEL_FROZEN: "Channel frozen"
}, Yn = {
  language: Hr.language,
  dateLocale: Hr.dateLocale,
  stringSet: np
}, rp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yn
}, Symbol.toStringTag, { value: "Module" })), Gr = /* @__PURE__ */ new Map([[En, Yn]]);
async function sp(e) {
  const t = Gr.get(e);
  if (t) return t;
  try {
    if (Ua.has(e)) {
      const { default: n } = await tp(/* @__PURE__ */ Object.assign({ "./languages/de.ts": () => __webpack_require__.e(/* import() */ 2597).then(__webpack_require__.bind(__webpack_require__, 2597)), "./languages/en.ts": () => Promise.resolve().then(() => rp), "./languages/es.ts": () => __webpack_require__.e(/* import() */ 2281).then(__webpack_require__.bind(__webpack_require__, 12281)), "./languages/fr.ts": () => __webpack_require__.e(/* import() */ 4370).then(__webpack_require__.bind(__webpack_require__, 64370)), "./languages/hi.ts": () => __webpack_require__.e(/* import() */ 7403).then(__webpack_require__.bind(__webpack_require__, 57403)), "./languages/it.ts": () => __webpack_require__.e(/* import() */ 512).then(__webpack_require__.bind(__webpack_require__, 10512)), "./languages/ja.ts": () => __webpack_require__.e(/* import() */ 9845).then(__webpack_require__.bind(__webpack_require__, 49845)), "./languages/ko.ts": () => __webpack_require__.e(/* import() */ 866).then(__webpack_require__.bind(__webpack_require__, 80866)), "./languages/pt.ts": () => __webpack_require__.e(/* import() */ 720).then(__webpack_require__.bind(__webpack_require__, 90720)), "./languages/tr.ts": () => __webpack_require__.e(/* import() */ 6559).then(__webpack_require__.bind(__webpack_require__, 26559)) }), `./languages/${e}.ts`, 3);
      return Gr.set(e, n), n;
    }
    return Yn;
  } catch {
    return Yn;
  }
}
const {
  Provider: op,
  useContext: fe
} = xe("Localization"), ip = ({
  language: e = navigator.language,
  languageCode: t,
  logger: n,
  stringSet: r,
  children: s
}) => {
  const [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Gr.get(En));
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const c = t ?? Fa(e);
    o.language !== c && (n == null || n.debug("localization.useEffect: update language", {
      from: o.language,
      to: c
    }), sp(c).then(i));
  }, [e, t, n]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    op,
    {
      value: {
        language: o.language,
        defaultStringSet: o.stringSet,
        stringSet: { ...o.stringSet, ...r },
        dateLocale: o.dateLocale,
        format: (c, l, u) => (0,date_fns__WEBPACK_IMPORTED_MODULE_14__/* .format */ .WU)(c, l, { locale: o.dateLocale, ...u })
      }
    },
    s
  );
}, qn = "data-sb-agent-theme", Fo = (e) => (t, ...n) => {
  let r = "";
  return t.forEach((s, o) => {
    r += s + (n[o] ?? "");
  }), `[${qn}='${e}'] & { ${r} }`;
}, ie = {
  light: Fo("light"),
  dark: Fo("dark")
}, ap = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)(({ theme: e }) => {
  const { palette: t } = e;
  return `
    :root,
    :host {
      --sendbird-primary-extra-dark: ${t.primary.extraDark};
      --sendbird-primary-dark: ${t.primary.dark};
      --sendbird-primary-main: ${t.primary.main};
      --sendbird-primary-light: ${t.primary.light};
      --sendbird-primary-extra-light: ${t.primary.extraLight};

      --sendbird-secondary-extra-dark: ${t.secondary.extraDark};
      --sendbird-secondary-dark: ${t.secondary.dark};
      --sendbird-secondary-main: ${t.secondary.main};
      --sendbird-secondary-light: ${t.secondary.light};
      --sendbird-secondary-extra-light: ${t.secondary.extraLight};

      --sendbird-information-extra-dark: ${t.information.extraDark};
      --sendbird-information-dark: ${t.information.dark};
      --sendbird-information-main: ${t.information.main};
      --sendbird-information-light: ${t.information.light};
      --sendbird-information-extra-light: ${t.information.extraLight};

      --sendbird-error-extra-dark: ${t.error.extraDark};
      --sendbird-error-dark: ${t.error.dark};
      --sendbird-error-main: ${t.error.main};
      --sendbird-error-light: ${t.error.light};
      --sendbird-error-extra-light: ${t.error.extraLight};

      --sendbird-background-700: ${t.background700};
      --sendbird-background-600: ${t.background600};
      --sendbird-background-500: ${t.background500};
      --sendbird-background-400: ${t.background400};
      --sendbird-background-300: ${t.background300};
      --sendbird-background-200: ${t.background200};
      --sendbird-background-100: ${t.background100};
      --sendbird-background-50: ${t.background50};

      --sendbird-onlight-text-high-emphasis: ${t.onlight.textHighEmphasis};
      --sendbird-onlight-text-mid-emphasis: ${t.onlight.textMidEmphasis};
      --sendbird-onlight-text-low-emphasis: ${t.onlight.textLowEmphasis};
      --sendbird-onlight-text-disabled: ${t.onlight.textDisabled};

      --sendbird-ondark-text-high-emphasis: ${t.ondark.textHighEmphasis};
      --sendbird-ondark-text-mid-emphasis: ${t.ondark.textMidEmphasis};
      --sendbird-ondark-text-low-emphasis: ${t.ondark.textLowEmphasis};
      --sendbird-ondark-text-disabled: ${t.ondark.textDisabled};

      --sendbird-overlay-dark: ${t.overlay.dark};
      --sendbird-overlay-light: ${t.overlay.light};
    }
  `;
}), cp = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`[${qn}='light'] &{--sb-text-high-emphasis:var(--sendbird-onlight-text-high-emphasis);--sb-text-mid-emphasis:var(--sendbird-onlight-text-mid-emphasis);--sb-text-low-emphasis:var(--sendbird-onlight-text-low-emphasis);--sb-text-disabled:var(--sendbird-onlight-text-disabled);--sb-text-high-emphasis-inverse:var(--sendbird-ondark-text-high-emphasis);--sb-text-mid-emphasis-inverse:var(--sendbird-ondark-text-mid-emphasis);--sb-text-low-emphasis-inverse:var(--sendbird-ondark-text-low-emphasis);--sb-text-disabled-inverse:var(--sendbird-ondark-text-disabled);--sb-bg-50-600:var(--sendbird-background-50);--sb-bg-100-500:var(--sendbird-background-100);--sb-bg-300-500:var(--sendbird-background-300);--sb-bg-200-400:var(--sendbird-background-200);--sb-primary:var(--sendbird-primary-main);--sb-secondary:var(--sendbird-secondary-main);--sb-error:var(--sendbird-error-main);--sb-information:var(--sendbird-information-light);}[${qn}='dark'] &{--sb-text-high-emphasis:var(--sendbird-ondark-text-high-emphasis);--sb-text-mid-emphasis:var(--sendbird-ondark-text-mid-emphasis);--sb-text-low-emphasis:var(--sendbird-ondark-text-low-emphasis);--sb-text-disabled:var(--sendbird-ondark-text-disabled);--sb-text-high-emphasis-inverse:var(--sendbird-onlight-text-high-emphasis);--sb-text-mid-emphasis-inverse:var(--sendbird-onlight-text-mid-emphasis);--sb-text-low-emphasis-inverse:var(--sendbird-onlight-text-low-emphasis);--sb-text-disabled-inverse:var(--sendbird-onlight-text-disabled);--sb-bg-50-600:var(--sendbird-background-600);--sb-bg-100-500:var(--sendbird-background-500);--sb-bg-300-500:var(--sendbird-background-500);--sb-bg-200-400:var(--sendbird-background-400);--sb-primary:var(--sendbird-primary-light);--sb-secondary:var(--sendbird-secondary-light);--sb-error:var(--sendbird-error-light);--sb-information:var(--sendbird-information-light);}`, b = {
  color: {
    primary: {
      dark: "var(--sendbird-primary-dark)",
      main: "var(--sendbird-primary-main)"
    },
    secondary: {
      dark: "var(--sendbird-secondary-dark)",
      light: "var(--sendbird-secondary-light)"
    },
    error: {
      dark: "var(--sendbird-error-dark)",
      light: "var(--sendbird-error-light)"
    },
    information: {
      main: "var(--sendbird-information-main)",
      light: "var(--sendbird-information-light)"
    },
    background700: "var(--sendbird-background-700)",
    background500: "var(--sendbird-background-500)",
    background400: "var(--sendbird-background-400)",
    background300: "var(--sendbird-background-300)",
    background200: "var(--sendbird-background-200)",
    background100: "var(--sendbird-background-100)",
    background50: "var(--sendbird-background-50)",
    onlight: {
      textLowEmphasis: "var(--sendbird-onlight-text-low-emphasis)",
      textDisabled: "var(--sendbird-onlight-text-disabled)"
    },
    ondark: {
      textHighEmphasis: "var(--sendbird-ondark-text-high-emphasis)",
      textMidEmphasis: "var(--sendbird-ondark-text-mid-emphasis)",
      textLowEmphasis: "var(--sendbird-ondark-text-low-emphasis)",
      textDisabled: "var(--sendbird-ondark-text-disabled)"
    },
    overlay: {
      dark: "var(--sendbird-overlay-dark)"
    }
  },
  themedColor: {
    textHighEmphasis: "var(--sb-text-high-emphasis)",
    textMidEmphasis: "var(--sb-text-mid-emphasis)",
    textLowEmphasis: "var(--sb-text-low-emphasis)",
    textDisabled: "var(--sb-text-disabled)",
    textHighEmphasisInverse: "var(--sb-text-high-emphasis-inverse)",
    textLowEmphasisInverse: "var(--sb-text-low-emphasis-inverse)",
    bg_50_600: "var(--sb-bg-50-600)",
    bg_100_500: "var(--sb-bg-100-500)",
    bg_300_500: "var(--sb-bg-300-500)",
    bg_200_400: "var(--sb-bg-200-400)",
    primary: "var(--sb-primary)",
    error: "var(--sb-error)",
    secondary: "var(--sb-secondary)"
  }
};
class wt extends react__WEBPACK_IMPORTED_MODULE_0__.PureComponent {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t) {
    var n, r;
    (r = (n = this.props).onError) == null || r.call(n, t);
  }
  render() {
    const { fallback: t = null, errorFallback: n = t, loadingFallback: r = t, children: s } = this.props;
    return this.state.hasError ? n : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Suspense, { fallback: r }, s);
  }
}
const ct = (e) => {
  const t = e;
  return typeof t == "number" ? `${t}px` : t;
}, lp = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { className: "fill", d: "M52.552 11.448a2.666 2.666 0 0 1 .222 3.52l-.222.251-16.781 16.78 16.781 16.782a2.665 2.665 0 0 1 0 3.771 2.666 2.666 0 0 1-3.52.222l-.251-.222L32 35.771 15.219 52.552a2.665 2.665 0 0 1-3.771 0 2.666 2.666 0 0 1-.222-3.52l.222-.251L28.228 32l-16.78-16.781a2.665 2.665 0 0 1 0-3.771 2.666 2.666 0 0 1 3.52-.222l.251.222 16.78 16.78 16.782-16.78a2.665 2.665 0 0 1 3.771 0z", fill: "#000", fillRule: "evenodd" })), up = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { className: "fill", d: "M7.33348 7.3335L2.00015 7.3335L2.00015 6.00016H5.05735L1.3335 2.27631L2.27631 1.3335L6.00015 5.05734V2.00016L7.33348 2.00016L7.33348 7.3335ZM8.66683 8.66683H14.0002V10.0002L10.943 10.0002L14.6668 13.724L13.724 14.6668L10.0002 10.943V14.0002H8.66683L8.66683 8.66683Z", fill: "#000", fillRule: "evenodd" })), dp = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { className: "fill", fillRule: "evenodd", clipRule: "evenodd", d: "M2 2H7.33333V3.33333L4.27613 3.33333L7.99999 7.05719L7.05718 8L3.33333 4.27616L3.33333 7.33333H2V2ZM14 14H8.66667V12.6667H11.7239L8.00001 8.94281L8.94282 8L12.6667 11.7238V8.66667H14V14Z", fill: "#000" })), mp = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "evenodd", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { className: "fill", fill: "#0D0D0D", d: "M50.667 18.667H13.333v-5.334h37.334zM50.667 34.667H13.333v-5.334h37.334zM13.333 50.667h37.334v-5.334H13.333z" })), hp = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M59.795 29.43 7.329 2.979C4.691 1.802 1.76 4.153 2.932 6.798l6.925 18.609a2 2 0 0 0 1.544 1.275l32.273 5.394L11.4 37.47a1.998 1.998 0 0 0-1.544 1.275L2.932 57.353c-.879 2.645 1.76 4.997 4.397 3.527l52.466-26.453c2.051-.882 2.051-3.82 0-4.996z", className: "fill" })), gp = /* @__PURE__ */ new Set([
  "send",
  "chat",
  "message",
  "chevron-right",
  "good",
  "good-filled",
  "bad",
  "bad-filled"
]), fp = {
  close: lp,
  send: hp,
  menu: mp,
  expand: dp,
  collapse: up,
  spinner: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8107).then(__webpack_require__.bind(__webpack_require__, 18107))),
  chat: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 5355).then(__webpack_require__.bind(__webpack_require__, 5355))),
  message: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 7389).then(__webpack_require__.bind(__webpack_require__, 37389))),
  error: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8706).then(__webpack_require__.bind(__webpack_require__, 48706))),
  refresh: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 3705).then(__webpack_require__.bind(__webpack_require__, 53705))),
  "chevron-down": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8688).then(__webpack_require__.bind(__webpack_require__, 8688))),
  "chevron-right": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 7994).then(__webpack_require__.bind(__webpack_require__, 87994))),
  done: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 5708).then(__webpack_require__.bind(__webpack_require__, 85708))),
  "done-circle": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 6455).then(__webpack_require__.bind(__webpack_require__, 36455))),
  stop: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2324).then(__webpack_require__.bind(__webpack_require__, 22324))),
  "stop-circle": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 43).then(__webpack_require__.bind(__webpack_require__, 50043))),
  user: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 4039).then(__webpack_require__.bind(__webpack_require__, 84039))),
  "file-document": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 1704).then(__webpack_require__.bind(__webpack_require__, 41704))),
  download: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 5456).then(__webpack_require__.bind(__webpack_require__, 45456))),
  attach: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2614).then(__webpack_require__.bind(__webpack_require__, 22614))),
  "close-filled": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8999).then(__webpack_require__.bind(__webpack_require__, 48999))),
  agent: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 767).then(__webpack_require__.bind(__webpack_require__, 60767))),
  actionbook: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2904).then(__webpack_require__.bind(__webpack_require__, 92904))),
  function: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 542).then(__webpack_require__.bind(__webpack_require__, 20542))),
  "radio-on": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8403).then(__webpack_require__.bind(__webpack_require__, 98403))),
  "radio-off": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 9827).then(__webpack_require__.bind(__webpack_require__, 39827))),
  confluence: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 4179).then(__webpack_require__.bind(__webpack_require__, 14179))),
  zendesk: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 3432).then(__webpack_require__.bind(__webpack_require__, 33432))),
  salesforce: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2711).then(__webpack_require__.bind(__webpack_require__, 72711))),
  sprinklr: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 6801).then(__webpack_require__.bind(__webpack_require__, 56801))),
  website: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 7870).then(__webpack_require__.bind(__webpack_require__, 97870))),
  snippet: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 633).then(__webpack_require__.bind(__webpack_require__, 90633))),
  template: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 9445).then(__webpack_require__.bind(__webpack_require__, 52833))),
  source: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 1518).then(__webpack_require__.bind(__webpack_require__, 41518))),
  copy: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 3963).then(__webpack_require__.bind(__webpack_require__, 33963))),
  show: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 5288).then(__webpack_require__.bind(__webpack_require__, 85288))),
  mute: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 5141).then(__webpack_require__.bind(__webpack_require__, 95141))),
  good: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8900).then(__webpack_require__.bind(__webpack_require__, 58900))),
  bad: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2376).then(__webpack_require__.bind(__webpack_require__, 2376))),
  "good-filled": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 8609).then(__webpack_require__.bind(__webpack_require__, 18609))),
  "bad-filled": (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 377).then(__webpack_require__.bind(__webpack_require__, 40377))),
  delight: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 3042).then(__webpack_require__.bind(__webpack_require__, 43042))),
  photo: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 9576).then(__webpack_require__.bind(__webpack_require__, 79576))),
  add: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2998).then(__webpack_require__.bind(__webpack_require__, 42998))),
  document: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 6974).then(__webpack_require__.bind(__webpack_require__, 56974))),
  memory: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 609).then(__webpack_require__.bind(__webpack_require__, 10609))),
  activity: (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 2559).then(__webpack_require__.bind(__webpack_require__, 72559)))
}, pp = (e) => ({ size: t = 24, color: n = b.color.primary.main, flipInRtl: r = !1 }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ep, { $size: t, $color: n, $rtlFlip: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { errorFallback: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Cp, null) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e, null))), Ga = Object.fromEntries(
  Object.entries(fp).map(([e, t]) => [e, pp(t)])
), _p = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`[dir='rtl'] &:not([dir='ltr']),&[dir='rtl']{transform:scaleX(-1);}`, Ep = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span.attrs */ .ZP.span.attrs({
  "aria-hidden": "true"
})`
  width: ${({ $size: e }) => ct(e)};
  height: ${({ $size: e }) => ct(e)};
  display: inline-block;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  [class*='fill'] {
    fill: ${({ $color: e }) => e};
  }

  [class*='stroke'] {
    stroke: ${({ $color: e }) => e};
    stroke-width: 2px;
    stroke-linejoin: round;
  }

  ${({ $rtlFlip: e }) => e && _p};
`, Cp = () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { x: "8", y: "8", width: "48", height: "48", fill: "none", className: "stroke", rx: "4" }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("line", { x1: "20", y1: "20", x2: "44", y2: "44", className: "stroke" }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("line", { x1: "44", y1: "20", x2: "20", y2: "44", className: "stroke" })), {
  Provider: vp,
  useContext: bp
} = xe("MessengerIcon", { icons: Ga }), Sp = ({ icons: e, children: t }) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({ icons: Pm(Ga, e) }), [e]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vp, { value: n }, t);
}, {
  Provider: yp,
  useContext: Ap
} = xe("MessengerTheme");
function Tp(e) {
  const { theme: t, appearance: n, logger: r } = e;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Th,
    {
      appearance: n,
      palette: t == null ? void 0 : t.palette,
      typography: t == null ? void 0 : t.typography,
      colors: t == null ? void 0 : t.colors,
      logger: r
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ip, { ...e })
  );
}
function Ip({ rootElement: e = document.body, children: t }) {
  const { theme: n, updateTheme: r } = nr();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    e.setAttribute(qn, n.selectedTheme);
  }, [e, n.selectedTheme]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(styled_components__WEBPACK_IMPORTED_MODULE_15__/* .ThemeProvider */ .f6, { theme: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yp, { value: { theme: n, updateTheme: r, rootElement: e } }, t));
}
const xp = (e, t) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const n = yt(t) instanceof ShadowRoot, r = yt(t, !0);
    if (!(n ? t : r).querySelector(`link[href*='${e}']`)) {
      const o = r.createElement("link");
      o.rel = "stylesheet", o.href = e, (n ? t : r.head).appendChild(o);
    }
  }, [e, t]);
}, Mp = (e, t = document.body) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e) return;
    const n = yt(t), s = n instanceof ShadowRoot ? t : n.head;
    if (!s) return;
    const o = `sba-${btoa(e).slice(0, 10)}`;
    let i = s.querySelector(`style#${o}`);
    i ? i.textContent !== e && (i.textContent = e) : (i = s.ownerDocument.createElement("style"), i.id = o, i.textContent = e, s.appendChild(i));
  }, [e, t]);
}, Rp = 80, wp = () => {
  const { stringSet: e } = fe(), t = {
    screenConversation: e.A11Y_SCREEN_CONVERSATION,
    screenConversationWithAgent: e.A11Y_SCREEN_CONVERSATION_WITH_AGENT,
    screenConversationListNoCount: e.A11Y_SCREEN_CONVERSATION_LIST_NO_COUNT,
    screenConversationListWithCount: e.A11Y_SCREEN_CONVERSATION_LIST_WITH_COUNT,
    newMessage: e.A11Y_NEW_MESSAGES_RECEIVED,
    newMessageFromSender: e.A11Y_NEW_MESSAGES_RECEIVED_FROM_SENDER,
    typing: e.A11Y_TYPING_FORMAT,
    sendFailed: e.A11Y_MESSAGE_FAILED,
    agentConnected: e.A11Y_AGENT_CONNECTED,
    conversationClosed: e.A11Y_CONVERSATION_CLOSED,
    csatDisplayed: e.A11Y_CSAT_DISPLAYED,
    csatExpired: e.CSAT_SUBMISSION_EXPIRED,
    emptyState: e.A11Y_EMPTY_CONVERSATION,
    inputDisabled: e.A11Y_INPUT_DISABLED,
    fileSizeExceeded: e.A11Y_FILE_SIZE_EXCEEDED,
    csatFormError: e.A11Y_CSAT_FORM_ERROR
  }, n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);
  return n.current = t, n;
}, Va = xe("AriaLiveRegion", {
  announce: Ae,
  announceScreenEntry: Ae,
  announceStatus: Ae,
  announceError: Ae,
  flush: Ae,
  setSuppressionState: Ae
}), kp = Va.Provider, As = Va.useContext, Lp = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
}, Op = ({ children: e }) => {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Ae), s = wp(), [o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => vf(
      (g) => {
        r.current(g);
      },
      {
        throttleMs: 1e3,
        isSuppressed: () => n.current.size > 0
      }
    )
  );
  r.current = (g) => {
    const f = t.current;
    f && (f.textContent = "", requestAnimationFrame(() => {
      f.textContent = g;
    }));
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    o.destroy();
  }, [o]);
  const i = o.announce, c = o.flush, l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g) => {
      const f = Sf(g, s.current);
      i(f);
    },
    [i]
  ), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g, f) => {
      const v = yf(g, s.current), _ = (f == null ? void 0 : f.mode) ?? bf(g.event);
      i(v, { mode: _, dedupeKey: f == null ? void 0 : f.dedupeKey });
    },
    [i]
  ), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (g, f) => {
      const v = Af(g, s.current);
      o.announceIgnoringSuppression(v), f && setTimeout(() => {
        f.focus();
      }, Rp);
    },
    [o]
  ), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((g, f) => {
    if (f) {
      n.current.add(g);
      return;
    }
    n.current.delete(g);
  }, []), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      announce: i,
      announceScreenEntry: l,
      announceStatus: u,
      announceError: d,
      flush: c,
      setSuppressionState: m
    }),
    [i, d, l, u, c, m]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(kp, { value: h }, e, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: t,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      style: Lp
    }
  ));
}, za = xe(
  "ConversationAnnouncements",
  {
    announcementsEnabled: !0,
    announce: Ae,
    announceScreenEntry: Ae,
    announceStatus: Ae,
    announceError: Ae,
    setIsSuppressed: Ae,
    setStatusPauseState: Ae,
    flush: Ae
  }
), Np = za.Provider, _t = za.useContext, Dp = ({
  children: e,
  announcementsEnabled: t = !0
}) => {
  const { announce: n, announceScreenEntry: r, announceStatus: s, announceError: o, flush: i, setSuppressionState: c } = As(), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Symbol("conversation-announcements")), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => {
      if (!t || !A) {
        c(d.current, !1);
        return;
      }
      c(d.current, !0);
    },
    [t, c]
  ), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    l.current = [];
  }, []), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (l.current.length === 0)
      return;
    if (!t) {
      h();
      return;
    }
    const A = [...l.current];
    h(), A.forEach((I) => {
      i(), s(I.params, I.options);
    });
  }, [s, t, h, i]), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A, I) => {
      if (I) {
        u.current.add(A);
        return;
      }
      u.current.delete(A), u.current.size === 0 && g();
    },
    [g]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => {
      t && n(A);
    },
    [n, t]
  ), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A) => {
      t && r(A);
    },
    [r, t]
  ), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A, I) => {
      if (t) {
        if (u.current.size > 0) {
          l.current.push({ params: A, options: I });
          return;
        }
        s(A, I);
      }
    },
    [s, t]
  ), y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (A, I) => {
      t && o(A, I);
    },
    [o, t]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (t || (h(), c(d.current, !1)), () => {
    h(), c(d.current, !1);
  }), [t, h, c]);
  const S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      announcementsEnabled: t,
      announce: v,
      announceScreenEntry: _,
      announceStatus: p,
      announceError: y,
      setIsSuppressed: m,
      setStatusPauseState: f,
      flush: i
    }),
    [
      t,
      i,
      v,
      y,
      _,
      p,
      m,
      f
    ]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Np, { value: S }, e);
}, rr = [
  "a[href]",
  "button:not(:disabled)",
  "input:not(:disabled)",
  "select:not(:disabled)",
  "textarea:not(:disabled)",
  '[tabindex]:not([tabindex="-1"])'
].join(", "), Ka = `${rr}, [tabindex="-1"]`, Wt = (e) => {
  if (!e.isConnected || e.hidden) return !1;
  let t = e;
  const n = e.ownerDocument.defaultView;
  for (; t; ) {
    if (t.hidden || t.getAttribute("aria-hidden") === "true")
      return !1;
    if (n) {
      const r = n.getComputedStyle(t);
      if (r.display === "none" || r.visibility === "hidden")
        return !1;
    }
    t = t.parentElement;
  }
  return !0;
}, dn = (e, t) => {
  for (const n of e.querySelectorAll(t))
    if (!n.hasAttribute(bs) && Wt(n))
      return n;
  return null;
}, Wa = (e) => {
  let t = null, n = null;
  for (const r of e.querySelectorAll(rr))
    r.hasAttribute(bs) || Wt(r) && (t ?? (t = r), n = r);
  return t ? { first: t, last: n } : null;
}, Ya = (e, t) => e instanceof ShadowRoot && !(t instanceof HTMLElement) ? e.host.ownerDocument.activeElement === e.host : t instanceof HTMLElement ? e instanceof Document ? t === e.body || t === e.documentElement : !1 : !0, $p = (e, t, n) => Ya(e, t) || n != null && t instanceof HTMLElement && n.contains(t), Ts = (e) => dn(e, Nf), qa = (e) => Ts(e) ?? dn(e, rr), Pp = (e) => {
  const t = Ts(e);
  if (t) return t;
  const n = e.querySelector($f);
  return (n ? dn(n, Ka) : null) ?? dn(e, rr);
}, G = ({
  as: e,
  variant: t = "body1",
  color: n,
  maxTextLines: r,
  className: s,
  ...o
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  Bp,
  {
    as: e,
    $variant: t,
    className: s,
    $color: n,
    $maxTextLines: r,
    ...o
  }
), Uo = /* @__PURE__ */ new WeakMap(), Fp = (e, t) => {
  let n = Uo.get(t);
  n || (n = /* @__PURE__ */ new Map(), Uo.set(t, n));
  const r = n.get(e);
  if (r) return r;
  const s = t[e] ?? t.body1, o = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`font-size:${ct(s.fontSize)};font-weight:${s.fontWeight};${s.fontFamily ? `font-family: ${s.fontFamily};` : ""}
    ${s.lineHeight ? `line-height: ${s.lineHeight};` : "line-height: 100%;"}
  `;
  return n.set(e, o), o;
}, Up = (e) => e ? styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:${e};overflow:hidden;` : "", Bp = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span */ .ZP.span`font-stretch:normal;letter-spacing:normal;${({ $variant: e, theme: t }) => Fp(e, t.typography)}color:${({ $color: e }) => e};${({ $maxTextLines: e }) => Up(e)}`;
async function Is(e) {
  let t = e;
  t && (!t.startsWith("http://") && !t.startsWith("https://") && (t = "https://" + t), window.open(t, "_blank", "noopener,noreferrer"));
}
const Vr = '[role="dialog"][aria-modal="true"]', Hp = (e, t) => {
  const n = new Set(
    Array.from(e.ownerDocument.querySelectorAll(Vr)).filter(
      (s) => s !== e && (s.contains(e) || e.contains(s))
    )
  ), r = t == null ? void 0 : t.closest(Vr);
  return r && r !== e && n.add(r), n;
}, Gp = (e, t) => Array.from(e.ownerDocument.querySelectorAll(Vr)).some(
  (n) => n !== e && !t.has(n) && !n.contains(e) && Wt(n)
), Vp = (e) => {
  const t = qa(e) ?? e;
  t === e && ja(e), t.focus();
}, ja = (e) => {
  e.hasAttribute("tabindex") || e.setAttribute("tabindex", "-1");
}, zp = (e, t) => {
  const n = Wa(e);
  if (!n) {
    ja(e), e.focus();
    return;
  }
  n[t].focus();
}, Bo = (e, t) => {
  const n = e.ownerDocument.createElement("span");
  return n.tabIndex = 0, n.setAttribute(bs, Df), n.style.cssText = [
    "position: fixed",
    "width: 1px",
    "height: 1px",
    "opacity: 0",
    "overflow: hidden",
    "pointer-events: none"
  ].join(";"), n.addEventListener("focus", () => zp(e, t)), n;
}, Kp = (e, t) => {
  e.key === "Tab" && (e.defaultPrevented || e.target === t && (Wa(t) || (e.preventDefault(), t.focus())));
}, sr = (e, t, { nameReady: n = !0 } = {}) => {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e || !t.current) {
      s.current = !1;
      return;
    }
    r.current += 1;
    const o = r.current, i = t.current, c = i.getRootNode(), l = c.activeElement instanceof HTMLElement ? c.activeElement : null, u = Hp(i, l);
    return () => {
      l && Oe(() => {
        if (r.current !== o) return;
        const d = c.activeElement;
        i.isConnected && d instanceof HTMLElement && d !== i && !i.contains(d) && !Ya(c, d) && d.matches(Ka) && Wt(d) || Gp(i, u) || !l.isConnected || !Wt(l) || l.focus();
      });
    };
  }, [e, t]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e || !t.current) return;
    const o = t.current;
    let i = !1;
    const c = () => {
      if (i || s.current || !o.isConnected) return;
      const d = o.getRootNode().activeElement;
      if (d instanceof HTMLElement && d !== o && o.contains(d) && Wt(d)) {
        s.current = !0;
        return;
      }
      s.current = !0, Vp(o);
    };
    if (n)
      return Oe(c), () => {
        i = !0;
      };
    const l = setTimeout(() => Oe(c), $a);
    return () => {
      i = !0, clearTimeout(l);
    };
  }, [e, t, n]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e || !t.current) return;
    const o = t.current, i = Bo(o, "last"), c = Bo(o, "first"), l = (u) => Kp(u, o);
    return o.insertBefore(i, o.firstChild), o.appendChild(c), o.addEventListener("keydown", l), () => {
      o.removeEventListener("keydown", l), i.remove(), c.remove();
    };
  }, [e, t]);
}, Tt = ({
  style: e,
  portalContainerId: t,
  visible: n,
  onClose: r,
  children: s,
  cancelable: o = !0,
  "aria-label": i,
  "aria-labelledby": c,
  "aria-describedby": l
}) => {
  const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), { resolvePortalContainer: d } = Ss();
  return sr(n, u), Qf(n, o ? r : Ae), n ? (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wp, { onClick: o ? r : void 0, style: e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Yp,
      {
        ref: u,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": i,
        "aria-labelledby": c,
        "aria-describedby": l,
        onClick: (m) => m.stopPropagation()
      },
      s
    )),
    d(t)
  ) : null;
}, Wp = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:fixed;top:0;left:0;width:100%;height:100%;background:${b.color.overlay.dark};display:flex;justify-content:center;align-items:center;z-index:${Dt.MODAL};`, Yp = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`border-radius:4px;overflow:hidden;box-shadow:0 16px 24px 2px rgba(13,13,13,0.12),0 6px 30px 5px rgba(13,13,13,0.08),0 6px 10px -5px rgba(13,13,13,0.04);z-index:${Dt.MODAL};`, qp = ({ id: e, children: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jp, { id: e }, t), jp = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span */ .ZP.span`position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;`, Ho = (e, t) => {
  const n = {
    role: "heading",
    "aria-level": 2,
    "aria-label": e
  };
  return t != null && t.active && t.titleId ? {
    ...n,
    id: t.titleId,
    tabIndex: -1,
    ...t.initialFocus === !1 ? {} : wa
  } : n;
}, Xp = () => {
  const e = `${(0,react__WEBPACK_IMPORTED_MODULE_0__.useId)()}-`;
  return (t, n) => {
    if (!t)
      return {
        props: {},
        node: null
      };
    const r = e + n, s = (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(qp, { id: r, children: t });
    return {
      props: {
        "aria-describedby": r
      },
      node: s
    };
  };
}, Go = ({ name: e, mimeType: t, selected: n }, r) => {
  var o;
  const s = je(t ?? "") ? r.A11Y_FILE_IMAGE(e) : gn(t ?? "") ? r.A11Y_FILE_VIDEO(e) : Vi({ name: e, mimeType: t }) ? r.A11Y_FILE_PDF(e) : r.A11Y_FILE_DOCUMENT(e);
  return n ? ((o = r.A11Y_FILE_SELECTED) == null ? void 0 : o.call(r, s)) ?? `${s}, selected` : s;
}, Zp = (e) => (t) => {
  t.repeat || (t.key === "Enter" || t.key === " ") && (t.preventDefault(), e());
}, sn = ({ onActivate: e }) => ({
  role: "button",
  tabIndex: 0,
  onClick: e,
  onKeyDown: Zp(e)
}), Jp = ({ disabled: e, currentIndex: t, totalCount: n, onNavigate: r }) => (s) => {
  var l;
  if (e || n <= 0) return;
  let o = null;
  switch (s.key) {
    case "ArrowRight":
    case "ArrowDown":
      o = (t + 1) % n;
      break;
    case "ArrowLeft":
    case "ArrowUp":
      o = (t - 1 + n) % n;
      break;
    default:
      return;
  }
  s.preventDefault(), r(o);
  const i = s.currentTarget.parentElement, c = i == null ? void 0 : i.querySelectorAll('[role="radio"]');
  (l = c == null ? void 0 : c[o]) == null || l.focus();
}, Vo = (e, t, n, r, s, o) => {
  let i = -1;
  return (e || !s && n === 0) && (i = 0), {
    role: "radio",
    "aria-checked": e,
    "aria-disabled": t,
    onKeyDown: Jp({ disabled: t, currentIndex: n, totalCount: r, onNavigate: o }),
    tabIndex: i
  };
}, pe = () => {
  const { stringSet: e } = fe(), t = Xp(), n = (i, c) => {
    let l = e.A11Y_HINT_OPEN_FILE, u = "of";
    je(i ?? "") && (l = e.A11Y_HINT_OPEN_IMAGE, u = "oi"), c !== void 0 && (u += c);
    const d = t(l, u);
    return {
      props: d.props,
      descriptionNode: d.node
    };
  }, r = (i) => ({
    "aria-label": Go(i, e)
  });
  return {
    launcher: {
      button: ({ isOpened: i, opensConversationList: c }) => {
        const l = Lf({
          intent: Rf({ isOpened: i, opensConversationList: c }),
          strings: {
            openConversation: e.A11Y_OPEN_CONVERSATION,
            openConversationList: e.A11Y_OPEN_CONVERSATIONS,
            closeConversation: e.A11Y_CLOSE_CONVERSATION,
            closeConversationList: e.A11Y_CLOSE_CONVERSATIONS,
            hintOpenConversation: e.A11Y_HINT_OPEN_CONVERSATION,
            hintOpenConversationList: e.A11Y_HINT_OPEN_CONVERSATIONS,
            hintCloseConversation: e.A11Y_HINT_CLOSE_CONVERSATION
          }
        });
        let u = "lc";
        l.hint === e.A11Y_HINT_OPEN_CONVERSATION && (u = "lo"), l.hint === e.A11Y_HINT_OPEN_CONVERSATIONS && (u = "los");
        const d = t(l.hint, u);
        return {
          props: {
            "aria-label": l.label,
            ...d.props
          },
          descriptionNode: d.node
        };
      }
    },
    messenger: {
      closeButton: () => ({
        props: {
          "aria-label": e.A11Y_CLOSE_MESSENGER
        },
        descriptionNode: null
      }),
      expandButton: (i) => {
        let c = e.A11Y_EXPAND_MESSENGER;
        return i && (c = e.A11Y_COLLAPSE_MESSENGER), {
          props: {
            "aria-label": c
          },
          descriptionNode: null
        };
      },
      connectionDelayDialog: () => ({
        props: {
          "aria-label": e.CONNECTION_DELAY__TITLE
        },
        descriptionNode: null
      })
    },
    conversation: {
      header: {
        menuButton: () => {
          const i = e.A11Y_HINT_OPEN_MENU, c = t(i, "mb");
          return {
            props: {
              "aria-label": e.A11Y_MENU,
              ...c.props
            },
            descriptionNode: c.node
          };
        },
        closeConversationButton: () => {
          const i = e.A11Y_HINT_CLOSE_CONVERSATION, c = t(i, "cc");
          return {
            props: {
              "aria-label": e.A11Y_CLOSE_CONVERSATION,
              ...c.props
            },
            descriptionNode: c.node
          };
        },
        handoffButton: () => {
          const i = e.A11Y_HINT_CONNECT_TO_AGENT, c = t(i, "h");
          return {
            props: {
              "aria-label": e.A11Y_CONNECT_AGENT,
              ...c.props
            },
            descriptionNode: c.node
          };
        },
        title: (i, c) => ({
          props: Ho(i, c),
          descriptionNode: null
        }),
        memoryIndicator: (i) => {
          let c = e.A11Y_MEMORY_INDICATOR_OFF, l = "mof";
          i && (c = e.A11Y_MEMORY_INDICATOR_ON, l = "mon");
          const u = t(c, l);
          return {
            props: {
              "aria-label": e.A11Y_MEMORY_INDICATOR_MANAGE,
              ...u.props
            },
            descriptionNode: u.node
          };
        }
      },
      messageInput: {
        attachFileButton: () => {
          const i = e.A11Y_HINT_ATTACH_FILE, c = t(i, "af");
          return {
            props: {
              "aria-label": e.A11Y_ATTACH_FILE,
              ...c.props
            },
            descriptionNode: c.node
          };
        },
        sendButton: () => {
          const i = e.A11Y_HINT_SEND_MESSAGE, c = t(i, "sm");
          return {
            props: {
              "aria-label": e.A11Y_SEND_MESSAGE,
              ...c.props
            },
            descriptionNode: c.node
          };
        },
        textInput: (i) => ({
          props: {
            role: "textbox",
            "aria-label": i,
            ...Ff
          },
          descriptionNode: null
        })
      },
      suggestedReplies: {
        item: (i, c) => {
          const l = e.A11Y_HINT_SEND_REPLY, u = t(l, `sr${c}`);
          return {
            props: {
              "aria-label": `${e.A11Y_SUGGESTED_REPLY}, ${i}`,
              ...u.props
            },
            descriptionNode: u.node
          };
        }
      },
      feedback: {
        container: () => {
          const i = e.A11Y_HINT_SELECT_RATING, c = t(i, "fb");
          return {
            props: c.props,
            descriptionNode: c.node
          };
        },
        button: (i, c) => {
          const l = e.A11Y_HINT_SELECT_RATING, u = t(l, `f${i}`);
          let d = e.FEEDBACK_BAD;
          return i === "good" && (d = e.FEEDBACK_GOOD), {
            props: {
              "aria-label": d,
              ...u.props,
              "aria-pressed": c
            },
            descriptionNode: u.node
          };
        },
        optionsBottomSheet: () => ({
          props: {
            "aria-label": e.A11Y_FEEDBACK_OPTIONS
          },
          descriptionNode: null
        })
      },
      messageList: {
        item: ({ label: i, holding: c }) => c ? {
          props: { "aria-hidden": !0 },
          descriptionNode: null
        } : {
          props: { role: "listitem", tabIndex: -1, "aria-label": i },
          descriptionNode: null
        },
        typingItem: (i) => ({
          props: {
            role: "listitem",
            tabIndex: -1,
            "aria-label": cn({
              sender: i,
              message: e.A11Y_TYPING_INDICATOR,
              codeBlockPlaceholder: e.A11Y_CODE_BLOCK_PLACEHOLDER
            })
          },
          descriptionNode: null
        })
      },
      newMessagesButton: () => {
        const i = e.A11Y_HINT_VIEW_NEW_MESSAGES, c = t(i, "nm");
        return {
          props: {
            "aria-label": e.A11Y_SCROLL_TO_NEW_MESSAGES,
            ...c.props
          },
          descriptionNode: c.node
        };
      },
      scrollToBottomButton: () => {
        const i = e.A11Y_HINT_VIEW_NEW_MESSAGES, c = t(i, "sb");
        return {
          props: {
            "aria-label": e.A11Y_SCROLL_TO_BOTTOM,
            ...c.props
          },
          descriptionNode: c.node
        };
      },
      startNewConversationButton: ({ onActivate: i }) => ({
        props: {
          ...sn({ onActivate: i }),
          "aria-label": e.TALK_TO_AGENT
        },
        descriptionNode: null
      }),
      poweredByLink: () => ({
        props: {
          "aria-label": `${e.POWERED_BY} Sendbird`
        },
        descriptionNode: null
      }),
      retryButton: (i = e.RETRY) => ({
        props: {
          "aria-label": i
        },
        descriptionNode: null
      }),
      file: {
        label: (i, c, l) => i ? Go(
          {
            name: i,
            mimeType: c,
            selected: l
          },
          e
        ) : "",
        preview: (i) => ({
          props: r(i),
          descriptionNode: null
        }),
        buttonLikePreview: ({
          onActivate: i,
          ...c
        }, l) => {
          const u = n(c.mimeType, l);
          return {
            props: {
              ...sn({ onActivate: i }),
              ...r(c),
              ...u.props
            },
            descriptionNode: u.descriptionNode
          };
        },
        removeButton: (i) => ({
          props: {
            "aria-label": e.A11Y_FILE_REMOVE_BUTTON(i)
          },
          descriptionNode: null
        })
      },
      csat: {
        scoresContainer: (i) => {
          const c = e.A11Y_HINT_SELECT_RATING, l = t(c, "cs");
          return {
            props: {
              role: "radiogroup",
              "aria-label": i,
              ...l.props
            },
            descriptionNode: l.node
          };
        },
        scoreItem: ({
          score: i,
          label: c,
          selected: l,
          disabled: u,
          currentIndex: d,
          totalCount: m,
          hasSelection: h,
          onChange: g
        }) => {
          var p;
          const f = c.trim() || c, v = e.A11Y_HINT_SELECT_RATING, _ = t(v, `cs${i}`);
          return {
            props: {
              disabled: u,
              onClick: () => g(i),
              ...Vo(
                l,
                u,
                d,
                m,
                h,
                (y) => g(y + 1)
              ),
              ..._.props,
              "aria-label": ((p = e.A11Y_CSAT_RATING_LABEL) == null ? void 0 : p.call(e, i, f)) ?? `${i} / ${m} — ${f}`
            },
            descriptionNode: _.node
          };
        },
        submitButton: (i) => ({
          props: {
            "aria-label": i
          },
          descriptionNode: null
        })
      },
      form: {
        button: (i) => ({
          props: {
            "aria-label": i
          },
          descriptionNode: null
        }),
        textInput: (i, c, l, u) => ({
          props: {
            ...u != null && u.labelId ? { "aria-labelledby": u.labelId } : { "aria-label": i },
            "aria-required": c,
            "aria-disabled": l
          },
          descriptionNode: null
        }),
        numberInput: (i, c, l) => ({
          props: {
            "aria-label": i,
            "aria-required": c,
            "aria-disabled": l
          },
          descriptionNode: null
        }),
        singleSelectGroup: (i) => {
          const c = {
            role: "radiogroup"
          };
          return i && (c["aria-label"] = i), {
            props: c,
            descriptionNode: null
          };
        },
        singleSelectOption: (i, c, l, u, d, m, h) => ({
          props: {
            ...Vo(c, l, u, d, m, h),
            "aria-label": i
          },
          descriptionNode: null
        }),
        multiSelectOption: (i, c, l) => ({
          props: {
            "aria-label": i,
            "aria-pressed": c,
            "aria-disabled": l
          },
          descriptionNode: null
        })
      }
    },
    conversationList: {
      headerTitle: (i, c) => ({
        props: Ho(i, c),
        descriptionNode: null
      }),
      footer: {
        button: ({ onActivate: i }) => ({
          props: {
            ...sn({ onActivate: i }),
            "aria-label": e.TALK_TO_AGENT
          },
          descriptionNode: null
        })
      },
      item: ({ agent: i, status: c, lastMessage: l, time: u, unreadCount: d, onActivate: m }) => {
        const h = pf(
          { agent: i, status: c, lastMessage: l, time: u, unreadCount: d },
          e.A11Y_CONVERSATION_ITEM
        );
        if (!m)
          return {
            props: {
              "aria-label": h
            },
            descriptionNode: null
          };
        const g = e.A11Y_HINT_OPEN_CONVERSATION, f = t(g, "cli");
        return {
          props: {
            ...sn({ onActivate: m }),
            ...f.props,
            "aria-label": h
          },
          descriptionNode: f.node
        };
      }
    }
  };
}, Qp = ({ title: e, description: t, highlightedText: n }) => {
  const r = Vg(t, n);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t_, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n_, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { as: "div", variant: "h1", color: b.themedColor.textHighEmphasis }, e), t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(r_, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { as: "div", variant: "body3", color: b.themedColor.textMidEmphasis }, r.beforeText, r.highlightedText ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(s_, null, r.highlightedText) : null, r.afterText))));
}, e_ = () => {
  const { components: e } = xs.useContext(), { stringSet: t } = fe(), { messenger: n } = pe(), r = Hg(), s = r.showDescription ? Gg(r.remainingTime) : "", o = r.showDescription ? t.CONNECTION_DELAY__DESCRIPTION(s) : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Tt,
    {
      portalContainerId: Me.WINDOW,
      visible: r.visible,
      onClose: Ae,
      ...n.connectionDelayDialog().props
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      e.Dialog,
      {
        title: t.CONNECTION_DELAY__TITLE,
        description: o,
        highlightedText: s || void 0
      }
    )
  );
}, xs = ot({
  template: e_,
  components: { Dialog: Qp }
}), t_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:280px;padding:24px;margin:0 auto;border-radius:4px;box-sizing:border-box;background-color:${({ theme: e }) => e.colors.base.modalContentBackground};`, n_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;`, r_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`margin-top:16px;`, s_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].strong */ .ZP.strong`font-weight:700;`, o_ = ({ url: e }) => Is(e), {
  Provider: i_,
  Consumer: Xa,
  useContext: Ee
} = xe("Messenger");
function a_({
  children: e,
  state: t,
  enableCloseConversationButton: n = !1,
  enableExpandButton: r = !0,
  enableAutoDisconnectInLauncher: s = !0,
  ...o
}) {
  const [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), d = {
    opened: (t == null ? void 0 : t.opened) ?? i,
    setOpened: (t == null ? void 0 : t.setOpened) ?? c,
    expanded: (t == null ? void 0 : t.expanded) ?? l,
    setExpanded: (t == null ? void 0 : t.setExpanded) ?? u
  }, { resolveElement: m } = Ss(), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    d.setOpened(!1);
  }, [d.setOpened]);
  ep(d.opened, h);
  const g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(d.opened);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const _ = g.current && !d.opened;
    if (g.current = d.opened, !_) return;
    const p = yt(o.rootElement), y = m(Me.WINDOW);
    let S = !1;
    return Oe(() => {
      var A;
      S || $p(p, p.activeElement, y) && ((A = m(Me.LAUNCHER)) == null || A.focus());
    }), () => {
      S = !0;
    };
  }, [d.opened, o.rootElement, m]);
  const { Template: f } = xs.useContext(), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => {
      var _;
      return {
        ...o.handlers,
        onClickLink: ((_ = o.handlers) == null ? void 0 : _.onClickLink) ?? o_
      };
    },
    [o.handlers]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Km, { ...o }, (_) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    i_,
    {
      value: {
        ...o,
        ..._,
        state: d,
        enableCloseConversationButton: n,
        enableExpandButton: r,
        enableAutoDisconnectInLauncher: s,
        handlers: v
      }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(f, null),
    e
  ));
}
const Za = /iPad|iPhone|iPod/.test(navigator.userAgent), c_ = /Android/.test(navigator.userAgent), Cn = (e) => Za || c_;
let tn = null, br = null;
const l_ = (e, t = 5e3) => {
  tn && (clearInterval(tn), clearTimeout(br));
  const n = document.title;
  tn = setInterval(() => {
    document.title = document.title === e ? n : e;
  }, 750), br = setTimeout(() => {
    clearInterval(tn), tn = null, br = null, document.title = n;
  }, t);
}, Ja = () => {
  __webpack_require__.e(/* import() */ 117).then(__webpack_require__.bind(__webpack_require__, 80117)).then((e) => {
    new Audio(e.default).play().catch(() => {
    });
  });
}, Qa = "0 16px 24px 2px rgba(33, 33, 33, 0.12), 0 6px 30px 5px rgba(33, 33, 33, 0.08), 0 6px 10px -5px rgba(33, 33, 33, 0.04)", Ne = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`&:focus-visible{outline:2px solid ${b.themedColor.primary};outline-offset:2px;}`, zo = (e) => {
  if (typeof e == "string" || typeof e == "number") return String(e);
}, vn = ({
  visible: e,
  title: t,
  description: n,
  confirmText: r = "OK",
  cancelText: s,
  onConfirm: o,
  onCancel: i,
  onClose: c,
  "aria-label": l
}) => {
  const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), m = l ?? zo(t) ?? zo(n), h = l ? void 0 : t ? u : n ? d : void 0, g = t && n ? d : void 0, f = () => {
    c(), Oe(() => o == null ? void 0 : o());
  }, v = () => {
    c(), Oe(() => i == null ? void 0 : i());
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Tt,
    {
      portalContainerId: Me.WINDOW,
      visible: e,
      onClose: c,
      "aria-label": m,
      "aria-labelledby": h,
      "aria-describedby": g
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(u_, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(d_, null, t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: u }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "h1", color: b.themedColor.textHighEmphasis }, t)), n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(m_, { id: d }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body3", color: b.themedColor.textMidEmphasis }, n))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(h_, null, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ko, { onClick: v }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.themedColor.textHighEmphasis }, s)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ko, { onClick: f }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.themedColor.primary }, r))))
  );
}, u_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:360px;height:auto;padding-block:24px 12px;padding-inline:24px;margin:0 auto;border-radius:4px;box-sizing:border-box;background-color:${({ theme: e }) => e.colors.base.modalContentBackground};`, d_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`margin-bottom:16px;`, m_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`margin-top:16px;`, h_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;justify-content:flex-end;`, Ko = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;display:flex;justify-content:center;align-items:center;border-radius:4px;cursor:pointer;background-color:transparent;padding:10px 16px;${Ne}`, {
  Provider: g_,
  useContext: Ge
} = xe("MessengerSession"), f_ = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ children: e, ...t }, n) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rh, { ref: n, ...t }, (r) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(p_, { ...r }, e));
}), p_ = ({ children: e, ...t }) => {
  const { chatSDK: n, logger: r, appId: s, aiAgentId: o, agentPreviewConfigs: i, state: c, handlers: l, dispatcher: u, _aiAgentSDK: d } = Ee(), { userSessionInfo: m, authenticate: h, userSession: g, aiAgentInfo: f, launcherInfo: v } = t, [_, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  At(n, {
    async onUserJoined(A, I) {
      var N, R, M, B;
      A.conversation && A.conversation.type === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.$.PROACTIVE && I.userId === ((N = n.currentUser) == null ? void 0 : N.userId) && (r.info("messengerSession.onUserJoined: proactive channel joined", A.url), (M = d.session) == null || M._updateActiveChannel({
        url: A.url,
        status: "open",
        conversationStatus: (R = A.conversation) == null ? void 0 : R.status
      }), c.setOpened(!0), __({ sound: document.hidden || !c.opened }), (B = y.current) == null || B.call(y, { channel: A }));
    }
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    h().then(({ launcher: A }) => {
      A.auto_open && !Cn() && setTimeout(() => c.setOpened(!0), 500);
    }).catch((A) => {
      var I;
      r.error("messengerSession: failed to initialize", A), (I = l == null ? void 0 : l.onInitializeFailed) == null || I.call(l, A);
    });
  }, [n, s, o, m == null ? void 0 : m.userId]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const A = () => p(!0);
    return u.subscribe(qe.AnonymousSessionTokenExpired, A), () => u.unsubscribe(qe.AnonymousSessionTokenExpired, A);
  }, [u]);
  const S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    t.deauthenticate().finally(() => window.location.reload());
  }, [t.deauthenticate]);
  return !g || !f || !v ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    g_,
    {
      value: {
        ...t,
        userSession: g,
        aiAgentInfo: { ...f, ...i == null ? void 0 : i.bot },
        launcherInfo: { ...v, ...i == null ? void 0 : i.launcher },
        registerOnJoinedProactiveConversation: (A) => y.current = A
      }
    },
    e,
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      vn,
      {
        visible: _,
        title: "Session timed out",
        description: "Start a new conversation.",
        onConfirm: S,
        onClose: Ae
      }
    )
  );
};
function __({ sound: e }) {
  l_("🔔You have received a new message"), e && Ja();
}
const jn = `@${Ve}-focused-channel`, ec = `${Date.now()}-${Math.random().toString(36).slice(2)}`, E_ = () => {
  try {
    const e = localStorage.getItem(jn);
    return e ? JSON.parse(e).channelUrl ?? null : null;
  } catch {
    return null;
  }
}, Wo = (e) => {
  try {
    localStorage.setItem(jn, JSON.stringify({ channelUrl: e, tabId: ec }));
  } catch {
  }
}, Yo = () => {
  try {
    const e = localStorage.getItem(jn);
    if (!e) return;
    JSON.parse(e).tabId === ec && localStorage.removeItem(jn);
  } catch {
  }
}, C_ = (e, t) => ((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
  if (!t || !e) return;
  const n = () => Wo(e), r = () => Yo();
  return document.hasFocus() && Wo(e), window.addEventListener("focus", n), window.addEventListener("blur", r), () => {
    window.removeEventListener("focus", n), window.removeEventListener("blur", r), Yo();
  };
}, [t, e]), {
  isChannelViewedInAnyTab: () => document.hasFocus() || E_() === e
}), v_ = (e) => {
  const { config: t, chatSDK: n } = Ee(), { sdkUser: r } = Ge(), s = t.conversation.messageAlertSoundEnabled, { isChannelViewedInAnyTab: o } = C_(e, s);
  At(n, {
    onMessageReceived(i, c) {
      if (!s || i.url !== e || o()) return;
      (tt(c) && c.sender.userId !== (r == null ? void 0 : r.userId) || c.isAdminMessage() && !c.silent) && Ja();
    }
  });
}, zr = /* @__PURE__ */ new WeakMap();
function b_(e, t) {
  je(e.type) && !zr.has(e) && zr.set(e, tc(t));
}
async function S_(e) {
  const t = URL.createObjectURL(e), n = await tc(t);
  return URL.revokeObjectURL(t), n;
}
function tc(e) {
  return new Promise((t) => {
    const n = new Image();
    n.onload = function() {
      t({ width: String(n.width), height: String(n.height) });
    }, n.onerror = function() {
      t(void 0);
    }, n.src = e;
  });
}
async function y_(e) {
  if ("file" in e && e.file instanceof File && je(e.file.type)) {
    const t = await (zr.get(e.file) ?? S_(e.file));
    return t ? new _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__._({
      key: Bi,
      value: [t.width, t.height]
    }) : void 0;
  }
}
const A_ = ({ onScrollAfterSendMessage: e }) => {
  const { agentPreviewConfigs: t, handlers: n } = Ee(), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t == null ? void 0 : t.agentAttributes);
  return r.current = t == null ? void 0 : t.agentAttributes, {
    onBeforeSendMessage: async (s) => {
      const o = await y_(s), i = {
        ...s,
        metaArrays: o ? [o] : void 0
      }, c = T_(r.current);
      return c ? { ...i, data: JSON.stringify(c) } : i;
    },
    onAfterSendMessage: (s) => {
      var o, i, c;
      e(), (o = n == null ? void 0 : n.onMessageSend) == null || o.call(n, s.message), s.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.SUCCEEDED ? (i = n == null ? void 0 : n.onCustomEvent) == null || i.call(n, { type: "message-sent-succeeded", data: { message: s } }) : s.sendingStatus === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.ax.PENDING && ((c = n == null ? void 0 : n.onCustomEvent) == null || c.call(n, { type: "message-sent-pending", data: { message: s } }));
    }
  };
}, T_ = (e) => {
  if (!e) return null;
  const t = {};
  return e.ai && Object.keys(e.ai).length > 0 && (t.ai_attrs = e.ai), e.safeguard && Object.keys(e.safeguard).length > 0 && (t.safeguard_attrs = e.safeguard), typeof e.use_prompt_cache == "boolean" && (t.use_prompt_cache = e.use_prompt_cache), Object.keys(t).length > 0 ? t : null;
}, Gt = 50, Sr = Gt - 40, {
  Provider: I_,
  useContext: nc
} = xe("ConversationScroll"), qo = {
  viewport: 0,
  contentHeight: 0,
  contentSnapshotHeight: 0,
  shouldRecalc: !1,
  shouldUpdate: !1
}, yr = (e) => Math.max(0, e.scrollHeight - e.scrollTop - e.clientHeight), jo = (e) => Array.from(e.querySelectorAll(`#${Ve}-message-item`));
function x_({ scrollMode: e, messageStackDirection: t, children: n }) {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    mutation: null,
    resize: null,
    resizeTargets: /* @__PURE__ */ new Set()
  }), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    distanceFromBottom: 0,
    prevScrollTop: 0
  }), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    awayByUser: !1,
    programmatic: !1,
    streaming: !1,
    reconcileTimer: null,
    userMessageTimer: null
  }), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(qo), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), [d, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), [h, g] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [f, v] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [_, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!0), y = (x) => {
    const O = yr(x);
    return o.current.distanceFromBottom = O, m(O), O;
  }, S = () => {
    const x = i.current;
    x.reconcileTimer && (clearTimeout(x.reconcileTimer), x.reconcileTimer = null);
  }, A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const x = s.current;
    x.mutation && (x.mutation.disconnect(), x.mutation = null), x.resize && (x.resize.disconnect(), x.resize = null), x.resizeTargets.clear();
  }, []), I = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => h || t === "bottom" ? "auto" : e,
    [h, t, e]
  ), k = () => {
    c.current.contentSnapshotHeight = c.current.contentHeight, c.current.shouldUpdate = !0, c.current.shouldRecalc = !0;
  }, N = () => {
    const x = r.current;
    !x || !c.current.shouldUpdate || u((O) => {
      c.current.shouldUpdate = !1;
      const { contentHeight: F, contentSnapshotHeight: H, shouldRecalc: te } = c.current, ue = x.clientHeight;
      if (H > F)
        return O;
      const re = R(x, { messageType: "outgoing" });
      let ye = 0;
      if (re) {
        const K = re.message.offsetTop - Sr + ue;
        ye = Math.max(0, K - F);
      } else {
        const K = F - H, Ce = ue - Sr;
        ye = Math.max(0, K - Ce);
      }
      return O === 0 || ye !== O || te ? (c.current.shouldRecalc = !1, ye) : O;
    });
  }, R = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x, O) => {
      const { messageType: F = "all" } = O ?? {}, H = jo(x);
      let te = H;
      F === "outgoing" && (te = H.filter((ve) => ve.getAttribute("data-layout-id") === "outgoingmessage"));
      const ue = te[te.length - 1];
      if (!ue) return null;
      const re = x.getBoundingClientRect(), ye = ue.getBoundingClientRect(), K = x.scrollTop + (ye.top - re.top), Ce = K + ue.offsetHeight;
      return {
        message: ue,
        scrollTop: K,
        lastMessageBottom: Ce
      };
    },
    []
  ), M = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const x = r.current;
    if (!x || I !== "fixed") return;
    const O = R(x);
    c.current.contentHeight = (O == null ? void 0 : O.lastMessageBottom) ?? x.scrollHeight, !i.current.streaming && c.current.contentSnapshotHeight > 0 && k(), i.current.programmatic ? o.current.distanceFromBottom = yr(x) : y(x), N();
  }, [I, R]), B = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    A(), S(), c.current = qo, u(0), m(0), p(!0), o.current.distanceFromBottom = 0, o.current.prevScrollTop = 0, i.current.awayByUser = !1, i.current.programmatic = !1;
  }, [A]), P = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((x = !0) => {
    const O = o.current.distanceFromBottom > Gt;
    if (i.current.awayByUser = !1, m(0), !O) {
      Oe(() => {
        const F = r.current;
        F && !i.current.awayByUser && F.scrollTo({ top: F.scrollHeight, behavior: "auto" });
      });
      return;
    }
    i.current.programmatic || (i.current.programmatic = !0, p(!1), S()), Oe(() => {
      const F = r.current;
      if (!F) {
        i.current.programmatic = !1, p(!0);
        return;
      }
      if (i.current.awayByUser) {
        i.current.programmatic = !1, y(F), p(!0);
        return;
      }
      const H = () => {
        if (r.current !== F) {
          i.current.programmatic = !1, r.current && y(r.current), p(!0);
          return;
        }
        i.current.programmatic = !1, y(F), p(!0);
      };
      if (x && !i.current.reconcileTimer) {
        const te = setTimeout(H, 500);
        i.current.reconcileTimer = te, F.addEventListener(
          "scrollend",
          () => {
            clearTimeout(te), i.current.reconcileTimer = null, H();
          },
          { once: !0 }
        );
      }
      F.scrollTo({
        top: F.scrollHeight,
        behavior: x ? "smooth" : "auto"
      }), x || H();
    });
  }, []), ne = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const x = r.current;
    if (x) {
      if (i.current.awayByUser) {
        y(x);
        return;
      }
      P(!1);
    }
  }, [P]), ce = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const x = r.current, O = s.current;
    if (!x || !O.resize) return;
    const F = new Set(jo(x));
    for (const H of O.resizeTargets)
      F.has(H) || (O.resize.unobserve(H), O.resizeTargets.delete(H));
    for (const H of F)
      O.resizeTargets.has(H) || (O.resize.observe(H), O.resizeTargets.add(H));
  }, []), X = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      A();
      const O = s.current;
      typeof ResizeObserver < "u" && (O.resize = new ResizeObserver(ne), ce());
      const F = new MutationObserver(() => {
        ce(), ne();
      });
      O.mutation = F, F.observe(x, {
        childList: !0
      });
    },
    [A, ne, ce]
  ), J = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      if (!x) {
        r.current = null, A();
        return;
      }
      if (r.current = x, I !== "fixed") {
        X(x);
        return;
      }
      B(), c.current.viewport = x.clientHeight;
      const O = new MutationObserver(() => {
        M();
      });
      s.current.mutation = O, O.observe(x, {
        childList: !0,
        subtree: !0
      });
    },
    [A, I, M, B, X]
  ), U = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    const x = r.current;
    if (!x) return;
    const O = R(x, { messageType: "outgoing" });
    O && (x.scrollTo({
      top: O.message.offsetTop - Sr,
      behavior: "smooth"
    }), i.current.userMessageTimer && clearTimeout(i.current.userMessageTimer), i.current.userMessageTimer = setTimeout(() => {
      v(!1);
    }, 500));
  }, [R]), Y = (x, O, F) => {
    const H = yr(x);
    if (F && H > Gt) {
      i.current.programmatic = !1, i.current.awayByUser = !0, S(), y(x), p(!0), o.current.prevScrollTop = O;
      return;
    }
    o.current.distanceFromBottom = H;
  }, q = (x, O, F) => {
    const te = y(x) <= Gt;
    O && !te && (i.current.awayByUser = !0, S()), F && te && (i.current.awayByUser = !1);
  }, j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((x) => {
    const { scrollTop: O } = x.currentTarget, F = o.current.prevScrollTop;
    i.current.programmatic ? Y(x.currentTarget, O, O < F) : q(x.currentTarget, O < F, O > F), o.current.prevScrollTop = O;
  }, []), V = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    I === "fixed" && (v(!0), k());
  }, [I]), z = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    I === "fixed" ? setTimeout(() => U(), 300) : P();
  }, [I, U]), W = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      i.current.streaming = x, I === "fixed" ? k() : i.current.awayByUser || P();
    },
    [I, P]
  ), se = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      g(x), x && (u(0), I === "fixed" && A());
    },
    [A, I]
  ), he = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (x) => {
      I === "auto" && x && !i.current.awayByUser && P();
    },
    [I, P]
  ), Ie = !(d <= Gt) && !f, ke = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => o.current.distanceFromBottom > Gt, []), Pe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      ref: J,
      state: {
        bottomSpace: l,
        isAwayFromBottom: Ie,
        isScrollPositionReconciled: _,
        shouldCountNewMessages: ke
      },
      props: {
        onScroll: j
      },
      actions: {
        scrollToBottom: P,
        onBeforeMessageSend: V,
        onAfterMessageSend: z,
        onStreamingUpdate: W,
        onConversationClosed: se,
        onTypingIndicatorUpdate: he
      }
    }),
    [
      J,
      l,
      Ie,
      _,
      ke,
      j,
      P,
      V,
      z,
      W,
      se,
      he
    ]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(I_, { value: Pe }, n);
}
const {
  Provider: M_,
  Context: d0,
  useContext: De
} = xe("Conversation"), R_ = ({ children: e }) => {
  var s;
  const { channelSource: t } = De(), n = (s = t.channel) == null ? void 0 : s.url, { checkForUserActionRequired: r } = yg(n);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var i;
    const o = (i = t.channel) == null ? void 0 : i.lastMessage;
    o && r(o);
  }, [t.channel, r]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e);
}, w_ = ({
  context: e,
  scrollSource: t,
  goToActiveConversation: n,
  onNavigateToConversationList: r,
  children: s
}) => {
  const o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({ ...e, scrollSource: t, goToActiveConversation: n, onNavigateToConversationList: r }),
    [e, t, n, r]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(M_, { value: o }, s);
}, k_ = ({
  channelUrl: e,
  onClearChannelUrl: t,
  onNavigateToConversationList: n,
  conversationStatsEnabled: r,
  shouldMarkAsRead: s,
  shouldInitializeConversation: o,
  initialUserMessage: i,
  children: c
}) => {
  const { activeChannel: l, refreshActiveChannel: u } = Ge(), d = nc(), m = e || (l == null ? void 0 : l.url);
  v_(m);
  const { onBeforeSendMessage: h, onAfterSendMessage: g } = A_({
    onScrollAfterSendMessage: () => {
      d.actions.onAfterMessageSend();
    }
  }), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => (d.actions.onBeforeMessageSend(), h(y)),
    [d.actions, h]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => {
      const S = y.some((A) => Re.isStreaming(A));
      d.actions.onStreamingUpdate(S);
    },
    [d.actions.onStreamingUpdate]
  ), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (y) => {
      d.actions.onConversationClosed(y === _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_5__.K.CLOSED);
    },
    [d.actions.onConversationClosed]
  ), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async () => {
    await u(), e && (t == null || t());
  }, [u, e, t]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    og,
    {
      key: m,
      channelUrl: m,
      onBeforeSendMessage: f,
      onAfterSendMessage: g,
      onMessagesUpdated: v,
      onMessagesReceived: v,
      onChannelDeleted: p,
      onConversationStatusChanged: _,
      conversationStatsEnabled: r,
      shouldMarkAsRead: s,
      shouldInitializeConversation: o,
      initialUserMessage: i,
      shouldCountNewMessages: d.state.shouldCountNewMessages
    },
    (y) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      w_,
      {
        context: y,
        scrollSource: d,
        goToActiveConversation: p,
        onNavigateToConversationList: n
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(R_, null, c)
    )
  );
}, L_ = ({ children: e, ...t }) => {
  const { config: n } = we(), { agentPreviewConfigs: r } = Ee(), s = n.conversation.list.scrollMode, o = r == null ? void 0 : r.messageStackDirection;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(x_, { scrollMode: s, messageStackDirection: o }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(k_, { ...t }, e));
}, Ms = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  onDrop: Ae,
  subscribe: () => Ae
}), Kr = ({ children: e }) => {
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set());
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Ms.Provider,
    {
      value: {
        onDrop: (n) => {
          var r;
          if (n.preventDefault(), (r = n.dataTransfer) != null && r.files) {
            const s = Array.from(n.dataTransfer.files);
            s.length > 0 && t.current.forEach((o) => o(s));
          }
        },
        subscribe: (n) => (t.current.add(n), () => t.current.delete(n))
      }
    },
    e
  );
}, O_ = ({ onDropFiles: e }) => {
  const { subscribe: t } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Ms);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => t(e), [e]);
};
Kr.Consumer = ({ children: e }) => {
  const { onDrop: t } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Ms);
  return e({ onDrop: t, onDragOver: (s) => s.preventDefault() });
};
const rc = xe("WindowTitle", {
  hasWindowTitleReference: !1,
  isTitlePending: !1,
  isWindowNameReady: !0,
  registerWindowTitleReference: () => Ae,
  registerWindowTitlePending: () => Ae
}), N_ = rc.Provider, sc = rc.useContext, Xo = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    let s = !0;
    return e.current += 1, e.current === 1 && n(!0), () => {
      s && (s = !1, e.current = Math.max(0, e.current - 1), e.current === 0 && n(!1));
    };
  }, []);
  return [t, r];
}, Rs = ({ children: e }) => {
  const [t, n] = Xo(), [r, s] = Xo(), o = !r || t, i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      hasWindowTitleReference: t,
      isTitlePending: r,
      isWindowNameReady: o,
      registerWindowTitleReference: n,
      registerWindowTitlePending: s
    }),
    [t, r, n, s]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(N_, { value: i }, e);
}, or = sc, oc = ({ enabled: e, label: t }) => {
  const { registerWindowTitleReference: n, registerWindowTitlePending: r } = sc(), s = e && t.trim().length > 0;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (e)
      return r();
  }, [r, e]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (s)
      return n();
  }, [n, s]), {
    enabled: s,
    id: s ? Me.WINDOW_TITLE : void 0
  };
}, D_ = (e, t) => {
  const r = (t ? dn(e, t) : null) ?? Pp(e) ?? e;
  r === e && !e.hasAttribute("tabindex") && e.setAttribute("tabindex", "-1"), r.focus({ focusVisible: !1 });
}, ic = (e, { enabled: t, ready: n, nameReady: r = !0, targetSelector: s, suppressed: o = !1 }) => {
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) {
      i.current = !1;
      return;
    }
    if (i.current || !e.current || o || s && !n) return;
    const c = Ts(e.current) != null;
    if (!s && !c && !n) return;
    let l = !1;
    const u = () => {
      l || i.current || !e.current || (i.current = !0, D_(e.current, s));
    };
    if (r)
      return Oe(u), () => {
        l = !0;
      };
    const d = setTimeout(() => Oe(u), $a);
    return () => {
      l = !0, clearTimeout(d);
    };
  }, [t, n, r, s, e, o]);
}, $_ = (e, t) => {
  const { announcementsEnabled: n } = _t(), { channelSource: r } = De(), { isWindowNameReady: s } = or(), o = Ha(), i = r.channel != null || r.error != null;
  ic(e, {
    enabled: n,
    ready: i,
    nameReady: s,
    targetSelector: t === "messageInput" ? Pf : void 0,
    suppressed: o
  });
}, P_ = () => {
  var s;
  const { _statsEnabled: e, channelSource: t } = De(), n = (s = t.channel) == null ? void 0 : s.url, r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((o) => {
    const i = () => {
      o(Br() ? "backgrounded" : "foregrounded");
    };
    return document.addEventListener("visibilitychange", i), () => document.removeEventListener("visibilitychange", i);
  }, []);
  Wg({
    channelUrl: n,
    enabled: e,
    isInitiallyBackgrounded: Br,
    isForegrounded: Gf,
    subscribeToForegroundState: r
  });
}, F_ = (e) => je(e) || gn(e);
function U_(e, t) {
  return e.filter((n) => Re.isWelcomeMessage(n, t));
}
const ac = (e, {
  previewWelcomeMessages: t,
  aiAgentUserId: n
}) => e.filter((r) => t.length > 0 ? !Re.isWelcomeMessage(r, n) : !0), B_ = [], cc = () => {
  var f, v, _, p, y, S;
  const { agentPreviewConfigs: e = {}, aiAgentId: t } = Ee(), { aiAgentInfo: n, userSession: r } = Ge(), {
    channelSource: s,
    messageSource: o,
    state: { input: i, streamAnimation: c }
  } = De(), l = e.welcomeMessages ?? B_, u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ac(o.messages, {
      previewWelcomeMessages: l,
      aiAgentUserId: t
    }),
    [t, o.messages, l]
  ), d = ft(s.channel), m = (v = (f = Xi(s.channel, r.userId)) == null ? void 0 : f.nickname) == null ? void 0 : v.trim(), h = d ? (p = (_ = s.channel) == null ? void 0 : _.name) == null ? void 0 : p.trim() : (y = n == null ? void 0 : n.nickname) == null ? void 0 : y.trim(), g = m || h || void 0;
  return {
    initialized: o.initialized,
    channelUrl: (S = s.channel) == null ? void 0 : S.url,
    agentName: g,
    isClosed: He(s.channel),
    isHandedOff: d,
    messages: u,
    filteredMessagesCount: u.length,
    hasWelcomeMessages: l.length > 0,
    inputDisabled: i.disabled,
    inputDisabledBy: i.disabledBy,
    isStreamAnimating: c.isAnimating,
    currentUserId: r.userId
  };
}, H_ = (e = {}) => {
  const { announceScreenEntry: t, announcementsEnabled: n } = _t(), {
    initialized: r = !1,
    channelUrl: s,
    agentName: o,
    isClosed: i = !1,
    messages: c = [],
    hasWelcomeMessages: l = !1
  } = e, u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => c.some((h) => $e.isAdmin(h) && $e.isCSAT(h)), [c]), m = c.length === 0 && !l;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!n) {
      u.current = null;
      return;
    }
    !r || !s || u.current !== s && (t({
      screen: "conversation",
      agentName: o,
      isClosed: i,
      hasCSAT: d,
      ...m ? { isEmpty: !0 } : {}
    }), u.current = s);
  }, [o, t, n, s, d, r, i, m]);
}, G_ = () => {
  const e = cc();
  H_(e);
}, lc = (e) => ({
  image: e.A11Y_RECEIVED_FILE_IMAGE,
  video: e.A11Y_RECEIVED_FILE_VIDEO,
  pdf: e.A11Y_RECEIVED_FILE_PDF,
  document: e.A11Y_FILE_DOCUMENT,
  receivedFilesImageCount: e.A11Y_RECEIVED_FILES_IMAGE_COUNT,
  multipleFilesCount: e.CONVERSATION_LIST__MULTIPLE_FILES_COUNT,
  codeBlockPlaceholder: e.A11Y_CODE_BLOCK_PLACEHOLDER
}), Zo = (e, t, n = date_fns__WEBPACK_IMPORTED_MODULE_14__/* .format */ .WU) => {
  const r = xa(e, lc(t)), s = "sender" in e ? e.sender : void 0, o = e.createdAt != null && e.createdAt !== 0 ? n(e.createdAt, t.DATE_FORMAT__MESSAGE_TIMESTAMP) : void 0;
  return {
    senderName: typeof (s == null ? void 0 : s.nickname) == "string" && s.nickname.trim() || void 0,
    body: r || void 0,
    time: o
  };
}, V_ = {
  senderName: !0,
  body: !0,
  time: !0
}, z_ = Object.keys(V_), K_ = (e, t) => z_.every((n) => e[n] === t[n]), Jo = 2e3, Qo = 400, Wr = (e) => {
  const t = /* @__PURE__ */ new Set();
  return "reqId" in e && typeof e.reqId == "string" && e.reqId.length > 0 && t.add(`req:${e.reqId}`), "messageId" in e && e.messageId > 0 && t.add(`message:${String(e.messageId)}`), [...t];
}, uc = (e) => {
  if (!$e.isAdmin(e) || !$e.isCSAT(e)) return null;
  const t = xf(e);
  return t ? `csat:${t}` : null;
}, W_ = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) {
    const r = uc(n);
    r && t.add(r);
  }
  return t;
}, Y_ = (e, t) => {
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    if (r && Wr(r).some((s) => t.includes(s)))
      return r;
  }
}, Ar = (e, t) => e.some((n) => t.includes(n)), ei = () => typeof document > "u" ? null : document.activeElement instanceof HTMLElement ? document.activeElement : null, Tr = (e) => new Map(
  e.map(({ key: t, sendingStatus: n }) => [t, n])
), q_ = () => {
  const { announceStatus: e, announcementsEnabled: t } = _t(), { stringSet: n, format: r } = fe(), {
    channelUrl: s,
    messages: o,
    isClosed: i,
    isHandedOff: c,
    agentName: l,
    initialized: u,
    inputDisabled: d,
    inputDisabledBy: m,
    isStreamAnimating: h,
    currentUserId: g
  } = cc(), { outgoingMessageStates: f, outgoingMessageStatusSignature: v } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!g)
      return {
        outgoingMessageStates: [],
        outgoingMessageStatusSignature: ""
      };
    const j = o.flatMap((V) => {
      const z = Tf(V, g);
      return !z || !("sendingStatus" in V) ? [] : [{ key: z, sendingStatus: V.sendingStatus }];
    });
    return {
      outgoingMessageStates: j,
      outgoingMessageStatusSignature: j.map(({ key: V, sendingStatus: z }) => `${V}:${z}`).join(",")
    };
  }, [g, o]), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isClosed: !1,
    isHandedOff: !1,
    inputDisabled: d,
    inputDisabledBy: m,
    outgoingMessageStatuses: Tr(f)
  }), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    messages: o,
    currentUserId: g,
    inputDisabledBy: m,
    isStreamAnimating: h,
    stringSet: n,
    format: r
  }), y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]), S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]), I = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Set()), N = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), R = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(s);
  p.current = {
    messages: o,
    currentUserId: g,
    inputDisabledBy: m,
    isStreamAnimating: h,
    stringSet: n,
    format: r
  };
  const M = () => p.current.isStreamAnimating || p.current.inputDisabledBy === "ai_responding", B = () => {
    S.current != null && (clearTimeout(S.current), S.current = null);
  }, P = (j, V, z) => {
    const W = z == null ? void 0 : z.replaceableForMs;
    if (j.length === 0 || !W) return;
    const se = Date.now();
    A.current = [
      ...A.current.filter(({ replaceableUntil: he }) => he > se),
      { eventKeys: j, parts: V, replaceableUntil: se + W }
    ];
  }, ne = () => y.current.length > 0, ce = () => {
    y.current = [];
  }, X = () => {
    const [j, ...V] = y.current;
    if (!j) return !1;
    y.current = V;
    const { eventKeys: z, parts: W, dedupeKey: se } = j, he = (ke) => {
      P(z, ke, {
        replaceableForMs: z.length > 0 ? Jo : void 0
      }), e({ event: "newMessage", ...ke }, se ? { dedupeKey: se } : void 0);
    };
    if (z.length === 0)
      return he(W), !0;
    const $ = p.current, Ie = Y_($.messages, z);
    if (Ie) {
      const ke = Zo(Ie, $.stringSet, $.format);
      return he(ke), !0;
    }
    return he(W), !0;
  }, J = () => {
    for (B(); X(); )
      ;
  }, U = (j = Jo) => {
    B(), S.current = setTimeout(() => {
      if (S.current = null, M()) return;
      const V = ei(), [z] = y.current;
      if (!z) return;
      if (z.focusTarget !== V) {
        y.current = [
          {
            ...z,
            focusTarget: V
          },
          ...y.current.slice(1)
        ], U(Qo);
        return;
      }
      X() && ne() && U(Qo);
    }, j);
  }, Y = (j, V, z) => {
    const W = {
      eventKeys: V,
      parts: j,
      focusTarget: ei(),
      dedupeKey: z ? z.dedupeKey ?? void 0 : V[0]
    }, se = V.length === 0 ? -1 : y.current.findIndex(
      ({ eventKeys: he }) => Ar(he, V)
    );
    se >= 0 ? y.current = y.current.map(
      (he, $) => $ === se ? {
        ...W,
        dedupeKey: z ? W.dedupeKey : he.dedupeKey
      } : he
    ) : y.current = [
      ...y.current,
      W
    ], U();
  }, q = (j, V, z) => {
    if (j !== "messagesUpdated" || V.length === 0) return !1;
    const W = Date.now(), se = A.current.find(
      (he) => he.replaceableUntil > W && Ar(he.eventKeys, V)
    );
    return se ? !K_(z, se.parts) : !1;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const j = R.current !== s;
    (!t || !u || j) && (N.current = !1, k.current.clear(), ce(), A.current = [], I.current.clear(), B(), j && (R.current = s), !t || !u) || N.current || (N.current = !0, R.current = s, _.current = {
      isClosed: i,
      isHandedOff: c,
      inputDisabled: d,
      inputDisabledBy: m,
      outgoingMessageStatuses: Tr(f)
    }, I.current = new Set(
      o.flatMap((V) => {
        if (!Re.isStreaming(V)) return [];
        const z = "sender" in V ? V.sender : void 0;
        return (z == null ? void 0 : z.userId) === p.current.currentUserId ? [] : Wr(V);
      })
    ), k.current = W_(o));
  }, [
    e,
    t,
    s,
    u,
    d,
    i,
    c,
    v
  ]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const j = (V, z) => {
      const W = p.current, se = Wr(V), he = uc(V);
      if (he != null) {
        if (k.current.has(he)) return;
        k.current.add(he), e({ event: "csatDisplayed" });
        return;
      }
      if (Re.isStreaming(V)) {
        se.forEach((H) => {
          I.current.add(H);
        });
        return;
      }
      const $ = se.filter(
        (H) => I.current.has(H)
      ), Ie = z === "messagesUpdated" && $.length > 0;
      Ie && $.forEach((H) => {
        I.current.delete(H);
      });
      const ke = z === "messagesUpdated" && y.current.some(
        ({ eventKeys: H }) => Ar(H, se)
      ), Pe = Zo(
        V,
        W.stringSet,
        W.format
      ), x = q(
        z,
        se,
        Pe
      );
      if (!Ie && z !== "messagesAdded" && !ke && !x)
        return;
      const O = x ? { dedupeKey: null } : void 0;
      if (Ie || M() || ke) {
        Y(
          Pe,
          [.../* @__PURE__ */ new Set([...$, ...se])],
          O
        );
        return;
      }
      if (x) {
        Y(Pe, se, O);
        return;
      }
      ne() && J();
      const F = se[0];
      e({ event: "newMessage", ...Pe }, F ? { dedupeKey: F } : void 0);
    };
    return tr.subscribe((V) => {
      if (!N.current || V.channelUrl !== s || V.kind === "initialized" || V.kind === "messagesDeleted" || !Mf(V.source)) return;
      const z = p.current.currentUserId;
      for (const W of V.messages)
        W && If(W, z) && j(W, V.kind);
    });
  }, [e, s]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    N.current && (M() || ne() && U());
  }, [m, h]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    B();
  }, []), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!N.current) return;
    const j = _.current, V = j.outgoingMessageStatuses;
    j.outgoingMessageStatuses = Tr(f), f.some(({ key: W, sendingStatus: se }) => {
      const he = V.get(W);
      return he !== void 0 && he !== "failed" && se === "failed";
    }) && e({ event: "sendFailed" });
  }, [e, v]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!N.current) return;
    const j = _.current;
    i && !j.isClosed && e({ event: "conversationClosed" }), j.isClosed = i;
  }, [e, i]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!N.current) return;
    const j = _.current;
    c && !j.isHandedOff && e({ event: "agentConnected", agentName: l }), j.isHandedOff = c;
  }, [l, e, c]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!N.current) return;
    const j = _.current;
    d && m !== "ai_responding" && (!j.inputDisabled || j.inputDisabledBy === "ai_responding") && e({ event: "inputDisabled" }), j.inputDisabled = d, j.inputDisabledBy = m;
  }, [e, d, m]);
}, j_ = () => {
  const { channelSource: e } = De(), t = Ea(e.channel);
  return !(t != null && t.user.userId) || !t.user.nickname ? null : {
    userId: t.user.userId,
    nickname: t.user.nickname
  };
}, X_ = (e) => {
  const { announceStatus: t, announcementsEnabled: n } = _t();
  Rg(
    e ?? null,
    (r) => {
      t({ event: "typing", agentName: r });
    },
    1e4,
    n
  );
}, Z_ = () => {
  const e = j_();
  X_(e);
}, oe = ({ type: e, size: t = 24, className: n, color: r }) => {
  const { icons: s } = bp(), o = s[e];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(J_, { className: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(o, { size: t, color: r ?? b.color.primary.main, flipInRtl: gp.has(e) }));
}, J_ = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span.attrs */ .ZP.span.attrs({
  "aria-hidden": "true"
})`
  display: inline-flex;
  &:focus {
    outline: none;
  }
`, Q_ = ({
  visible: e,
  onClose: t,
  children: n,
  "aria-label": r
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tt, { portalContainerId: Me.WINDOW, visible: e, onClose: t, "aria-label": r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rE, null, n)), eE = ({ onClick: e, destructive: t, icon: n, initialFocus: r, children: s }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tE, { onClick: e, $destructive: t, "data-sb-initial-focus": r ? "true" : void 0 }, n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: n, size: 24, color: b.themedColor.primary })), s), bt = Object.assign(Q_, {
  ActionItem: eE
}), tE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;display:flex;align-items:center;gap:24px;width:100%;padding:12px 24px;cursor:pointer;color:${({ $destructive: e }) => e ? b.themedColor.error : b.themedColor.textHighEmphasis};${Ne}`, nE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;flex-shrink:0;`, rE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;left:0;right:0;bottom:0;border-radius:12px 12px 0 0;flex-direction:column;align-items:flex-end;margin:0 auto;box-sizing:border-box;background-color:${({ theme: e }) => e.colors.base.modalContentBackground};`, ti = 40, ni = 0.9, sE = "[data-message-listitem]", oE = 'input, textarea, select, [role="textbox"], [contenteditable="true"]', iE = ({
  event: e,
  list: t,
  isMessageAnchor: n
}) => {
  switch (e.key) {
    case "PageDown":
      return t.clientHeight * ni;
    case "PageUp":
      return t.clientHeight * -ni;
    case "ArrowDown":
      return n ? ti : void 0;
    case "ArrowUp":
      return n ? ti * -1 : void 0;
    default:
      return;
  }
}, aE = ({
  listRef: e,
  syncScrollPosition: t
}) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
  (n) => {
    const r = e.current;
    if (!r || n.defaultPrevented || n.metaKey || n.altKey || n.ctrlKey) return;
    const s = n.target;
    if (!s || !r.contains(s) || s.closest(oE)) return;
    const o = s === r || s.matches(sE), i = iE({ event: n, list: r, isMessageAnchor: o });
    if (i == null || i === 0) return;
    const c = Math.max(0, r.scrollHeight - r.clientHeight), l = Math.min(c, Math.max(0, r.scrollTop + i));
    l !== r.scrollTop && (n.preventDefault(), t(l));
  },
  [e, t]
), cE = "[data-message-listitem]", lE = (e) => Math.min(Math.max(0, e), 1), uE = (e) => {
  const n = e.getRootNode().activeElement, r = n == null ? void 0 : n.closest(cE), s = n === e || n === r;
  return !n || !e.contains(n) ? null : s ? e : n;
}, dE = ({
  list: e,
  focusRestoreTarget: t
}) => {
  if (!t) return;
  const r = e.getRootNode().activeElement, s = r === e || e.contains(r), o = t === e || e.contains(t);
  s && o && t.focus({ preventScroll: !0 });
}, mE = ({
  depsForResetScrollPositionToBottom: e,
  listRef: t,
  loadThreshold: n,
  messagesLength: r,
  onLoadNext: s,
  onLoadPrev: o,
  onScroll: i
}) => {
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    t.current && (t.current.scrollTop = t.current.scrollHeight);
  }, e), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    const p = t.current;
    p && (l.current === "top" && (p.scrollTop = p.scrollHeight - d.current, dE({
      list: p,
      focusRestoreTarget: m.current
    }), m.current = null), l.current === "bottom" && (p.scrollTop = u.current), l.current = void 0);
  }, [t, r]);
  const f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (p) => {
      const y = t.current;
      if (!y || (i == null || i(p), d.current = y.scrollHeight - y.scrollTop, u.current = y.scrollTop, c.current)) return;
      const S = y.clientHeight * lE(n);
      if (y.scrollTop <= S) {
        c.current = !0, l.current = "top", m.current = uE(y), await o(), c.current = !1;
        return;
      }
      if (y.scrollHeight - y.scrollTop - y.clientHeight <= S) {
        c.current = !0, l.current = "bottom", await s(), c.current = !1;
        return;
      }
      l.current = void 0;
    },
    [t, n, s, o, i]
  ), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p) => {
      const y = t.current;
      if (!y) return;
      const S = g.current;
      if (S != null) {
        if (S === y.scrollTop) {
          g.current = null;
          return;
        }
        g.current = null;
      }
      const A = h.current;
      if (A != null && A === y.scrollTop) {
        h.current = null, g.current = y.scrollTop, f(p);
        return;
      }
      h.current = null, f(p);
    },
    [f, t]
  ), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (p) => {
      const y = t.current;
      y && (h.current = p, g.current = null, y.scrollTop = p, y.dispatchEvent(new Event("scroll", { bubbles: !0 })));
    },
    [t]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => () => {
    h.current = null, g.current = null;
  }, []), {
    handleScroll: v,
    syncScrollPosition: _
  };
}, hE = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(t, n) {
  const {
    messages: r,
    renderMessage: s,
    loading: o,
    LoadingComponent: i,
    error: c,
    ErrorComponent: l,
    empty: u,
    EmptyComponent: d,
    messageTopArea: m,
    messageBottomArea: h,
    overlayArea: g,
    onLoadPrev: f,
    onLoadNext: v,
    loadThreshold: _ = 0.05,
    onScroll: p = Ae,
    depsForResetScrollPositionToBottom: y,
    stackDirection: S = "top",
    bottomSpacerHeight: A = 0,
    "aria-label": I
  } = t, k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), N = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (P) => {
      k.current = P, n && (typeof n == "function" ? n(P) : n.current = P);
    },
    [n]
  ), { handleScroll: R, syncScrollPosition: M } = mE({
    depsForResetScrollPositionToBottom: y,
    listRef: k,
    loadThreshold: _,
    messagesLength: r.length,
    onLoadNext: v,
    onLoadPrev: f,
    onScroll: p
  }), B = aE({ listRef: k, syncScrollPosition: M });
  return c ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l) : o ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, i) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(gE, { id: "infinite-list-container" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    fE,
    {
      id: "infinite-list-inner",
      ref: N,
      onScroll: R,
      onKeyDown: B,
      role: "list",
      "aria-label": I,
      tabIndex: 0
    },
    S === "bottom" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { flexGrow: 1 } }),
    m,
    u ? d : r.map((P, ne) => s({ message: P, index: ne })),
    h,
    A > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { minHeight: A } })
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pE, { id: "infinite-list-overlay-container" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_E, { id: "infinite-list-overlay" }, g)));
}), gE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;position:relative;flex:1;overflow:hidden;`, fE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex:1;flex-direction:column;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;scrollbar-color:${b.themedColor.textLowEmphasis}transparent;&::-webkit-scrollbar-thumb:hover{background-color:transparent;}`, pE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;top:0;bottom:0;left:0;right:0;pointer-events:none;`, _E = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`pointer-events:auto;`, lt = ({
  as: e,
  type: t,
  size: n = 16,
  color: r,
  disabled: s,
  children: o,
  ...i
}) => {
  const c = s ? b.themedColor.textDisabled : b.themedColor.textHighEmphasis;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EE, { as: e, disabled: s, ...i }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: t, size: n, color: r ?? c }), o);
}, EE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;padding:4px;cursor:pointer;display:flex;align-items:center;justify-content:center;${Ne}&:disabled{cursor:not-allowed;}`, $t = ({ className: e, children: t, size: n = 26 }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CE, { className: e, $size: n }, t ?? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", size: n })), CE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;width:${({ $size: e }) => ct(e)};height:${({ $size: e }) => ct(e)};animation:1s infinite linear;animation-name:rotate;@keyframes rotate{from{transform:rotate(0);}to{transform:rotate(360deg);}}`, vE = ({ files: e, initialIndex: t = 0, onClose: n, visible: r }) => {
  const [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t), [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), { stringSet: l, format: u } = fe(), { config: d } = Ee(), m = e.length, h = e[s], g = d.conversation.fileViewer.downloadEnabled, f = m > 1, v = (h == null ? void 0 : h.type) || "", _ = je(v), p = gn(v), y = !F_(v);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    r && (o(t), c(!1));
  }, [r, t]);
  const S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    s > 0 && (o((I) => I - 1), c(!1));
  }, [s]), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    s < m - 1 && (o((I) => I + 1), c(!1));
  }, [s, m]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!r) return;
    const I = (k) => {
      k.key === "ArrowLeft" ? S() : k.key === "ArrowRight" && A();
    };
    return window.addEventListener("keydown", I), () => window.removeEventListener("keydown", I);
  }, [r, S, A]), !r || !h ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Tt,
    {
      onClose: n,
      visible: r,
      portalContainerId: Me.MODAL_ROOT,
      "aria-label": (h == null ? void 0 : h.name) || l.IMAGE_VIEWER__DEFAULT_TITLE
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", maxTextLines: 1, color: b.color.ondark.textHighEmphasis }, h.name || l.IMAGE_VIEWER__DEFAULT_TITLE), h.timestamp && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption2", color: b.color.ondark.textHighEmphasis }, u(new Date(h.timestamp), "h:mm a")))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      TE,
      {
        type: "close",
        size: 18,
        color: b.color.ondark.textHighEmphasis,
        "aria-label": l.A11Y_IMAGE_VIEWER_CLOSE,
        onClick: n
      }
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IE, null, f && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      ri,
      {
        $position: "left",
        type: "chevron-right",
        size: 22,
        color: b.color.ondark.textHighEmphasis,
        onClick: S,
        "aria-label": l.A11Y_IMAGE_VIEWER_PREVIOUS,
        disabled: s === 0,
        $flipped: !0
      }
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(xE, { onClick: (I) => I.currentTarget === I.target && n() }, _ && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !i && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ME, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: 32 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", color: "textLowEmphasis", size: 32 }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      RE,
      {
        src: h.url,
        alt: h.name || "Image",
        $loaded: i,
        onLoad: () => c(!0)
      }
    )), p && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wE, { controls: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: h.url, type: v })), y && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(kE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "h1", color: b.themedColor.textHighEmphasis }, l.FILE_VIEWER__UNSUPPORT))), f && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      ri,
      {
        $position: "right",
        type: "chevron-right",
        size: 22,
        color: b.color.ondark.textHighEmphasis,
        onClick: A,
        "aria-label": l.A11Y_IMAGE_VIEWER_NEXT,
        disabled: s === m - 1
      }
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LE, null, f && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body2", color: b.color.ondark.textHighEmphasis }, s + 1, "/", m), g && !y && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      OE,
      {
        forwardedAs: "a",
        href: h.url,
        download: h.name || "file",
        type: "download",
        size: 24,
        color: b.color.ondark.textHighEmphasis,
        "aria-label": l.A11Y_IMAGE_VIEWER_DOWNLOAD
      }
    )))
  );
}, bE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:fixed;top:0;left:0;right:0;bottom:0;height:100dvh;outline:none;display:flex;flex-direction:column;background-color:${b.themedColor.bg_50_600};`, SE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].header */ .ZP.header`display:flex;align-items:center;justify-content:space-between;padding-top:calc(12px + env(safe-area-inset-top));padding-right:12px;padding-bottom:12px;padding-left:16px;min-height:56px;background-color:${b.color.overlay.dark};`, yE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex:1;min-width:0;padding-right:8px;`, AE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:2px;`, TE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(lt)`flex-shrink:0;width:28px;height:28px;border-radius:50%;`, ir = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;`, IE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(ir)`flex:1;min-height:0;position:relative;`, xE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(ir)`position:relative;width:100%;height:100%;min-width:0;min-height:0;`, ME = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(ir)`position:absolute;inset:0;pointer-events:none;`, RE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`max-width:100%;max-height:100%;object-fit:contain;user-select:none;-webkit-user-drag:none;opacity:${(e) => e.$loaded ? 1 : 0};transition:opacity 0.3s ease;`, wE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].video */ .ZP.video`max-width:100%;max-height:100%;object-fit:contain;`, kE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(ir)`flex-direction:column;gap:16px;`, ri = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(lt)`position:absolute;${(e) => e.$position === "left" ? "left: 12px;" : "right: 12px;"}top:50%;z-index:1;width:38px;height:38px;transform:translateY(-50%) ${(e) => e.$flipped ? "scaleX(-1)" : ""};border-radius:50%;background-color:${b.color.overlay.dark};&:disabled{opacity:0.3;}`, LE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].footer */ .ZP.footer`position:relative;display:flex;align-items:center;justify-content:center;padding-top:16px;padding-right:16px;padding-bottom:calc(16px + env(safe-area-inset-bottom));padding-left:16px;min-height:56px;background-color:${b.color.overlay.dark};`, OE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(lt)`position:absolute;right:16px;top:50%;transform:translateY(-50%);padding:0;width:24px;height:24px;`, NE = 0.75, dc = 6, DE = dc * 2;
let Yr = null;
typeof Intl < "u" && "Segmenter" in Intl && (Yr = new Intl.Segmenter(void 0, { granularity: "grapheme" }));
const $E = (e) => Yr ? Array.from(Yr.segment(e), (t) => t.segment) : [...e], PE = (e) => {
  const t = Math.floor(e.length * NE), n = Math.max(0, e.length - dc);
  return Math.max(t, n);
}, si = (e, t = "") => {
  if (e.length < DE)
    return { start: e + t, end: "" };
  const n = $E(e), r = PE(n);
  return {
    start: n.slice(0, r).join(""),
    end: n.slice(r).join("") + t
  };
}, FE = (e) => {
  const t = e.normalize("NFC").trim(), n = t.lastIndexOf(".");
  if (!(n > 0 && n < t.length - 1))
    return si(t);
  const s = t.slice(0, n), o = t.slice(n);
  return si(s, o);
}, mc = ({ children: e, ...t }) => {
  const { start: n, end: r } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => FE(e), [e]);
  return r ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BE, { ...t }, n), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HE, { ...t }, r)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { ...t }, n);
}, UE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span */ .ZP.span`display:flex;width:100%;min-width:0;overflow:hidden;direction:inherit;`, BE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex-shrink:1;min-width:0;`, HE = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`flex-shrink:0;white-space:nowrap;`, ws = ({
  name: e,
  mimeType: t,
  type: n = "FILE",
  iconColor: r,
  iconBackgroundColor: s,
  onClick: o,
  selected: i
}) => {
  const { colors: c } = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), { conversation: l } = pe(), u = o ? l.file.buttonLikePreview({ name: e, mimeType: t, selected: i, onActivate: o }) : l.file.preview({ name: e, mimeType: t, selected: i });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GE, { ...u.props, $clickable: !!o }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zE, { $bgColor: s ?? c.base.primary }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "file-document", size: 24, color: r ?? c.base.primaryContrastContent })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(KE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mc, { variant: "button", color: b.themedColor.textHighEmphasis }, e), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { color: b.themedColor.textMidEmphasis, variant: "caption3" }, n)), u.descriptionNode);
}, GE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`border:none;border-radius:12px;gap:8px;width:${ae.BODY_MAX_WIDTH}px;height:64px;display:flex;align-items:center;padding:12px;box-sizing:border-box;border:1px solid ${b.themedColor.textDisabled};background-color:${b.themedColor.bg_50_600};${({ $clickable: e }) => e && VE}`, VE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:pointer;${Ne}&:hover{background-color:${b.themedColor.bg_100_500};}`, zE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`border-radius:8px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;background-color:${({ $bgColor: e }) => e};`, KE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex:1;flex-direction:column;gap:4px;min-width:0;`;
function WE({ file: e, children: t, onClickFile: n }) {
  const r = n ? () => n(e) : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(YE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ws,
    {
      name: e.name,
      mimeType: e.type,
      type: os(e.name, e.type),
      onClick: r
    }
  ), t);
}
const YE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-start;gap:${ae.GAP_GROUPED}px;`, nt = `${Ve}-incoming-msg`, oi = `${Ve}-marked-text`, qE = "masked-text";
function jE({
  file: e,
  onClickMedia: t,
  onClickMediaFiles: n,
  children: r
}) {
  const { conversation: s } = pe(), o = e.type.startsWith("image"), i = (() => {
    if (n)
      return () => n({
        files: [{ url: e.url, type: e.type, name: e.name }],
        index: 0
      });
    if (t)
      return () => t(e);
  })(), c = i ? s.file.buttonLikePreview({ name: e.name, mimeType: e.type, onActivate: i }) : s.file.preview({ name: e.name, mimeType: e.type }), l = () => o ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(JE, { src: e.url, alt: "image-message" }) : e.type.startsWith("video") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QE, { controls: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: e.url }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })) : null;
  if (l) {
    const u = {
      id: `${nt}-media-body`,
      ...c.props
    };
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(XE, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZE, { ...u }, l(), c.descriptionNode), r);
  }
  return null;
}
const XE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-start;gap:${ae.GAP_GROUPED}px;`, ZE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:${ae.BODY_MAX_WIDTH}px;height:160px;border-radius:12px;overflow:hidden;cursor:pointer;${ie.light`
    background-color: ${b.color.background100};
  `}
  ${ie.dark`
    background-color: ${b.color.background400};
  `}
`, JE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`width:100%;height:100%;object-fit:cover;`, QE = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].video */ .ZP.video`width:100%;height:100%;object-fit:cover;`, eC = (e) => e.startsWith("blob:"), hc = ({ images: e, isPending: t = !1, onClickImage: n }) => {
  const { conversation: r } = pe(), s = e.length;
  if (s === 0) return null;
  const o = Gm(s), i = !!n && !t;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nC, { $width: ae.BODY_MAX_WIDTH, $columns: o }, e.map((c, l) => {
    const { columnSpan: u } = Vm({ index: l, itemCount: s }), d = c.name || "", m = () => {
      t || n == null || n(l);
    }, h = c.type ?? "image/*", g = i ? r.file.buttonLikePreview(
      {
        name: d,
        mimeType: h,
        onActivate: m
      },
      l
    ) : r.file.preview({
      name: d,
      mimeType: h
    });
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      rC,
      {
        key: c.url,
        $clickable: i,
        $itemSpan: u,
        $isPending: t,
        ...g.props
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tC, { src: c.url, alt: c.name || "" }),
      t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sC, null),
      g.descriptionNode
    );
  }));
}, tC = ({ src: e, alt: t }) => {
  const [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => eC(e)), [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !n && !s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: 20 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", color: "textLowEmphasis", size: 20 }))), s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(iC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "photo", color: "textLowEmphasis", size: 24 })), !s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(aC, { src: e, alt: t, $loaded: n, onLoad: () => r(!0), onError: () => o(!0) }));
}, nC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:grid;grid-template-columns:repeat(${({ $columns: e }) => e},1fr);width:${({ $width: e }) => e}px;gap:2px;border-radius:16px;overflow:hidden;`, rC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;width:100%;aspect-ratio:1;overflow:hidden;cursor:${(e) => e.$clickable ? "pointer" : "default"};${ie.light`
    background-color: ${b.color.background100};
  `}
  ${ie.dark`
    background-color: ${b.color.background400};
  `}
  ${(e) => e.$itemSpan && e.$itemSpan > 1 && `
    grid-column: span ${e.$itemSpan};
    aspect-ratio: ${e.$itemSpan / 2};
  `}

  &:focus-visible {
    outline: 2px solid ${b.color.primary.main};
    outline-offset: -2px;
  }

  &:hover {
    ${(e) => e.$clickable && !e.$isPending && `
      & > img {
        opacity: 0.8;
      }
    `}
  }
`, sC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;top:0;left:0;width:100%;height:100%;background-color:${b.color.overlay.dark};pointer-events:none;`, gc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;`, oC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(gc)`position:absolute;inset:0;`, iC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(gc)`position:absolute;inset:0;${ie.light`
    background-color: ${b.color.background200};
  `}
  ${ie.dark`
    background-color: ${b.color.background500};
  `}
`, aC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:${({ $loaded: e }) => e ? 1 : 0};transition:opacity 0.3s ease;`, cC = ({
  files: e,
  children: t,
  onClickMedia: n,
  onClickMediaFiles: r
}) => {
  const s = (o) => {
    const i = e[o];
    i && (r ? r({ files: e, index: o }) : n && n({ url: i.url, type: i.type || "image/*" }));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hc, { images: e, onClickImage: s }), t);
}, lC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-start;gap:${ae.GAP_GROUPED}px;`, uC = (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(async () => ({ default: (await __webpack_require__.e(/* import() */ 617).then(__webpack_require__.bind(__webpack_require__, 30617))).MarkdownText })), ii = typeof __SBA_USE_SYNTAX_HIGHLIGHT__ > "u" || __SBA_USE_SYNTAX_HIGHLIGHT__ ? (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(async () => ({ default: (await __webpack_require__.e(/* import() */ 6605).then(__webpack_require__.bind(__webpack_require__, 86605))).CodeBlock })) : null;
function dC(e) {
  var s, o;
  const t = e.maxBodyWidth ?? ae.BODY_MAX_WIDTH, n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => Xl(e.message), [e.message]), r = {
    id: `${nt}-text-body`,
    $maxWidth: t,
    $color: (s = e.customStyle) == null ? void 0 : s.bubbleContentColor,
    $bgColor: (o = e.customStyle) == null ? void 0 : o.bubbleBackgroundColor
  };
  return n.length === 0 ? e.children ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ai, { ...r }, e.children) : null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ai, { ...r }, n.map((i, c) => i.type === "text" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ci, { key: c, variant: "body3" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { fallback: i.value }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    uC,
    {
      onClickImage: (l) => {
        var d;
        const u = { url: l, type: "image/*" };
        e.onClickMediaFiles ? e.onClickMediaFiles({ files: [u], index: 0 }) : (d = e.onClickMedia) == null || d.call(e, u);
      },
      onClickLink: e.onClickLink
    },
    i.value
  ))) : i.type === "code" ? ii ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { key: c, fallback: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ci, { variant: "body3" }, i.value) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ii, { code: i.value, language: i.language })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mC, { key: c }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, i.value)) : null), e.children);
}
const ai = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;min-width:0;max-width:min(${({ $maxWidth: e }) => e}px,100%);border-radius:12px;overflow:hidden;padding:12px 0;${({ theme: e, $color: t, $bgColor: n }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
    color: ${t || e.colors.messageIncoming.text};
    background-color: ${n || e.colors.messageIncoming.background};
  `}
  transition: max-width 0.3s;
  overflow-wrap: break-word;
`, ci = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`align-items:flex-start;line-height:140%;white-space:pre-wrap;padding:0 12px;`, mC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].pre */ .ZP.pre`margin:0;padding:1em;overflow-x:auto;white-space:pre;font-family:monospace;font-size:13px;line-height:1.5;color:#d4d4d4;background:#1e1e1e;border-radius:4px;`;
function fc({
  id: e,
  src: t,
  size: n = 56,
  onClick: r,
  onImageError: s,
  onImageLoad: o,
  style: i,
  backgroundColor: c,
  ...l
}) {
  const [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    hC,
    {
      id: e,
      tabIndex: r ? 0 : void 0,
      onClick: r,
      $size: ct(n),
      $backgroundColor: c,
      style: i,
      ...l
    },
    t && t !== u ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      gC,
      {
        src: t,
        alt: "",
        onLoad: () => o == null ? void 0 : o(t),
        onError: () => {
          d(t), s == null || s(t);
        }
      }
    ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "user", size: n })
  );
}
const hC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`border-radius:50%;display:inline-block;overflow:hidden;position:relative;flex-shrink:0;height:${(e) => e.$size};width:${(e) => e.$size};background-color:${(e) => e.$backgroundColor ?? b.themedColor.bg_100_500};&:focus{outline:none;}${Ne}`, gC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`object-fit:cover;width:100%;height:100%;position:absolute;`, fC = ({
  sender: e,
  isBotMessage: t
}) => {
  const n = `${nt}-sender-avatar`, [r, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  return t && (!e.profileUrl || e.profileUrl === r) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pC, { id: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "delight", size: "100%" })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    fc,
    {
      id: n,
      size: ae.AVATAR_SIZE,
      src: e.profileUrl,
      onImageError: t ? s : void 0
    }
  );
}, pC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex-shrink:0;width:${ae.AVATAR_SIZE}px;height:${ae.AVATAR_SIZE}px;box-sizing:border-box;padding:4px;border-radius:50%;display:flex;justify-content:center;align-items:center;background-color:${({ theme: e }) => e.colors.base.primary}!important;ellipse,path{fill:${({ theme: e }) => e.colors.base.primaryContrastContent}!important;}}`, _C = ({ sender: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EC, { id: `${nt}-sender-name`, variant: "caption1", color: b.themedColor.textMidEmphasis }, e.nickname), EC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`text-align:start;width:100%;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-block:5px;padding-inline:0 7px;`, CC = ({ createdAt: e }) => {
  const { stringSet: t, format: n } = fe();
  return e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { id: `${nt}-sent-time`, variant: "caption4", color: b.themedColor.textLowEmphasis }, n(e, t.DATE_FORMAT__MESSAGE_TIMESTAMP)) : null;
}, pc = "(prefers-reduced-motion: reduce)", vC = () => typeof window > "u" || typeof window.matchMedia != "function" ? !1 : window.matchMedia(pc).matches, _c = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(vC);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof window > "u" || typeof window.matchMedia != "function")
      return;
    const n = window.matchMedia(pc);
    t(n.matches);
    const r = (s) => {
      t(s.matches);
    };
    return typeof n.addEventListener == "function" ? (n.addEventListener("change", r), () => {
      n.removeEventListener("change", r);
    }) : (n.addListener(r), () => {
      n.removeListener(r);
    });
  }, []), e;
}, bC = ({ thinkingMessage: e, customStyle: t }) => {
  const n = _c();
  return e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AC, { $prefersReducedMotion: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TC, null, e), !n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IC, null)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SC, { $bgColor: t == null ? void 0 : t.bubbleBackgroundColor }, [0, 1, 2].map((r) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yC, { key: r, $color: t == null ? void 0 : t.bubbleContentColor, $prefersReducedMotion: n })));
}, SC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`align-items:center;border-radius:16px;display:flex;gap:6px;height:26px;justify-content:center;padding:0 12px;background-color:${({ theme: e, $bgColor: t }) => t || e.colors.messageIncoming.background};`, yC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span */ .ZP.span`animation:${({ $prefersReducedMotion: e }) => e ? "none" : "blink 1.4s infinite"};animation-fill-mode:both;border-radius:50%;height:8px;width:8px;background:${({ theme: e, $color: t }) => t || e.colors.messageIncoming.text};opacity:${({ $prefersReducedMotion: e }) => e ? 0.38 : void 0};@keyframes blink{0%{opacity:0.12;transform:scale(1);}21.43%{opacity:0.38;transform:scale(1.2);}42.86%{opacity:0.12;transform:scale(1);}100%{opacity:0.12;transform:scale(1);}}&:nth-child(1){animation-delay:0.4s;}&:nth-child(2){animation-delay:0.6s;}&:nth-child(3){animation-delay:0.8s;}`, AC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.attrs */ .ZP.div.attrs({
  id: `${nt}-typing-indicator`
})`
  position: relative;
  overflow: hidden;
  animation: ${({ $prefersReducedMotion: e }) => e ? "none" : "fadeIn 0.4s ease-in-out"};
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`, TC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G).attrs({ variant: "body3" })`
  white-space: pre-wrap;
  word-break: break-word;
  color: ${b.themedColor.textHighEmphasis};
`, IC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;inset:0;pointer-events:none;background-size:33% 100%;background-repeat:no-repeat;animation:shimmerSweepLtr 1.6s linear infinite;@keyframes shimmerSweepLtr{from{background-position:-33% 0;}to{background-position:133% 0;}}[dir='rtl'] &{animation-name:shimmerSweepRtl;@keyframes shimmerSweepRtl{from{background-position:133% 0;}to{background-position:-33% 0;}}}background-image:${({ theme: e }) => {
  const t = uo(e.colors.base.background, 0.5), n = uo(e.colors.base.background, 0);
  return `linear-gradient(90deg, ${n} 0%, ${t} 30%, ${t} 60%, ${n} 100%)`;
}};
`, xC = ({
  extendedMessagePayload: e,
  onClickCTA: t = ({ url: n }) => Is(n)
}) => {
  const n = e == null ? void 0 : e.cta_button;
  if (!n) return null;
  const r = () => t(n);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MC, { id: `${nt}-ext-cta-button`, onClick: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RC, { variant: "button" }, n.label));
}, MC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button.attrs */ .ZP.button.attrs({ type: "button" })`
  all: unset;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  padding: 8px;
  color: ${b.themedColor.textHighEmphasis};
  background-color: ${b.color.background50};
  ${ie.dark`
    background-color: ${b.color.ondark.textDisabled};
  `}

  ${Ne}
`, RC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`, wC = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), kC = ({
  extendedMessagePayload: e,
  onClickCitation: t = (n) => Is(n.link)
}) => {
  const { stringSet: n } = fe(), { theme: r } = nr(), s = e == null ? void 0 : e.citations;
  return !s || s.length === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LC, { id: `${nt}-ext-citation` }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OC, { variant: "caption1", color: r.colors.messageIncoming.text }, n.CITATION_SOURCE_TITLE), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NC, null, s.map((o, i) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($C, { key: `${o.embedding_id}-${i}`, onClick: () => t(o) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "source", size: 16, color: r.colors.messageIncoming.text }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DC, { variant: "body3", color: r.colors.messageIncoming.text }, o.title)))));
}, LC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;border-radius:8px;padding:8px 12px 6px;`, OC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`opacity:0.5;`, NC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, DC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`text-decoration:underline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`, $C = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button.attrs */ .ZP.button.attrs({ type: "button" })`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;

  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`, PC = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), qr = (e) => `${e}-filled`, FC = (e) => e === "good" ? _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .AIAgentMessageFeedbackRating.GOOD */ .y3.GOOD : _sendbird_chat_aiAgent__WEBPACK_IMPORTED_MODULE_4__/* .AIAgentMessageFeedbackRating.BAD */ .y3.BAD, ks = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`&:hover{opacity:0.8;}&:active{opacity:0.6;}`, Ln = {
  good: {
    onlight: b.color.secondary.dark,
    ondark: b.color.secondary.light
  },
  bad: {
    onlight: b.color.error.dark,
    ondark: b.color.error.light
  }
}, UC = {
  good: b.themedColor.secondary,
  bad: b.themedColor.error
}, Ec = (e) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`color:${Ln[e].onlight};border-color:${Ln[e].onlight};${ie.dark`
    color: ${Ln[e].ondark};
    border-color: ${Ln[e].ondark};
  `}
`, BC = ({
  visible: e,
  onClose: t,
  isEdit: n,
  initialRating: r,
  initialComment: s = "",
  onSubmit: o,
  isCommentEnabled: i = !1
}) => {
  const { stringSet: c } = fe(), { conversation: l } = pe(), { rootElement: u } = Ap(), d = yt(u), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(r), [g, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(s), [v, _] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), y = m ?? r ?? "good", S = l.feedback;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    e ? (h(r), f(s)) : (h(void 0), f(""));
  }, [e, r, s]), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e) return;
    const N = (M) => {
      const B = M;
      B.metaKey || B.altKey || B.ctrlKey || (p.current = !0);
    }, R = () => {
      p.current = !1, _(!1);
    };
    return d.addEventListener("keydown", N), d.addEventListener("pointerdown", R), () => {
      d.removeEventListener("keydown", N), d.removeEventListener("pointerdown", R);
    };
  }, [d, e]);
  const A = () => {
    m && (o({ rating: m, comment: g.trim() || void 0 }), t());
  }, I = () => {
    t();
  };
  if (!e) return null;
  const k = {
    feedback: S.container()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Tt,
    {
      portalContainerId: Me.WINDOW,
      visible: e,
      onClose: I,
      "aria-label": c.FEEDBACK_TITLE
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "h2", color: b.themedColor.textHighEmphasis }, c.FEEDBACK_TITLE)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zC, { ...k.feedback.props }, ["good", "bad"].map((N) => {
      const R = m === N, M = N === "good" ? c.FEEDBACK_GOOD : c.FEEDBACK_BAD, B = S.button(N, R);
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: N }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        KC,
        {
          type: "button",
          $selected: R,
          $rating: N,
          ...B.props,
          onClick: () => h(N),
          "data-sb-initial-focus": N === y ? "true" : void 0
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: R ? qr(N) : N, size: 24, color: "currentColor" }),
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption1", color: "currentColor" }, M)
      ), B.descriptionNode);
    }), k.feedback.descriptionNode), i && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption3", color: b.themedColor.textHighEmphasis }, c.FEEDBACK_COMMENT_LABEL), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      YC,
      {
        placeholder: c.FEEDBACK_COMMENT_PLACEHOLDER,
        value: g,
        onChange: (N) => f(N.target.value),
        onFocus: () => _(p.current),
        onBlur: () => _(!1),
        maxLength: 100,
        $focusVisible: v,
        "data-focus-visible": v ? "true" : "false"
      }
    ))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(qC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jC, { onClick: I }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.themedColor.textHighEmphasis }, c.FEEDBACK_CANCEL)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(XC, { onClick: A, disabled: !m }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button" }, n ? c.FEEDBACK_SAVE : c.FEEDBACK_SUBMIT))))
  );
}, HC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:280px;background-color:${({ theme: e }) => e.colors.base.modalContentBackground};border-radius:12px;overflow:hidden;`, GC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding:24px;`, VC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding-inline:24px;display:flex;flex-direction:column;gap:24px;`, zC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:4px;`, KC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`width:114px;height:64px;border-radius:12px;border:1px solid ${b.themedColor.textDisabled};box-sizing:border-box;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0;gap:0;transition:background-color 0.2s;color:${b.themedColor.textLowEmphasis};background-color:transparent;${({ $selected: e, $rating: t }) => e && Ec(t)}${ks}`, WC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].label */ .ZP.label`display:flex;flex-direction:column;gap:6px;`, YC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].textarea */ .ZP.textarea`font-family:inherit;font-size:12px;line-height:16px;border:1px solid ${b.themedColor.textDisabled};border-radius:4px;padding:6px 12px;color:${b.themedColor.textHighEmphasis};background-color:${b.themedColor.textLowEmphasisInverse};resize:none;field-sizing:content;min-height:28px;max-height:118px;overflow-y:auto;&::placeholder{color:${b.themedColor.textLowEmphasis};}&:focus{outline:none;}${({ $focusVisible: e }) => e && styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
      outline: 2px solid ${b.themedColor.primary};
      outline-offset: 2px;
    `}
`, qC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding-inline:24px;padding-block:16px;display:flex;justify-content:flex-end;gap:4px;`, Cc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`width:86px;height:40px;border-radius:20px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:opacity 0.2s;`, jC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Cc)`background-color:transparent;${ks}`, XC = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Cc)`cursor:${({ disabled: e }) => e ? "not-allowed" : "pointer"};opacity:${({ disabled: e }) => e ? 0.4 : 1};&:hover:not(:disabled){opacity:0.8;}&:active:not(:disabled){opacity:0.6;}background-color:${({ theme: e }) => e.colors.base.primary};span{color:${({ theme: e }) => e.colors.base.primaryContrastContent};}`, ZC = ({
  isBotMessage: e,
  isConversationClosed: t,
  isStreaming: n,
  isFeedbackEnabled: r,
  isFeedbackCommentEnabled: s,
  extendedMessagePayload: o,
  onFeedbackUpdate: i
}) => {
  const { stringSet: c } = fe(), { conversation: l } = pe(), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [g, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), [v, _] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), A = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), I = l.feedback, k = o == null ? void 0 : o.feedback, N = (k == null ? void 0 : k.rating) ?? "none";
  if (N !== "none" ? !1 : !!(n || !e || !r || (o == null ? void 0 : o.bot_message_type) !== "generated" || t)) return null;
  const M = (U) => {
    U && Oe(() => {
      const Y = U === "good" ? p.current : y.current;
      Y == null || Y.focus();
    });
  }, B = ({ restoreTrigger: U = !0 } = {}) => {
    h(!1), U && M(S.current);
  }, P = (U) => {
    N === "none" ? (f(U), _(""), d(!0)) : (S.current = U, h(!0));
  }, ne = () => {
    i == null || i(null), B();
  }, ce = () => {
    A.current = !0, B({ restoreTrigger: !1 }), f(k == null ? void 0 : k.rating), _((k == null ? void 0 : k.comment) ?? ""), d(!0);
  }, X = (U) => {
    A.current = !1, i == null || i(U), d(!1), M(S.current);
  }, J = () => {
    d(!1), A.current && (A.current = !1, h(!0));
  };
  return t && N !== "none" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(li, { role: "presentation", $horizontal: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(JC, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: qr(N), size: 12, color: UC[N] })), (k == null ? void 0 : k.comment) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui, { variant: "caption2", style: { lineHeight: "16px" } }, k.comment)) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(li, { role: "presentation" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QC, { role: "presentation" }, ["good", "bad"].map((U) => {
    const Y = N === U, q = I.button(U, Y);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: U }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      ev,
      {
        $selected: Y,
        $rating: U,
        ref: U === "good" ? p : y,
        ...q.props,
        onClick: () => P(U)
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: Y ? qr(U) : U, size: 14, color: "currentColor" })
    ), q.descriptionNode);
  })), N !== "none" && (k == null ? void 0 : k.comment) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui, { variant: "caption2" }, k.comment)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    bt,
    {
      visible: m,
      onClose: B,
      ...I.optionsBottomSheet().props
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bt.ActionItem, { onClick: ce, initialFocus: !0 }, c.FEEDBACK_EDIT),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bt.ActionItem, { onClick: ne, destructive: !0 }, c.FEEDBACK_REMOVE)
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    BC,
    {
      visible: u,
      onClose: J,
      isEdit: N !== "none",
      initialRating: g,
      initialComment: v,
      onSubmit: X,
      isCommentEnabled: s
    }
  ));
}, li = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:${({ $horizontal: e }) => e ? "row" : "column"};align-items:${({ $horizontal: e }) => e ? "flex-start" : "stretch"};gap:4px;margin-top:8px;word-break:break-word;max-width:${ae.BODY_MAX_WIDTH}px;`, JC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding:2px;flex-shrink:0;display:flex;align-items:center;`, QC = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:2px;`, ev = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`width:38px;height:20px;border-radius:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:opacity 0.2s;box-sizing:border-box;color:${b.themedColor.textMidEmphasis};border:1px solid ${b.color.background200};background-color:transparent;${ie.dark`
    border: 1px solid ${b.color.background400};
  `}

  ${({ $selected: e, $rating: t }) => e && Ec(t)}

  ${ks}
`, ui = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`color:${b.themedColor.textMidEmphasis};${ie.dark`
    color: ${b.themedColor.textHighEmphasis};
  `}
`, Ls = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`width:100%;height:36px;border-radius:6px;cursor:pointer;transition:all 0.2s ease;padding:0 12px;border:none;outline:none;display:flex;align-items:center;justify-content:center;${Ne}&:disabled{cursor:not-allowed;}`, di = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`${Ls};background-color:${b.themedColor.primary};color:${b.themedColor.textHighEmphasis};&:hover:not(:disabled){opacity:0.9;}`, tv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`${Ls};color:${b.themedColor.primary};${ie.light`
    background-color: ${b.color.background50};
  `};
  ${ie.dark`
    background-color: ${b.color.background700};
  `};

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`, nv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`${Ls};background-color:transparent;color:${b.themedColor.textHighEmphasis};&:hover:not(:disabled){opacity:0.7;}`, rv = (e) => {
  switch (e) {
    case "primary":
      return di;
    case "secondary":
      return tv;
    case "clear":
      return nv;
    default:
      return di;
  }
}, sv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`animation:1s infinite linear;animation-name:rotate;display:flex;align-items:center;justify-content:center;@keyframes rotate{from{transform:rotate(0);}to{transform:rotate(360deg);}}`, ov = ({
  children: e,
  onClick: t,
  variant: n = "primary",
  disabled: r = !1,
  loading: s = !1,
  className: o,
  ...i
}) => {
  const c = () => {
    switch (n) {
      case "primary":
        return b.themedColor.textHighEmphasisInverse;
      case "secondary":
        return b.themedColor.primary;
      case "clear":
        return b.themedColor.textHighEmphasis;
      default:
        return b.themedColor.textHighEmphasisInverse;
    }
  }, l = rv(n);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(l, { onClick: t, disabled: r || s, className: o, ...i }, s ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sv, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", size: 22, color: c() })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: c() }, e));
}, iv = ({ children: e, className: t, style: n, id: r, role: s }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  G,
  {
    variant: "caption4",
    color: b.themedColor.error,
    className: t,
    style: n,
    id: r,
    role: s
  },
  e
), av = ({ id: e, children: t, className: n, style: r, required: s, "aria-hidden": o }) => {
  const { stringSet: i } = fe();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    G,
    {
      id: e,
      variant: "caption3",
      color: b.themedColor.textMidEmphasis,
      className: n,
      style: r,
      "aria-hidden": o
    },
    t,
    !s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: { color: b.themedColor.textLowEmphasis } }, ` (${i.OPTIONAL})`)
  );
}, cv = ({
  value: e,
  onChange: t,
  placeholder: n,
  error: r = !1,
  submitted: s = !1,
  className: o,
  disabled: i = !1,
  max: c,
  ...l
}) => {
  const u = (m) => {
    const g = m.target.value.replace(/[^0-9.-]/g, ""), f = g.split("."), _ = f.length > 1 ? f[0] + "." + f.slice(1).join("").replace(/\./g, "") : g;
    if (m.target.value = _, _ === "" || _ === "-")
      t == null || t(null);
    else {
      const p = Number(_);
      if (!isNaN(p)) {
        if (c !== void 0 && p > c)
          return;
        t == null || t(p);
      }
    }
  }, d = e == null ? "" : String(e);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    hv,
    {
      type: "text",
      value: d,
      onChange: u,
      placeholder: n,
      className: o,
      disabled: i || s,
      inputMode: "decimal",
      $error: r,
      $submitted: s,
      ...l
    }
  );
}, lv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`width:100%;box-sizing:border-box;height:36px;padding:8px 12px;border-radius:6px;font-size:14px;font-weight:400;line-height:1.43;outline:none;transition:all 0.2s ease;${Ne}&::placeholder{color:${b.themedColor.textLowEmphasis};}&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}`, uv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`color:${b.themedColor.textHighEmphasis};border:1px solid transparent;cursor:not-allowed;${ie.light`
    background-color: ${b.color.ondark.textMidEmphasis};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}

  &::placeholder {
    color: ${b.themedColor.textLowEmphasis};
  }
`, dv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`border:1px solid ${b.themedColor.error};color:${b.themedColor.textHighEmphasis};${ie.light`
    background-color: ${b.color.background50};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}
`, mv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`border:1px solid ${b.themedColor.textDisabled};color:${b.themedColor.textHighEmphasis};${ie.light`
    background-color: ${b.color.background50};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}
  
  &:focus {
    border-color: ${b.themedColor.primary};
  }
`, hv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].input */ .ZP.input`${lv}${({ $error: e, $submitted: t }) => t ? uv : e ? dv : mv}`, gv = (e) => {
  if (e.multiple) {
    const { value: t = [], onChange: n, maxSelect: r, submitted: s = !1 } = e;
    return {
      selectedValues: t,
      handleOptionClick: (i) => {
        if (s) return;
        if (t.includes(i)) {
          const l = t.filter((u) => u !== i);
          n == null || n(l);
        } else {
          if (r && t.length >= r)
            return;
          const l = [...t, i];
          n == null || n(l);
        }
      }
    };
  } else {
    const { value: t, onChange: n, submitted: r = !1 } = e;
    return {
      selectedValues: t ? [t] : [],
      handleOptionClick: (o) => {
        r || t !== o && (n == null || n(o));
      }
    };
  }
}, vc = (e) => {
  const { options: t, submitted: n = !1, error: r = !1, className: s, groupLabel: o } = e, { conversation: i } = pe(), c = e.multiple === !0, { selectedValues: l, handleOptionClick: u } = gv(e), d = t.some((m) => l.includes(m.value));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    pv,
    {
      className: s,
      ...c ? void 0 : i.form.singleSelectGroup(o).props
    },
    t.map((m, h) => {
      const g = l.includes(m.value), f = o ? `${o}, ${m.label}` : m.label;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        yv,
        {
          key: m.value,
          type: "button",
          $active: g,
          $submitted: n,
          $error: r,
          ...(c ? i.form.multiSelectOption(f, g, n) : i.form.singleSelectOption(
            f,
            g,
            n,
            h,
            t.length,
            d,
            (v) => {
              const _ = t[v];
              _ && u(_.value);
            }
          )).props,
          disabled: n,
          onClick: () => u(m.value)
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption1", color: fv(g, n) }, m.label)
      );
    })
  );
}, fv = (e, t) => t ? e ? b.themedColor.textHighEmphasis : b.themedColor.textDisabled : e ? b.themedColor.primary : b.themedColor.textMidEmphasis, pv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-wrap:wrap;gap:4px 2px;`, _v = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`display:inline-flex;align-items:center;padding:8px 12px;border-radius:15px;transition:all 0.2s ease;`, Ev = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:default;background-color:${b.color.ondark.textMidEmphasis};color:${b.themedColor.textHighEmphasis};${ie.dark`
    background-color: transparent;
    border: 1px solid white;
    color: white;
  `}
`, Cv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:default;${ie.light`
    background-color: ${b.color.ondark.textMidEmphasis};
    color: ${b.themedColor.textDisabled};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
    border: 1px solid ${b.color.onlight.textLowEmphasis};
    color: ${b.themedColor.textDisabled};
  `}
`, vv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:pointer;border:1px solid ${b.themedColor.primary};${ie.light`
    background-color: ${b.color.background50};
    color: ${b.themedColor.primary};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
    color: ${b.themedColor.primary};
  `}
`, bv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:pointer;border:1px solid ${b.themedColor.textDisabled};${ie.light`
    background-color: ${b.color.background50};
    color: ${b.themedColor.textMidEmphasis};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
    color: ${b.themedColor.textMidEmphasis};
  `}
`, Sv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`border-color:${b.themedColor.error}!important;`, yv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`${_v}${({ $active: e, $submitted: t, $error: n }) => {
  if (t)
    return e ? Ev : Cv;
  const r = e ? vv : bv;
  return n ? styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
          ${r} ${Sv}
        ` : r;
}}
`, Av = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vc, { ...e, multiple: !1 }), Tv = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vc, { ...e, multiple: !0 }), Iv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:100%;height:1px;background-color:${b.themedColor.textDisabled};`, xv = ({ className: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Iv, { className: e }), Mv = ({
  id: e,
  value: t = "",
  onChange: n,
  placeholder: r,
  variant: s = "single-line",
  error: o = !1,
  submitted: i = !1,
  className: c,
  disabled: l = !1,
  maxLength: u,
  ...d
}) => {
  const h = {
    id: e,
    value: t,
    onChange: (g) => {
      const f = g.target.value;
      u && f.length > u || n == null || n(f);
    },
    placeholder: r,
    className: c,
    disabled: l || i,
    maxLength: u,
    $error: o,
    $submitted: i,
    ...d
  };
  return s === "multi-line" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wv, { ...h }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rv, { ...h });
}, bc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`width:100%;box-sizing:border-box;padding:8px 12px;border-radius:6px;font-size:14px;font-weight:400;line-height:1.43;outline:none;transition:all 0.2s ease;${Ne}&::placeholder{color:${b.themedColor.textLowEmphasis};}`, Sc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`color:${b.themedColor.textHighEmphasis};border:1px solid transparent;cursor:not-allowed;${ie.light`
    background-color: ${b.color.ondark.textMidEmphasis};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}

  &::placeholder {
    color: ${b.themedColor.textLowEmphasis};
  }
`, yc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`border:1px solid ${b.themedColor.error};color:${b.themedColor.textHighEmphasis};${ie.light`
    background-color: ${b.color.background50};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}
`, Ac = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`border:1px solid ${b.themedColor.textDisabled};color:${b.themedColor.textHighEmphasis};${ie.light`
    background-color: ${b.color.background50};
  `}
  ${ie.dark`
    background-color: ${b.color.onlight.textLowEmphasis};
  `}
  
  &:focus {
    border-color: ${b.themedColor.primary};
  }
`, Rv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].input */ .ZP.input`${bc};height:36px;${({ $error: e, $submitted: t }) => t ? Sc : e ? yc : Ac}`, wv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].textarea */ .ZP.textarea`${bc};height:96px;resize:none;font-family:inherit;${({ $error: e, $submitted: t }) => t ? Sc : e ? yc : Ac}`, kv = ({ children: e, className: t, style: n }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.themedColor.textHighEmphasis, className: t, style: n }, e), Fe = {
  Title: kv,
  Label: av,
  ErrorLabel: iv,
  Separator: xv,
  Button: ov,
  TextInput: Mv,
  NumberInput: cv,
  SingleSelect: Av,
  MultiSelect: Tv
}, Lv = 1, Ov = /* @__PURE__ */ new Set(["text", "number", "single-select", "multi-select"]), Tc = typeof __SBA_USE_FORM__ > "u" || __SBA_USE_FORM__, Nv = ({
  messageForm: e,
  onError: t
}) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (Tc || !e || !t) return;
    const r = e.key ?? "";
    n.current !== r && (t(new Error("Form rendering is disabled")), n.current = r);
  }, [e, t]);
}, Dv = (e) => {
  var p, y;
  const t = (p = e.extendedMessagePayload) == null ? void 0 : p.form;
  if (Nv({
    messageForm: t,
    onError: (y = e.statsCallbacks) == null ? void 0 : y.onFormRenderError
  }), !Tc) return null;
  if (!t) throw new Error("Form is not provided");
  const { stringSet: n } = fe(), { conversation: r } = pe(), [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ submitting: !1, canceling: !1 }), [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    visible: !1
  }), { state: l, fields: u, submit: d, cancel: m, updateFieldValue: h } = Sg(t, {
    labels: {
      required: n.FORM_VALIDATION_REQUIRED,
      regex: n.FORM_VALIDATION_REGEX_FAILED,
      minLength: n.FORM_VALIDATION_MIN_LENGTH,
      maxLength: n.FORM_VALIDATION_MAX_LENGTH,
      min: n.FORM_VALIDATION_MIN,
      max: n.FORM_VALIDATION_MAX,
      minSelect: n.FORM_VALIDATION_MIN_SELECT,
      maxSelect: n.FORM_VALIDATION_MAX_SELECT
    },
    onSubmit: (S) => {
      var A;
      return (A = e.onSubmitForm) == null ? void 0 : A.call(e, { key: t.key, data: S });
    },
    onCancel: () => {
      var S;
      return (S = e.onCancelForm) == null ? void 0 : S.call(e, { key: t.key });
    }
  }), g = l === "submitted", f = async () => {
    o((S) => ({ ...S, submitting: !0 }));
    try {
      await d();
    } catch (S) {
      c({
        visible: !0,
        description: S instanceof Error ? S.message : n.TRY_AGAIN
      });
    } finally {
      o((S) => ({ ...S, submitting: !1 }));
    }
  }, v = async () => {
    o((S) => ({ ...S, canceling: !0 }));
    try {
      await m();
    } catch (S) {
      c({
        visible: !0,
        description: S instanceof Error ? S.message : n.TRY_AGAIN
      });
    } finally {
      o((S) => ({ ...S, canceling: !1 }));
    }
  }, _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const S = () => t.version > Lv, A = () => t.fields.some((I) => !Ov.has(I.type));
    return S() || A() ? { visible: !1, cancelable: !0, reason: n.FORM_NOT_SUPPORTED } : l === "draft" && (e.isHandedOff || e.isConversationClosed) ? { visible: !1, cancelable: !1, reason: n.FORM_UNAVAILABLE } : { visible: !0, cancelable: !0, reason: "" };
  }, [t.version, t.fields, l, e.isHandedOff, e.isConversationClosed]);
  return l === "canceled" ? null : _.visible ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mi, { id: `${nt}-ext-form`, $maxWidth: e.maxBodyWidth ?? ae.BODY_MAX_WIDTH }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Title, null, t.title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($v, null, u.map((S) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Pv, { key: S.key }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Label, { style: { marginBottom: "6px" }, required: S.required }, S.label), S.type === "text" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.TextInput,
    {
      value: S.value || "",
      placeholder: S.placeholder,
      onChange: (A) => h(S.key, A),
      disabled: g,
      error: !!S.error,
      submitted: g,
      variant: S.layout === "multiline" ? "multi-line" : "single-line",
      maxLength: S.maxLength,
      ...r.form.textInput(S.label, S.required ?? !1, g).props
    }
  ), S.type === "number" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.NumberInput,
    {
      value: S.value || null,
      placeholder: S.placeholder,
      onChange: (A) => h(S.key, A),
      disabled: g,
      error: !!S.error,
      submitted: g,
      max: S.max,
      ...r.form.numberInput(S.label, S.required ?? !1, g).props
    }
  ), S.type === "single-select" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.SingleSelect,
    {
      options: S.options.map((A) => ({ label: A, value: A })),
      value: S.value || "",
      onChange: (A) => h(S.key, A),
      submitted: g,
      groupLabel: S.label
    }
  ), S.type === "multi-select" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.MultiSelect,
    {
      options: S.options.map((A) => ({ label: A, value: A })),
      value: S.value || [],
      onChange: (A) => h(S.key, A),
      submitted: g,
      maxSelect: S.maxSelect,
      groupLabel: S.label
    }
  ), S.error && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.ErrorLabel, { style: { marginTop: "4px" } }, S.error)))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Separator, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fv, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.Button,
    {
      variant: g ? "clear" : "primary",
      ...r.form.button(g ? n.SUBMITTED : n.BUTTON__SUBMIT).props,
      onClick: f,
      disabled: g || s.canceling,
      loading: s.submitting
    },
    g ? n.SUBMITTED : n.BUTTON__SUBMIT
  ), l !== "submitted" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.Button,
    {
      variant: "secondary",
      ...r.form.button(n.BUTTON__CANCEL).props,
      onClick: v,
      disabled: s.submitting,
      loading: s.canceling
    },
    n.BUTTON__CANCEL
  ))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vn, { ...i, onClose: () => c({ visible: !1, title: "" }) })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mi, { id: `${nt}-ext-form`, $maxWidth: e.maxBodyWidth ?? ae.BODY_MAX_WIDTH }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body3" }, _.reason), _.cancelable && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.Button,
    {
      variant: "primary",
      ...r.form.button(n.BUTTON__CANCEL).props,
      onClick: v,
      loading: s.canceling
    },
    n.BUTTON__CANCEL
  ));
}, mi = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:12px;border-radius:12px;overflow:hidden;width:100%;box-sizing:border-box;max-width:${({ $maxWidth: e }) => e}px;${({ theme: e }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
    color: ${e.colors.messageIncoming.text};
    background-color: ${e.colors.messageIncoming.background};
  `}
  padding: 16px 12px;
  transition: max-width 0.3s;
  overflow-wrap: break-word;
`, $v = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:12px;`, Pv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;`, Fv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, Uv = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), jr = typeof __SBA_USE_MESSAGE_TEMPLATE__ > "u" || __SBA_USE_MESSAGE_TEMPLATE__ ? (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 4524).then(__webpack_require__.bind(__webpack_require__, 94524)).then((e) => ({ default: e.MessageTemplateWrapper }))) : null, Bv = ({
  messageTemplate: e,
  onError: t
}) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (jr || !e || !t) return;
    const r = e.key ?? "";
    n.current !== r && (t(new Error("Message template rendering is disabled")), n.current = r);
  }, [e, t]);
}, Hv = (e) => {
  var n, r, s;
  const t = (n = e.extendedMessagePayload) == null ? void 0 : n.message_template;
  return Bv({
    messageTemplate: t,
    onError: (r = e.statsCallbacks) == null ? void 0 : r.onMessageTemplateError
  }), jr ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    wt,
    {
      errorFallback: e.messageTemplateErrorFallback,
      loadingFallback: e.messageTemplateLoadingFallback,
      onError: (s = e.statsCallbacks) == null ? void 0 : s.onMessageTemplateError
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jr, { ...e })
  ) : null;
}, Gv = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), Vv = ({
  data: e,
  extendedMessagePayload: t,
  onClickSuggestedReply: n,
  onConfirmTicketClosure: r,
  suggestedRepliesDirection: s = "vertical"
}) => {
  const { conversation: o } = pe(), { stringSet: i } = fe(), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), { suggestedReplies: h } = o, g = Dm({
    data: e,
    extendedMessagePayload: t,
    ticketClosureLabels: {
      confirm: i.DESK__TICKET_CLOSURE_CONFIRM,
      decline: i.DESK__TICKET_CLOSURE_DECLINE
    }
  });
  if (g.length === 0 || c)
    return null;
  const f = (v) => {
    if (v.action === "confirmTicketClosure") {
      if (m.current || !r) return;
      m.current = !0, r({ ticketId: v.ticketId, confirmed: v.confirmed }).catch(() => {
        m.current = !1, d(!0);
      });
      return;
    }
    n && (n({ reply: v.label }), l(!0));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zv, { id: `${nt}-ext-suggested-replies`, role: "presentation", $type: s }, g.map((v, _) => {
    const p = h.item(v.label, _);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: _ }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Kv, { $type: s, ...p.props, onClick: () => f(v) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wv, { variant: "body3" }, v.label)), p.descriptionNode);
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    vn,
    {
      visible: u,
      title: i.PLACE_HOLDER__WRONG,
      description: i.DESK__TICKET_CLOSURE_ERROR_MESSAGE,
      onClose: () => d(!1)
    }
  ));
}, zv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`margin:16px 0;padding:0 ${ae.HORIZONTAL_PADDING}px;position:relative;display:flex;align-self:stretch;gap:8px;${({ $type: e }) => e === "vertical" ? Yv : qv};`, Kv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button.attrs */ .ZP.button.attrs({ type: "button" })`
  all: unset;
  box-sizing: border-box;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px / clamp(20px, 5%, 100px);
  cursor: pointer;
  word-break: break-word;
  color: ${b.color.primary.main};
  border: 1px solid ${b.color.primary.main};
  background-color: ${b.themedColor.bg_50_600};

  &:hover {
    background-color: ${b.themedColor.bg_100_500};
  }

  ${Ne}

  ${({ $type: e, theme: t }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`${e === "vertical" ? jv : Xv};&:active{background-color:${t.colors.base.primary};color:${t.colors.base.primaryContrastContent};}`}
`, Wv = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`color:inherit;`, Yv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`flex-direction:column;align-items:flex-end;`, qv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`flex-direction:row;overflow-x:scroll;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}`, jv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`max-width:calc(100% - 70px);white-space:pre-wrap;`, Xv = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`white-space:nowrap;`, Zv = (e) => {
  const { components: t } = kt.useContext(), { stringSet: n } = fe(), r = Ki(e) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TextMessageBody, { ...e }) : null;
  if (e.messageType === "user")
    return r;
  if (e.messageType === "file") {
    const s = e.file;
    return s.type.startsWith("image") || s.type.startsWith("video") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MediaMessageBody, { ...e }, r) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.FileMessageBody, { ...e }, r);
  }
  return e.messageType === "multipleFiles" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MultipleFilesMessageBody, { ...e }, r) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TextMessageBody, { ...e, message: n.UNKNOWN__UNKNOWN_MESSAGE_TYPE });
}, Jv = Object.freeze({}), Qv = (e) => {
  var A, I, k, N, R;
  const { components: t } = kt.useContext(), { streamText: n, isAnimating: r, isHolding: s } = Fg({
    text: e.message,
    enabled: e.isStreaming,
    snapOnDisable: ((A = e.extendedMessagePayload) == null ? void 0 : A.is_last_in_turn) !== !0,
    deferredMarkdownElements: e.deferredMarkdownElements,
    onAnimationStart: e.onStreamAnimationStart,
    onAnimationProgress: e.onStreamAnimationProgress,
    onAnimationComplete: e.onStreamAnimationComplete,
    onAnimationHoldChange: e.onStreamAnimationHoldChange,
    onVisibleTextProgress: (I = e.statsCallbacks) == null ? void 0 : I.onVisibleTextProgress,
    onRenderedTextProgress: (k = e.statsCallbacks) == null ? void 0 : k.onRenderedTextProgress
  });
  if (s) return null;
  const o = {
    ...e,
    message: n,
    extendedMessagePayload: r ? Jv : e.extendedMessagePayload
  }, i = !!o.isTyping, c = !!o.isSenderAvatarVisible, l = hn(o.extendedMessagePayload), u = l.hasCTAButton, d = l.hasChallenge, m = l.hasCitations, h = l.hasForm, g = l.hasMessageTemplate, f = !!o.createdAt, v = u || m, _ = o.groupType === "top" || o.groupType === "single", p = o.groupType === "bottom" || o.groupType === "single", y = c ? ae.AVATAR_SIZE : 0, S = v && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, u && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tb, { $marginTop: 12, $paddingInline: 12 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.CTAButton, { ...o })), m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Citation, { ...o }));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(eb, { $marginBottom: i ? 0 : Qn(o.groupType) }, _ && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nb, null, c && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SenderAvatar, { ...o }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SenderName, { ...o })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Prechecks, { ...o }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ir, { $extraStartPadding: y }, i ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TypingIndicator, { ...o }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MessageBody, { ...o }, S)), g && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hi, { $startPadding: 0, $endPadding: 0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    t.MessageTemplate,
    {
      ...o,
      messageTemplateErrorFallback: o.messageTemplateErrorFallback ?? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ir, { $extraStartPadding: y }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        t.MessageBody,
        {
          ...o,
          messageType: "user",
          message: ((R = (N = o.extendedMessagePayload) == null ? void 0 : N.message_template) == null ? void 0 : R.fallback_message) ?? "Cannot read this template."
        }
      )),
      messageTemplateLoadingFallback: o.messageTemplateLoadingFallback ?? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ir, { $extraStartPadding: y }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TypingIndicator, { ...o }))
    }
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.CustomMessageTemplate, { ...o }), d && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Challenge, { ...o }), h && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hi, { $extraStartPadding: y }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Form, { ...o }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MessageLogs, { ...o }), p && f && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rb, { $extraStartPadding: y + 8 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SentTime, { ...o })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !i && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bn, { $extraStartPadding: y + 8 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Feedback, { ...o })), o.suggestedRepliesVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SuggestedReplies, { ...o })));
}, kt = ot({
  template: Qv,
  components: {
    SenderName: _C,
    SenderAvatar: fC,
    SentTime: CC,
    MessageBody: Zv,
    TextMessageBody: dC,
    MediaMessageBody: jE,
    FileMessageBody: WE,
    MultipleFilesMessageBody: cC,
    TypingIndicator: bC,
    SuggestedReplies: Vv,
    MessageTemplate: Hv,
    CustomMessageTemplate: PC,
    Challenge: wC,
    CTAButton: xC,
    Citation: kC,
    Form: Dv,
    Feedback: ZC,
    MessageLogs: Uv,
    Prechecks: Gv
  }
}), eb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.attrs */ .ZP.div.attrs({ role: "presentation" })`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${({ $marginBottom: e }) => `${e}px`};
`, bn = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.attrs */ .ZP.div.attrs({ role: "presentation" })`
  display: flex;
  align-self: stretch;
  justify-content: flex-start;
  ${({
  $startPadding: e = ae.HORIZONTAL_PADDING,
  $endPadding: t = ae.HORIZONTAL_PADDING,
  $extraStartPadding: n = 0
}) => `
    padding-inline: ${e + n}px ${t}px;
  `}
`, tb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.attrs */ .ZP.div.attrs({ role: "presentation" })`
  display: flex;
  flex-direction: column;
  min-width: 0;
  ${({ $marginTop: e = 0, $paddingInline: t = 0 }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`margin-top:${e}px;padding-inline:${t}px;`}
`, nb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(bn)`display:flex;flex-direction:row;align-items:center;gap:8px;`, Ir = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(bn)`display:flex;`, rb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(bn)`margin-top:${ae.BODY_TIME_GAP}px;display:flex;align-items:flex-start;justify-content:flex-start;`, hi = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(bn).attrs({ role: "presentation" })`
  display: flex;
  ${({
  $startPadding: e = ae.HORIZONTAL_PADDING,
  $endPadding: t = ae.HORIZONTAL_PADDING,
  $extraStartPadding: n = 0
}) => `
    padding-inline: ${e + n}px ${t}px;
  `}
`, sb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.attrs */ .ZP.div.attrs({ role: "presentation" })`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-width: 0;
  max-width: 100%;
  gap: ${ae.GAP_GROUPED}px;
`;
function ob({ file: e, children: t, onClickFile: n, sendingStatus: r }) {
  const s = (() => {
    if (!(!n || r === "failed"))
      return () => n == null ? void 0 : n(e);
  })();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ib, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ws,
    {
      name: e.name,
      mimeType: e.type,
      type: os(e.name, e.type),
      onClick: s
    }
  ), t);
}
const ib = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-end;gap:${ae.GAP_GROUPED}px;`, Xn = /* @__PURE__ */ new WeakMap();
function Os(e) {
  const t = Xn.get(e);
  if (t) return t;
  const n = URL.createObjectURL(e);
  return Xn.set(e, n), n;
}
function gi(e) {
  const t = Xn.get(e);
  t && (URL.revokeObjectURL(t), Xn.delete(e));
}
function ab({
  sendingStatus: e,
  file: t,
  metadata: n,
  onClickMedia: r,
  onClickMediaFiles: s,
  children: o
}) {
  const { conversation: i } = pe(), { aspectRatio: c, localFile: l } = n, [u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    () => l instanceof Blob ? Os(l) : void 0
  ), d = u ?? t.url, [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => l instanceof Blob), g = (() => {
    if (e === "failed") return;
    const _ = e === "succeeded" ? t.url : d;
    if (s)
      return () => s({
        files: [{ url: _, type: t.type, name: t.name }],
        index: 0
      });
    if (r)
      return () => r({ ...t, url: _ });
  })(), f = g ? i.file.buttonLikePreview({
    name: t.name,
    mimeType: t.type,
    onActivate: g
  }) : i.file.preview({
    name: t.name,
    mimeType: t.type
  }), v = {
    ...f.props,
    $ratio: c,
    $clickable: !!g
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lb, { ...v }, !m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: 26 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", color: "textLowEmphasis", size: 26 })), d ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ub, { $loaded: m, src: d, alt: "image-message", onLoad: () => h(!0) }) : null, f.descriptionNode), o);
}
const cb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-end;gap:${ae.GAP_GROUPED}px;`, lb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:${ae.BODY_MAX_WIDTH}px;border-radius:12px;overflow:hidden;cursor:${(e) => e.$clickable ? "pointer" : "default"};height:auto;aspect-ratio:${(e) => e.$ratio};position:relative;display:flex;align-items:center;justify-content:center;${ie.light`
    background-color: ${b.color.background100};
  `}
  ${ie.dark`
    background-color: ${b.color.background400};
  `}
`, ub = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`position:absolute;width:100%;height:100%;inset-block-start:0;inset-inline-start:0;object-fit:cover;border-radius:inherit;opacity:${(e) => e.$loaded ? 1 : 0};transition:opacity 0.5s ease;`;
function db(e) {
  return typeof e == "object" && e !== null && "url" in e;
}
const mb = ({
  sendingStatus: e,
  files: t,
  metadata: n,
  onClickMedia: r,
  onClickMediaFiles: s,
  children: o
}) => {
  const [i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    if (!n.localFiles) return null;
    const m = n.localFiles.flatMap((h) => h instanceof Blob ? {
      url: Os(h),
      type: h.type,
      name: h instanceof File ? h.name : ""
    } : db(h) ? h : []);
    return m.length > 0 ? m : null;
  }), c = i ?? t, l = e === "pending", u = e === "succeeded", d = (m) => {
    if (!u) return;
    const h = t[m];
    h && (s ? s({ files: t, index: m }) : r && r({ url: h.url, type: h.type || "image/*" }));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    hc,
    {
      images: c,
      isPending: l,
      onClickImage: u ? d : void 0
    }
  ), o);
}, hb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:flex-end;gap:${ae.GAP_GROUPED}px;`, gb = ({ children: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { id: oi, className: oi, "aria-label": qE }, e), fb = "✱", fi = (e) => {
  var t, n;
  return {
    files: e.fileInfoList.map((r) => ({
      url: r.url,
      type: r.mimeType ?? "",
      name: r.fileName ?? ""
    })),
    metadata: {
      localFiles: (n = (t = e.messageParams) == null ? void 0 : t.fileInfoList) == null ? void 0 : n.map((r) => {
        if (r.file) return r.file;
        if (r.fileUrl) return { url: r.fileUrl, name: r.fileName ?? "", type: r.mimeType ?? "" };
      })
    }
  };
}, pb = (e) => {
  const t = new RegExp(`(\`+)[^\`]+?\\1|(${fb}+)`, "g"), n = [];
  let r;
  for (; (r = t.exec(e)) !== null; )
    r[2] && n.push({ start: r.index, end: r.index + r[0].length, text: r[2] });
  return n;
}, xr = (e, t, n, r) => {
  const s = [];
  let o = t;
  for (const i of r)
    i.start < o || i.end > n || (i.start > o && s.push(e.slice(o, i.start)), s.push(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(gb, { key: i.start }, i.text)), o = i.end);
  return o < n && s.push(e.slice(o, n)), s;
}, _b = (e) => {
  const t = pb(e), n = /\*\*.*?\*\*/g, r = [];
  let s = 0, o;
  for (; (o = n.exec(e)) !== null; ) {
    const i = o.index + o[0].length;
    r.push(...xr(e, s, o.index, t)), r.push(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("b", { key: o.index }, xr(e, o.index + 2, i - 2, t))), s = i;
  }
  return r.push(...xr(e, s, e.length, t)), r;
};
function Eb(e) {
  var n, r;
  const t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => _b(e.message), [e.message]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Cb,
    {
      $maxWidth: e.maxBodyWidth ?? ae.BODY_MAX_WIDTH,
      $color: (n = e.customStyle) == null ? void 0 : n.bubbleContentColor,
      $bgColor: (r = e.customStyle) == null ? void 0 : r.bubbleBackgroundColor
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vb, { variant: "body3" }, t)
  );
}
const Cb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;border-radius:12px;overflow:hidden;max-width:${({ $maxWidth: e }) => e}px;${({ theme: e, $color: t, $bgColor: n }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
    color: ${t || e.colors.messageOutgoing.text};
    background-color: ${n || e.colors.messageOutgoing.background};
  `}
  padding: 12px 0;
  transition: max-width 0.3s;
  overflow-wrap: break-word;
`, vb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`align-items:flex-start;line-height:140%;white-space:pre-wrap;padding:0 12px;`, bb = ({ sendingStatus: e }) => {
  const t = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)();
  switch (e) {
    case "pending":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sb, { size: 16 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", color: t.colors.messageOutgoing.background, size: 16 }));
    case "failed":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { marginBottom: 2 } }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "error", color: b.themedColor.error, size: 16 }));
    case "scheduled":
    case "canceled":
      return null;
    default:
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { marginBottom: 2 } }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "done", color: b.themedColor.secondary, size: 16 }));
  }
}, Sb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)($t)`margin-bottom:2px;width:16px;height:16px;`, yb = ({ createdAt: e }) => {
  const { stringSet: t, format: n } = fe();
  return e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption4", color: b.themedColor.textLowEmphasis }, n(e, t.DATE_FORMAT__MESSAGE_TIMESTAMP)) : null;
}, Ab = (e) => {
  const { components: t } = Sn.useContext(), { stringSet: n } = fe(), r = () => {
    const i = Ki(e) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TextMessageBody, { ...e }) : null;
    return e.messageType === "user" ? i : e.messageType === "file" ? e.file.type.startsWith("image") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MediaMessageBody, { ...e }, i) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.FileMessageBody, { ...e }, i) : e.messageType === "multipleFiles" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MultipleFilesMessageBody, { ...e }, i) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TextMessageBody, { ...e, message: n.UNKNOWN__UNKNOWN_MESSAGE_TYPE });
  }, s = e.sendingStatus === "failed" && e.onClickFailedMessage, o = s ? sn({ onActivate: () => {
    var i;
    return (i = e.onClickFailedMessage) == null ? void 0 : i.call(e);
  } }) : {};
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ...o, style: { display: "contents", cursor: s ? "pointer" : "default" } }, r());
}, Tb = (e) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), Ib = (e) => {
  const { components: t } = Sn.useContext(), n = e.sendingStatus === "succeeded", r = e.groupType === "bottom" || e.groupType === "single";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(xb, { $marginBottom: Qn(e.groupType) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Mb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MessageBody, { ...e })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.MessageLogs, { ...e }), r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rb, { $extraEndPadding: 8 }, n ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SentTime, { ...e }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.SendingStatus, { ...e })));
}, Sn = ot({
  template: Ib,
  components: {
    SendingStatus: bb,
    SentTime: yb,
    MessageBody: Ab,
    TextMessageBody: Eb,
    MediaMessageBody: ab,
    FileMessageBody: ob,
    MultipleFilesMessageBody: mb,
    MessageLogs: Tb
  }
}), xb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex:1;flex-direction:column;align-items:flex-end;margin-bottom:${({ $marginBottom: e }) => `${e}px`};
`, Ic = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-self:stretch;justify-content:flex-end;${({ $startPadding: e = ae.HORIZONTAL_PADDING, $endPadding: t = ae.HORIZONTAL_PADDING, $extraEndPadding: n = 0 }) => `padding-inline: ${e}px ${t + n}px;`};
`, Mb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Ic)``, Rb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Ic)`margin-top:${ae.BODY_TIME_GAP}px;`, wb = (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 617).then(__webpack_require__.bind(__webpack_require__, 30617)).then((e) => ({ default: e.MarkdownText }))), kb = (e) => e.messageType !== "admin" ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Lb, { forwardedAs: "div", variant: "caption2", color: b.themedColor.textMidEmphasis }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { fallback: e.message }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ob, { onClickLink: e.onClickLink }, e.message)))), Lb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`&&{line-height:${4 / 3};}`, Ob = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(wb)`&& p{font-size:inherit;line-height:inherit;}&& a{font-weight:inherit;}`, Nb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`text-align:center;text-wrap:pretty;word-break:break-word;padding-inline:${ae.HORIZONTAL_PADDING}px;a{text-decoration:underline;color:inherit;}`, Db = ({
  direction: e,
  currentIndex: t,
  totalCount: n
}) => n <= 0 ? t : e === "next" ? (t + 1) % n : (t - 1 + n) % n, xc = ({
  options: e,
  value: t,
  disabled: n,
  hasError: r = !1,
  errorId: s,
  onChange: o
}) => {
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]), c = e.findIndex((m) => m.value === t), l = c >= 0 ? c : 0, u = (m) => {
    requestAnimationFrame(() => {
      var h;
      (h = i.current[m]) == null || h.focus();
    });
  }, d = (m) => {
    const h = e[m];
    !h || n || (o == null || o(h.value), u(m));
  };
  return {
    radioGroupProps: (m) => ({
      role: "radiogroup",
      "aria-label": m,
      ...r && s ? {
        "aria-invalid": !0,
        "aria-errormessage": s
      } : {}
    }),
    getRadioProps: (m) => ({
      ref: (h) => {
        i.current[m] = h;
      },
      tabIndex: n ? -1 : m === l ? 0 : -1,
      describedBy: r && s ? s : void 0,
      onArrowNavigate: (h) => {
        d(
          Db({
            direction: h,
            currentIndex: m,
            totalCount: e.length
          })
        );
      }
    })
  };
}, $b = (e) => {
  switch (e.key) {
    case "ArrowDown":
    case "ArrowRight":
      return "next";
    case "ArrowUp":
    case "ArrowLeft":
      return "previous";
    default:
      return;
  }
}, Pb = ({
  event: e,
  onClick: t,
  onArrowNavigate: n
}) => {
  if (Fb(e)) return;
  const r = $b(e);
  if (r) {
    e.preventDefault(), n == null || n(r);
    return;
  }
  e.key !== "Enter" && e.key !== " " || (e.preventDefault(), t == null || t());
}, Fb = (e) => e.repeat || e.currentTarget.getAttribute("aria-disabled") === "true", Ns = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(
  ({ onClick: e, checked: t, label: n, disabled: r, tabIndex: s = 0, labelVariant: o = "caption2", describedBy: i, onArrowNavigate: c }, l) => {
    const u = t ? b.themedColor.primary : r ? b.themedColor.textDisabled : b.themedColor.textLowEmphasis, d = t ? b.themedColor.textHighEmphasis : r ? b.themedColor.textLowEmphasis : b.themedColor.textHighEmphasis;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Hb,
      {
        ref: l,
        role: "radio",
        tabIndex: r ? -1 : s,
        "aria-checked": t,
        "aria-disabled": !!r,
        "aria-label": n,
        "aria-describedby": i,
        onClick: r ? void 0 : e,
        onKeyDown: (m) => Pb({
          event: m,
          onClick: e,
          onArrowNavigate: c
        })
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ub, { "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 20, type: t ? "radio-on" : "radio-off", color: u })),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Bb, { "aria-hidden": "true", variant: o, color: d }, n)
    );
  }
);
Ns.displayName = "Radio";
const Ub = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:20px;height:20px;`, Bb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`line-height:20px;word-break:break-word;`, Hb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:flex-start;justify-content:flex-start;gap:2px;${Ne}&[aria-disabled='false']{cursor:pointer;}`, Gb = ({ csatPayload: e, submitted: t, defaultValue: n, value: r, onChange: s }) => {
  var l, u;
  const o = [
    { label: ((l = e.cre) == null ? void 0 : l.positive_label) ?? "", value: !0 },
    { label: ((u = e.cre) == null ? void 0 : u.negative_label) ?? "", value: !1 }
  ], i = xc({
    options: o,
    value: r,
    disabled: t,
    onChange: s
  });
  if ((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    typeof r > "u" && typeof n == "boolean" && (s == null || s(n));
  }, [r, n]), !e.cre) return null;
  const c = e.cre;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Label, { required: c.required, "aria-hidden": !0 }, c.question), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zb, { ...i.radioGroupProps(c.question) }, o.map((d, m) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Ns,
    {
      key: d.label,
      checked: r === d.value,
      label: d.label,
      disabled: t,
      ...i.getRadioProps(m),
      onClick: () => s == null ? void 0 : s(d.value)
    }
  ))));
}, Vb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, zb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, Kb = ({
  followUpItem: e,
  submitted: t,
  value: n = "",
  onChange: r,
  hasError: s
}) => {
  const { stringSet: o } = fe(), { conversation: i } = pe(), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), u = e.response_type !== "free_text", d = e.response_type === "single_choice" ? e.options.map((h) => ({
    label: h,
    value: h
  })) : [], m = xc({
    options: d,
    value: n,
    disabled: t,
    hasError: s,
    errorId: c,
    onChange: r
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Label, { id: l, required: e.required, "aria-hidden": u }, e.question), e.response_type === "free_text" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Fe.TextInput,
    {
      variant: "multi-line",
      disabled: t,
      submitted: t,
      maxLength: 100,
      value: n,
      onChange: (h) => r(h),
      error: s,
      ...i.form.textInput(
        o.A11Y_CSAT_TEXT_INPUT_LABEL,
        e.required ?? !1,
        t,
        {
          labelId: l
        }
      ).props,
      "aria-invalid": s,
      "aria-errormessage": s ? c : void 0
    }
  ), e.response_type === "single_choice" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Yb, { ...m.radioGroupProps(e.question) }, d.map((h, g) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Ns,
    {
      key: h.value,
      checked: n === h.value,
      label: h.label,
      disabled: t,
      ...m.getRadioProps(g),
      onClick: () => r == null ? void 0 : r(h.value),
      labelVariant: "body3"
    }
  ))), s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(qb, { role: "alert", id: c }, o.FORM_VALIDATION_REQUIRED));
}, Wb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, Yb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, qb = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Fe.ErrorLabel)``, jb = ({ value: e, selected: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xb, { $selected: t, "aria-hidden": "true" }, Zb[e - 1]), Xb = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`user-select:none;-webkit-user-drag:none;width:40px;height:40px;aspect-ratio:1;opacity:${({ $selected: e }) => e ? 1 : 0.38};`, Zb = [
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M2.08337 19.9999C2.08337 10.1048 10.1049 2.08325 20 2.08325C29.8952 2.08325 37.9167 10.1048 37.9167 19.9999C37.9167 29.8951 29.8952 37.9166 20 37.9166C10.1049 37.9166 2.08337 29.8951 2.08337 19.9999Z",
      fill: "url(#paint0_linear_159_173206)"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5828 29.3328C13.1348 29.7473 13.9184 29.636 14.3329 29.084C15.6272 27.3607 17.6839 26.25 20 26.25C22.3164 26.25 24.373 27.3607 25.6672 29.084C26.0819 29.636 26.8654 29.7473 27.4175 29.3328C27.9695 28.9182 28.0809 28.1347 27.6662 27.5825C25.9202 25.2577 23.136 23.75 20 23.75C16.8642 23.75 14.0801 25.2577 12.334 27.5825C11.9194 28.1347 12.0308 28.9182 12.5828 29.3328Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M28.4454 13.7707C29.1329 13.8328 29.6405 14.4406 29.5785 15.1281C29.5165 15.8153 28.9095 16.3221 28.2224 16.2608C28.2224 16.2608 28.0287 16.2502 27.9272 16.2487C27.7229 16.2457 27.4387 16.2509 27.1229 16.2833C26.7869 16.3177 26.4649 16.3782 26.1804 16.4662L26.3045 16.86C26.7797 18.3675 25.5099 19.5813 24.2062 19.5813C23.5045 19.5813 22.8324 19.2617 22.43 18.6857C22.003 18.0745 21.9422 17.241 22.408 16.5344C22.751 16.0143 23.2449 15.3831 23.8964 14.8657C24.836 14.1195 26.044 13.8809 26.8675 13.7963C27.3029 13.7517 28.0154 13.7319 28.4454 13.7707Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M11.5549 13.7707C10.8674 13.8328 10.3597 14.4406 10.4218 15.1281C10.4838 15.8153 11.0908 16.3221 11.7779 16.2608C11.7779 16.2608 11.9716 16.2502 12.073 16.2487C12.2774 16.2457 12.5616 16.2509 12.8774 16.2833C13.2134 16.3177 13.5353 16.3782 13.8199 16.4662L13.6958 16.86C13.2205 18.3675 14.4904 19.5813 15.794 19.5813C16.4958 19.5813 17.168 19.2617 17.5703 18.6857C17.9971 18.0745 18.0581 17.241 17.5921 16.5344C17.2493 16.0143 16.7553 15.3831 16.1039 14.8657C15.1643 14.1195 13.9562 13.8809 13.1327 13.7963C12.6974 13.7517 11.9849 13.7319 11.5549 13.7707Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "linearGradient",
    {
      id: "paint0_linear_159_173206",
      x1: "20",
      y1: "2.08325",
      x2: "20",
      y2: "37.9166",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", { stopColor: "#FF2D1D" }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", { offset: "1", stopColor: "#FFA540" })
  ))),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M2.083 20C2.083 10.105 10.105 2.083 20 2.083c9.895 0 17.917 8.021 17.917 17.917 0 9.895-8.022 17.917-17.917 17.917C10.105 37.917 2.083 29.895 2.083 20Z",
      fill: "#FFD46E"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M14.249 27.334C15.851 26.13 17.844 25.417 20 25.417c2.156 0 4.149.714 5.751 1.917.553.415.664 1.199.25 1.751-.415.552-1.199.664-1.751.25-1.183-.889-2.652-1.416-4.25-1.416s-3.067.527-4.25 1.416c-.553.414-1.336.302-1.751-.25-.415-.552-.303-1.336.249-1.751Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M23.445 14.596c-.687.062-1.294-.445-1.356-1.132-.062-.687.445-1.295 1.132-1.357.082-.005.342-.02.482-.022.277-.004.662.002 1.097.047.823.085 2.031.323 2.97 1.07.652.518 1.146 1.15 1.489 1.67.466.706.405 1.54-.022 2.15-.402.576-1.074.896-1.775.896-1.304 0-2.573-1.214-2.098-2.722l.125-.394c-.285-.088-.607-.148-.942-.182-.316-.033-.6-.038-.804-.035-.101.002-.242.01-.294.013Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M11.779 14.596c-.687.062-1.294-.445-1.356-1.132-.062-.687.445-1.295 1.132-1.357.082-.005.342-.02.482-.022.277-.004.662.002 1.097.047.823.085 2.031.323 2.97 1.07.652.518 1.146 1.15 1.489 1.67.466.706.405 1.54-.022 2.15-.402.576-1.074.896-1.775.896-1.304 0-2.573-1.214-2.098-2.722l.124-.394c-.284-.088-.606-.148-.941-.182-.316-.033-.6-.038-.804-.035-.101.002-.243.01-.294.013Z",
      fill: "#141B34"
    }
  )),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M2.083 20C2.083 10.105 10.105 2.083 20 2.083c9.895 0 17.917 8.021 17.917 17.917 0 9.895-8.022 17.917-17.917 17.917C10.105 37.917 2.083 29.895 2.083 20Z",
      fill: "#FFD46E"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.25 15c0-1.151.933-2.083 2.083-2.083h.015c1.151 0 2.084.933 2.084 2.083 0 1.151-.933 2.083-2.084 2.083h-.015c-1.15 0-2.083-.933-2.083-2.083ZM24.568 15c0-1.151.933-2.083 2.084-2.083h.015c1.151 0 2.083.933 2.083 2.083 0 1.151-.932 2.083-2.083 2.083h-.015c-1.151 0-2.084-.933-2.084-2.083Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.75 26.667c0-.691.56-1.25 1.25-1.25h10c.69 0 1.25.559 1.25 1.25 0 .691-.56 1.25-1.25 1.25h-10c-.69 0-1.25-.559-1.25-1.25Z",
      fill: "#141B34"
    }
  )),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M2.083 20C2.083 10.105 10.105 2.083 20 2.083c9.895 0 17.917 8.021 17.917 17.917 0 9.895-8.022 17.917-17.917 17.917C10.105 37.917 2.083 29.895 2.083 20Z",
      fill: "#FFD46E"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.583 24.001c.552-.414 1.335-.302 1.75.25 1.294 1.723 3.35 2.834 5.667 2.834s4.373-1.11 5.667-2.834c.415-.552 1.199-.664 1.751-.25.552.415.664 1.199.25 1.751C25.92 28.076 23.136 29.584 20 29.584s-5.92-1.508-7.666-3.832c-.415-.552-.303-1.336.249-1.751Z",
      fill: "#141B34"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.25 15c0-1.151.933-2.083 2.083-2.083h.015c1.151 0 2.084.933 2.084 2.083 0 1.151-.933 2.083-2.084 2.083h-.015c-1.15 0-2.083-.933-2.083-2.083ZM24.568 15c0-1.151.933-2.083 2.084-2.083h.015c1.151 0 2.083.933 2.083 2.083 0 1.151-.932 2.083-2.083 2.083h-.015c-1.151 0-2.084-.933-2.084-2.083Z",
      fill: "#141B34"
    }
  )),
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", fill: "none" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M2.083 20C2.083 10.105 10.105 2.083 20 2.083c9.895 0 17.917 8.021 17.917 17.917 0 9.895-8.022 17.917-17.917 17.917C10.105 37.917 2.083 29.895 2.083 20Z",
      fill: "#FFD46E"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: "url(#clip0_159_173224)" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { clipPath: "url(#clip1_159_173224)" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M20 30.624c3.752 0 6.904-2.532 7.789-5.956.412-1.593-.185-1.959-1.76-1.959H13.973c-1.575 0-2.173.366-1.761 1.959.885 3.424 4.037 5.956 7.788 5.956Z",
      fill: "#141B34"
    }
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "mask",
    {
      id: "mask0_159_173224",
      style: { maskType: "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "12",
      y: "22",
      width: "16",
      height: "9"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "path",
      {
        d: "M20 30.624c3.752 0 6.904-2.532 7.789-5.956.412-1.593-.185-1.959-1.76-1.959H13.973c-1.575 0-2.173.366-1.761 1.959.885 3.424 4.037 5.956 7.788 5.956Z",
        fill: "#141B34"
      }
    )
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { mask: "url(#mask0_159_173224)" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M20 32.998c3.278 0 5.936-1.594 5.936-3.561 0-1.968-2.658-3.562-5.936-3.562-3.278 0-5.936 1.594-5.936 3.562 0 1.967 2.658 3.561 5.936 3.561Z",
      fill: "#FF493B"
    }
  ))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "path",
    {
      d: "M11.667 15.833c0-1.381 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5M23.333 15.833c0-1.381 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5",
      stroke: "#141B34",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: "clip0_159_173224" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: "15.83", height: "7.915", fill: "white", transform: "translate(12.085 22.709)" })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: "clip1_159_173224" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: "15.83", height: "7.915", fill: "white", transform: "translate(12.085 22.709)" }))))
], Jb = ({ csatPayload: e, submitted: t, value: n, onChange: r }) => {
  const s = typeof n > "u", { conversation: o } = pe(), i = o.csat.scoresContainer(e.csat_question);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(eS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption3", color: b.themedColor.textMidEmphasis, "aria-hidden": "true" }, e.csat_question), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tS, { ...i.props }, i.descriptionNode, e.csat_scores.map(({ label: c, image_url: l }, u) => {
    const d = u + 1, m = n === d, h = e.csat_scores.length, g = o.csat.scoreItem({
      score: d,
      label: c,
      selected: m,
      disabled: t,
      currentIndex: u,
      totalCount: h,
      hasSelection: !s,
      onChange: r
    });
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nS, { key: u, type: "button", ...g.props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qb, { value: d, selected: s || m, src: l }), !!c && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      G,
      {
        "aria-hidden": "true",
        color: m ? b.themedColor.textHighEmphasis : b.themedColor.textLowEmphasis,
        variant: "caption3"
      },
      c
    ), g.descriptionNode);
  })));
}, Qb = ({ value: e, src: t, selected: n }) => {
  const [r, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), o = r ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jb, { value: e, selected: n }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sS, { $selected: n, alt: "", "aria-hidden": "true", src: t, onError: () => s(!0) });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rS, null, o);
}, eS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;`, tS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;justify-content:space-between;align-self:center;width:100%;max-width:400px;gap:16px;`, nS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`appearance:none;-webkit-appearance:none;background-color:transparent;border:none;padding:0;text-align:center;gap:4px;display:flex;flex-direction:column;align-items:center;justify-content:start;box-sizing:border-box;min-width:48px;max-width:68px;${Ne}&:not(:disabled):hover span{color:${b.themedColor.textHighEmphasis};}`, rS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`button:not(:disabled):hover &{border-radius:4px;cursor:pointer;background-color:${b.color.background200};${ie.dark`
      background-color: ${b.color.background500};
    `}
  }
`, sS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].img */ .ZP.img`user-select:none;-webkit-user-drag:none;width:40px;height:40px;aspect-ratio:1;opacity:${({ $selected: e }) => e ? 1 : 0.38};`, oS = ({ csatPayload: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.themedColor.textHighEmphasis }, e.title), Mr = ({
  csatPayload: e,
  type: t,
  renderSubmitButton: n,
  initialCsat: r,
  initialCsatReason: s,
  initialIsResolved: o
}) => {
  const { params: i, setParams: c, error: l, setError: u, followUpItem: d, state: m, validateParams: h, itemProps: g } = Lg({
    csatPayload: e,
    type: t,
    initialCsat: r,
    initialCsatReason: s,
    initialIsResolved: o
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(iS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oS, { ...g }), t === gt.AI_AGENT_CSAT_5_WITH_CRE && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Gb,
    {
      ...g,
      defaultValue: o,
      value: i.isResolved,
      onChange: (f) => c({ isResolved: f })
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Jb, { ...g, value: i.csat, onChange: (f) => c({ csat: f }) }), d && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Kb,
    {
      ...g,
      followUpItem: d,
      value: i.csatReason,
      onChange: (f) => {
        c({ csatReason: f }), u({ followUpItem: !1 });
      },
      hasError: l.followUpItem
    }
  )), m !== "unsubmittable" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe.Separator, null), n({ state: m, params: i, validateParams: h })));
}, iS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:12px;`, aS = (e) => {
  const { stringSet: t } = fe();
  return Lu(e, {
    title: t.CSAT_TITLE_UNSUBMITTED,
    question: t.CSAT_RATING_TITLE,
    cre: {
      question: t.CSAT_CRE_TITLE,
      positive_label: t.CSAT_CRE_SOLVED,
      negative_label: t.CSAT_CRE_NOT_SOLVED
    },
    followUp: {
      question: t.CSAT_REASON_PLACEHOLDER
    },
    submit_label: t.CSAT_SUBMIT_LABEL,
    submitted_label: t.CSAT_TITLE_SUBMITTED
  });
}, cS = () => {
  const { stringSet: e } = fe();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body2", color: b.themedColor.textMidEmphasis, style: { textAlign: "center" } }, e.CSAT_SUBMISSION_EXPIRED);
}, lS = ({ onMount: e, children: t }) => ((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
  e && Oe(e);
}, []), t), uS = (e) => {
  const { conversation: t } = pe();
  if (e.messageType !== "admin.csat")
    throw new Error("Invalid message type");
  const { extendedMessagePayload: n, onSubmitCSAT: r, onScrollToBottom: s } = e, { csat: o, csatReason: i, csatExpireAt: c, isResolvedWhenDeterminedByUser: l } = e, u = er(), d = aS(n == null ? void 0 : n.csat), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [g, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    Oe(() => {
      var I;
      return (I = h.current) == null ? void 0 : I.focus();
    });
  }, []), { isExpiredNow: p, isRenderableCSAT: y } = Og({ csat: o, csatExpireAt: c, csatPayload: d, isSubmitInFlight: g });
  if (wg({
    csat: o,
    csatPayload: d,
    isRenderableCSAT: y,
    isExpiredNow: p,
    announceStatus: e.announceStatus,
    onSubmittedAnnounced: _
  }), !y || !d) return null;
  const S = () => {
    var k;
    const I = (k = m.current) == null ? void 0 : k.querySelector('[aria-invalid="true"]');
    return I ? I.getAttribute("role") === "radiogroup" ? I.querySelector('[role="radio"]') : I : null;
  }, A = d.type === gt.AI_AGENT_CSAT_5 || d.type === gt.AI_AGENT_CSAT_5_WITH_CRE || d.type === gt.HELPDESK_CSAT_5 ? Mr : () => null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(dS, { ref: m }, !o && p ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cS, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    A,
    {
      csatPayload: d,
      type: d.type,
      initialCsat: o,
      initialCsatReason: i,
      initialIsResolved: l,
      renderSubmitButton: ({ state: I, params: k, validateParams: N }) => I === "submitted" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        hS,
        {
          ref: h,
          role: "status",
          "aria-live": "polite",
          "aria-atomic": "true",
          "aria-label": d.csat_submitted_label,
          tabIndex: -1
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", "aria-hidden": "true" }, d.csat_submitted_label)
      ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lS, { onMount: s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        mS,
        {
          type: "button",
          ...t.csat.submitButton(d.csat_submit_label).props,
          onClick: async () => {
            if (v.current) return;
            const R = Zi(c);
            if (!R && N()) {
              v.current = !0, f(!0);
              try {
                await r(k);
              } catch (M) {
                throw v.current = !1, f(!1), M;
              }
            } else
              u(), R || Oe(() => {
                var M;
                (M = e.announceError) == null || M.call(e, { type: "csatFormError" }, S());
              });
          }
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button" }, d.csat_submit_label)
      ))
    }
  ));
}, dS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;background-color:${({ theme: e }) => e.colors.csat.background};border-radius:16px;gap:16px;padding:16px;`, mS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;width:100%;box-sizing:border-box;background-color:${({ theme: e }) => e.colors.base.primary};color:${({ theme: e }) => e.colors.base.primaryContrastContent};border-radius:6px;padding:10px 20px;display:flex;align-items:center;justify-content:center;cursor:pointer;text-align:center;word-break:break-word;${Ne}&:hover{background-color:${b.color.primary.dark};}`, hS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:100%;box-sizing:border-box;color:${b.themedColor.textHighEmphasis};background-color:${b.color.background200};border-radius:6px;padding:10px 20px;display:flex;align-items:center;justify-content:center;text-align:center;word-break:break-word;${ie.dark`
    background-color: ${b.color.onlight.textDisabled};
  `}
`, gS = (e) => {
  const { components: t } = Ds.useContext(), n = e.messageType === "admin" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.AdminMessage, { ...e }) : e.messageType === "admin.csat" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.CSATMessage, { ...e }) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(fS, { $marginBottom: Qn(e.groupType) }, n);
}, Ds = ot({
  template: gS,
  components: {
    AdminMessage: kb,
    CSATMessage: uS
  }
}), fS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding-inline:${ae.HORIZONTAL_PADDING}px;margin-bottom:${({ $marginBottom: e }) => e}px;`, $s = ({
  title: e,
  titleId: t,
  description: n,
  descriptionId: r,
  negativeText: s,
  positiveText: o,
  onCancel: i,
  onConfirm: c,
  buttonLayout: l = "horizontal",
  styles: u
}) => {
  const d = s !== void 0 && i !== void 0, m = o !== void 0 && c !== void 0, h = d ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    vS,
    {
      type: "button",
      onClick: i,
      $fullWidth: l !== "horizontal",
      $background: u == null ? void 0 : u.negativeBackground,
      $borderColor: u == null ? void 0 : u.negativeBorderColor
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: (u == null ? void 0 : u.negativeText) ?? b.themedColor.textHighEmphasis }, s)
  ) : null, g = m ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    bS,
    {
      type: "button",
      onClick: c,
      $fullWidth: l !== "horizontal",
      $background: u == null ? void 0 : u.positiveBackground,
      $borderColor: u == null ? void 0 : u.positiveBorderColor
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: (u == null ? void 0 : u.positiveText) ?? b.themedColor.textHighEmphasisInverse }, o)
  ) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_S, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    G,
    {
      as: "div",
      id: t,
      variant: "h2",
      color: (u == null ? void 0 : u.titleColor) ?? b.themedColor.textHighEmphasis
    },
    e
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ES, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    G,
    {
      as: "div",
      id: r,
      variant: "body3",
      color: (u == null ? void 0 : u.descriptionColor) ?? b.themedColor.textMidEmphasis
    },
    n
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CS, { $buttonLayout: l }, l === "horizontal" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, h, g) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, g, h)));
}, pS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;width:280px;border-radius:16px;overflow:hidden;background-color:${({ theme: e }) => e.colors.base.modalContentBackground};`, _S = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding:24px 24px 16px;`, ES = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding-inline:24px;`, CS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:${({ $buttonLayout: e }) => e === "vertical-full-width" ? "column" : "row"};align-items:center;justify-content:flex-end;gap:4px;padding:16px 24px;`, vS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:${({ $fullWidth: e }) => e ? "100%" : "auto"};padding:12px 20px;border-radius:20px;cursor:pointer;border:1px solid ${({ $borderColor: e }) => e ?? "transparent"};background:${({ $background: e }) => e ?? "none"};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:hover{opacity:0.8;}`, bS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:${({ $fullWidth: e }) => e ? "100%" : "auto"};padding:12px 20px;border-radius:20px;cursor:pointer;border:1px solid ${({ $borderColor: e }) => e ?? "transparent"};background-color:${({ $background: e }) => e ?? b.themedColor.textHighEmphasis};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:hover{opacity:0.8;}`, On = 16, SS = ({ status: e }) => e === Bn.COMPLETED ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "done-circle", size: On, color: b.themedColor.textHighEmphasis }) : e === Bn.CANCELED ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "stop-circle", size: On, color: b.themedColor.textLowEmphasis }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: On }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", size: On, color: b.themedColor.textHighEmphasis })), Mc = 24, yS = 8, AS = 40, TS = ({ task: e, isFirst: t, isLast: n }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IS, { role: "listitem" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(xS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pi, { $hidden: t }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SS, { status: e.status })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pi, { $hidden: n })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  G,
  {
    as: "div",
    variant: "body3",
    color: e.status === Bn.CANCELED ? b.themedColor.textLowEmphasis : b.themedColor.textHighEmphasis
  },
  e.user_facing_title
))), IS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:4px;`, xS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;align-items:center;width:${Mc}px;flex-shrink:0;`, pi = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:1px;flex:1;transform:translateX(-25%);${({ $hidden: e }) => e && "visibility: hidden;"}background-image:repeating-linear-gradient( to bottom,${b.themedColor.textHighEmphasis}0 2px,transparent 2px 4px );`, MS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;height:${Mc}px;align-items:center;justify-content:center;`, RS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex:1;align-items:center;box-sizing:border-box;min-width:0;min-height:${AS}px;padding-block:${yS}px;`, wS = ({ steward: e, onCancelSteward: t }) => {
  const { logger: n } = Ee(), [r, s] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), c = !!e.cancellation_option, l = zl(e.status);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(kS, { $marginBottom: Qn("single") }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { as: "div", variant: "caption1", color: b.themedColor.textHighEmphasis }, e.title), !!e.description && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { as: "div", variant: "caption4", color: b.themedColor.textLowEmphasis }, e.description)), c && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    FS,
    {
      type: "button",
      "aria-label": "Stop steward",
      disabled: o,
      onClick: () => s(!0)
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      oe,
      {
        type: "stop",
        size: 16,
        color: o ? b.themedColor.textDisabled : b.themedColor.textHighEmphasis
      }
    )
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DS, null), e.tasks.length === 0 ? l !== an.IN_PROGRESS ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PS, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: 16 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "spinner", size: 16, color: b.themedColor.textHighEmphasis }))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($S, { role: "list" }, e.tasks.map((u, d) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    TS,
    {
      key: u.id,
      task: u,
      isFirst: d === 0,
      isLast: d === e.tasks.length - 1
    }
  )))), r && e.cancellation_option && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tt, { portalContainerId: Me.WINDOW, visible: r, onClose: () => s(!1) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    $s,
    {
      title: e.cancellation_option.title,
      description: e.cancellation_option.description,
      negativeText: e.cancellation_option.negative_text,
      positiveText: e.cancellation_option.positive_text,
      onCancel: () => s(!1),
      onConfirm: async () => {
        s(!1), i(!0);
        try {
          await (t == null ? void 0 : t());
        } catch (u) {
          n.warn("steward.cancelSteward: failed", u);
        } finally {
          i(!1);
        }
      }
    }
  )));
}, kS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;margin:0 ${ae.HORIZONTAL_PADDING}px;margin-bottom:${({ $marginBottom: e }) => `${e}px`};
`, LS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;border-radius:12px;overflow:hidden;padding:16px;border:1px solid ${b.themedColor.bg_300_500};background-color:${b.themedColor.bg_50_600};box-shadow:0 8px 20px rgba(0,0,0,0.12);`, OS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;align-items:flex-start;gap:8px;`, NS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:4px;flex:1;min-width:0;`, DS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`height:1px;margin-block:12px;background-color:${b.themedColor.bg_200_400};`, $S = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;`, PS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;width:100%;height:40px;align-items:center;justify-content:center;`, FS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;border:none;cursor:pointer;color:${b.themedColor.textHighEmphasis};background-color:${b.themedColor.bg_200_400};&:hover:not(:disabled){opacity:0.8;}&:disabled{cursor:default;}`, US = ({ className: e, label: t, onClick: n }) => {
  const { colors: r } = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), { conversation: s } = pe(), o = {
    newMessages: s.newMessagesButton()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BS, { className: e, onClick: n, ...o.newMessages.props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: r.base.primaryContrastContent }, t), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: "chevron-down", color: r.base.primaryContrastContent }), o.newMessages.descriptionNode);
}, BS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;cursor:pointer;display:flex;align-items:center;gap:4px;padding:10px 12px 10px 16px;border-radius:24px;background-color:${({ theme: e }) => e.colors.base.primary};box-shadow:0 8px 10px 1px rgba(13,13,13,0.12),0 3px 14px 2px rgba(13,13,13,0.08),0 3px 5px -3px rgba(13,13,13,0.04);&:focus{outline:none;}${Ne}`, Ps = ({ iconSize: e = 64, icon: t, className: n, label: r, children: s }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GS, { className: n }, t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: t, size: e, color: b.themedColor.textLowEmphasis }), r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body1", color: b.themedColor.textMidEmphasis }, r), s), HS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;display:flex;justify-content:center;align-items:center;width:100%;height:100%;`, GS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;min-height:104px;align-items:center;gap:20px;text-align:center;`, VS = ({
  label: e = "Something went wrong",
  icon: t = "error",
  action: n,
  ...r
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ps, { icon: t, label: e, ...r }, n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zS, { onClick: n.onClick, label: n.label ?? "Retry" })), zS = ({ label: e, onClick: t }) => {
  const { conversation: n } = pe();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(KS, { tabIndex: 0, ...n.retryButton(e).props, onClick: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "refresh", size: 20 }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "button", color: b.color.primary.main }, e));
}, KS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;display:flex;cursor:pointer;gap:4px;align-items:center;justify-content:center;${Ne}`, WS = ({ iconSize: e = 48, className: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($t, { size: e, className: t }), YS = ({ label: e = "No channels", icon: t = "chat", ...n }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ps, { icon: t, label: e, ...n }), qS = ({
  label: e = "No messages",
  icon: t = "message",
  ...n
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ps, { icon: t, label: e, ...n }), jS = (e) => {
  const { components: t } = Fs.useContext(), n = e.type === "loading" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Loading, { ...e }) : e.type === "error" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Error, { ...e }) : e.type === "noChannels" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.NoChannels, { ...e }) : e.type === "noMessages" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.NoMessages, { ...e }) : null;
  return n && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HS, null, n);
}, Fs = ot({
  template: jS,
  components: {
    Loading: WS,
    Error: VS,
    NoChannels: YS,
    NoMessages: qS
  }
}), ln = (e) => {
  const { Template: t } = Fs.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, { ...e });
}, XS = [0, 150, 450];
function ZS({ enabled: e }) {
  const { state: t, actions: n } = nc(), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t.isAwayFromBottom);
  s.current = t.isAwayFromBottom, (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e) {
      r.current += 1;
      return;
    }
    const o = r.current + 1;
    r.current = o;
    const i = XS.map((c) => setTimeout(() => {
      Oe(() => {
        r.current === o && (s.current || n.scrollToBottom(!1));
      });
    }, c));
    return () => {
      r.current += 1, i.forEach((c) => clearTimeout(c));
    };
  }, [n.scrollToBottom, e]);
}
const JS = ({ className: e, date: t = Date.now(), role: n, style: r }) => {
  const { format: s, stringSet: o } = fe();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QS, { id: `${Ve}-date-separator`, role: n, style: r, className: e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption4", color: b.themedColor.textMidEmphasis }, s(t, o.DATE_FORMAT__MESSAGE_LIST__DATE_SEPARATOR)));
}, QS = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;justify-content:center;align-items:center;text-align:center;word-break:break-word;`, ey = ({ className: e, style: t, onClick: n }) => {
  const { conversation: r } = pe(), s = {
    scrollToBottom: r.scrollToBottomButton()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ty, { className: e, style: t, onClick: n, tabIndex: 0, ...s.scrollToBottom.props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 24, type: "chevron-down", color: b.color.primary.main }), s.scrollToBottom.descriptionNode ?? null);
}, ty = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;cursor:pointer;display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:24px;box-shadow:0 2px 8px 0 rgba(0,0,0,0.08),0 4px 6px 0 rgba(0,0,0,0.12);${ie.light`
    background-color: ${b.color.background50};
    &:hover {
      background-color: ${b.color.background100};
    }
    &:active {
      background-color: ${b.color.background200};
    }
  `}
  ${ie.dark`
    background-color: ${b.color.background400};
    &:hover {
      background-color: ${b.color.background500};
    }
    &:active {
      background-color: ${b.color.background700};
    }
  `}

  &:focus {
    outline: none;
  }

  ${Ne}
`, ny = () => null, Us = ot({
  template: ny,
  components: {
    DateSeparator: JS,
    ScrollToBottomButton: ey
  }
}), ry = () => {
  const { stringSet: e, format: t } = fe(), { agentPreviewConfigs: n = {}, aiAgentId: r } = Ee(), { aiAgentInfo: s } = Ge(), { messageSource: o } = De(), { Template: i } = kt.useContext(), { components: c } = Us.useContext(), l = n.welcomeMessages ?? [], u = o.messages, d = U_(u, r), m = u[d.length + 1], h = d[0] ?? m;
  return {
    /**
     * Returns a list of messages filtered according to business requirements.
     */
    filteredMessages: ac(u, {
      previewWelcomeMessages: l,
      aiAgentUserId: r
    }),
    /**
     * Determines whether to display the DateSeparator in the data list by comparing it with the welcome messages from Bot Studio.
     */
    shouldShowOriginalDate: (g) => g > 0 || l.length === 0 ? !0 : m && !(0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* .isSameDay */ .K)(m.createdAt, (h == null ? void 0 : h.createdAt) ?? 0),
    /**
     * Renders the list of welcome messages from Bot Studio.
     */
    renderAgentPreviewWelcomeMessages: () => l.length === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      c.DateSeparator,
      {
        role: "listitem",
        style: { margin: "16px 0" },
        date: h == null ? void 0 : h.createdAt
      }
    ), l.map((g, f) => {
      const v = f === l.length - 1, _ = d.length !== u.length, p = l.length === 1 ? "single" : f === 0 ? "top" : v || _ ? "bottom" : "middle", y = (h == null ? void 0 : h.createdAt) ?? Date.now();
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          key: f,
          role: "listitem",
          tabIndex: -1,
          "aria-label": cn({
            sender: (s == null ? void 0 : s.nickname) || "",
            message: g.message,
            messageFormat: "markdown",
            time: t(y, e.DATE_FORMAT__MESSAGE_TIMESTAMP),
            codeBlockPlaceholder: e.A11Y_CODE_BLOCK_PLACEHOLDER
          }),
          "data-message-listitem": ""
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          i,
          {
            messageType: "user",
            message: g.message,
            sender: s,
            groupType: p,
            createdAt: y,
            extendedMessagePayload: { suggested_replies: g.suggestedReplies },
            suggestedRepliesDirection: n.suggestedRepliesDirection,
            suggestedRepliesVisible: v && !_,
            isBotMessage: !0,
            onClickSuggestedReply: async ({ reply: S }) => {
              o.sendUserMessage({ message: S });
            }
          }
        )
      );
    }))
  };
}, sy = () => {
  const { messageSource: e, scrollSource: t } = De();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    !t.state.isAwayFromBottom && t.state.isScrollPositionReconciled && e.resetNewMessages();
  }, [t.state.isAwayFromBottom, t.state.isScrollPositionReconciled]);
}, _i = "https://delight.ai?utm_medium=product&utm_source=aiagent&utm_campaign=fy26-glbl-ai-agent-poweredby", oy = ({ style: e }) => {
  const { stringSet: t } = fe(), { handlers: n } = Ee(), { conversation: r } = pe();
  return Cs("powered-by") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(iy, { variant: "caption2", style: e }, t.POWERED_BY + " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    ay,
    {
      variant: "caption2",
      forwardedAs: "a",
      href: _i,
      ...r.poweredByLink().props,
      rel: Hf,
      target: "_blank",
      onClick: (o) => {
        o.preventDefault(), n.onClickLink({ url: _i });
      }
    },
    "Sendbird"
  )) : null;
}, iy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`color:${b.themedColor.textLowEmphasis};text-align:center;`, ay = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`color:${b.themedColor.textLowEmphasis};cursor:pointer;text-decoration:none;`, cy = () => {
  var c;
  const { stringSet: e } = fe(), { conversation: t } = pe(), { channelSource: n, goToActiveConversation: r, scrollSource: s } = De(), o = He(n.channel), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(o);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!i.current && o) {
      const d = setTimeout(() => {
        s.actions.scrollToBottom();
      }, 100);
      return () => clearTimeout(d);
    }
    i.current = o;
  }, [o, s.actions.scrollToBottom]), !((c = n.channel) != null && c.isAIAgent) || !o ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ly, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    uy,
    {
      variant: "button",
      color: b.themedColor.textHighEmphasis,
      ...t.startNewConversationButton({ onActivate: r }).props
    },
    e.TALK_TO_AGENT
  ));
}, ly = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;justify-content:center;margin-bottom:16px;`, uy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`border-radius:6px;box-sizing:border-box;padding:10px 20px;cursor:pointer;user-select:none;background-color:${b.color.background50};border:1px solid ${b.color.onlight.textDisabled};${ie.dark`
    background-color: ${b.color.background700};
    border-color: ${b.color.ondark.textLowEmphasis};
  `}
`, dy = ({ statsCallbacks: e, ...t }) => (Kg(e), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wS, { ...t })), my = (e, t, n) => t && Re.isWelcomeMessage(e, n) && Re.isWelcomeMessage(t, n) ? !1 : !(0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* .isSameDay */ .K)((t == null ? void 0 : t.createdAt) ?? 0, e.createdAt), hy = () => {
  var he;
  const { Template: e } = Sn.useContext(), { Template: t } = kt.useContext(), { Template: n } = Ds.useContext(), { components: r } = Us.useContext(), { stringSet: s, format: o } = fe(), { announceError: i, announceStatus: c } = _t(), { messageList: l } = pe().conversation, { config: u, cache: d, agentPreviewConfigs: m, chatSDK: h, handlers: g, state: f, _aiAgentSDK: v } = Ee(), { userSession: _, aiAgentInfo: p, connectionError: y } = Ge(), {
    _statsEnabled: S,
    _stats: A,
    conversation: I,
    channelSource: k,
    messageSource: N,
    scrollSource: R,
    state: { input: M, streamAnimation: B }
  } = De(), { filteredMessages: P, shouldShowOriginalDate: ne, renderAgentPreviewWelcomeMessages: ce } = ry(), X = zg({ enabled: S }), J = Ig(
    Ea(k.channel),
    iu(P, _.userId)
  ), [U, Y] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [q, j] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), V = He(k.channel) ? void 0 : J ?? B.heldTypingInfo;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    R.actions.onTypingIndicatorUpdate(!!V);
  }, [!!V, R.actions.onTypingIndicatorUpdate]), sy(), ZS({
    enabled: N.initialized && N.messages.length > 0
  });
  const z = ($) => {
    var Ie;
    return Kl($, { aiAgentInfo: p, members: (Ie = k.channel) == null ? void 0 : Ie.members });
  }, W = ($) => {
    if ($.sendingStatus === "failed" && !M.disabled)
      return () => j($);
  }, se = ({ message: $, index: Ie }) => {
    const ke = Wl($), Pe = P[Ie - 1], x = P[Ie + 1], O = P[P.length - 1], F = $ === O, H = ze($, p.userId), te = !(p.isUserFeedbackEnabled && H && !Re.isWelcomeMessage($)), ue = Yl($, Pe, x, te), re = my($, Pe, p.userId) && ne(Ie), ye = (Be) => {
      Y({
        files: Be.files.map((at) => ({ ...at, timestamp: $.createdAt })),
        index: Be.index
      });
    }, K = (Be) => {
      ye({ files: [Be], index: 0 });
    }, Ce = re ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(r.DateSeparator, { role: "listitem", style: { margin: "16px 0" }, date: $.createdAt }) : null, ve = {
      data: $.data,
      maxBodyWidth: f.expanded ? ae.WIDE_BODY_MAX_WIDTH : void 0,
      extendedMessagePayload: $.extendedMessagePayload,
      createdAt: $.createdAt,
      groupType: ue,
      onClickMedia: K,
      onClickMediaFiles: ye,
      onClickFile: g.onClickLink,
      onClickCTA: g.onClickLink,
      onClickCitation: (Be) => g.onClickLink({ url: Be.link }),
      onClickLink: g.onClickLink
    }, de = () => {
      if ($e.isOutgoing($, _.userId))
        return "outgoingmessage";
      if ($e.isIncoming($, _.userId))
        return "incomingmessage";
    }, Se = $.createdAt != null && $.createdAt !== 0 ? o($.createdAt, s.DATE_FORMAT__MESSAGE_TIMESTAMP) : void 0, _e = (() => {
      var at;
      const Be = (at = $.message) == null ? void 0 : at.trim();
      return $.isFileMessage() || $.isMultipleFilesMessage() ? Ur(
        xa($, lc(s))
      ) : Be ? Ef({ markdownText: Be }) : Ur("");
    })(), Te = (() => {
      if ($e.isAdmin($))
        return cn({
          message: _e.text,
          messageFormat: _e.format,
          codeBlockPlaceholder: s.A11Y_CODE_BLOCK_PLACEHOLDER
        });
      if ($e.isOutgoing($, _.userId))
        return cn({
          sender: s.A11Y_MESSAGE_SENDER_YOU,
          message: _e.text,
          messageFormat: "plain",
          time: Se,
          codeBlockPlaceholder: s.A11Y_CODE_BLOCK_PLACEHOLDER
        });
      if ($e.isIncoming($, _.userId))
        return cn({
          sender: z($).nickname,
          message: _e.text,
          messageFormat: _e.format,
          time: Se,
          codeBlockPlaceholder: s.A11Y_CODE_BLOCK_PLACEHOLDER
        });
    })(), Ke = (() => {
      var Be, at;
      if ($e.isAdmin($))
        return $e.isCSAT($) ? I ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          n,
          {
            ...ve,
            ...I,
            isResolvedWhenDeterminedByUser: wu(I),
            messageType: "admin.csat",
            announceError: i,
            announceStatus: c,
            onSubmitCSAT: async (ut) => {
              var dt;
              await ((dt = k.channel) == null ? void 0 : dt.submitCSAT(ut));
            },
            onScrollToBottom: () => R.actions.scrollToBottom()
          }
        ) : null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, { ...ve, messageType: "admin", message: $.message });
      if ($e.isSteward($)) {
        const ut = X({
          message: $,
          isBotMessage: H,
          aiAgentUserId: p.userId
        });
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          dy,
          {
            steward: $.extendedMessagePayload.steward,
            statsCallbacks: ut,
            onCancelSteward: async () => {
              await h.aiAgent.cancelStewardTask({
                channelUrl: $.channelUrl,
                messageId: $.messageId
              });
            }
          }
        );
      }
      if ($e.isOutgoing($, _.userId)) {
        const ut = {
          ...ve,
          message: $.message,
          sender: z($),
          sendingStatus: $.sendingStatus,
          onClickFailedMessage: W($)
        };
        if ($.isUserMessage())
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e, { messageType: "user", ...ut });
        if ($.isFileMessage()) {
          const [dt, Et] = ((Be = $.metaArrays.find((be) => be.key === Bi)) == null ? void 0 : Be.value) ?? [];
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            e,
            {
              messageType: "file",
              file: $,
              metadata: {
                aspectRatio: dt && Et ? `${dt}/${Et}` : "1/1",
                localFile: (at = $.messageParams) == null ? void 0 : at.file
              },
              ...ut
            }
          );
        }
        if ($.isMultipleFilesMessage()) {
          const { files: dt, metadata: Et } = fi($);
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            e,
            {
              messageType: "multipleFiles",
              files: dt,
              metadata: Et,
              ...ut
            }
          );
        }
      }
      if ($e.isIncoming($, _.userId)) {
        const ut = Re.isStreaming($), dt = X({
          message: $,
          isBotMessage: H,
          aiAgentUserId: p.userId
        }), Et = {
          ...ve,
          statsCallbacks: dt,
          sender: z($),
          message: $.message,
          suggestedRepliesVisible: F,
          suggestedRepliesDirection: m == null ? void 0 : m.suggestedRepliesDirection,
          isBotMessage: H,
          isStreaming: ut,
          isHandedOff: ft(k.channel),
          isConversationClosed: He(k.channel),
          isFeedbackEnabled: p.isUserFeedbackEnabled,
          isFeedbackCommentEnabled: p.isUserFeedbackCommentOptionEnabled,
          isSenderAvatarVisible: u.conversation.list.senderAvatarEnabled,
          deferredMarkdownElements: u.conversation.list.deferredMarkdownElements,
          onClickSuggestedReply: async ({ reply: be }) => {
            N.sendUserMessage({ message: be });
          },
          onConfirmTicketClosure: async ({ ticketId: be, confirmed: Ye }) => {
            await v.confirmEndOfChat({ messageId: $.messageId, ticketId: be, confirmed: Ye });
          },
          onRequestMessageTemplate: async (be) => {
            const { template: Ye } = await h.aiAgent.getMessageTemplate(be);
            return d.template.set(be, Ye), Ye;
          },
          onGetCachedMessageTemplate: (be) => d.template.get(be),
          onHandleTemplateInternalAction: (be) => {
            if (be.type === "internal" && be.internalData) {
              const { method: Ye, payload: mt } = be.internalData;
              Ye === "message.send" && (mt != null && mt.message) && N.sendUserMessage({ message: mt.message });
            }
          },
          onFeedbackUpdate: (be) => {
            const Ye = {
              messageId: $.messageId,
              channelUrl: $.channelUrl
            };
            if (!be)
              return h.aiAgent.deleteMessageFeedback(Ye);
            const mt = { ...Ye, rating: FC(be.rating), comment: be.comment };
            return Re.hasFeedback($) ? h.aiAgent.updateMessageFeedback(mt) : h.aiAgent.createMessageFeedback(mt);
          },
          onSubmitForm: ({ key: be, data: Ye }) => h.aiAgent.submitForm({
            messageId: $.messageId,
            channelUrl: $.channelUrl,
            formKey: be,
            formData: Ye
          }),
          onCancelForm: ({ key: be }) => h.aiAgent.cancelForm({
            messageId: $.messageId,
            channelUrl: $.channelUrl,
            formKey: be
          }),
          onSendChallengeAction: ({ key: be, requestId: Ye, action: mt, data: sl }) => h.aiAgent.sendChallengeAction({
            channelUrl: $.channelUrl,
            key: be,
            requestId: Ye,
            action: mt,
            data: sl
          }),
          onStreamAnimationStart: () => {
            B.start($.messageId), A.onMessageLifecycleAnimationStart($.messageId);
          },
          onStreamAnimationProgress: () => {
            R.actions.onStreamingUpdate(!0);
          },
          onStreamAnimationComplete: ({ completed: be }) => {
            B.stop($.messageId), R.actions.onStreamingUpdate(!1), A.onMessageLifecycleAnimationComplete($.messageId, be);
          },
          onStreamAnimationHoldChange: (be) => {
            be ? B.holdStart($.messageId, {
              user: z($),
              isBot: H
            }) : B.holdStop($.messageId);
          }
        };
        if ($.isUserMessage())
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, { messageType: "user", ...Et });
        if ($.isFileMessage())
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, { messageType: "file", file: $, ...Et });
        if ($.isMultipleFilesMessage()) {
          const { files: be } = fi($);
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, { messageType: "multipleFiles", files: be, ...Et });
        }
      }
    })(), We = B.isHolding($.messageId), rt = l.item({ label: Te, holding: We });
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: ke }, Ce, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: `${Ve}-message-item`, ...rt.props, "data-message-listitem": "", "data-layout-id": de() }, Ke));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(gy, { id: `${Ve}-message-list` }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    hE,
    {
      ref: R.ref,
      onScroll: R.props.onScroll,
      stackDirection: m == null ? void 0 : m.messageStackDirection,
      messages: P,
      renderMessage: se,
      onLoadPrev: N.loadPrevious,
      onLoadNext: N.loadNext,
      depsForResetScrollPositionToBottom: [N.initialized, N.messages.length !== 0],
      bottomSpacerHeight: R.state.bottomSpace,
      "aria-label": s.A11Y_MESSAGE_LIST,
      loading: !N.initialized || !k.channel,
      empty: P.length === 0 && !V,
      error: !!(y || k.error),
      LoadingComponent: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ln, { type: "loading" }),
      EmptyComponent: (() => {
        const $ = ce();
        return $ ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { width: "100%" } }, $) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ln, { type: "noMessages", label: s.PLACE_HOLDER__NO_MESSAGES });
      })(),
      ErrorComponent: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        ln,
        {
          type: "error",
          label: (y == null ? void 0 : y.message) ?? ((he = k.error) == null ? void 0 : he.message),
          action: k.error ? {
            label: s.RETRY,
            onClick: () => k.refetch()
          } : void 0
        }
      ),
      messageTopArea: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oy, { style: { marginTop: 16 } }), ce()),
      messageBottomArea: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, V && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          id: `${Ve}-message-item`,
          ...l.typingItem(V.user.nickname).props,
          "data-message-listitem": "",
          style: { marginTop: P.length === 0 ? 8 : 0 }
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          t,
          {
            isTyping: !0,
            isBotMessage: V.isBot,
            sender: V.user,
            thinkingMessage: V.thinkingMessage,
            messageType: "user",
            groupType: "single",
            message: "",
            isSenderAvatarVisible: u.conversation.list.senderAvatarEnabled
          }
        )
      ), u.conversation.list.isTalkToAgentViewEnabled && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cy, null)),
      overlayArea: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, u.conversation.list.newMessageIndicatorEnabled && R.state.isAwayFromBottom && N.newMessages.length > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        fy,
        {
          label: s.SCROLL_TO_NEW_MESSAGES_LABEL(N.newMessages),
          onClick: () => R.actions.scrollToBottom()
        }
      ), R.state.isAwayFromBottom && N.newMessages.length === 0 && !V && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        r.ScrollToBottomButton,
        {
          onClick: () => R.actions.scrollToBottom(),
          style: { position: "absolute", bottom: 12, insetInlineEnd: 16 }
        }
      ))
    }
  ), U && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    vE,
    {
      files: U.files,
      initialIndex: U.index,
      onClose: () => Y(null),
      visible: !0
    }
  ), q && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    bt,
    {
      visible: !0,
      onClose: () => j(null),
      "aria-label": s.A11Y_FAILED_MESSAGE_OPTIONS
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      bt.ActionItem,
      {
        onClick: () => {
          N.resendMessage(q), j(null);
        }
      },
      s.FAILED_MESSAGE_RESEND
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      bt.ActionItem,
      {
        destructive: !0,
        onClick: () => {
          N.deleteMessage(q), j(null);
        }
      },
      s.FAILED_MESSAGE_REMOVE
    )
  ));
}, gy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`overflow-y:hidden;display:flex;flex:1;position:relative;`, fy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(US)`position:absolute;bottom:12px;left:50%;transform:translateX(-50%);`, py = () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hy, null), Ei = {
  file: "attach",
  snippet: "snippet",
  site: "website",
  sb_sprinklr: "sprinklr",
  sb_salesforce: "salesforce",
  sb_confluence: "confluence",
  sb_zendesk: "zendesk",
  sb_desk: "snippet"
  // TODO: request icon
}, _y = ({
  actionbook: e,
  functionCalls: t,
  groundedness: n,
  agentMessageTemplates: r,
  flaggedTypes: s,
  onClickActionbook: o,
  onClickFunctionCall: i,
  onClickFunctionCallDetail: c,
  onClickGroundedness: l,
  onClickAgentMessageTemplate: u,
  topContent: d,
  bottomContent: m,
  renderCustomGroundednessIcon: h = (f) => f.default,
  style: g = {}
}) => {
  const {
    // Note: This component is used with the dashboard, so cssVars should not be used.
    iconColor: f = "#000000",
    textColor: v = "#000000",
    highlightColor: _ = un.DEFAULT_PRIMARY
  } = g;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ci, null, d, e && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ci, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: "actionbook", color: f })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nn,
    {
      $clickable: !!o,
      $highlightColor: _,
      variant: "body2",
      color: v,
      onClick: () => o == null ? void 0 : o(e),
      maxTextLines: 1
    },
    e.name
  ))), t == null ? void 0 : t.map((p) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fn, { key: p.key }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: "function", color: f })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nn,
    {
      $clickable: !!i,
      $highlightColor: _,
      variant: "body2",
      color: v,
      onClick: () => i == null ? void 0 : i(p),
      maxTextLines: 1
    },
    p.name
  ), c && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ey, { role: "button", onClick: () => c == null ? void 0 : c(p) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body2", color: _ }, "View details"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "chevron-right", size: 16, color: _ }))))), n == null ? void 0 : n.map((p) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fn, { key: p.id }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nn, null, h({
    default: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: Ei[p.source_type] ?? Ei.snippet, color: f }),
    sourceType: p.source_type
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nn,
    {
      $clickable: !!l,
      $highlightColor: _,
      variant: "body2",
      color: v,
      onClick: () => l == null ? void 0 : l(p),
      maxTextLines: 1
    },
    p.preview_title
  ))), r == null ? void 0 : r.map((p) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fn, { key: p.key }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: "template", color: f })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nn,
    {
      $clickable: !!u,
      $highlightColor: _,
      variant: "body2",
      color: v,
      onClick: () => u == null ? void 0 : u(p),
      maxTextLines: 1
    },
    p.name
  ))), !!(s != null && s.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Cy, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nn, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: 16, type: "activity", color: f })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vy, { variant: "body2", color: v }, s.map((p) => p.replace(/_/g, " ")).join(" · "))), m);
}, Rc = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`font-weight:400;`, Nn = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Rc)`${({ $clickable: e, $highlightColor: t }) => e && styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        color: ${t};
      }
    `}
`, nn = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;flex-shrink:0;`, Zn = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:8px;align-items:center;word-break:break-word;`, Ey = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Zn)`cursor:pointer;gap:4px;`, Fn = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Zn)`flex-direction:row;align-items:center;`, Cy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Fn)`align-items:flex-start;max-width:100%;`, vy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Rc)`min-width:0;`, Ci = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:4px;flex-direction:column;align-items:flex-start;`, by = (e) => {
  const t = e.replace(/[_-]+/g, " ").trim().toLowerCase();
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}, Sy = ({ prechecks: e, maxBodyWidth: t }) => {
  const { theme: n } = nr();
  return e.length === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yy, { id: `${nt}-ext-prechecks` }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ay, { $maxWidth: t ?? ae.BODY_MAX_WIDTH }, e.map((r) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ty, { key: r.key }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Iy, { type: "done-circle", size: 16, color: b.themedColor.secondary }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption2", color: n.colors.messageIncoming.text }, by(r.key))))));
}, yy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`align-self:stretch;padding-block-end:8px;padding-inline-start:${ae.HORIZONTAL_PADDING + ae.AVATAR_SIZE}px;padding-inline-end:${ae.HORIZONTAL_PADDING}px;`, Ay = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-wrap:wrap;gap:4px 14px;width:fit-content;max-width:min(${({ $maxWidth: e }) => e}px,100%);padding:8px 12px;border-radius:8px;background-color:${({ theme: e }) => e.colors.messageIncoming.background};`, Ty = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;gap:6px;min-width:0;overflow-wrap:anywhere;`, Iy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(oe)`flex-shrink:0;`, wc = xe("DashboardTester"), xy = wc.Provider;
function My({
  testerType: e,
  origin: t,
  children: n
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(xy, { value: { testerType: e, origin: t } }, e && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ry, null), n);
}
const kc = wc.useContext, Ry = () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(kt.Prechecks, { component: wy }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(kt.MessageLogs, { component: vi }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sn.MessageLogs, { component: vi })), wy = ({ extendedMessagePayload: e = {}, maxBodyWidth: t }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sy, { prechecks: e.prechecks ?? [], maxBodyWidth: t }), vi = ({ extendedMessagePayload: e = {} }) => {
  const { handlers: t } = Ee(), { manual: n, groundedness: r, function_calls: s, agent_message_templates: o, flagged_types: i, is_thinking: c } = e, l = !!n || [r, s, o, i].some((u) => u == null ? void 0 : u.length);
  return c || !l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ky, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ly, { $width: 4 }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _y,
    {
      actionbook: n,
      functionCalls: s,
      groundedness: r,
      agentMessageTemplates: o,
      flaggedTypes: i,
      onClickFunctionCallDetail: t == null ? void 0 : t.onFunctionCallDetailClick,
      style: {
        iconColor: b.themedColor.textHighEmphasis,
        textColor: b.themedColor.textHighEmphasis,
        barColor: b.themedColor.textDisabled
      },
      topContent: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption4", color: b.themedColor.textLowEmphasis }, "Only visible in the tester")
    }
  ));
}, ky = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:16px;margin:6px ${ae.HORIZONTAL_PADDING}px 4px ${ae.HORIZONTAL_PADDING + ae.AVATAR_SIZE}px;align-self:stretch;`, Ly = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:${({ $width: e }) => e}px;background-color:${b.themedColor.textDisabled};border-radius:100px;flex-shrink:0;`, Oy = () => {
  var s;
  const { origin: e } = kc(), { appId: t, aiAgentId: n } = we(), { channelSource: r } = De();
  return (s = r.channel) != null && s.conversation ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ny, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xr, { style: { gap: 4 } }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { color: b.themedColor.textLowEmphasis, size: 12, type: "show" }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { as: "i", color: b.themedColor.textLowEmphasis, variant: "caption2" }, "Only visible in the tester")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Xr,
    {
      role: "button",
      style: { gap: 4 },
      onClick: () => {
        var l, u;
        const o = e ?? window.location.origin, i = (u = (l = r.channel) == null ? void 0 : l.conversation) == null ? void 0 : u.id, c = `${o}/ai-agent/${t}/${n}/evaluate/conversations/${i}`;
        navigator.clipboard.writeText(c);
      }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "body3", color: b.themedColor.textHighEmphasis }, "Copy ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: { color: b.themedColor.primary } }, "conversation link")),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { color: b.themedColor.primary, size: 14, type: "copy" })
  )) : null;
}, Xr = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;justify-content:center;align-items:center;`, Ny = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Xr)`flex-direction:column;padding-block:16px;background-color:${b.themedColor.bg_100_500};gap:8px;`, Dy = (e, t) => {
  const n = [], r = [], s = [];
  for (const o of e) {
    const i = t.isSupportedMimeType(o.type), c = o.size <= t.getUploadSizeLimit(o.type);
    i && c ? n.push(o) : i ? r.push(o) : s.push(o);
  }
  return { passed: n, failedBySize: r, failedByType: s };
}, Lc = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(void 0), $y = ({ children: e }) => {
  var ne, ce;
  const { chatSDK: t } = Ee(), { createAttachmentRules: n } = Ge(), { stringSet: r } = fe(), { channelSource: s, state: o } = De(), [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), { announceError: l } = As(), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), m = n({
    channel: s.channel,
    uploadSizeLimit: (ne = t.appInfo) == null ? void 0 : ne.uploadSizeLimit
  }), h = ((ce = o == null ? void 0 : o.input) == null ? void 0 : ce.disabled) ?? !1, g = m.isEnabled(), f = m.maxAttachmentCount, v = () => d(null), _ = (X) => d(X), p = () => {
    _({
      title: r.FILE_UPLOAD_NOTIFICATION__COUNT_LIMIT.replace("%d", f.toString())
    });
  }, y = (X) => {
    _({
      title: r.FILE_UPLOAD_NOTIFICATION__SIZE_LIMIT.replace("%d", X.toString())
    }), l({ type: "fileSizeExceeded", maxSizeMB: X });
  }, S = (X) => {
    _({
      title: r.FILE_UPLOAD_NOTIFICATION__FILES_EXCLUDED_BY_VALIDATION.replace("%d", X.toString())
    });
  }, A = (X) => X.map((J) => {
    const U = Os(J);
    return b_(J, U), { file: J, preview: { url: U, type: J.type, name: J.name } };
  }), I = (X) => {
    c((J) => [...J, ...X]);
  }, k = (X) => {
    c((J) => (J.forEach((U) => gi(U.file)), X));
  }, N = (X) => {
    const { passed: J, failedBySize: U, failedByType: Y } = Dy(X, m), q = U.length + Y.length, j = X.length === 1 ? U[0] : void 0;
    return j ? y(m.getUploadSizeLimitInMB(j.type)) : q > 0 && S(q), J;
  }, R = (X) => {
    const J = N(X.files);
    if (J.length === 0) return;
    const U = A(J);
    X.type === "append" ? I(U) : k(U);
  }, M = (X) => {
    if (!g || h || !Um(X)) return;
    const J = Hm({
      currentFiles: i.map(({ file: U }) => U),
      incomingFiles: X,
      maxAttachmentCount: f
    });
    switch (J.type) {
      case "reject":
        p();
        return;
      case "confirm_replace":
        _({
          title: r.FILE_UPLOAD_REPLACE_ALERT__TITLE,
          description: r.FILE_UPLOAD_REPLACE_ALERT__DESCRIPTION,
          confirmText: r.BUTTON__OK,
          cancelText: r.BUTTON__CANCEL,
          onConfirm: () => R(J.action)
        });
        return;
      case "apply":
        R(J.action);
        return;
    }
  }, B = (X) => {
    c((J) => {
      var Y;
      const U = (Y = J[X]) == null ? void 0 : Y.file;
      return U && gi(U), J.filter((q, j) => j !== X);
    });
  }, P = () => {
    c([]);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Lc.Provider,
    {
      value: {
        files: i,
        addFiles: M,
        removeFile: B,
        clearFiles: P,
        isFileUploadEnabled: g,
        acceptableMimeTypes: m.supportedMimeTypes,
        maxAttachmentCount: m.maxAttachmentCount,
        showFileUploadAlert: _
      }
    },
    e,
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vn, { visible: !!u, ...u ?? {}, onClose: v })
  );
}, Bs = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Lc);
  if (!e)
    throw new Error("useFileUpload must be used within FileUploadProvider");
  return e;
};
function Py({ elementRef: e, ready: t, onRestore: n }) {
  const r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var i;
    !t || !r.current || (n == null || n(), (i = e.current) == null || i.focus(), r.current = !1);
  }, [t, n]);
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    r.current = !0;
  }, []), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    r.current = !1;
  }, []);
  return { requestRestore: s, cancelRestore: o };
}
function Fy({ blurred: e, elementRef: t, document: n = window.document, onRecoverFocus: r }) {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  e && t.current && n.activeElement === t.current && (s.current = !0), (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    var o;
    !e && s.current && (r == null || r(), (o = t.current) == null || o.focus(), s.current = !1);
  }, [e, r]);
}
const Uy = () => {
  const { announceError: e } = _t();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (t) => {
      e({ type: "sendFailed" }, t);
    },
    [e]
  );
}, By = 1e3, Hy = (e, t, n) => {
  const { announcementsEnabled: r, setIsSuppressed: s } = _t(), o = n ?? !0, i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (u) => {
      var m;
      const d = () => {
      };
      u && o && (i.current = !0, c.current = e, e == null || e.startTyping().catch(d)), u || (i.current && o && ((m = c.current) == null || m.endTyping().catch(d)), i.current = !1, c.current = void 0), s(u);
    },
    [e, s, o]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    s(i.current);
  }, [r, s]), xg(t, l, {
    enabled: o,
    idleMs: By
  });
}, Gy = ({ enabled: e = !0, focusRoot: t }) => {
  const [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!e) {
      r(!1);
      return;
    }
    const u = (m) => {
      const h = m;
      h.metaKey || h.altKey || h.ctrlKey || (s.current = !0);
    }, d = () => {
      s.current = !1, r(!1);
    };
    return t.addEventListener("keydown", u), t.addEventListener("pointerdown", d), () => {
      t.removeEventListener("keydown", u), t.removeEventListener("pointerdown", d);
    };
  }, [e, t]);
  const i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (o.current) {
      o.current = !1, r(!1);
      return;
    }
    r(s.current);
  }, []), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    r(!1);
  }, []), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    o.current = !0, r(!1);
  }, []);
  return {
    isFocusVisible: n,
    suppressNextFocusVisible: l,
    focusHandlers: {
      onFocus: i,
      onBlur: c
    }
  };
}, Vy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`&::-webkit-scrollbar{display:none;}overflow-x:auto;display:flex;flex-direction:row;gap:10px;padding:8px 16px;background-color:transparent;`, zy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-shrink:0;position:relative;margin-block-start:8px;border-radius:12px;height:64px;img{border-radius:12px;object-fit:cover;width:64px;-webkit-user-drag:none;}&:hover button,&:focus-within button{opacity:1;}`, Ky = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`display:flex;align-items:center;justify-content:center;position:absolute;inset-inline-end:-8px;inset-block-start:-8px;cursor:pointer;border-radius:50%;border:none;padding:0;opacity:${({ $mobile: e }) => e ? 1 : 0};transition:opacity 0.12s ease-in-out;${ie.light`
    background-color: ${b.color.background50};
  `}
  ${ie.dark`
    background-color: ${b.color.background500};
  `}
  path {
    fill: ${b.themedColor.textMidEmphasis};
  }

  &:hover {
    path {
      fill: ${b.themedColor.textHighEmphasis};
    }
  }

  &:focus-visible {
    opacity: 1;
    outline: 2px solid ${b.color.primary.main};
    outline-offset: 2px;
  }

  circle {
    stroke: ${b.themedColor.bg_50_600};
  }
`, Wy = () => {
  const e = Cn(), { conversation: t } = pe(), { files: n, removeFile: r, isFileUploadEnabled: s } = Bs();
  return s && n.length > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vy, null, n.map(({ preview: { type: i, name: c, url: l } }, u) => {
    let d = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ws, { name: c, mimeType: i, type: os(c, i), selected: !0 });
    return i.startsWith("image/") && (d = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { alt: t.file.label(c, i, !0), src: l })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zy, { key: l }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Ky,
      {
        type: "button",
        ...t.file.removeButton(c).props,
        $mobile: e,
        onClick: () => r(u)
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "close-filled", color: b.themedColor.textMidEmphasis })
    ), d);
  })) : null;
}, Yy = {
  textArea: styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`min-height:40px;height:40px;font-size:16px;line-height:24px;`
}, Oc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;cursor:pointer;display:flex;align-items:center;justify-content:center;width:32px;height:32px;${Ne}`, bi = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:100%;position:relative;background-color:${({ theme: e }) => e.colors.messageInput.background};border-radius:20px;`, Si = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;align-items:flex-end;position:relative;`, yi = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].textarea */ .ZP.textarea`all:unset;display:block;flex:1;min-width:0;padding-top:8px;padding-bottom:8px;padding-inline-start:16px;padding-inline-end:12px;box-sizing:border-box;font-size:14px;line-height:20px;color:${({ theme: e }) => e.colors.messageInput.text};resize:none;width:100%;height:${Pa}px;overflow-wrap:break-word;white-space:pre-wrap;overflow-x:hidden;${Za && Yy.textArea};${({ $focusVisible: e }) => e && styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
      outline: 2px solid ${b.themedColor.primary};
      outline-offset: 2px;
    `}

  &::placeholder {
    color: ${({ theme: e }) => e.colors.messageInput.placeholderText};
  }

  &:disabled {
    cursor: not-allowed;
    &::placeholder {
      color: ${b.themedColor.textDisabled};
    }
  }

  ${({ $blocked: e }) => e && styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`cursor:not-allowed;&::placeholder{color:${b.themedColor.textDisabled};}`}
`, qy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].input */ .ZP.input`display:none;`;
styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;gap:24px;`;
const jy = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Oc)`flex-shrink:0;border-radius:8px;&:disabled{cursor:not-allowed;}&:not(:disabled){&:hover{background-color:${b.themedColor.bg_100_500};path{fill:${b.themedColor.textHighEmphasis};}}&:active{background-color:${b.themedColor.bg_200_400};}}`, Ai = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding:10px 16px 10px 12px;position:relative;display:flex;align-items:center;gap:8px;`, Ti = (e) => e.startsWith("image/"), Ii = ({ disabled: e }) => {
  const { stringSet: t } = fe(), { conversation: n } = pe(), { config: r } = Ee(), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), { addFiles: l, isFileUploadEnabled: u, acceptableMimeTypes: d, showFileUploadAlert: m } = Bs(), h = d.includes(kr), g = h ? ["image/*"] : d.filter(Ti), f = h ? [kr] : d.filter((N) => !Ti(N)), v = r.conversation.input.gallery.photoEnabled, _ = r.conversation.input.fileEnabled, p = () => h || g.length > 0, y = () => h || f.length > 0, S = (N) => {
    const R = N.currentTarget.files;
    R && l(Array.from(R)), N.target.value = "";
  }, A = () => {
    c(!0);
  }, I = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const N = [];
    return v && N.push({
      type: "image",
      icon: "photo",
      label: t.FILE_UPLOAD_PHOTOS,
      accept: g.join(","),
      inputRef: s,
      onSelect: () => {
        if (!p()) {
          m({ title: t.FILE_UPLOAD_NO_SUPPORTED_FILES });
          return;
        }
        c(!1), setTimeout(() => {
          var R;
          return (R = s.current) == null ? void 0 : R.click();
        }, 100);
      }
    }), _ && N.push({
      type: "file",
      icon: "document",
      label: t.FILE_UPLOAD_FILES,
      accept: d.join(","),
      inputRef: o,
      onSelect: () => {
        if (!y()) {
          m({ title: t.FILE_UPLOAD_NO_SUPPORTED_FILES });
          return;
        }
        c(!1), setTimeout(() => {
          var R;
          return (R = o.current) == null ? void 0 : R.click();
        }, 100);
      }
    }), N;
  }, [g, d, t, v, _]);
  if (!u) return null;
  const k = {
    attach: n.messageInput.attachFileButton()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jy, { ...k.attach.props, disabled: e, onClick: A }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "add", color: e ? b.themedColor.textDisabled : b.color.primary.main, size: 20 }), k.attach.descriptionNode), I.map((N) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    qy,
    {
      key: N.type,
      type: "file",
      ref: N.inputRef,
      multiple: N.type === "image",
      onChange: S,
      accept: N.accept
    }
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    bt,
    {
      visible: i,
      onClose: () => c(!1),
      "aria-label": t.A11Y_FILE_UPLOAD_OPTIONS
    },
    I.map((N) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bt.ActionItem, { key: N.type, onClick: N.onSelect, icon: N.icon }, N.label))
  ));
}, Xy = () => {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [t, n] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), { stringSet: r } = fe(), { conversation: s } = pe(), { rootElement: o } = Ee(), i = yt(o), {
    focusHandlers: c,
    isFocusVisible: l,
    suppressNextFocusVisible: u
  } = Gy({ focusRoot: i }), { channelSource: d, messageSource: m, state: h } = De(), { files: g, addFiles: f, clearFiles: v } = Bs(), _ = Uy(), { focusPolicy: p, disabled: y, disabledBy: S } = h.input, A = p === "preserve", I = p === "release", k = (() => {
    if (!y) return r.MESSAGE_INPUT__PLACE_HOLDER;
    switch (S) {
      case "form_active":
        return r.FORM_PLACEHOLDER;
      case "ai_responding":
        return r.MESSAGE_INPUT__PLACE_HOLDER__WAIT_AI_AGENT_RESPONSE;
      case "suggested_replies":
        return r.MESSAGE_INPUT__PLACE_HOLDER__SUGGESTED_REPLIES;
      case "steward":
        return r.MESSAGE_INPUT__PLACE_HOLDER__STEWARD;
      case "system":
        return r.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
      case "reconnecting":
        return r.MESSAGE_INPUT__PLACE_HOLDER__RECONNECTING;
      case "unavailable":
      case "conversation_closed":
      default:
        return r.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
    }
  })();
  O_({
    onDropFiles: (W) => {
      f(W);
    }
  }), Fy({
    blurred: I,
    elementRef: e,
    document: i,
    onRecoverFocus: () => {
      u();
    }
  }), Hy(d.channel, t, !y);
  const N = t.trim().length > 0, R = g.length > 0, M = !y && (N || R), B = {
    input: s.messageInput.textInput(r.A11Y_MESSAGE_INPUT),
    send: s.messageInput.sendButton()
  }, P = () => {
    e.current && (e.current.value = "", e.current.style.height = ""), v(), n("");
  }, ne = () => {
    var W;
    u(), (W = e.current) == null || W.focus();
  }, { requestRestore: ce, cancelRestore: X } = Py({
    elementRef: e,
    ready: A,
    onRestore: u
  }), J = (W) => {
    X(), _(W);
  }, U = () => {
    X();
  }, Y = async (W) => {
    try {
      await W(), U();
    } catch {
      J(e.current);
    }
  }, q = async () => {
    if (y) return;
    const W = t.trim();
    if (!W && !g.length) return;
    const se = [...g];
    if (ce(), P(), ne(), se.length === 0) {
      await Y(() => m.sendUserMessage({ message: W }));
      return;
    }
    if (se.length === 1)
      await Y(() => m.sendFileMessage({ message: W, file: se[0].file }));
    else {
      const he = se.map(({ file: $ }) => ({ file: $ }));
      await Y(() => m.sendMultipleFilesMessage({ message: W, fileInfoList: he }));
    }
  }, j = (W) => {
    const se = Array.from(W.clipboardData.files);
    se.length > 0 && (W.preventDefault(), f(se));
  }, V = (W) => {
    W.key !== "Enter" || W.nativeEvent.isComposing || W.shiftKey || (W.preventDefault(), q());
  }, z = (W) => {
    if (y) {
      e.current && (e.current.value = t);
      return;
    }
    if (e.current) {
      e.current.style.height = "";
      const se = Math.min(Uf, e.current.scrollHeight);
      Pa < se && (e.current.style.height = `${se}px`);
    }
    n(W.target.value);
  };
  return I ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ai, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ii, { disabled: !0 }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bi, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Si, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    yi,
    {
      rows: 1,
      ...B.input.props,
      disabled: !0,
      placeholder: k,
      $blocked: !0,
      $focusVisible: !1,
      "data-focus-visible": "false"
    }
  )))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ai, { "data-message-composer": "" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ii, { disabled: y }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bi, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wy, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Si, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    yi,
    {
      ref: e,
      rows: 1,
      ...B.input.props,
      readOnly: A,
      "aria-disabled": A ? "true" : void 0,
      placeholder: k,
      maxLength: 5e3,
      $blocked: y,
      $focusVisible: l,
      "data-focus-visible": l ? "true" : "false",
      onKeyDown: V,
      onChange: z,
      onFocus: c.onFocus,
      onBlur: c.onBlur,
      onPaste: j
    }
  ))), M && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Oc, { ...B.send.props, onClick: () => q() }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "send", color: b.color.primary.main, size: 20 }), B.send.descriptionNode));
}, Zy = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`padding:8px 16px;text-align:center;word-break:break-word;white-space:pre-wrap;line-height:1.43;letter-spacing:-0.2px;font-size:14px;font-weight:400;color:${b.themedColor.textLowEmphasis};&& a{font-weight:700;text-decoration:none;${ie.light`
      color: ${b.color.information.light};
    `};
    ${ie.dark`
      color: ${b.color.information.main};
    `};
  }
`, Jy = (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 617).then(__webpack_require__.bind(__webpack_require__, 30617)).then((e) => ({ default: e.MarkdownText }))), Qy = () => {
  const { aiAgentInfo: e, userSession: t } = Ge(), { handlers: n } = Ee(), { messageSource: r, channelSource: s } = De(), [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), c = Cs("special-notice", s.channel), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => s.channel ? c ? r.messages.some((u) => ze(u, (t == null ? void 0 : t.userId) ?? "")) : !0 : null, [s.channel, c, r.messages, t == null ? void 0 : t.userId]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    o || i(l());
  }, [l, o]), o || !e.specialNotice ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zy, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { fallback: e.specialNotice }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Jy, { onClickLink: n.onClickLink }, e.specialNotice)));
}, eA = () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tA, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qy, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($y, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xy, null))), tA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`z-index:0;border:none;width:100%;`, nA = () => {
  var s;
  const { testerType: e } = kc(), { channelSource: t } = De(), n = He(t.channel), r = !!e && ((s = t.channel) == null ? void 0 : s.isAIAgent);
  return n && r ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Oy, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(eA, null);
}, Nc = ({ start: e, title: t, titleAlign: n = "start", end: r, containerProps: s }) => {
  const o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    o.current && l(o.current.offsetWidth), i.current && d(i.current.offsetWidth);
  }, [e, r]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rA, { ...s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sA, null, n === "center" && t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oA, { $sideWidth: Math.max(c, u) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(iA, null, t)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(aA, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cA, { ref: o }, e), (n === "start" || n === "end") && t && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(uA, { $align: n, $hasStart: !!e, $hasEnd: !!r }, t), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lA, { ref: i }, r))));
}, rA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;width:100%;background-color:${({ theme: e }) => e.colors.base.headerBackground};border-bottom:1px solid ${b.themedColor.textDisabled};`, sA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;height:56px;padding:11px 12px;`, oA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;left:${({ $sideWidth: e }) => e}px;right:${({ $sideWidth: e }) => e}px;top:0;bottom:0;display:flex;align-items:center;justify-content:center;`, iA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`max-width:100%;overflow:hidden;`, aA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;align-items:center;justify-content:space-between;height:100%;z-index:1;`, cA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex-shrink:0;display:flex;align-items:center;`, lA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex-shrink:0;display:flex;align-items:center;`, uA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex:1;overflow:hidden;display:flex;align-items:${({ $align: e }) => e === "start" ? "flex-start" : "flex-end"};margin-left:${({ $hasStart: e }) => e ? 8 : 0}px;margin-right:${({ $hasEnd: e }) => e ? 8 : 0}px;`, Xt = (e = 16) => Cn() ? e * 1.5 : e, dA = () => {
  const { state: e } = Ee(), { messenger: t } = pe(), n = Xt(), r = () => {
    e.setOpened(!1);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lt, { ...t.closeButton().props, type: "close", size: n, onClick: r });
}, mA = () => {
  const { enableCloseConversationButton: e, dispatcher: t } = Ee(), { channelSource: n } = De(), { conversation: r } = pe(), s = n.channel, o = Xt(), i = (s == null ? void 0 : s.isAIAgent) && e, c = !cs(s);
  if (!i) return null;
  const l = {
    close: r.header.closeConversationButton()
  }, u = async () => {
    s && await t.send(Ct.CloseConversation({ channelUrl: s.url }));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lt, { ...l.close.props, type: "mute", size: o, disabled: c, onClick: u }), l.close.descriptionNode);
}, hA = () => {
  const { state: e, enableExpandButton: t } = Ee(), { messenger: n } = pe(), r = Xt();
  return t ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    lt,
    {
      ...n.expandButton(e.expanded).props,
      type: e.expanded ? "collapse" : "expand",
      size: r,
      onClick: () => e.setExpanded(!e.expanded)
    }
  ) : null;
}, gA = ({ label: e, children: t, position: n = "top", disabled: r }) => r ? t : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zr, null, t, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_A, { $position: n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EA, { variant: "caption1" }, e), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(fA, { $position: n }))), fA = ({ $position: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
  "svg",
  {
    style: { transform: e === "top" ? "rotate(0)" : "rotate(180deg)" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "6",
    viewBox: "0 0 12 6",
    fill: "none"
  },
  /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M6 6L0 0h12L6 6Z", fill: b.themedColor.textHighEmphasis })
), pA = {
  top: styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`flex-direction:column;top:0;transform:translate(-50%,-100%);`,
  bottom: styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`flex-direction:column-reverse;bottom:0;transform:translate(-50%,100%);`
}, Zr = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;`, _A = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;position:absolute;left:50%;z-index:${Dt.TOOLTIP};${({ $position: e }) => pA[e]}opacity:0;transition:opacity 0.2s ease-in-out;pointer-events:none;${Zr}:hover &,${Zr}:focus-within &{opacity:1;}`, EA = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`padding:6px 8px;background:${b.themedColor.textHighEmphasis};color:${b.themedColor.textHighEmphasisInverse};border-radius:4px;font-size:12px;white-space:nowrap;`, CA = 2e3, xi = 0, vA = 1500, Dn = Symbol("header-focus-status-pause"), Mi = "data-sb-header-focus-protected", bA = "[data-message-composer]", Ri = /* @__PURE__ */ new WeakMap(), Rr = (e) => {
  const t = Ri.get(e);
  if (t) return t;
  const n = {
    focusedTargetIds: /* @__PURE__ */ new Set(),
    pendingBlurTimeouts: /* @__PURE__ */ new Map(),
    maxPauseTimeout: null
  };
  return Ri.set(e, n), n;
}, wr = (e, t) => {
  const n = e.pendingBlurTimeouts.get(t);
  n && (clearTimeout(n), e.pendingBlurTimeouts.delete(t));
}, Un = (e) => {
  e.maxPauseTimeout && (clearTimeout(e.maxPauseTimeout), e.maxPauseTimeout = null);
}, SA = (e) => {
  e.pendingBlurTimeouts.forEach((t) => clearTimeout(t)), e.pendingBlurTimeouts.clear(), e.focusedTargetIds.clear(), Un(e);
}, yA = (e) => {
  const t = e.hasAttribute("tabindex"), n = e.getAttribute("tabindex");
  return t || e.tabIndex >= 0 ? () => {
  } : (e.setAttribute("tabindex", "-1"), () => {
    if (n === null) {
      e.removeAttribute("tabindex");
      return;
    }
    e.setAttribute("tabindex", n);
  });
}, AA = (e) => e instanceof HTMLBodyElement || (e instanceof HTMLButtonElement || e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement) && e.disabled ? !0 : (e instanceof HTMLElement && e.closest(bA), !1), Hs = () => {
  const { setStatusPauseState: e } = _t(), t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(Symbol("header-focus-target")), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    s.current && (clearTimeout(s.current), s.current = null);
  }, []), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (n.current) return;
    n.current = !0, r.current = Date.now() + vA, o();
    const l = Rr(e);
    wr(l, t.current), l.focusedTargetIds.add(t.current), l.focusedTargetIds.size === 1 && e(Dn, !0), Un(l), l.maxPauseTimeout = setTimeout(() => {
      SA(l), e(Dn, !1);
    }, CA);
  }, [o, e]), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      if (!n.current) return;
      n.current = !1;
      const u = l.currentTarget, d = Rr(e), m = u instanceof HTMLElement && Date.now() <= r.current;
      wr(d, t.current), m && (o(), s.current = setTimeout(() => {
        if (s.current = null, !(u instanceof HTMLElement) || !u.isConnected) return;
        const g = u.ownerDocument.activeElement, f = g instanceof HTMLElement && g.hasAttribute(Mi);
        if (g === u || f || !AA(g)) return;
        const v = yA(u);
        u.focus({ preventScroll: !0 }), v();
      }, xi)), d.pendingBlurTimeouts.set(
        t.current,
        setTimeout(() => {
          d.pendingBlurTimeouts.delete(t.current), d.focusedTargetIds.delete(t.current), d.focusedTargetIds.size === 0 && (Un(d), e(Dn, !1));
        }, xi)
      );
    },
    [o, e]
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
    const l = Rr(e);
    n.current = !1, o(), wr(l, t.current), l.focusedTargetIds.delete(t.current) && l.focusedTargetIds.size === 0 && (Un(l), e(Dn, !1));
  }, [o, e]), {
    [Mi]: "true",
    onFocus: i,
    onBlur: c
  };
}, TA = () => {
  const { logger: e } = Ee(), { stringSet: t } = fe(), { channelSource: n } = De(), { conversation: r } = pe(), s = n.channel, o = Xt(), i = Cs("handoff-button", s), c = !cs(s) || ft(s), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), d = Hs(), m = async () => {
    u(!1);
    try {
      const g = await (s == null ? void 0 : s.markConversationAsHandoff());
      e.info("conversation.handleAgentHandoff: success", g);
    } catch (g) {
      e.error("conversation.handleAgentHandoff: error", g);
    }
  };
  if (!i) return null;
  const h = {
    handoff: r.header.handoffButton()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(gA, { label: t.HEADER_BUTTON__AGENT_HANDOFF, position: "bottom", disabled: c }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    lt,
    {
      ...h.handoff.props,
      type: "agent",
      size: o,
      disabled: c,
      ...d,
      onClick: () => u(!0)
    }
  )), h.handoff.descriptionNode), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tt, { portalContainerId: Me.WINDOW, visible: l, onClose: () => u(!1) }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    $s,
    {
      title: t.HANDOFF_CONFIRM__TITLE,
      description: t.HANDOFF_CONFIRM__DESCRIPTION,
      negativeText: t.HANDOFF_CONFIRM__CANCEL,
      positiveText: t.HANDOFF_CONFIRM__HANDOFF,
      onCancel: () => u(!1),
      onConfirm: m
    }
  )));
}, IA = (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(() => __webpack_require__.e(/* import() */ 617).then(__webpack_require__.bind(__webpack_require__, 30617)).then((e) => ({ default: e.MarkdownText }))), xA = () => {
  const { logger: e, _aiAgentSDK: t } = Ee(), { stringSet: n } = fe(), { memoryInfo: r, sdkUser: s } = Ge(), { actions: o } = De(), { conversation: i } = pe(), c = Xt(20), l = Hs(), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  if ((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    s && (r != null && r.consentDialog) && d({ ...r });
  }, [s, r == null ? void 0 : r.consentDialog]), !s || !r) return null;
  const f = i.header.memoryIndicator(r.enabled), v = (y, S, A) => {
    t.liveMetricManager.track({ type: "memory", variant: y, action: S, deleteOnOff: A });
  }, _ = () => d(null), p = async (y) => {
    if (!g.current) {
      g.current = !0, h(!1);
      try {
        await o.setUserMemoryState({ enabled: y }), _();
      } catch (S) {
        e.error("memoryIndicator.setUserMemoryState: error", S), h(!0);
      } finally {
        g.current = !1;
      }
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, r.showIndicator && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    kA,
    {
      ...f.props,
      as: "button",
      type: "button",
      onClick: () => d({ ...r }),
      ...l,
      $size: c
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: "memory", size: c, color: b.themedColor.textHighEmphasis }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LA, { $enabled: r.enabled })
  ), f.descriptionNode), u && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MA,
    {
      memoryInfo: u,
      onClose: _,
      onSetEnabled: p,
      trackMemory: v
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    vn,
    {
      visible: m,
      title: n.PLACE_HOLDER__WRONG,
      description: n.MEMORY__ERROR_MESSAGE,
      onClose: () => h(!1)
    }
  ));
}, MA = ({
  memoryInfo: e,
  onClose: t,
  onSetEnabled: n,
  trackMemory: r
}) => {
  var p;
  const { stringSet: s } = fe(), { colors: o } = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)(), l = Fm(e), u = l === "consent", d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), h = (y) => {
    y !== "shown" && (m.current = !0), r(l, y, e.deleteOnOff);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    d.current || (d.current = !0, h("shown"));
  }, []);
  const g = () => {
    m.current || h("dismiss"), t();
  }, f = {
    consent: {
      body: ((p = e.consentDialog) == null ? void 0 : p.body) ?? "",
      negativeText: s.MEMORY__BUTTON_DONT_USE,
      positiveText: s.MEMORY__BUTTON_USE,
      onCancel: () => n(!1),
      onConfirm: () => n(!0)
    },
    on: {
      body: s.MEMORY__DESC_ON,
      negativeText: e.deleteOnOff ? s.MEMORY__BUTTON_DISABLE_AND_DELETE : s.MEMORY__BUTTON_DISABLE,
      positiveText: s.MEMORY__BUTTON_KEEP_USING,
      onCancel: () => n(!1),
      onConfirm: t
    },
    off: {
      body: s.MEMORY__DESC_OFF,
      negativeText: s.MEMORY__BUTTON_ENABLE,
      positiveText: s.MEMORY__BUTTON_KEEP_OFF,
      onCancel: () => n(!0),
      onConfirm: t
    },
    readonly: {
      body: e.enabled ? s.MEMORY__DESC_ON : s.MEMORY__DESC_OFF,
      negativeText: void 0,
      positiveText: s.MEMORY__BUTTON_CANCEL,
      onCancel: void 0,
      onConfirm: t
    }
  }[l], { onCancel: v } = f, _ = o.memoryDialog;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Tt,
    {
      visible: !0,
      portalContainerId: Me.WINDOW,
      onClose: g,
      cancelable: !u,
      "aria-labelledby": i,
      "aria-describedby": c
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      $s,
      {
        title: s.MEMORY__DIALOG_TITLE,
        titleId: i,
        description: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RA, null, f.body),
        descriptionId: c,
        negativeText: f.negativeText,
        positiveText: f.positiveText,
        buttonLayout: u ? "horizontal" : "vertical-full-width",
        onCancel: v && (() => {
          h("cancel"), v();
        }),
        onConfirm: () => {
          h("confirm"), f.onConfirm();
        },
        styles: {
          titleColor: _.titleText,
          positiveBackground: _.positiveBackground,
          positiveText: _.positiveText,
          positiveBorderColor: _.positiveBorderColor,
          negativeBackground: _.negativeBackground,
          negativeText: _.negativeText,
          negativeBorderColor: _.negativeBorderColor
        }
      }
    )
  );
}, RA = ({ children: e }) => {
  const { handlers: t } = Ee();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OA, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wt, { fallback: e }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IA, { onClickLink: t.onClickLink }, e)));
}, wA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`all:unset;box-sizing:border-box;width:${({ $size: e }) => e}px;height:${({ $size: e }) => e}px;display:flex;align-items:center;justify-content:center;position:relative;`, kA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`${wA};cursor:pointer;${Ne}`, LA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span */ .ZP.span`position:absolute;top:0;inset-inline-end:0;width:8px;height:8px;border-radius:999px;background-color:${({ $enabled: e }) => e ? b.themedColor.secondary : b.color.background300};box-shadow:0 0 0 2px ${b.color.background50};${ie.dark`
    box-shadow: 0 0 0 2px ${b.color.background500};
  `}
`, OA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`color:${({ theme: e }) => e.colors.memoryDialog.markdownBodyText};line-height:20px;word-break:break-word;&& a{color:${({ theme: e }) => e.colors.memoryDialog.markdownLinkText};font-weight:inherit;text-decoration:underline;}`, NA = () => {
  const { conversation: e } = pe(), { onNavigateToConversationList: t } = De();
  if (!t) return null;
  const n = {
    menu: e.header.menuButton()
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    lt,
    {
      ...n.menu.props,
      ...wa,
      type: "menu",
      size: 24,
      onClick: () => t()
    }
  ), n.menu.descriptionNode);
}, Dc = ({ channel: e, size: t = 40, skeletonColor: n = b.themedColor.bg_100_500 }) => {
  const { userSession: r, aiAgentInfo: s } = Ge(), { fallbackIcon: o, url: i } = vs({ channel: e, aiAgentInfo: s, userSession: r }), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  c && c.url !== i && l(void 0);
  const u = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), { primary: d, primaryContrastContent: m } = u.colors.base;
  if (!o)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wi, { "aria-hidden": "true", $size: t, $bgColor: n });
  if (i && (c == null ? void 0 : c.status) !== "failed") {
    const h = (c == null ? void 0 : c.status) === "loaded" ? d : n;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      fc,
      {
        src: i,
        size: t,
        "aria-hidden": "true",
        onImageError: (g) => l({ url: g, status: "failed" }),
        onImageLoad: (g) => l({ url: g, status: "loaded" }),
        backgroundColor: h
      }
    );
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wi, { "aria-hidden": "true", $size: t, $bgColor: d }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { type: o, size: t * 0.55, color: m }));
}, wi = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:${({ $size: e }) => e}px;height:${({ $size: e }) => e}px;border-radius:50%;background-color:${({ $bgColor: e }) => e};display:flex;align-items:center;justify-content:center;flex-shrink:0;`, DA = (e) => {
  const { channelSource: t } = De(), { aiAgentInfo: n, userSession: r } = Ge(), { conversation: s } = pe(), { config: o } = we(), { announcementsEnabled: i } = _t(), c = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), l = t.channel, u = vs({ channel: l, userSession: r, aiAgentInfo: n }), d = e.title ?? u.title, m = o.conversation.header.avatarEnabled, h = Hs(), g = oc({ enabled: i, label: d }), f = {
    title: s.header.title(d, {
      active: g.enabled,
      titleId: g.id,
      initialFocus: !1
    })
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement($A, null, m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dc, { channel: l, size: 34, skeletonColor: c.colors.conversation.headerProfileSkeleton }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PA, { ...f.title.props, ...h }, d));
}, $A = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;align-items:center;gap:6px;min-width:0;width:100%;overflow:hidden;`, PA = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G).attrs({
  variant: "h2",
  color: b.themedColor.textHighEmphasis
})`
  margin: 0;
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 2px 0;

  &:focus {
    outline: none;
  }
`, FA = (e) => {
  const { components: t } = Zt.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nc,
    {
      start: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.StartArea, null),
      title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TitleArea, null),
      titleAlign: e.titleAlign,
      end: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.EndArea, null),
      containerProps: Oa
    }
  );
}, UA = () => {
  const { components: e } = Zt.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.MenuButton, null);
}, BA = () => {
  const { components: e } = Zt.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Title, null);
}, HA = () => {
  const { components: e } = Zt.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VA, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.MemoryIndicator, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.HandoffButton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.ConversationCloseButton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.ExpandButton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.CloseButton, null));
}, Zt = ot({
  template: FA,
  components: {
    StartArea: UA,
    TitleArea: BA,
    EndArea: HA,
    MenuButton: NA,
    Title: DA,
    MemoryIndicator: xA,
    HandoffButton: TA,
    ConversationCloseButton: mA,
    ExpandButton: hA,
    CloseButton: dA
  }
}), GA = () => {
  const { Template: e } = Zt.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e, { titleAlign: "start" });
}, VA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;gap:10px;align-items:center;justify-content:center;`, zA = ({
  children: e,
  onNavigateToConversationList: t,
  channelUrl: n,
  onClearChannelUrl: r,
  shouldMarkAsRead: s,
  shouldInitializeConversation: o,
  initialUserMessage: i,
  announcementsEnabled: c = !0,
  conversationStatsEnabled: l,
  initialFocusTarget: u,
  style: d,
  closedChannelUrl: m,
  onClearClosedChannelUrl: h
}) => {
  const { Template: g } = Gs.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    L_,
    {
      onNavigateToConversationList: t,
      channelUrl: n ?? m,
      onClearChannelUrl: r ?? h,
      conversationStatsEnabled: l,
      shouldMarkAsRead: s,
      shouldInitializeConversation: o,
      initialUserMessage: i
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Kr, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Kr.Consumer, null, (f) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dp, { announcementsEnabled: c }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(KA, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WA, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(YA, { style: d, dragHandlers: f, initialFocusTarget: u }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(g, null)), e)))
  );
}, KA = () => (P_(), null), WA = () => (Z_(), G_(), q_(), null), YA = ({
  style: e,
  dragHandlers: t,
  initialFocusTarget: n,
  children: r
}) => {
  const s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return $_(s, n), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jA, { ref: s, style: e, ...t }, r);
}, qA = (e) => {
  const { components: t } = Gs.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Header, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Body, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.Footer, null));
}, Gs = ot({
  template: qA,
  components: {
    Header: GA,
    Body: py,
    Footer: nA
  }
}), jA = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`height:100%;width:100%;display:flex;flex-direction:column;flex:1;background-color:${({ theme: e }) => e.colors.base.background};`, $c = xe(
  "ConversationListAnnouncements",
  {
    announcementsEnabled: !0,
    announceScreenEntry: Ae
  }
), XA = $c.Provider, Vs = $c.useContext, ZA = ({
  children: e,
  announcementsEnabled: t = !0
}) => {
  const { announceScreenEntry: n } = As(), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (o) => {
      t && n(o);
    },
    [n, t]
  ), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({
      announcementsEnabled: t,
      announceScreenEntry: r
    }),
    [t, r]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(XA, { value: s }, e);
}, {
  Provider: JA,
  Context: m0,
  useContext: ar
} = xe("ConversationList");
function QA({
  conversationListLimit: e,
  conversationListFilter: t,
  conversationListStatsEnabled: n,
  onOpenConversationView: r = Ae,
  children: s
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    lg,
    {
      conversationListLimit: e,
      conversationListFilter: t,
      conversationListStatsEnabled: n
    },
    (o) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(JA, { value: { ...o, onOpenConversationView: r } }, s)
  );
}
const eT = (e) => {
  const { announcementsEnabled: t } = Vs(), { listSource: n } = ar(), r = Ha();
  ic(e, {
    enabled: t,
    ready: n.initialized,
    suppressed: r
  });
}, tT = () => {
  const { announceScreenEntry: e, announcementsEnabled: t } = Vs(), { listSource: n } = ar(), r = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!t) {
      r.current = !1;
      return;
    }
    if (!n.initialized || r.current) return;
    const s = n.channels.length, o = setTimeout(() => {
      e({ screen: "conversationList", conversationCount: s }), r.current = !0;
    }, 0);
    return () => clearTimeout(o);
  }, [e, t, n.initialized]);
}, nT = ({ channel: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dc, { channel: e }), Jr = 99, rT = (e) => {
  var _, p;
  const { channel: t, onClick: n } = e, { stringSet: r, format: s } = fe(), { userSession: o, aiAgentInfo: i } = Ge(), { conversationList: c } = pe(), l = vs({ channel: t, userSession: o, aiAgentInfo: i }), u = km(t, {
    formatMultipleFilesCount: r.CONVERSATION_LIST__MULTIPLE_FILES_COUNT
  }), d = Om(t, s, {
    justNow: r.DATE_FORMAT__JUST_NOW,
    minutesAgo: r.DATE_FORMAT__MINUTES_AGO,
    hoursAgo: r.DATE_FORMAT__HOURS_AGO,
    dateShortFormat: r.DATE_FORMAT__DATE_SHORT
  }), m = t.unreadMessageCount, h = (_ = t.lastMessage) != null && _.isAdminMessage() ? r.CONVERSATION_LIST__SYSTEM_MESSAGE : l.title, g = He(t) ? r.CONVERSATION_LIST__ENDED : "", f = n ? () => n() : void 0, v = c.item({
    agent: h,
    status: g,
    lastMessage: u,
    time: d,
    unreadCount: m,
    onActivate: f
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(sT, { "data-testid": "sb-conversation-list-item", $clickable: !!f, ...v.props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oT, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nT, { ...e })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(iT, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(aT, null, (p = t.lastMessage) != null && p.isFileMessage() && (!t.lastMessage.message || t.lastMessage.name === t.lastMessage.message) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mc, { variant: "subtitle1", color: b.themedColor.textHighEmphasis }, u) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "subtitle1", color: b.themedColor.textHighEmphasis, maxTextLines: 1 }, u), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(cT, null, He(t) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption1", color: b.themedColor.textMidEmphasis, maxTextLines: 1 }, r.CONVERSATION_LIST__ENDED), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lT, null)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption2", color: b.themedColor.textLowEmphasis, maxTextLines: 1 }, d))), m > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(uT, { $count: m }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(G, { variant: "caption3", color: b.themedColor.textHighEmphasisInverse }, m <= Jr ? m : `${Jr}+`))), v.descriptionNode);
}, Pc = ot({
  template: rT,
  // Note: 리스트 변경되면 디자인 변경 가능성이 있어서 일단 컴포넌트는 비워둠
  components: {}
}), sT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-shrink:0;flex-direction:row;align-items:center;position:relative;width:100%;height:72px;box-sizing:border-box;gap:16px;cursor:${({ $clickable: e }) => e ? "pointer" : "default"};`, oT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;padding-inline-start:16px;`, iT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:row;align-items:center;flex:1;min-width:0;padding-inline-end:16px;height:100%;gap:8px;border-bottom:1px solid ${b.themedColor.textDisabled};`, aT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;justify-content:center;flex:1;min-width:0;gap:4px;word-break:break-word;overflow-wrap:break-word;`, cT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;gap:6px;`, lT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:2px;height:2px;border-radius:1px;background-color:${b.themedColor.textLowEmphasis};`, uT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;align-items:center;justify-content:center;height:20px;padding:4px;border-radius:10px;background-color:${b.themedColor.error};${({ $count: e }) => e <= Jr && styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
      width: 20px;
    `}
`, dT = ({ items: e, renderItem: t, onEndReached: n, role: r, "aria-label": s }) => {
  const o = (i) => {
    const c = i.target;
    c.scrollHeight - c.scrollTop - c.clientHeight <= 2 && (n == null || n());
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mT, { role: r, "aria-label": s, onScroll: (i) => o(i) }, e.map((i, c) => {
    const l = t(i, c);
    if (r !== "list") return l;
    const u = (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(l) && l.key != null ? l.key : c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(hT, { key: u, role: "listitem" }, l);
  }));
}, mT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:100%;height:100%;display:flex;flex-direction:column;flex:1;overflow:auto;overscroll-behavior:contain;`, hT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`flex-shrink:0;`, gT = () => {
  const { stringSet: e } = fe(), { listSource: t, onOpenConversationView: n } = ar(), { Template: r } = Pc.useContext();
  return t.initialized ? t.channels.length === 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ln, { type: "noChannels", label: e.CONVERSATION_LIST__NO_CONVERSATIONS }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    dT,
    {
      role: "list",
      "aria-label": e.CONVERSATION_LIST__HEADER_TITLE,
      items: t.channels,
      renderItem: (s) => {
        var o, i, c;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          r,
          {
            key: s.url,
            channel: s,
            onClick: () => n(s.url, He(s) ? "closed" : "open"),
            channelUrl: s.url,
            title: (i = (o = s.conversation) == null ? void 0 : o.topics) == null ? void 0 : i.join(", "),
            lastMessageTimestamp: (c = s.lastMessage) == null ? void 0 : c.createdAt
          }
        );
      },
      onEndReached: () => {
        t.loadMore();
      }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ln, { type: "loading" });
}, fT = () => {
  const { stringSet: e } = fe(), { _aiAgentSDK: t } = we(), { language: n, countryCode: r, context: s } = Ee(), { aiAgentInfo: o, refreshActiveChannel: i, createConversation: c } = Ge(), { onOpenConversationView: l } = ar(), { conversationList: u } = pe(), d = async () => {
    var m;
    if (o.isMultipleActiveConversationsEnabled) {
      const h = await c({
        aiAgentId: o.userId,
        language: n,
        country: r,
        context: s
      });
      (m = t.session) == null || m._updateActiveChannel({ url: h, status: "open" }), l(h, "open", { initialFocusTarget: "messageInput" });
    } else {
      const h = await i();
      l(h, "open", { initialFocusTarget: "messageInput" });
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pT, { ...u.footer.button({ onActivate: d }).props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_T, { variant: "h1" }, e.TALK_TO_AGENT));
}, pT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`background-color:${({ theme: e }) => e.colors.base.primary};display:flex;align-items:center;justify-content:center;padding:16px;cursor:pointer;`, _T = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`color:${({ theme: e }) => e.colors.base.primaryContrastContent};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`, ET = () => {
  const { state: e } = Ee(), { messenger: t } = pe(), n = Xt(), r = () => {
    e.setOpened(!1);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lt, { ...t.closeButton().props, type: "close", size: n, onClick: r });
}, CT = () => {
  const { stringSet: e } = fe(), { announcementsEnabled: t } = Vs(), { conversationList: n } = pe(), r = e.CONVERSATION_LIST__HEADER_TITLE, s = oc({ enabled: t, label: r }), o = {
    title: n.headerTitle(r, {
      active: s.enabled,
      titleId: s.id
    })
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vT, { forwardedAs: "h2", variant: "h2", color: b.themedColor.textHighEmphasis, ...o.title.props }, r);
}, vT = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`margin:0;padding:0 4px;min-width:0;width:100%;box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;`, bT = (e) => {
  const { components: t } = yn.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Nc,
    {
      start: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.StartArea, null),
      title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.TitleArea, null),
      titleAlign: e.titleAlign,
      end: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t.EndArea, null),
      containerProps: Oa
    }
  );
}, ST = () => null, yT = () => {
  const { components: e } = yn.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Title, null);
}, AT = () => {
  const { components: e } = yn.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.CloseButton, null);
}, yn = ot({
  template: bT,
  components: {
    StartArea: ST,
    TitleArea: yT,
    EndArea: AT,
    Title: CT,
    CloseButton: ET
  }
}), TT = () => {
  const { Template: e } = yn.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e, { titleAlign: "start" });
}, IT = () => (tT(), null), xT = ({
  conversationListLimit: e,
  conversationListFilter: t,
  children: n,
  onOpenConversationView: r,
  announcementsEnabled: s = !0,
  conversationListStatsEnabled: o,
  style: i
}) => {
  const { Template: c } = zs.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    QA,
    {
      conversationListLimit: e,
      conversationListFilter: t,
      conversationListStatsEnabled: o,
      onOpenConversationView: r
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZA, { announcementsEnabled: s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IT, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MT, { style: i }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(c, null)), n)
  );
}, MT = ({ style: e, children: t }) => {
  const n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  return eT(n), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wT, { ref: n, style: e }, t);
}, RT = () => {
  const { components: e } = zs.useContext();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Header, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Body, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Footer, null));
}, zs = ot({
  template: RT,
  components: {
    Header: TT,
    Body: gT,
    Footer: fT
  }
}), wT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`height:100%;width:100%;display:flex;flex-direction:column;flex:1;background-color:${({ theme: e }) => e.colors.base.background};`, kT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`:where(#${Me.ENTRY}) :not(code *){font-family:'Roboto',sans-serif;box-sizing:border-box;}`, LT = [kT, ap, cp], OT = (e, ...t) => (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .createGlobalStyle */ .vJ)(e, ...LT, ...t), NT = OT``, DT = wm(
  Gs,
  kt,
  Sn,
  Ds,
  Us,
  zs,
  Zt,
  Pc,
  yn,
  Fs,
  xs
), $T = typeof __SBA_USE_MESSAGE_TEMPLATE__ > "u" || __SBA_USE_MESSAGE_TEMPLATE__;
function PT({
  appearance: e,
  rootElement: t,
  logger: n,
  language: r,
  languageCode: s,
  stringSet: o,
  children: i,
  messageTemplate: c,
  icons: l,
  theme: u,
  entryElement: d,
  modalRootElement: m
}) {
  Mp($T ? qf : "", t);
  const [h, g] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((p) => {
    g((y) => y === p ? y : p);
  }, []), v = d ?? h, _ = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(styled_components__WEBPACK_IMPORTED_MODULE_15__/* .StyleSheetManager */ .LC, { target: t }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tp, { rootElement: t, logger: n, appearance: e, theme: u }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Jf, { rootElement: t, boundaryElement: v }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mg, { internalVariables: c == null ? void 0 : c.__internalVariables }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ip, { stringSet: o, logger: n, language: r, languageCode: s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sp, { icons: l }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DT, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    Xf,
    {
      entryElement: v,
      modalRootElement: m,
      rootElement: t
    },
    i
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NT, null))))))));
  return d ? _ : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: f, style: { display: "contents" } }, _);
}
const FT = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), s = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((i) => {
    t((c) => c === i ? c : i);
  }, []), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((i) => {
    r((c) => c === i ? c : i);
  }, []);
  return { entryElement: e, modalRootElement: n, setEntryElement: s, setModalRootElement: o };
}, Fc = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({
  rootElement: t = document.body,
  logLevel: n = _sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.p.WARN,
  language: r = navigator.language,
  userSessionInfo: s,
  children: o,
  chatParams: i,
  icons: c,
  ...l
}, u) {
  var _, p, y;
  on.level !== n && (on.level = n);
  const { entryElement: d, modalRootElement: m, setEntryElement: h, setModalRootElement: g } = FT();
  xp("https://fonts.googleapis.com/css2?family=Roboto&display=swap", t);
  const f = Fa(r), v = Ua.has(f) ? f : En;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      ref: h,
      id: Me.ENTRY,
      lang: v,
      style: { width: "fit-content", height: "fit-content", ...l.entryStyle }
    },
    d && m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      PT,
      {
        logger: on,
        rootElement: t,
        appearance: (_ = l.agentPreviewConfigs) == null ? void 0 : _.appearance,
        stringSet: l.stringSet,
        language: v,
        messageTemplate: l.messageTemplate,
        icons: c,
        theme: l.theme,
        entryElement: d,
        modalRootElement: m
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        a_,
        {
          rootElement: t,
          language: r,
          logger: on,
          dispatcher: UT,
          chatParams: {
            ...i,
            ...l.customApiHost && { customApiHost: l.customApiHost },
            ...l.customWebSocketHost && { customWebSocketHost: l.customWebSocketHost }
          },
          chatSDK: l.customChatSDK,
          _forceCreateChannel: (p = l.agentPreviewConfigs) == null ? void 0 : p.forceCreateChannel,
          _agentVersion: (y = l.agentPreviewConfigs) == null ? void 0 : y.agentVersion,
          ...l
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(f_, { ref: u, userSessionInfo: s }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(My, { ...l._UNSAFE_INTERNAL_dashboardTester }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Op, null, o)))
      )
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: g, id: Me.MODAL_ROOT, dir: l.dir })
  );
}), on = new Qi(_sendbird_chat__WEBPACK_IMPORTED_MODULE_8__.p.WARN), UT = new ji(on), Jn = () => {
  const [e, t] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((r) => t(() => r), []);
  return [e, n];
}, {
  Provider: BT,
  useContext: An
} = xe("PageChildren"), Uc = ({ children: e }) => {
  const [t, n] = Jn(), [r, s] = Jn(), [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    BT,
    {
      value: {
        conversationComponent: t,
        setConversationComponent: n,
        conversationChildren: o,
        setConversationChildren: i,
        conversationListComponent: r,
        setConversationListComponent: s,
        conversationListChildren: c,
        setConversationListChildren: l
      }
    },
    e
  );
}, HT = 48, GT = 2 / 3, ki = 12;
function VT({
  className: e,
  children: t,
  isOpened: n,
  onClick: r,
  "aria-label": s,
  "aria-describedby": o,
  type: i,
  imageUrl: c,
  dir: l,
  animated: u = !0,
  backgroundColor: d,
  size: m = HT,
  hasUnread: h = !1
}) {
  const g = _c(), f = u && !g, v = Fr(d), _ = Math.round(m * GT);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    WT,
    {
      dir: l,
      id: Me.LAUNCHER,
      className: e,
      "aria-label": s,
      "aria-describedby": o,
      onClick: r,
      $animated: f,
      $backgroundColor: d,
      $prefersReducedMotion: g,
      $size: m
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      YT,
      {
        $isOpened: n,
        $animated: f,
        $fillColor: v,
        $iconSize: _,
        $prefersReducedMotion: g
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Li.Open, { url: c, isDefaultIcon: i === "default_icon", size: _ })
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      qT,
      {
        $isOpened: n,
        $animated: f,
        $fillColor: v,
        $iconSize: _,
        $prefersReducedMotion: g
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Li.Close, { size: _ })
    ),
    h && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(jT, null),
    t
  );
}
const zT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`&:hover{transition:transform 250ms cubic-bezier(0.33,0,0,1);transform:scale(1.1);}&:active{transform:scale(0.8);}`, KT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`img{width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-drag:none;&[data-default-icon='true']{width:${({ $iconSize: e }) => e}px;height:${({ $iconSize: e }) => e}px;filter:${({ $fillColor: e }) => e === un.WHITE ? "grayscale(100%) brightness(2000%)" : "grayscale(100%) invert(100%) saturate(0%) brightness(0%) contrast(1000%)"};}}`, Bc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`svg{width:${({ $iconSize: e }) => e}px;height:${({ $iconSize: e }) => e}px;${({ $fillColor: e }) => styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
        ellipse,
        path {
          fill: ${e};
        }
        [class*='fill'] {
          fill: ${e};
        }
      `}
  }
`, WT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`position:relative;padding:0;width:${({ $size: e }) => e}px;height:${({ $size: e }) => e}px;background:${({ $backgroundColor: e }) => e};border-radius:50%;transition:${({ $prefersReducedMotion: e }) => e ? "none" : "all 0.3s cubic-bezier(0.31, -0.105, 0.43, 1.4)"};border:none;display:flex;justify-content:center;align-items:center;box-shadow:${Qa};${({ $animated: e }) => e && zT}`, Hc = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span.attrs */ .ZP.span.attrs({
  "aria-hidden": "true"
})`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
`, YT = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Hc)`transition:${({ $prefersReducedMotion: e }) => e ? "none" : "transform 0.16s linear, opacity 0.08s linear, scale 0.16s linear"};opacity:${({ $isOpened: e }) => e ? 0 : 1};transform:${({ $animated: e, $isOpened: t }) => e && (t ? "rotate(-90deg) scale(0)" : "rotate(0deg)")};${KT}${Bc}`, qT = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Hc)`transition:${({ $prefersReducedMotion: e }) => e ? "none" : "transform 0.16s linear, opacity 0.08s linear, scale 0.16s linear"};scale:${({ $isOpened: e }) => e ? 1 : 0};transform:${({ $animated: e, $isOpened: t }) => e && (t ? "rotate(0deg)" : "rotate(-90deg)")};${Bc}`, jT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].span.attrs */ .ZP.span.attrs({ "aria-hidden": "true" })`
  position: absolute;
  top: 1px;
  inset-inline-end: 1px;
  width: ${ki}px;
  height: ${ki}px;
  border-radius: 50%;
  background-color: ${b.themedColor.error};
`, Li = {
  Open: (e) => e.url ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: e.url, alt: "", "data-default-icon": e.isDefaultIcon }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: e.size, type: "delight" }),
  Close: ({ size: e }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe, { size: e, type: "chevron-down" })
};
function Gc({
  opened: e,
  setOpened: t,
  className: n,
  size: r,
  entryPoint: s = "Conversation",
  activeRoute: o
}) {
  const { colors: i } = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .useTheme */ .Fg)(), { chatSDK: c, config: l, dir: u } = Ee(), { resolveElement: d } = Ss(), { launcher: m } = pe(), { launcherInfo: h } = Ge(), g = l.launcher.unreadBadgeEnabled, f = fa(), v = qg(c, {
    enabled: g,
    opened: e,
    filter: f
  }), _ = (o ?? s) === "ConversationList", p = {
    launcher: m.button({ isOpened: e, opensConversationList: _ })
  }, y = () => {
    Oe(() => {
      const I = d(Me.WINDOW), k = I ? qa(I) : null;
      k == null || k.focus();
    });
  }, S = () => {
    Oe(() => {
      var I;
      (I = d(Me.LAUNCHER)) == null || I.focus();
    });
  }, A = () => {
    const I = !e;
    t(I), I ? y() : S();
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    VT,
    {
      dir: u,
      className: n,
      isOpened: e,
      onClick: A,
      type: h.type,
      imageUrl: h.imageUrl,
      backgroundColor: i.base.primary,
      size: r,
      hasUnread: g && !e && v,
      ...p.launcher.props
    },
    p.launcher.descriptionNode
  );
}
const Vc = () => (Yg("launcher_toggle"), null), zc = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function cr() {
  const e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(zc);
  if (!e)
    throw new Error("useNavigator() must be used within <Navigator />");
  return e;
}
function Kc({ children: e }) {
  const t = cr();
  return typeof e == "function" ? e(t) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e);
}
function Wc({ children: e }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e);
}
const XT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .keyframes */ .F4`0%{transform:translateY(40px);opacity:0;}100%{transform:translateY(0px);opacity:1;}`, ZT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .keyframes */ .F4`0%{transform:translateY(0px);opacity:1;}100%{transform:translateY(40px);opacity:0;}`, JT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`animation-name:${XT};animation-duration:0.3s;animation-fill-mode:forwards;`, QT = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv``, eI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`animation-name:${ZT};animation-duration:0.3s;animation-fill-mode:forwards;`, tI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`visibility:hidden;`, nI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:absolute;top:0;left:0;width:100%;height:100%;${({ $transitionState: e }) => {
  switch (e) {
    case "entering":
      return JT;
    case "entered":
      return QT;
    case "exiting":
      return eI;
    case "exited":
      return tI;
    default:
      return "";
  }
}}${({ $active: e }) => e ? styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`
          z-index: 999;
        ` : styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`z-index:1;pointer-events:none;`}
`;
function zt({ initialId: e, children: t }) {
  const [n, r] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([e]), s = n[n.length - 1], o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((p, y) => {
    r((S) => [...S, p]), h((S) => ({ ...S, [p]: !0 })), y != null && y.reset && _((S) => ({
      ...S,
      [p]: (S[p] || 0) + 1
    })), f((S) => ({
      ...S,
      [p]: "entering"
    })), setTimeout(() => {
      f((S) => ({
        ...S,
        [p]: "entered"
      }));
    }, 300);
  }, []), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    r((p) => {
      if (p.length <= 1) return p;
      const y = p[p.length - 1];
      return f((S) => ({
        ...S,
        [y]: "exiting"
      })), setTimeout(() => {
        f((S) => ({
          ...S,
          [y]: "exited"
        })), r((S) => S.slice(0, -1));
      }, 300), p;
    });
  }, []), c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    navigation: {
      navigate: o,
      pop: i
    },
    activeScreenId: s
  }), [o, i, s]), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(t).filter(
    (p) => p.type === Kc
  ), [t]), u = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(t).filter((p) => p.type === Wc), [t]), d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const p = {};
    return l.forEach((y) => {
      const { id: S, lazy: A, children: I } = y.props;
      p[S] = { lazy: A, element: typeof I == "function" ? I(c) : I };
    }), p;
  }, [l, c]), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    const p = {};
    return Object.entries(d).forEach(([y, { lazy: S }]) => {
      S === !1 && (p[y] = !0);
    }), p[e] = !0, p;
  }), [g, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    const p = {};
    return Object.keys(d).forEach((y) => {
      y === e ? p[y] = "entered" : p[y] = "exited";
    }), p;
  }), [v, _] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({});
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zc.Provider, { value: c }, u, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rI, null, Object.keys(d).map((p) => {
    var I;
    if (!m[p]) return null;
    const y = g[p] || "exited", S = p === s, A = `${p}-${v[p] || 0}`;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      nI,
      {
        key: A,
        $transitionState: y,
        $active: S,
        "aria-hidden": S ? void 0 : !0,
        inert: S ? void 0 : !0
      },
      (I = d[p]) == null ? void 0 : I.element
    );
  })));
}
const rI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;width:100%;height:100%;`;
zt.Screen = Kc;
zt.Effect = Wc;
const Je = {
  conv: "conv",
  convList: "conv-list"
}, sI = (e) => e === Je.convList ? "ConversationList" : "Conversation", Yc = ({
  isOpened: e,
  entryPoint: t,
  selectedChannelUrl: n,
  setSelectedChannelUrl: r,
  nudgeConversation: s,
  onActiveRouteChange: o
}) => {
  const { conversationComponent: i, conversationChildren: c, conversationListComponent: l, conversationListChildren: u } = An(), d = i ?? zA, m = l ?? xT, [h, g] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), f = (() => {
    switch (t) {
      case "Conversation":
        return Je.conv;
      case "ConversationList":
        return Je.convList;
      default:
        return Je.conv;
    }
  })(), v = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    oI,
    {
      onOpenConversationView: (_, p) => {
        r(p), g(void 0), _.navigate(Je.conv);
      }
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(aI, { onActiveRouteChange: o }));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zt, { initialId: f }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zt.Effect, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    iI,
    {
      nudgeConversation: s,
      onNavigate: (_) => {
        g("messageInput"), _.navigate(Je.conv);
      }
    }
  )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zt.Screen, { id: Je.conv }, ({ navigation: _, activeScreenId: p }) => {
    const y = p === Je.conv, S = e && y;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, v, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      d,
      {
        key: n,
        channelUrl: n,
        onClearChannelUrl: () => r(void 0),
        onNavigateToConversationList: () => {
          g(void 0), _.navigate(Je.convList);
        },
        announcementsEnabled: S,
        conversationStatsEnabled: S,
        shouldMarkAsRead: S,
        shouldInitializeConversation: S,
        initialUserMessage: s && s.channelUrl === n ? s.initialUserMessage : void 0,
        initialFocusTarget: h
      },
      c
    ));
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(zt.Screen, { id: Je.convList, lazy: !0 }, ({ navigation: _, activeScreenId: p }) => {
    const y = p === Je.convList, S = e && y;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, v, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      m,
      {
        announcementsEnabled: S,
        conversationListStatsEnabled: S,
        onOpenConversationView: (A, I, k) => {
          r(A), g(k == null ? void 0 : k.initialFocusTarget), _.navigate(Je.conv);
        }
      },
      u
    ));
  }));
}, oI = ({
  onOpenConversationView: e
}) => {
  const { registerOnJoinedProactiveConversation: t } = Ge(), { navigation: n } = cr();
  return t(({ channel: r }) => {
    e(n, r.url);
  }), null;
}, iI = ({
  nudgeConversation: e,
  onNavigate: t
}) => {
  const { navigation: n } = cr();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e && t(n);
  }, [e]), null;
}, aI = ({ onActiveRouteChange: e }) => {
  const { activeScreenId: t } = cr();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    e == null || e(sI(t));
  }, [t, e]), null;
}, Ks = (e, t) => e ? {
  role: "dialog",
  "aria-modal": "true",
  ...t ? { "aria-labelledby": Me.WINDOW_TITLE } : { "aria-label": "Messenger" }
} : {
  "aria-hidden": "true",
  inert: !0
}, cI = ({ isExpanded: e, isOpened: t, children: n, launcher: r }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rs, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(lI, { isExpanded: e, isOpened: t, launcher: r }, n)), lI = ({ isExpanded: e, isOpened: t, children: n, launcher: r }) => {
  const { dir: s } = Ee(), o = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), { hasWindowTitleReference: i, isWindowNameReady: c } = or();
  return sr(t, o, { nameReady: c }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(uI, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    dI,
    {
      ref: o,
      dir: s,
      id: Me.WINDOW,
      ...Ks(t, i),
      $isExpanded: e,
      $isOpened: t
    },
    n
  ), r);
}, uI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`display:flex;flex-direction:column;gap:8px;align-items:flex-end;`, dI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`background:${({ theme: e }) => e.colors.base.background};display:flex;overscroll-behavior:none;-webkit-overflow-scrolling:auto;height:640px;min-height:80px;width:400px;max-width:80vw;max-height:80vh;box-shadow:0px 16px 24px 2px rgba(33,33,33,0.12),0px 6px 30px 5px rgba(33,33,33,0.08),0px 6px 10px -5px rgba(33,33,33,0.04);border-radius:16px;overflow:hidden;transition:width 200ms ease 0s,height 200ms ease 0s,max-height 200ms ease 0s,transform 150ms cubic-bezier(0,1.2,1,1) 0s,opacity 83ms ease-out 0s;transform:scale(0.15);opacity:0;transform-origin:right bottom;[dir='rtl'] &:not([dir='ltr']),&[dir='rtl']{transform-origin:left bottom;}${({ $isOpened: e }) => e && hI};${({ $isExpanded: e }) => e && mI};`, mI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`width:743px;height:723px;`, hI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`pointer-events:all;transform:scale(1);opacity:1;transition:width 200ms ease 0s,height 200ms ease 0s,max-height 200ms ease 0s,transform 300ms cubic-bezier(0,1.2,1,1) 0s,opacity 83ms ease-out 0s;`, gI = ({ isMessengerOpened: e, onConversationStarted: t, className: n }) => {
  const r = _a({ isMessengerOpened: e, onConversationStarted: t });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(qc, { ...r, className: n });
}, qc = ({
  nudgeMessage: e,
  nudgeMessageKey: t,
  dismissNudgeMessage: n,
  startNudgeConversation: r,
  className: s
}) => {
  const { stringSet: o } = fe(), { dir: i } = Ee();
  return e ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(pI, { key: t, id: Me.NUDGE_MESSAGE, className: s, dir: i }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_I, { onClick: r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EI, { variant: "body3", color: b.themedColor.textHighEmphasis, maxTextLines: 2 }, e.message)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    CI,
    {
      type: "close",
      size: 16,
      "aria-label": o.A11Y_DISMISS_NUDGE_MESSAGE,
      onClick: n
    }
  )) : null;
}, jc = 12, fI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .keyframes */ .F4`from{opacity:0;transform:scale(0.8);}`, pI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`position:relative;display:flex;align-items:flex-start;gap:8px;padding:16px;min-width:120px;max-width:320px;box-sizing:border-box;border-radius:${jc}px;background-color:${b.themedColor.bg_50_600};box-shadow:${Qa};animation-name:${fI};animation-duration:0.3s;animation-timing-function:cubic-bezier(0.31,-0.105,0.43,1.4);@media (prefers-reduced-motion:reduce){animation-name:none;}`, _I = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].button */ .ZP.button`all:unset;flex:1;min-width:0;cursor:pointer;text-align:start;${Ne}&::after{content:'';position:absolute;inset:0;border-radius:${jc}px;}`, EI = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(G)`line-height:20px;overflow-wrap:anywhere;white-space:pre-line;`, CI = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(lt)`position:relative;margin:-4px;`, vI = 1e3 * 60, Xc = () => {
  const { chatSDK: e, state: t, logger: n, enableAutoDisconnectInLauncher: r } = Ee();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!r) return;
    if (t.opened) {
      e.connectionState === _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.w.CLOSED && (e.reconnect(), n.debug("SDKInactivityTimeout: reconnected"));
      return;
    }
    const s = setTimeout(async () => {
      await e.disconnectWebSocket(), n.debug("SDKInactivityTimeout: disconnected");
    }, vI);
    return n.debug("SDKInactivityTimeout: schedule disconnect"), () => clearTimeout(s);
  }, [r, e, t.opened, n]), null;
}, h0 = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ children: e, initialChannelUrl: t, ...n }, r) {
  const [s, o] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t), [i, c] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), [l, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(n.entryPoint ?? "Conversation");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fc, { enableExpandButton: !Cn(), ref: r, ...n }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xa, null, ({ state: d }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Uc, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xc, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vc, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    cI,
    {
      isExpanded: d.expanded,
      isOpened: d.opened,
      launcher: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        gI,
        {
          isMessengerOpened: d.opened,
          onConversationStarted: (m) => {
            o(m.channelUrl), c(m), d.setOpened(!0);
          }
        }
      ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        Gc,
        {
          opened: d.opened,
          setOpened: d.setOpened,
          entryPoint: n.entryPoint,
          activeRoute: l
        }
      ))
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Yc,
      {
        isOpened: d.opened,
        entryPoint: n.entryPoint,
        selectedChannelUrl: s,
        setSelectedChannelUrl: o,
        nudgeConversation: i,
        onActiveRouteChange: u
      }
    )
  ), e)));
}), {
  Provider: bI,
  useContext: Jt
} = xe("FixedMessengerStyle"), SI = ({ children: e, isOpened: t, zIndex: n = Dt.WINDOW }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rs, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(yI, { isOpened: t, zIndex: n }, e)), yI = ({ children: e, isOpened: t, zIndex: n = Dt.WINDOW }) => {
  const { dir: r, rootElement: s } = Ee(), o = yt(s, !0), i = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), { hasWindowTitleReference: c, isWindowNameReady: l } = or();
  return sr(t, i, { nameReady: l }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const u = "sb-agent-block-scroll";
    return t ? o.body.classList.add(u) : o.body.classList.remove(u), () => {
      o.body.classList.remove(u);
    };
  }, [o, t]), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    AI,
    {
      ref: i,
      id: Me.WINDOW,
      dir: r,
      ...Ks(t, c),
      $visible: t,
      $zIndex: n
    },
    e
  );
}, AI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`width:100%;height:100%;position:fixed;top:0;left:0;z-index:${({ $zIndex: e }) => e};visibility:${({ $visible: e }) => e ? "visible" : "hidden"};`;
function Zc(e, t, n, r) {
  const { top: s, bottom: o, start: i, end: c } = n;
  return {
    ...e === "start" ? { insetInlineStart: ct(i) } : { insetInlineEnd: ct(c) },
    ...t === "top" ? { top: `calc(${ct(s)} + ${r}px)` } : { bottom: `calc(${ct(o)} + ${r}px)` }
  };
}
const Qr = { position: "fixed", zIndex: Dt.LAUNCHER };
function Jc(e, t, n, r = 0) {
  return styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`&&{position:${Qr.position};z-index:${Qr.zIndex};${Qc(e, t, n, r)};}`;
}
function Qc(e, t, n, r = 0) {
  return (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv)(Zc(e, t, n, r));
}
function el(e, t, n, r, s) {
  return {
    ...Qr,
    direction: s,
    ...Zc(e, t, n, r)
  };
}
function TI(e) {
  const { horizontal: t, vertical: n, margin: r, launcherSize: s } = Jt();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(II, { ...e, size: s, $horizontal: t, $vertical: n, $margin: r });
}
const II = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(Gc)`${({ $horizontal: e, $vertical: t, $margin: n }) => Jc(e, t, n)};`, tl = xe("FixedMessengerSlots"), xI = tl.Provider, lr = tl.useContext, MI = ({ children: e }) => {
  const [t, n] = Jn(), [r, s] = Jn();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(xI, { value: { launcherComponent: t, setLauncherComponent: n, nudgeMessageComponent: r, setNudgeMessageComponent: s } }, e);
}, RI = ({ isExpanded: e, isOpened: t, children: n }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rs, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(wI, { isExpanded: e, isOpened: t }, n)), wI = ({ isExpanded: e, isOpened: t, children: n }) => {
  const { dir: r } = Ee(), { horizontal: s, vertical: o, margin: i, launcherSize: c } = Jt(), l = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), { hasWindowTitleReference: u, isWindowNameReady: d } = or();
  return sr(t, l, { nameReady: d }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    kI,
    {
      ref: l,
      dir: r,
      id: Me.WINDOW,
      ...Ks(t, u),
      $isExpanded: e,
      $isOpened: t,
      $horizontal: s,
      $vertical: o,
      $margin: i,
      $launcherSize: c
    },
    n
  );
}, kI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div`background:${({ theme: e }) => e.colors.base.background};display:flex;overscroll-behavior:none;-webkit-overflow-scrolling:auto;position:fixed;pointer-events:none;visibility:hidden;${({ $horizontal: e, $vertical: t, $margin: n, $launcherSize: r }) => Qc(e, t, n, r + 12)};height:640px;min-height:80px;width:400px;max-width:80vw;max-height:80vh;box-shadow:0px 16px 24px 2px rgba(33,33,33,0.12),0px 6px 30px 5px rgba(33,33,33,0.08),0px 6px 10px -5px rgba(33,33,33,0.04);border-radius:16px;overflow:hidden;transition:width 200ms ease 0s,height 200ms ease 0s,max-height 200ms ease 0s,transform 150ms cubic-bezier(0,1.2,1,1) 0s,opacity 83ms ease-out 0s,visibility 0s linear 150ms;transform:scale(0.15);opacity:0;transform-origin:${({ $horizontal: e, $vertical: t }) => `${e === "start" ? "left" : "right"} ${t}`};
  [dir='rtl'] &:not([dir='ltr']),
  &[dir='rtl'] {
    transform-origin: ${({ $horizontal: e, $vertical: t }) => `${e === "start" ? "right" : "left"} ${t}`};
  }

  ${({ $isOpened: e }) => e && OI};
  ${({ $isExpanded: e }) => e && LI};
`, LI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`width:743px;height:723px;`, OI = styled_components__WEBPACK_IMPORTED_MODULE_15__/* .css */ .iv`z-index:${Dt.WINDOW};pointer-events:all;visibility:visible;transform:scale(1);opacity:1;transition:width 200ms ease 0s,height 200ms ease 0s,max-height 200ms ease 0s,transform 300ms cubic-bezier(0,1.2,1,1) 0s,opacity 83ms ease-out 0s,visibility 0s linear 0s;`, NI = 8, nl = (e) => e + NI, DI = (e) => {
  const { horizontal: t, vertical: n, margin: r, launcherSize: s } = Jt();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    $I,
    {
      ...e,
      $horizontal: t,
      $vertical: n,
      $margin: r,
      $launcherSize: s
    }
  );
}, $I = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(qc)`${({ $horizontal: e, $vertical: t, $margin: n, $launcherSize: r }) => Jc(e, t, n, nl(r))};`, rl = { top: 24, bottom: 24, start: 24, end: 24 }, PI = (e) => {
  const { launcherComponent: t } = lr(), { horizontal: n, vertical: r, margin: s, launcherSize: o } = Jt(), { dir: i } = Ee();
  if (t) {
    const c = el(n, r, s, 0, i);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(t, { ...e, size: o, style: c });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TI, { ...e });
}, FI = ({
  isMessengerOpened: e,
  onConversationStarted: t
}) => {
  const { nudgeMessageComponent: n } = lr(), { horizontal: r, vertical: s, margin: o, launcherSize: i } = Jt(), { dir: c } = Ee(), l = _a({ isMessengerOpened: e, onConversationStarted: t });
  if (n) {
    const { nudgeMessageKey: u, ...d } = l, m = el(r, s, o, nl(i), c);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, { key: u, ...d, style: m });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DI, { ...l });
}, UI = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function({ children: e, initialChannelUrl: t, entryPoint: n = "Conversation", ...r }, s) {
  const [o, i] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(t), [c, l] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), [u, d] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(n), [m, h] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("end-bottom"), [g, f] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(rl), [v, _] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(48), p = Cn(), y = p ? SI : RI, { horizontal: S, vertical: A } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const [I, k] = m.split("-");
    return { horizontal: I === "start" ? "start" : "end", vertical: k === "top" ? "top" : "bottom" };
  }, [m]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fc, { enableExpandButton: !p, ref: s, ...r }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xa, null, ({ state: I }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    bI,
    {
      value: { horizontal: S, vertical: A, margin: g, launcherSize: v, setPosition: h, setMargin: f, setLauncherSize: _ }
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Uc, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MI, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xc, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vc, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(y, { isExpanded: I.expanded, isOpened: I.opened }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      Yc,
      {
        isOpened: I.opened,
        entryPoint: n,
        selectedChannelUrl: o,
        setSelectedChannelUrl: i,
        nudgeConversation: c,
        onActiveRouteChange: d
      }
    )), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      PI,
      {
        opened: I.opened,
        setOpened: I.setOpened,
        entryPoint: n,
        activeRoute: u
      }
    ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      FI,
      {
        isMessengerOpened: I.opened,
        onConversationStarted: (k) => {
          i(k.channelUrl), l(k), I.setOpened(!0);
        }
      }
    ), e))
  )));
}), BI = (e) => {
  var s, o, i, c;
  const { setPosition: t, setMargin: n, setLauncherSize: r } = Jt();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    e.position && t(e.position), e.margin && n({ ...rl, ...e.margin }), e.launcherSize && r(e.launcherSize);
  }, [
    e.position,
    (s = e.margin) == null ? void 0 : s.top,
    (o = e.margin) == null ? void 0 : o.bottom,
    (i = e.margin) == null ? void 0 : i.start,
    (c = e.margin) == null ? void 0 : c.end,
    e.launcherSize
  ]), null;
}, Qt = (e, t) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => (e(t), () => e(null)), [t, e]);
}, HI = ({ component: e }) => (Qt(lr().setLauncherComponent, e), null), GI = ({ component: e }) => (Qt(lr().setNudgeMessageComponent, e), null), VI = ({ component: e }) => (Qt(An().setConversationComponent, e), null), zI = ({ component: e }) => (Qt(An().setConversationListComponent, e), null), KI = ({ children: e }) => (Qt(An().setConversationChildren, e), null), WI = ({ children: e }) => (Qt(An().setConversationListChildren, e), null), g0 = Object.assign(UI, {
  Style: BI,
  Launcher: HI,
  NudgeMessage: GI,
  Conversation: VI,
  ConversationChildren: KI,
  ConversationList: zI,
  ConversationListChildren: WI
}), f0 = (e) => {
  const { refreshActiveChannel: t } = Ge(), [n, r] = L(!1), s = T(null), o = T(null);
  return D(() => {
    n && t().then(() => {
      var i;
      (i = s.current) == null || i.call(s), r(!1);
    }).catch((i) => {
      var c;
      (c = o.current) == null || c.call(o, i), r(!1);
    });
  }, [n]), w(() => new Promise((i, c) => {
    s.current = i, o.current = c, e().then(() => r(!0)).catch(c);
  }), [e]);
};
sa.set(_sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.an.JS, {
  deviceOSPlatform: au() ? _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.a6.MOBILE_WEB : _sendbird_chat_message__WEBPACK_IMPORTED_MODULE_3__.a6.WEB,
  messengerVersion: Bf,
  keyValueStorage: Kf(),
  networkStateAdapter: zf(),
  foregroundStateAdapter: Vf
});



/***/ })

}]);